const index$1 = {};
const containers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index$1
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$3 = globalThis, e$9 = t$3.ShadowRoot && (void 0 === t$3.ShadyCSS || t$3.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$2 = Symbol(), o$7 = /* @__PURE__ */ new WeakMap();
let n$4 = class n {
  constructor(t2, e2, o2) {
    if (this._$cssResult$ = true, o2 !== s$2) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t2, this.t = e2;
  }
  get styleSheet() {
    let t2 = this.o;
    const s2 = this.t;
    if (e$9 && void 0 === t2) {
      const e2 = void 0 !== s2 && 1 === s2.length;
      e2 && (t2 = o$7.get(s2)), void 0 === t2 && ((this.o = t2 = new CSSStyleSheet()).replaceSync(this.cssText), e2 && o$7.set(s2, t2));
    }
    return t2;
  }
  toString() {
    return this.cssText;
  }
};
const r$5 = (t2) => new n$4("string" == typeof t2 ? t2 : t2 + "", void 0, s$2), i$6 = (t2, ...e2) => {
  const o2 = 1 === t2.length ? t2[0] : e2.reduce((e3, s2, o3) => e3 + ((t3) => {
    if (true === t3._$cssResult$) return t3.cssText;
    if ("number" == typeof t3) return t3;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t3 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s2) + t2[o3 + 1], t2[0]);
  return new n$4(o2, t2, s$2);
}, S$1 = (s2, o2) => {
  if (e$9) s2.adoptedStyleSheets = o2.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet);
  else for (const e2 of o2) {
    const o3 = document.createElement("style"), n3 = t$3.litNonce;
    void 0 !== n3 && o3.setAttribute("nonce", n3), o3.textContent = e2.cssText, s2.appendChild(o3);
  }
}, c$2 = e$9 ? (t2) => t2 : (t2) => t2 instanceof CSSStyleSheet ? ((t3) => {
  let e2 = "";
  for (const s2 of t3.cssRules) e2 += s2.cssText;
  return r$5(e2);
})(t2) : t2;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: i$5, defineProperty: e$8, getOwnPropertyDescriptor: h$1, getOwnPropertyNames: r$4, getOwnPropertySymbols: o$6, getPrototypeOf: n$3 } = Object, a$2 = globalThis, c$1 = a$2.trustedTypes, l$3 = c$1 ? c$1.emptyScript : "", p$1 = a$2.reactiveElementPolyfillSupport, d$1 = (t2, s2) => t2, u$3 = { toAttribute(t2, s2) {
  switch (s2) {
    case Boolean:
      t2 = t2 ? l$3 : null;
      break;
    case Object:
    case Array:
      t2 = null == t2 ? t2 : JSON.stringify(t2);
  }
  return t2;
}, fromAttribute(t2, s2) {
  let i4 = t2;
  switch (s2) {
    case Boolean:
      i4 = null !== t2;
      break;
    case Number:
      i4 = null === t2 ? null : Number(t2);
      break;
    case Object:
    case Array:
      try {
        i4 = JSON.parse(t2);
      } catch (t3) {
        i4 = null;
      }
  }
  return i4;
} }, f$2 = (t2, s2) => !i$5(t2, s2), b = { attribute: true, type: String, converter: u$3, reflect: false, useDefault: false, hasChanged: f$2 };
Symbol.metadata ??= Symbol("metadata"), a$2.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let y$1 = class y extends HTMLElement {
  static addInitializer(t2) {
    this._$Ei(), (this.l ??= []).push(t2);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t2, s2 = b) {
    if (s2.state && (s2.attribute = false), this._$Ei(), this.prototype.hasOwnProperty(t2) && ((s2 = Object.create(s2)).wrapped = true), this.elementProperties.set(t2, s2), !s2.noAccessor) {
      const i4 = Symbol(), h2 = this.getPropertyDescriptor(t2, i4, s2);
      void 0 !== h2 && e$8(this.prototype, t2, h2);
    }
  }
  static getPropertyDescriptor(t2, s2, i4) {
    const { get: e2, set: r2 } = h$1(this.prototype, t2) ?? { get() {
      return this[s2];
    }, set(t3) {
      this[s2] = t3;
    } };
    return { get: e2, set(s3) {
      const h2 = e2?.call(this);
      r2?.call(this, s3), this.requestUpdate(t2, h2, i4);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t2) {
    return this.elementProperties.get(t2) ?? b;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d$1("elementProperties"))) return;
    const t2 = n$3(this);
    t2.finalize(), void 0 !== t2.l && (this.l = [...t2.l]), this.elementProperties = new Map(t2.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d$1("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d$1("properties"))) {
      const t3 = this.properties, s2 = [...r$4(t3), ...o$6(t3)];
      for (const i4 of s2) this.createProperty(i4, t3[i4]);
    }
    const t2 = this[Symbol.metadata];
    if (null !== t2) {
      const s2 = litPropertyMetadata.get(t2);
      if (void 0 !== s2) for (const [t3, i4] of s2) this.elementProperties.set(t3, i4);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t3, s2] of this.elementProperties) {
      const i4 = this._$Eu(t3, s2);
      void 0 !== i4 && this._$Eh.set(i4, t3);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(s2) {
    const i4 = [];
    if (Array.isArray(s2)) {
      const e2 = new Set(s2.flat(1 / 0).reverse());
      for (const s3 of e2) i4.unshift(c$2(s3));
    } else void 0 !== s2 && i4.push(c$2(s2));
    return i4;
  }
  static _$Eu(t2, s2) {
    const i4 = s2.attribute;
    return false === i4 ? void 0 : "string" == typeof i4 ? i4 : "string" == typeof t2 ? t2.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t2) => this.enableUpdating = t2), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t2) => t2(this));
  }
  addController(t2) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t2), void 0 !== this.renderRoot && this.isConnected && t2.hostConnected?.();
  }
  removeController(t2) {
    this._$EO?.delete(t2);
  }
  _$E_() {
    const t2 = /* @__PURE__ */ new Map(), s2 = this.constructor.elementProperties;
    for (const i4 of s2.keys()) this.hasOwnProperty(i4) && (t2.set(i4, this[i4]), delete this[i4]);
    t2.size > 0 && (this._$Ep = t2);
  }
  createRenderRoot() {
    const t2 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S$1(t2, this.constructor.elementStyles), t2;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(true), this._$EO?.forEach((t2) => t2.hostConnected?.());
  }
  enableUpdating(t2) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t2) => t2.hostDisconnected?.());
  }
  attributeChangedCallback(t2, s2, i4) {
    this._$AK(t2, i4);
  }
  _$ET(t2, s2) {
    const i4 = this.constructor.elementProperties.get(t2), e2 = this.constructor._$Eu(t2, i4);
    if (void 0 !== e2 && true === i4.reflect) {
      const h2 = (void 0 !== i4.converter?.toAttribute ? i4.converter : u$3).toAttribute(s2, i4.type);
      this._$Em = t2, null == h2 ? this.removeAttribute(e2) : this.setAttribute(e2, h2), this._$Em = null;
    }
  }
  _$AK(t2, s2) {
    const i4 = this.constructor, e2 = i4._$Eh.get(t2);
    if (void 0 !== e2 && this._$Em !== e2) {
      const t3 = i4.getPropertyOptions(e2), h2 = "function" == typeof t3.converter ? { fromAttribute: t3.converter } : void 0 !== t3.converter?.fromAttribute ? t3.converter : u$3;
      this._$Em = e2;
      const r2 = h2.fromAttribute(s2, t3.type);
      this[e2] = r2 ?? this._$Ej?.get(e2) ?? r2, this._$Em = null;
    }
  }
  requestUpdate(t2, s2, i4) {
    if (void 0 !== t2) {
      const e2 = this.constructor, h2 = this[t2];
      if (i4 ??= e2.getPropertyOptions(t2), !((i4.hasChanged ?? f$2)(h2, s2) || i4.useDefault && i4.reflect && h2 === this._$Ej?.get(t2) && !this.hasAttribute(e2._$Eu(t2, i4)))) return;
      this.C(t2, s2, i4);
    }
    false === this.isUpdatePending && (this._$ES = this._$EP());
  }
  C(t2, s2, { useDefault: i4, reflect: e2, wrapped: h2 }, r2) {
    i4 && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t2) && (this._$Ej.set(t2, r2 ?? s2 ?? this[t2]), true !== h2 || void 0 !== r2) || (this._$AL.has(t2) || (this.hasUpdated || i4 || (s2 = void 0), this._$AL.set(t2, s2)), true === e2 && this._$Em !== t2 && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t2));
  }
  async _$EP() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t3) {
      Promise.reject(t3);
    }
    const t2 = this.scheduleUpdate();
    return null != t2 && await t2, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [t4, s3] of this._$Ep) this[t4] = s3;
        this._$Ep = void 0;
      }
      const t3 = this.constructor.elementProperties;
      if (t3.size > 0) for (const [s3, i4] of t3) {
        const { wrapped: t4 } = i4, e2 = this[s3];
        true !== t4 || this._$AL.has(s3) || void 0 === e2 || this.C(s3, void 0, i4, e2);
      }
    }
    let t2 = false;
    const s2 = this._$AL;
    try {
      t2 = this.shouldUpdate(s2), t2 ? (this.willUpdate(s2), this._$EO?.forEach((t3) => t3.hostUpdate?.()), this.update(s2)) : this._$EM();
    } catch (s3) {
      throw t2 = false, this._$EM(), s3;
    }
    t2 && this._$AE(s2);
  }
  willUpdate(t2) {
  }
  _$AE(t2) {
    this._$EO?.forEach((t3) => t3.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t2)), this.updated(t2);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t2) {
    return true;
  }
  update(t2) {
    this._$Eq &&= this._$Eq.forEach((t3) => this._$ET(t3, this[t3])), this._$EM();
  }
  updated(t2) {
  }
  firstUpdated(t2) {
  }
};
y$1.elementStyles = [], y$1.shadowRootOptions = { mode: "open" }, y$1[d$1("elementProperties")] = /* @__PURE__ */ new Map(), y$1[d$1("finalized")] = /* @__PURE__ */ new Map(), p$1?.({ ReactiveElement: y$1 }), (a$2.reactiveElementVersions ??= []).push("2.1.1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2 = globalThis, i$4 = t$2.trustedTypes, s$1 = i$4 ? i$4.createPolicy("lit-html", { createHTML: (t2) => t2 }) : void 0, e$7 = "$lit$", h = `lit$${Math.random().toFixed(9).slice(2)}$`, o$5 = "?" + h, n$2 = `<${o$5}>`, r$3 = document, l$2 = () => r$3.createComment(""), c = (t2) => null === t2 || "object" != typeof t2 && "function" != typeof t2, a$1 = Array.isArray, u$2 = (t2) => a$1(t2) || "function" == typeof t2?.[Symbol.iterator], d = "[ 	\n\f\r]", f$1 = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, _ = />/g, m$1 = RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), p = /'/g, g = /"/g, $ = /^(?:script|style|textarea|title)$/i, y2 = (t2) => (i4, ...s2) => ({ _$litType$: t2, strings: i4, values: s2 }), x = y2(1), T = Symbol.for("lit-noChange"), E = Symbol.for("lit-nothing"), A = /* @__PURE__ */ new WeakMap(), C = r$3.createTreeWalker(r$3, 129);
function P(t2, i4) {
  if (!a$1(t2) || !t2.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== s$1 ? s$1.createHTML(i4) : i4;
}
const V = (t2, i4) => {
  const s2 = t2.length - 1, o2 = [];
  let r2, l2 = 2 === i4 ? "<svg>" : 3 === i4 ? "<math>" : "", c2 = f$1;
  for (let i5 = 0; i5 < s2; i5++) {
    const s3 = t2[i5];
    let a2, u2, d2 = -1, y3 = 0;
    for (; y3 < s3.length && (c2.lastIndex = y3, u2 = c2.exec(s3), null !== u2); ) y3 = c2.lastIndex, c2 === f$1 ? "!--" === u2[1] ? c2 = v : void 0 !== u2[1] ? c2 = _ : void 0 !== u2[2] ? ($.test(u2[2]) && (r2 = RegExp("</" + u2[2], "g")), c2 = m$1) : void 0 !== u2[3] && (c2 = m$1) : c2 === m$1 ? ">" === u2[0] ? (c2 = r2 ?? f$1, d2 = -1) : void 0 === u2[1] ? d2 = -2 : (d2 = c2.lastIndex - u2[2].length, a2 = u2[1], c2 = void 0 === u2[3] ? m$1 : '"' === u2[3] ? g : p) : c2 === g || c2 === p ? c2 = m$1 : c2 === v || c2 === _ ? c2 = f$1 : (c2 = m$1, r2 = void 0);
    const x2 = c2 === m$1 && t2[i5 + 1].startsWith("/>") ? " " : "";
    l2 += c2 === f$1 ? s3 + n$2 : d2 >= 0 ? (o2.push(a2), s3.slice(0, d2) + e$7 + s3.slice(d2) + h + x2) : s3 + h + (-2 === d2 ? i5 : x2);
  }
  return [P(t2, l2 + (t2[s2] || "<?>") + (2 === i4 ? "</svg>" : 3 === i4 ? "</math>" : "")), o2];
};
class N {
  constructor({ strings: t2, _$litType$: s2 }, n3) {
    let r2;
    this.parts = [];
    let c2 = 0, a2 = 0;
    const u2 = t2.length - 1, d2 = this.parts, [f2, v2] = V(t2, s2);
    if (this.el = N.createElement(f2, n3), C.currentNode = this.el.content, 2 === s2 || 3 === s2) {
      const t3 = this.el.content.firstChild;
      t3.replaceWith(...t3.childNodes);
    }
    for (; null !== (r2 = C.nextNode()) && d2.length < u2; ) {
      if (1 === r2.nodeType) {
        if (r2.hasAttributes()) for (const t3 of r2.getAttributeNames()) if (t3.endsWith(e$7)) {
          const i4 = v2[a2++], s3 = r2.getAttribute(t3).split(h), e2 = /([.?@])?(.*)/.exec(i4);
          d2.push({ type: 1, index: c2, name: e2[2], strings: s3, ctor: "." === e2[1] ? H : "?" === e2[1] ? I : "@" === e2[1] ? L : k }), r2.removeAttribute(t3);
        } else t3.startsWith(h) && (d2.push({ type: 6, index: c2 }), r2.removeAttribute(t3));
        if ($.test(r2.tagName)) {
          const t3 = r2.textContent.split(h), s3 = t3.length - 1;
          if (s3 > 0) {
            r2.textContent = i$4 ? i$4.emptyScript : "";
            for (let i4 = 0; i4 < s3; i4++) r2.append(t3[i4], l$2()), C.nextNode(), d2.push({ type: 2, index: ++c2 });
            r2.append(t3[s3], l$2());
          }
        }
      } else if (8 === r2.nodeType) if (r2.data === o$5) d2.push({ type: 2, index: c2 });
      else {
        let t3 = -1;
        for (; -1 !== (t3 = r2.data.indexOf(h, t3 + 1)); ) d2.push({ type: 7, index: c2 }), t3 += h.length - 1;
      }
      c2++;
    }
  }
  static createElement(t2, i4) {
    const s2 = r$3.createElement("template");
    return s2.innerHTML = t2, s2;
  }
}
function S(t2, i4, s2 = t2, e2) {
  if (i4 === T) return i4;
  let h2 = void 0 !== e2 ? s2._$Co?.[e2] : s2._$Cl;
  const o2 = c(i4) ? void 0 : i4._$litDirective$;
  return h2?.constructor !== o2 && (h2?._$AO?.(false), void 0 === o2 ? h2 = void 0 : (h2 = new o2(t2), h2._$AT(t2, s2, e2)), void 0 !== e2 ? (s2._$Co ??= [])[e2] = h2 : s2._$Cl = h2), void 0 !== h2 && (i4 = S(t2, h2._$AS(t2, i4.values), h2, e2)), i4;
}
class M {
  constructor(t2, i4) {
    this._$AV = [], this._$AN = void 0, this._$AD = t2, this._$AM = i4;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t2) {
    const { el: { content: i4 }, parts: s2 } = this._$AD, e2 = (t2?.creationScope ?? r$3).importNode(i4, true);
    C.currentNode = e2;
    let h2 = C.nextNode(), o2 = 0, n3 = 0, l2 = s2[0];
    for (; void 0 !== l2; ) {
      if (o2 === l2.index) {
        let i5;
        2 === l2.type ? i5 = new R$1(h2, h2.nextSibling, this, t2) : 1 === l2.type ? i5 = new l2.ctor(h2, l2.name, l2.strings, this, t2) : 6 === l2.type && (i5 = new z(h2, this, t2)), this._$AV.push(i5), l2 = s2[++n3];
      }
      o2 !== l2?.index && (h2 = C.nextNode(), o2++);
    }
    return C.currentNode = r$3, e2;
  }
  p(t2) {
    let i4 = 0;
    for (const s2 of this._$AV) void 0 !== s2 && (void 0 !== s2.strings ? (s2._$AI(t2, s2, i4), i4 += s2.strings.length - 2) : s2._$AI(t2[i4])), i4++;
  }
}
let R$1 = class R {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t2, i4, s2, e2) {
    this.type = 2, this._$AH = E, this._$AN = void 0, this._$AA = t2, this._$AB = i4, this._$AM = s2, this.options = e2, this._$Cv = e2?.isConnected ?? true;
  }
  get parentNode() {
    let t2 = this._$AA.parentNode;
    const i4 = this._$AM;
    return void 0 !== i4 && 11 === t2?.nodeType && (t2 = i4.parentNode), t2;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t2, i4 = this) {
    t2 = S(this, t2, i4), c(t2) ? t2 === E || null == t2 || "" === t2 ? (this._$AH !== E && this._$AR(), this._$AH = E) : t2 !== this._$AH && t2 !== T && this._(t2) : void 0 !== t2._$litType$ ? this.$(t2) : void 0 !== t2.nodeType ? this.T(t2) : u$2(t2) ? this.k(t2) : this._(t2);
  }
  O(t2) {
    return this._$AA.parentNode.insertBefore(t2, this._$AB);
  }
  T(t2) {
    this._$AH !== t2 && (this._$AR(), this._$AH = this.O(t2));
  }
  _(t2) {
    this._$AH !== E && c(this._$AH) ? this._$AA.nextSibling.data = t2 : this.T(r$3.createTextNode(t2)), this._$AH = t2;
  }
  $(t2) {
    const { values: i4, _$litType$: s2 } = t2, e2 = "number" == typeof s2 ? this._$AC(t2) : (void 0 === s2.el && (s2.el = N.createElement(P(s2.h, s2.h[0]), this.options)), s2);
    if (this._$AH?._$AD === e2) this._$AH.p(i4);
    else {
      const t3 = new M(e2, this), s3 = t3.u(this.options);
      t3.p(i4), this.T(s3), this._$AH = t3;
    }
  }
  _$AC(t2) {
    let i4 = A.get(t2.strings);
    return void 0 === i4 && A.set(t2.strings, i4 = new N(t2)), i4;
  }
  k(t2) {
    a$1(this._$AH) || (this._$AH = [], this._$AR());
    const i4 = this._$AH;
    let s2, e2 = 0;
    for (const h2 of t2) e2 === i4.length ? i4.push(s2 = new R(this.O(l$2()), this.O(l$2()), this, this.options)) : s2 = i4[e2], s2._$AI(h2), e2++;
    e2 < i4.length && (this._$AR(s2 && s2._$AB.nextSibling, e2), i4.length = e2);
  }
  _$AR(t2 = this._$AA.nextSibling, i4) {
    for (this._$AP?.(false, true, i4); t2 !== this._$AB; ) {
      const i5 = t2.nextSibling;
      t2.remove(), t2 = i5;
    }
  }
  setConnected(t2) {
    void 0 === this._$AM && (this._$Cv = t2, this._$AP?.(t2));
  }
};
class k {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t2, i4, s2, e2, h2) {
    this.type = 1, this._$AH = E, this._$AN = void 0, this.element = t2, this.name = i4, this._$AM = e2, this.options = h2, s2.length > 2 || "" !== s2[0] || "" !== s2[1] ? (this._$AH = Array(s2.length - 1).fill(new String()), this.strings = s2) : this._$AH = E;
  }
  _$AI(t2, i4 = this, s2, e2) {
    const h2 = this.strings;
    let o2 = false;
    if (void 0 === h2) t2 = S(this, t2, i4, 0), o2 = !c(t2) || t2 !== this._$AH && t2 !== T, o2 && (this._$AH = t2);
    else {
      const e3 = t2;
      let n3, r2;
      for (t2 = h2[0], n3 = 0; n3 < h2.length - 1; n3++) r2 = S(this, e3[s2 + n3], i4, n3), r2 === T && (r2 = this._$AH[n3]), o2 ||= !c(r2) || r2 !== this._$AH[n3], r2 === E ? t2 = E : t2 !== E && (t2 += (r2 ?? "") + h2[n3 + 1]), this._$AH[n3] = r2;
    }
    o2 && !e2 && this.j(t2);
  }
  j(t2) {
    t2 === E ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t2 ?? "");
  }
}
class H extends k {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t2) {
    this.element[this.name] = t2 === E ? void 0 : t2;
  }
}
class I extends k {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t2) {
    this.element.toggleAttribute(this.name, !!t2 && t2 !== E);
  }
}
class L extends k {
  constructor(t2, i4, s2, e2, h2) {
    super(t2, i4, s2, e2, h2), this.type = 5;
  }
  _$AI(t2, i4 = this) {
    if ((t2 = S(this, t2, i4, 0) ?? E) === T) return;
    const s2 = this._$AH, e2 = t2 === E && s2 !== E || t2.capture !== s2.capture || t2.once !== s2.once || t2.passive !== s2.passive, h2 = t2 !== E && (s2 === E || e2);
    e2 && this.element.removeEventListener(this.name, this, s2), h2 && this.element.addEventListener(this.name, this, t2), this._$AH = t2;
  }
  handleEvent(t2) {
    "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t2) : this._$AH.handleEvent(t2);
  }
}
class z {
  constructor(t2, i4, s2) {
    this.element = t2, this.type = 6, this._$AN = void 0, this._$AM = i4, this.options = s2;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2) {
    S(this, t2);
  }
}
const j = t$2.litHtmlPolyfillSupport;
j?.(N, R$1), (t$2.litHtmlVersions ??= []).push("3.3.1");
const B = (t2, i4, s2) => {
  const e2 = s2?.renderBefore ?? i4;
  let h2 = e2._$litPart$;
  if (void 0 === h2) {
    const t3 = s2?.renderBefore ?? null;
    e2._$litPart$ = h2 = new R$1(i4.insertBefore(l$2(), t3), t3, void 0, s2 ?? {});
  }
  return h2._$AI(t2), h2;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const s = globalThis;
let i$3 = class i extends y$1 {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t2 = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t2.firstChild, t2;
  }
  update(t2) {
    const r2 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t2), this._$Do = B(r2, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(true);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(false);
  }
  render() {
    return T;
  }
};
i$3._$litElement$ = true, i$3["finalized"] = true, s.litElementHydrateSupport?.({ LitElement: i$3 });
const o$4 = s.litElementPolyfillSupport;
o$4?.({ LitElement: i$3 });
(s.litElementVersions ??= []).push("4.2.1");
const tailwind = '/*! tailwindcss v4.1.11 | MIT License | https://tailwindcss.com */\n@layer properties {\n  @supports (((-webkit-hyphens: none)) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color: rgb(from red r g b)))) {\n    *, :before, :after, ::backdrop {\n      --tw-translate-x: 0;\n      --tw-translate-y: 0;\n      --tw-translate-z: 0;\n      --tw-scale-x: 1;\n      --tw-scale-y: 1;\n      --tw-scale-z: 1;\n      --tw-rotate-x: initial;\n      --tw-rotate-y: initial;\n      --tw-rotate-z: initial;\n      --tw-skew-x: initial;\n      --tw-skew-y: initial;\n      --tw-space-y-reverse: 0;\n      --tw-border-style: solid;\n      --tw-font-weight: initial;\n      --tw-tracking: initial;\n      --tw-shadow: 0 0 #0000;\n      --tw-shadow-color: initial;\n      --tw-shadow-alpha: 100%;\n      --tw-inset-shadow: 0 0 #0000;\n      --tw-inset-shadow-color: initial;\n      --tw-inset-shadow-alpha: 100%;\n      --tw-ring-color: initial;\n      --tw-ring-shadow: 0 0 #0000;\n      --tw-inset-ring-color: initial;\n      --tw-inset-ring-shadow: 0 0 #0000;\n      --tw-ring-inset: initial;\n      --tw-ring-offset-width: 0px;\n      --tw-ring-offset-color: #fff;\n      --tw-ring-offset-shadow: 0 0 #0000;\n      --tw-outline-style: solid;\n      --tw-blur: initial;\n      --tw-brightness: initial;\n      --tw-contrast: initial;\n      --tw-grayscale: initial;\n      --tw-hue-rotate: initial;\n      --tw-invert: initial;\n      --tw-opacity: initial;\n      --tw-saturate: initial;\n      --tw-sepia: initial;\n      --tw-drop-shadow: initial;\n      --tw-drop-shadow-color: initial;\n      --tw-drop-shadow-alpha: 100%;\n      --tw-drop-shadow-size: initial;\n      --tw-backdrop-blur: initial;\n      --tw-backdrop-brightness: initial;\n      --tw-backdrop-contrast: initial;\n      --tw-backdrop-grayscale: initial;\n      --tw-backdrop-hue-rotate: initial;\n      --tw-backdrop-invert: initial;\n      --tw-backdrop-opacity: initial;\n      --tw-backdrop-saturate: initial;\n      --tw-backdrop-sepia: initial;\n      --tw-duration: initial;\n      --tw-ease: initial;\n    }\n  }\n}\n\n@layer theme {\n  :root, :host {\n    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";\n    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;\n    --color-gray-200: oklch(92.8% .006 264.531);\n    --color-gray-500: oklch(55.1% .027 264.364);\n    --color-black: #000;\n    --color-white: #fff;\n    --spacing: .25rem;\n    --text-sm: .875rem;\n    --text-sm--line-height: calc(1.25 / .875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --tracking-tight: -.025em;\n    --radius-sm: .25rem;\n    --radius-md: .375rem;\n    --radius-lg: .5rem;\n    --ease-in-out: cubic-bezier(.4, 0, .2, 1);\n    --default-transition-duration: .15s;\n    --default-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n    --default-font-family: var(--font-sans);\n    --default-mono-font-family: var(--font-mono);\n  }\n}\n\n@layer base {\n  *, :after, :before, ::backdrop {\n    box-sizing: border-box;\n    border: 0 solid;\n    margin: 0;\n    padding: 0;\n  }\n\n  ::file-selector-button {\n    box-sizing: border-box;\n    border: 0 solid;\n    margin: 0;\n    padding: 0;\n  }\n\n  html, :host {\n    -webkit-text-size-adjust: 100%;\n    tab-size: 4;\n    line-height: 1.5;\n    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");\n    font-feature-settings: var(--default-font-feature-settings, normal);\n    font-variation-settings: var(--default-font-variation-settings, normal);\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  hr {\n    height: 0;\n    color: inherit;\n    border-top-width: 1px;\n  }\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    -webkit-text-decoration: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  b, strong {\n    font-weight: bolder;\n  }\n\n  code, kbd, samp, pre {\n    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);\n    font-feature-settings: var(--default-mono-font-feature-settings, normal);\n    font-variation-settings: var(--default-mono-font-variation-settings, normal);\n    font-size: 1em;\n  }\n\n  small {\n    font-size: 80%;\n  }\n\n  sub, sup {\n    vertical-align: baseline;\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n  }\n\n  sub {\n    bottom: -.25em;\n  }\n\n  sup {\n    top: -.5em;\n  }\n\n  table {\n    text-indent: 0;\n    border-color: inherit;\n    border-collapse: collapse;\n  }\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  summary {\n    display: list-item;\n  }\n\n  ol, ul, menu {\n    list-style: none;\n  }\n\n  img, svg, video, canvas, audio, iframe, embed, object {\n    vertical-align: middle;\n    display: block;\n  }\n\n  img, video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  button, input, select, optgroup, textarea {\n    font: inherit;\n    font-feature-settings: inherit;\n    font-variation-settings: inherit;\n    letter-spacing: inherit;\n    color: inherit;\n    opacity: 1;\n    background-color: #0000;\n    border-radius: 0;\n  }\n\n  ::file-selector-button {\n    font: inherit;\n    font-feature-settings: inherit;\n    font-variation-settings: inherit;\n    letter-spacing: inherit;\n    color: inherit;\n    opacity: 1;\n    background-color: #0000;\n    border-radius: 0;\n  }\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  @supports (not ((-webkit-appearance: -apple-pay-button))) or (contain-intrinsic-size: 1px) {\n    ::placeholder {\n      color: currentColor;\n    }\n\n    @supports (color: color-mix(in lab, red, red)) {\n      ::placeholder {\n        color: color-mix(in oklab, currentcolor 50%, transparent);\n      }\n    }\n  }\n\n  textarea {\n    resize: vertical;\n  }\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh;\n    text-align: inherit;\n  }\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-year-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-month-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-day-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-hour-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-minute-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-second-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-millisecond-field {\n    padding-block: 0;\n  }\n\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  button, input:where([type="button"], [type="reset"], [type="submit"]) {\n    appearance: button;\n  }\n\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  ::-webkit-inner-spin-button {\n    height: auto;\n  }\n\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  [hidden]:where(:not([hidden="until-found"])) {\n    display: none !important;\n  }\n}\n\n@layer components;\n\n@layer utilities {\n  .\\@container {\n    container-type: inline-size;\n  }\n\n  .pointer-events-none {\n    pointer-events: none;\n  }\n\n  .visible {\n    visibility: visible;\n  }\n\n  .absolute {\n    position: absolute;\n  }\n\n  .fixed {\n    position: fixed;\n  }\n\n  .relative {\n    position: relative;\n  }\n\n  .static {\n    position: static;\n  }\n\n  .sticky {\n    position: sticky;\n  }\n\n  .inset-0 {\n    inset: calc(var(--spacing) * 0);\n  }\n\n  .top-0 {\n    top: calc(var(--spacing) * 0);\n  }\n\n  .top-full {\n    top: 100%;\n  }\n\n  .right-0 {\n    right: calc(var(--spacing) * 0);\n  }\n\n  .bottom-0 {\n    bottom: calc(var(--spacing) * 0);\n  }\n\n  .left-0 {\n    left: calc(var(--spacing) * 0);\n  }\n\n  .left-\\[48\\%\\] {\n    left: 48%;\n  }\n\n  .z-0 {\n    z-index: 0;\n  }\n\n  .z-10 {\n    z-index: 10;\n  }\n\n  .z-\\[1\\] {\n    z-index: 1;\n  }\n\n  .z-\\[10\\] {\n    z-index: 10;\n  }\n\n  .container {\n    width: 100%;\n  }\n\n  @media (min-width: 40rem) {\n    .container {\n      max-width: 40rem;\n    }\n  }\n\n  @media (min-width: 48rem) {\n    .container {\n      max-width: 48rem;\n    }\n  }\n\n  @media (min-width: 64rem) {\n    .container {\n      max-width: 64rem;\n    }\n  }\n\n  @media (min-width: 80rem) {\n    .container {\n      max-width: 80rem;\n    }\n  }\n\n  @media (min-width: 96rem) {\n    .container {\n      max-width: 96rem;\n    }\n  }\n\n  .\\!m-\\[1px\\] {\n    margin: 1px !important;\n  }\n\n  .\\!mt-2 {\n    margin-top: calc(var(--spacing) * 2) !important;\n  }\n\n  .mt-1 {\n    margin-top: calc(var(--spacing) * 1);\n  }\n\n  .mt-2 {\n    margin-top: calc(var(--spacing) * 2);\n  }\n\n  .mt-4 {\n    margin-top: calc(var(--spacing) * 4);\n  }\n\n  .\\!mr-4 {\n    margin-right: calc(var(--spacing) * 4) !important;\n  }\n\n  .mr-4 {\n    margin-right: calc(var(--spacing) * 4);\n  }\n\n  .mr-4\\.5 {\n    margin-right: calc(var(--spacing) * 4.5);\n  }\n\n  .mr-\\[24px\\] {\n    margin-right: 24px;\n  }\n\n  .\\!mb-1 {\n    margin-bottom: calc(var(--spacing) * 1) !important;\n  }\n\n  .\\!mb-2 {\n    margin-bottom: calc(var(--spacing) * 2) !important;\n  }\n\n  .mb-2 {\n    margin-bottom: calc(var(--spacing) * 2);\n  }\n\n  .mb-4 {\n    margin-bottom: calc(var(--spacing) * 4);\n  }\n\n  .\\!ml-4 {\n    margin-left: calc(var(--spacing) * 4) !important;\n  }\n\n  .ml-4 {\n    margin-left: calc(var(--spacing) * 4);\n  }\n\n  .\\!hidden {\n    display: none !important;\n  }\n\n  .block {\n    display: block;\n  }\n\n  .flex {\n    display: flex;\n  }\n\n  .grid {\n    display: grid;\n  }\n\n  .hidden {\n    display: none;\n  }\n\n  .inline-block {\n    display: inline-block;\n  }\n\n  .h-6 {\n    height: calc(var(--spacing) * 6);\n  }\n\n  .h-\\[38px\\] {\n    height: 38px;\n  }\n\n  .h-\\[10000px\\] {\n    height: 10000px;\n  }\n\n  .h-full {\n    height: 100%;\n  }\n\n  .max-h-\\[70vh\\] {\n    max-height: 70vh;\n  }\n\n  .min-h-\\[50vh\\] {\n    min-height: 50vh;\n  }\n\n  .w-6 {\n    width: calc(var(--spacing) * 6);\n  }\n\n  .w-\\[1px\\] {\n    width: 1px;\n  }\n\n  .w-\\[38px\\] {\n    width: 38px;\n  }\n\n  .w-full {\n    width: 100%;\n  }\n\n  .min-w-\\[70vw\\] {\n    min-width: 70vw;\n  }\n\n  .min-w-\\[180px\\] {\n    min-width: 180px;\n  }\n\n  .min-w-\\[320px\\] {\n    min-width: 320px;\n  }\n\n  .flex-grow, .grow {\n    flex-grow: 1;\n  }\n\n  .-translate-x-full {\n    --tw-translate-x: -100%;\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n\n  .translate-x-0 {\n    --tw-translate-x: calc(var(--spacing) * 0);\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n\n  .translate-x-full {\n    --tw-translate-x: 100%;\n    translate: var(--tw-translate-x) var(--tw-translate-y);\n  }\n\n  .scale-y-\\[141\\.42\\%\\] {\n    --tw-scale-y: 141.42%;\n    scale: var(--tw-scale-x) var(--tw-scale-y);\n  }\n\n  .rotate-45 {\n    rotate: 45deg;\n  }\n\n  .rotate-180 {\n    rotate: 180deg;\n  }\n\n  .transform {\n    transform: var(--tw-rotate-x, ) var(--tw-rotate-y, ) var(--tw-rotate-z, ) var(--tw-skew-x, ) var(--tw-skew-y, );\n  }\n\n  .cursor-help {\n    cursor: help;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n  }\n\n  .resize {\n    resize: both;\n  }\n\n  .grid-cols-\\[repeat\\(auto-fit\\,minmax\\(150px\\,1fr\\)\\)\\] {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n\n  .grid-cols-\\[repeat\\(auto-fit\\,minmax\\(250px\\,1fr\\)\\)\\] {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  }\n\n  .flex-col {\n    flex-direction: column;\n  }\n\n  .flex-wrap {\n    flex-wrap: wrap;\n  }\n\n  .items-center {\n    align-items: center;\n  }\n\n  .items-start {\n    align-items: flex-start;\n  }\n\n  .justify-between {\n    justify-content: space-between;\n  }\n\n  .justify-center {\n    justify-content: center;\n  }\n\n  .justify-end {\n    justify-content: flex-end;\n  }\n\n  .gap-1 {\n    gap: calc(var(--spacing) * 1);\n  }\n\n  .gap-2 {\n    gap: calc(var(--spacing) * 2);\n  }\n\n  .gap-3 {\n    gap: calc(var(--spacing) * 3);\n  }\n\n  .gap-4 {\n    gap: calc(var(--spacing) * 4);\n  }\n\n  .gap-6 {\n    gap: calc(var(--spacing) * 6);\n  }\n\n  :where(.space-y-2 > :not(:last-child)) {\n    --tw-space-y-reverse: 0;\n    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));\n    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));\n  }\n\n  .gap-x-3 {\n    column-gap: calc(var(--spacing) * 3);\n  }\n\n  .gap-x-4 {\n    column-gap: calc(var(--spacing) * 4);\n  }\n\n  .gap-y-2 {\n    row-gap: calc(var(--spacing) * 2);\n  }\n\n  .gap-y-4 {\n    row-gap: calc(var(--spacing) * 4);\n  }\n\n  .self-center {\n    align-self: center;\n  }\n\n  .overflow-auto {\n    overflow: auto;\n  }\n\n  .overflow-hidden {\n    overflow: hidden;\n  }\n\n  .overflow-scroll {\n    overflow: scroll;\n  }\n\n  .overflow-x-scroll {\n    overflow-x: scroll;\n  }\n\n  .\\!rounded-md {\n    border-radius: var(--radius-md) !important;\n  }\n\n  .rounded-full {\n    border-radius: 3.40282e38px;\n  }\n\n  .rounded-lg {\n    border-radius: var(--radius-lg);\n  }\n\n  .rounded-md {\n    border-radius: var(--radius-md);\n  }\n\n  .rounded-sm {\n    border-radius: var(--radius-sm);\n  }\n\n  .border {\n    border-style: var(--tw-border-style);\n    border-width: 1px;\n  }\n\n  .border-gray-200 {\n    border-color: var(--color-gray-200);\n  }\n\n  .bg-\\[\\#964B00\\] {\n    background-color: #964b00;\n  }\n\n  .bg-\\[\\#F5F5F5\\] {\n    background-color: #f5f5f5;\n  }\n\n  .bg-\\[\\#f4f4f4\\] {\n    background-color: #f4f4f4;\n  }\n\n  .bg-white {\n    background-color: var(--color-white);\n  }\n\n  .p-2 {\n    padding: calc(var(--spacing) * 2);\n  }\n\n  .p-4 {\n    padding: calc(var(--spacing) * 4);\n  }\n\n  .\\!px-2 {\n    padding-inline: calc(var(--spacing) * 2) !important;\n  }\n\n  .\\!px-4 {\n    padding-inline: calc(var(--spacing) * 4) !important;\n  }\n\n  .px-0 {\n    padding-inline: calc(var(--spacing) * 0);\n  }\n\n  .px-1 {\n    padding-inline: calc(var(--spacing) * 1);\n  }\n\n  .px-4 {\n    padding-inline: calc(var(--spacing) * 4);\n  }\n\n  .\\!py-1 {\n    padding-block: calc(var(--spacing) * 1) !important;\n  }\n\n  .\\!py-\\[0\\.7rem\\] {\n    padding-block: .7rem !important;\n  }\n\n  .py-2 {\n    padding-block: calc(var(--spacing) * 2);\n  }\n\n  .py-4 {\n    padding-block: calc(var(--spacing) * 4);\n  }\n\n  .pt-2 {\n    padding-top: calc(var(--spacing) * 2);\n  }\n\n  .pt-4 {\n    padding-top: calc(var(--spacing) * 4);\n  }\n\n  .pt-\\[8px\\] {\n    padding-top: 8px;\n  }\n\n  .pr-8 {\n    padding-right: calc(var(--spacing) * 8);\n  }\n\n  .pb-0 {\n    padding-bottom: calc(var(--spacing) * 0);\n  }\n\n  .pb-2 {\n    padding-bottom: calc(var(--spacing) * 2);\n  }\n\n  .pl-8 {\n    padding-left: calc(var(--spacing) * 8);\n  }\n\n  .text-end {\n    text-align: end;\n  }\n\n  .text-4xl {\n    font-size: var(--text-4xl);\n    line-height: var(--tw-leading, var(--text-4xl--line-height));\n  }\n\n  .text-base {\n    font-size: var(--text-base);\n    line-height: var(--tw-leading, var(--text-base--line-height));\n  }\n\n  .text-lg {\n    font-size: var(--text-lg);\n    line-height: var(--tw-leading, var(--text-lg--line-height));\n  }\n\n  .text-sm {\n    font-size: var(--text-sm);\n    line-height: var(--tw-leading, var(--text-sm--line-height));\n  }\n\n  .\\!text-\\[0\\.85rem\\] {\n    font-size: .85rem !important;\n  }\n\n  .font-bold {\n    --tw-font-weight: var(--font-weight-bold);\n    font-weight: var(--font-weight-bold);\n  }\n\n  .font-semibold {\n    --tw-font-weight: var(--font-weight-semibold);\n    font-weight: var(--font-weight-semibold);\n  }\n\n  .tracking-tight {\n    --tw-tracking: var(--tracking-tight);\n    letter-spacing: var(--tracking-tight);\n  }\n\n  .text-wrap {\n    text-wrap: wrap;\n  }\n\n  .whitespace-nowrap {\n    white-space: nowrap;\n  }\n\n  .\\!text-black {\n    color: var(--color-black) !important;\n  }\n\n  .text-black {\n    color: var(--color-black);\n  }\n\n  .text-gray-500 {\n    color: var(--color-gray-500);\n  }\n\n  .lowercase {\n    text-transform: lowercase;\n  }\n\n  .uppercase {\n    text-transform: uppercase;\n  }\n\n  .underline {\n    text-decoration-line: underline;\n  }\n\n  .decoration-black {\n    -webkit-text-decoration-color: var(--color-black);\n    -webkit-text-decoration-color: var(--color-black);\n    text-decoration-color: var(--color-black);\n  }\n\n  .opacity-0 {\n    opacity: 0;\n  }\n\n  .opacity-40 {\n    opacity: .4;\n  }\n\n  .opacity-50 {\n    opacity: .5;\n  }\n\n  .shadow {\n    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, #0000001a), 0 1px 2px -1px var(--tw-shadow-color, #0000001a);\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n\n  .ring {\n    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);\n    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\n  }\n\n  .outline {\n    outline-style: var(--tw-outline-style);\n    outline-width: 1px;\n  }\n\n  .filter {\n    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );\n  }\n\n  .backdrop-filter {\n    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );\n    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );\n  }\n\n  .transition {\n    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, visibility, content-visibility, overlay, pointer-events;\n    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));\n    transition-duration: var(--tw-duration, var(--default-transition-duration));\n  }\n\n  .transition-transform {\n    transition-property: transform, translate, scale, rotate;\n    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));\n    transition-duration: var(--tw-duration, var(--default-transition-duration));\n  }\n\n  .duration-200, .duration-\\[200ms\\] {\n    --tw-duration: .2s;\n    transition-duration: .2s;\n  }\n\n  .ease-in-out {\n    --tw-ease: var(--ease-in-out);\n    transition-timing-function: var(--ease-in-out);\n  }\n\n  .\\[-ms-overflow-style\\:none\\] {\n    -ms-overflow-style: none;\n  }\n\n  .\\[scrollbar-width\\:none\\] {\n    scrollbar-width: none;\n  }\n\n  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n@property --tw-translate-x {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0;\n}\n\n@property --tw-translate-y {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0;\n}\n\n@property --tw-translate-z {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0;\n}\n\n@property --tw-scale-x {\n  syntax: "*";\n  inherits: false;\n  initial-value: 1;\n}\n\n@property --tw-scale-y {\n  syntax: "*";\n  inherits: false;\n  initial-value: 1;\n}\n\n@property --tw-scale-z {\n  syntax: "*";\n  inherits: false;\n  initial-value: 1;\n}\n\n@property --tw-rotate-x {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-rotate-y {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-rotate-z {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-skew-x {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-skew-y {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-space-y-reverse {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0;\n}\n\n@property --tw-border-style {\n  syntax: "*";\n  inherits: false;\n  initial-value: solid;\n}\n\n@property --tw-font-weight {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-tracking {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-shadow {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n\n@property --tw-shadow-color {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-shadow-alpha {\n  syntax: "<percentage>";\n  inherits: false;\n  initial-value: 100%;\n}\n\n@property --tw-inset-shadow {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n\n@property --tw-inset-shadow-color {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-inset-shadow-alpha {\n  syntax: "<percentage>";\n  inherits: false;\n  initial-value: 100%;\n}\n\n@property --tw-ring-color {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-ring-shadow {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n\n@property --tw-inset-ring-color {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-inset-ring-shadow {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n\n@property --tw-ring-inset {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-ring-offset-width {\n  syntax: "<length>";\n  inherits: false;\n  initial-value: 0;\n}\n\n@property --tw-ring-offset-color {\n  syntax: "*";\n  inherits: false;\n  initial-value: #fff;\n}\n\n@property --tw-ring-offset-shadow {\n  syntax: "*";\n  inherits: false;\n  initial-value: 0 0 #0000;\n}\n\n@property --tw-outline-style {\n  syntax: "*";\n  inherits: false;\n  initial-value: solid;\n}\n\n@property --tw-blur {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-brightness {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-contrast {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-grayscale {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-hue-rotate {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-invert {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-opacity {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-saturate {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-sepia {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-drop-shadow {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-drop-shadow-color {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-drop-shadow-alpha {\n  syntax: "<percentage>";\n  inherits: false;\n  initial-value: 100%;\n}\n\n@property --tw-drop-shadow-size {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-blur {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-brightness {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-contrast {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-grayscale {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-hue-rotate {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-invert {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-opacity {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-saturate {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-backdrop-sepia {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-duration {\n  syntax: "*";\n  inherits: false\n}\n\n@property --tw-ease {\n  syntax: "*";\n  inherits: false\n}\n';
const tokens = {
  // Brand colors - Adventure Shop primary palette
  color: {
    // Neutral colors
    white: "#FFFFFF",
    black: "#000000",
    gray: {
      500: "#999999",
      700: "#444444",
      900: "#151415"
    }
  }
};
const colors = {
  // Gray scale - neutral colors for UI elements
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    // Used in counter text, borders
    600: "#4b5563",
    700: "#374151",
    // Used in checkbox checked state, labels
    800: "#1f2937",
    900: "#111827"
  },
  // Adventure Shop MT brand colors - inspired by outdoor/adventure theme
  brand: {
    // Warm earth tones inspired by adventure gear and nature
    sand: "#EED9C4",
    // Existing separator color - warm sandy beige
    sandDark: "#D4C0A4",
    // Darker variant for hover states
    // Mountain/forest greens for primary actions
    forest: "#2D5016",
    // Deep forest green
    forestLight: "#4A7C2A",
    // Lighter forest green
    // Adventure orange for accents and calls to action
    adventure: "#E67E22",
    // Warm adventure orange
    adventureLight: "#F39C12",
    // Lighter orange for hover
    // Sky blue for focus states and info
    sky: "#3498DB",
    // Clear sky blue
    skyLight: "#5DADE2"
    // Light sky blue
  },
  // Primary brand palette mapped to semantic use
  primary: {
    50: "#f0f8f4",
    100: "#dcf0e4",
    200: "#bce1cc",
    300: "#8cc9a8",
    400: "#5aab7f",
    500: "#4A7C2A",
    // Brand forest light
    600: "#2D5016",
    // Brand forest
    700: "#234012",
    800: "#1d330f",
    900: "#182a0d"
  },
  // Secondary palette - adventure orange
  secondary: {
    50: "#fef7ed",
    100: "#fdebd4",
    200: "#fad4a8",
    300: "#f6b671",
    400: "#F39C12",
    // Brand adventure light
    500: "#E67E22",
    // Brand adventure
    600: "#d45a0a",
    700: "#b1450a",
    800: "#8f370f",
    900: "#742e10"
  },
  // Semantic colors
  success: {
    500: "#4A7C2A",
    // Using brand forest light
    600: "#2D5016"
    // Using brand forest
  },
  warning: {
    500: "#F39C12",
    // Using brand adventure light
    600: "#E67E22"
    // Using brand adventure
  },
  error: {
    500: "#e74c3c",
    600: "#c0392b"
  },
  info: {
    500: "#3498DB",
    // Using brand sky
    600: "#2980B9"
  },
  // Background colors
  background: {
    primary: "#ffffff",
    secondary: "#f9fafb",
    tertiary: "#EED9C4",
    // Brand sand for subtle backgrounds
    overlay: "rgba(0, 0, 0, 0.4)",
    overlayLight: "rgba(0, 0, 0, 0.5)",
    overlayTransparent: "rgba(0, 0, 0, 0)",
    separator: "#EED9C4"
    // Brand sand for separators
  },
  // Border colors
  border: {
    default: "#6b7280",
    // Gray 500
    hover: "#374151",
    // Gray 700
    focus: "#3498DB",
    // Brand sky for focus states
    light: "#dddddd",
    brand: "#EED9C4"
    // Brand sand for branded borders
  },
  // Text colors
  text: {
    primary: "#111827",
    // Gray 900 for main text
    secondary: "#374151",
    // Gray 700 for secondary text
    tertiary: "#6b7280",
    // Gray 500 for muted text (counters)
    inverse: "#ffffff",
    // White text on dark backgrounds
    brand: "#2D5016"
    // Brand forest for branded text
  }
};
const typography = {
  // Font families
  fontFamily: {
    primary: '"Jost", sans-serif',
    mono: "'Fira Code', 'Monaco', 'Consolas', monospace"
  },
  // Font sizes - based on existing 14px usage in components
  fontSize: {
    xs: "12px",
    // Extra small
    sm: "14px",
    // Small - used in labels and counters
    base: "16px",
    // Base font size
    lg: "18px",
    // Large
    xl: "20px",
    // Extra large
    "2xl": "24px",
    // 2x large
    "3xl": "30px",
    // 3x large
    "4xl": "36px"
    // 4x large
  },
  // Font weights
  fontWeight: {
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700"
  },
  // Line heights - based on existing 1.4 usage
  lineHeight: {
    tight: "1.2",
    normal: "1.4",
    // Used in existing components
    relaxed: "1.6",
    loose: "1.8"
  },
  // Letter spacing
  letterSpacing: {
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em"
  }
};
const spacing = {
  // Semantic spacing scale based on gutter sizes
  none: "0",
  "gutter-xs": "4px",
  // Extra small gutter
  "gutter-sm": "8px",
  // Small gutter - used in existing margin-left
  "gutter-md": "12px",
  // Medium gutter
  "gutter-base": "16px",
  // Base gutter
  "gutter-lg": "20px",
  // Large gutter
  "gutter-xl": "24px",
  // Extra large gutter - used in existing checkbox size
  "gutter-2xl": "32px",
  // 2x large gutter
  "gutter-3xl": "40px",
  // 3x large gutter
  "gutter-4xl": "48px",
  // 4x large gutter
  "gutter-5xl": "64px",
  // 5x large gutter
  "gutter-6xl": "80px",
  // 6x large gutter
  "gutter-7xl": "96px",
  // 7x large gutter
  "gutter-8xl": "128px",
  // 8x large gutter
  "gutter-9xl": "160px",
  // 9x large gutter
  "gutter-10xl": "192px"
  // 10x large gutter
};
const borderRadius = {
  sm: "2px",
  md: "6px"
};
function safeCss(value) {
  return i$6`
        ${r$5(value)}
    `;
}
const typographyClasses = {
  "text-heading-1": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize["4xl"]};
        font-weight: ${typography.fontWeight.bold};
        line-height: ${typography.lineHeight.tight};
        letter-spacing: ${typography.letterSpacing.tight};
    `),
  "text-heading-2": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize["3xl"]};
        font-weight: ${typography.fontWeight.bold};
        line-height: ${typography.lineHeight.tight};
        letter-spacing: ${typography.letterSpacing.tight};
    `),
  "text-heading-3": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize["2xl"]};
        font-weight: ${typography.fontWeight.semibold};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.normal};
    `),
  "text-heading-4": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.xl};
        font-weight: ${typography.fontWeight.semibold};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.normal};
    `),
  "text-heading-5": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.lg};
        font-weight: ${typography.fontWeight.medium};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.normal};
    `),
  "text-body-1": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.base};
        font-weight: ${typography.fontWeight.normal};
        line-height: ${typography.lineHeight.relaxed};
        letter-spacing: ${typography.letterSpacing.normal};
    `),
  "text-body-2": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.sm};
        font-weight: ${typography.fontWeight.normal};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.normal};
    `),
  "text-caption": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.xs};
        font-weight: ${typography.fontWeight.normal};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.wide};
    `),
  "text-button": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.sm};
        font-weight: ${typography.fontWeight.medium};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.wide};
    `),
  "text-label": safeCss(`
        font-family: ${typography.fontFamily.primary};
        font-size: ${typography.fontSize.sm};
        font-weight: ${typography.fontWeight.medium};
        line-height: ${typography.lineHeight.tight};
        letter-spacing: ${typography.letterSpacing.wide};
    `),
  "text-code": safeCss(`
        font-family: ${typography.fontFamily.mono};
        font-size: ${typography.fontSize.sm};
        font-weight: ${typography.fontWeight.normal};
        line-height: ${typography.lineHeight.normal};
        letter-spacing: ${typography.letterSpacing.normal};
    `)
};
const baseStyles = safeCss(`
    :host {
      font-family: ${typography.fontFamily.primary};
      font-size: ${typography.fontSize.sm};
      line-height: ${typography.lineHeight.normal};
      color: ${colors.text.primary};
      box-sizing: border-box;
    }

    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }

    .accessibility-hidden-screen-reader {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
`);
const BaseDesignSystemComponent = (style = "") => class extends TailwindElement([baseStyles, typeof style === "string" ? safeCss(style) : style]) {
  /**
   * Utility method to access design tokens in components
   */
  get tokens() {
    return {
      colors,
      typography,
      spacing
    };
  }
};
const focusRing = safeCss(`
  outline: 2px solid ${colors.border.focus};
  outline-offset: 2px;
`);
safeCss(`
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`);
safeCss(`
  all: unset;
  cursor: pointer;
  user-select: none;
`);
safeCss(`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.sm};
  line-height: ${typography.lineHeight.normal};
  border-radius: ${borderRadius.sm};
  transition: all 0.2s ease;
  
  &:focus {
    ${focusRing}
  }
`);
const cssVariables = {
  /* Miscellaneous  */
  "page-content-max-width": "unset"
};
const tailwindElement = safeCss(tailwind);
const TailwindElement = (style) => {
  var _a2;
  return _a2 = class extends i$3 {
    constructor() {
      super();
    }
  }, _a2.styles = [
    tailwindElement,
    safeCss(style),
    safeCss(`
                :host {
                    font-family: "Jost";
                }
            `)
  ], _a2;
};
class BriffaToggleButton {
  constructor() {
    this.buttonNode = null;
  }
  initializeHtml() {
    const buttonNode = document.createElement("button");
    buttonNode.innerHTML = "Toggle button";
    this.buttonNode = buttonNode;
  }
  getHtml() {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1 = (t2) => (e2, o2) => {
  void 0 !== o2 ? o2.addInitializer(() => {
    customElements.define(t2, e2);
  }) : customElements.define(t2, e2);
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o$3 = { attribute: true, type: String, converter: u$3, reflect: false, hasChanged: f$2 }, r$2 = (t2 = o$3, e2, r2) => {
  const { kind: n3, metadata: i4 } = r2;
  let s2 = globalThis.litPropertyMetadata.get(i4);
  if (void 0 === s2 && globalThis.litPropertyMetadata.set(i4, s2 = /* @__PURE__ */ new Map()), "setter" === n3 && ((t2 = Object.create(t2)).wrapped = true), s2.set(r2.name, t2), "accessor" === n3) {
    const { name: o2 } = r2;
    return { set(r3) {
      const n4 = e2.get.call(this);
      e2.set.call(this, r3), this.requestUpdate(o2, n4, t2);
    }, init(e3) {
      return void 0 !== e3 && this.C(o2, void 0, t2, e3), e3;
    } };
  }
  if ("setter" === n3) {
    const { name: o2 } = r2;
    return function(r3) {
      const n4 = this[o2];
      e2.call(this, r3), this.requestUpdate(o2, n4, t2);
    };
  }
  throw Error("Unsupported decorator location: " + n3);
};
function n$1(t2) {
  return (e2, o2) => "object" == typeof o2 ? r$2(t2, e2, o2) : ((t3, e3, o3) => {
    const r2 = e3.hasOwnProperty(o3);
    return e3.constructor.createProperty(o3, t3), r2 ? Object.getOwnPropertyDescriptor(e3, o3) : void 0;
  })(t2, e2, o2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r$1(r2) {
  return n$1({ ...r2, state: true, attribute: false });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$6 = (e2, t2, c2) => (c2.configurable = true, c2.enumerable = true, Reflect.decorate && "object" != typeof t2 && Object.defineProperty(e2, t2, c2), c2);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function e$5(e2, r2) {
  return (n3, s2, i4) => {
    const o2 = (t2) => t2.renderRoot?.querySelector(e2) ?? null;
    return e$6(n3, s2, { get() {
      return o2(this);
    } });
  };
}
var SortByType = /* @__PURE__ */ ((SortByType2) => {
  SortByType2["RELEVANCE"] = "RELEVANCE";
  SortByType2["NA"] = "N/A";
  SortByType2["NEWEST"] = "NEWEST";
  SortByType2["OLDEST"] = "OLDEST";
  SortByType2["PRICE_ASCENDING"] = "PRICE_ASCENDING";
  SortByType2["PRICE_DESCENDING"] = "PRICE_DESCENDING";
  return SortByType2;
})(SortByType || {});
var SIZE_FILTER_MODE = /* @__PURE__ */ ((SIZE_FILTER_MODE2) => {
  SIZE_FILTER_MODE2["ALL_VALUES"] = "ALL_VALUES";
  SIZE_FILTER_MODE2["BY_CATEGORY"] = "BY_CATEGORY";
  return SIZE_FILTER_MODE2;
})(SIZE_FILTER_MODE || {});
var PRODUCT_VARIANT_FILTER_TYPE = /* @__PURE__ */ ((PRODUCT_VARIANT_FILTER_TYPE2) => {
  PRODUCT_VARIANT_FILTER_TYPE2["SIZE"] = "size";
  PRODUCT_VARIANT_FILTER_TYPE2["PRICE"] = "price";
  return PRODUCT_VARIANT_FILTER_TYPE2;
})(PRODUCT_VARIANT_FILTER_TYPE || {});
var PRODUCT_GENERAL_FILTER_TYPE = /* @__PURE__ */ ((PRODUCT_GENERAL_FILTER_TYPE2) => {
  PRODUCT_GENERAL_FILTER_TYPE2["GENDER"] = "gender";
  PRODUCT_GENERAL_FILTER_TYPE2["BRAND"] = "brand";
  PRODUCT_GENERAL_FILTER_TYPE2["CATEGORY"] = "category";
  PRODUCT_GENERAL_FILTER_TYPE2["CATEGORY_SIZE"] = "category-size";
  PRODUCT_GENERAL_FILTER_TYPE2["AVAILABILITY"] = "availability";
  return PRODUCT_GENERAL_FILTER_TYPE2;
})(PRODUCT_GENERAL_FILTER_TYPE || {});
({
  ...PRODUCT_VARIANT_FILTER_TYPE,
  ...PRODUCT_GENERAL_FILTER_TYPE
});
var ProductGender = /* @__PURE__ */ ((ProductGender2) => {
  ProductGender2["N/A"] = "N/A";
  ProductGender2["MEN"] = "Men";
  ProductGender2["WOMEN"] = "Women";
  ProductGender2["BOYS"] = "Boys";
  ProductGender2["GIRLS"] = "Girls";
  ProductGender2["KIDS"] = "Kids";
  ProductGender2["UNISEX"] = "Unisex";
  return ProductGender2;
})(ProductGender || {});
const accordionStyles = safeCss(`
    :host {
        display: block;
    }
    
    /* Style the wa-details component */
    .accordion-details {
        --transition-duration: 200ms;
    }
    
    /* Style the summary (header) area */
    .accordion-details::part(summary) {
        padding: 0;
        font-weight: normal;
    }
    
    /* Style the content area */
    .accordion-details::part(content) {
        padding: 0;
    }
    
    /* Custom summary content layout */
    .summary-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        cursor: pointer;
    }
    
    .titles {
        display: flex;
        gap: 0.5rem;
        align-items: center;
    }
    
    .title {
        margin: 0;
    }
    
    .subtitle {
        margin: 0;
    }
    
    .body {
        padding: 0;
        overflow-y: auto;
    }
    
    .collapsed-content {
        transition: max-height var(--transition-duration, 200ms), opacity calc(var(--transition-duration, 200ms) / 4);
        transition-delay: calc(var(--transition-duration, 200ms) / 4);
        overflow: hidden;
    }
    
    .collapsed-content.visible {
        max-height: 200px;
        overflow-y: auto;
        opacity: 1;
    }
    
    .collapsed-content.hidden {
        max-height: 0;
        opacity: 0;
    }
`);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaAfterHideEvent = class extends Event {
  constructor() {
    super("wa-after-hide", { bubbles: true, cancelable: false, composed: true });
  }
};
var WaAfterShowEvent = class extends Event {
  constructor() {
    super("wa-after-show", { bubbles: true, cancelable: false, composed: true });
  }
};
var WaHideEvent = class extends Event {
  constructor(detail) {
    super("wa-hide", { bubbles: true, cancelable: true, composed: true });
    this.detail = detail;
  }
};
var WaShowEvent = class extends Event {
  constructor() {
    super("wa-show", { bubbles: true, cancelable: true, composed: true });
  }
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var details_styles_default = i$6`
  :host {
    --spacing: var(--wa-space-m);
    --show-duration: 200ms;
    --hide-duration: 200ms;

    display: block;
  }

  details {
    display: block;
    overflow-anchor: none;
    border: var(--wa-panel-border-width) var(--wa-color-surface-border) var(--wa-panel-border-style);
    background-color: var(--wa-color-surface-default);
    border-radius: var(--wa-panel-border-radius);
    color: var(--wa-color-text-normal);

    /* Print styles */
    @media print {
      background: none;
      border: solid var(--wa-border-width-s) var(--wa-color-surface-border);

      summary {
        list-style: none;
      }
    }
  }

  /* Appearance modifiers */
  :host([appearance='plain']) details {
    background-color: transparent;
    border-color: transparent;
    border-radius: 0;
  }

  :host([appearance='outlined']) details {
    background-color: var(--wa-color-surface-default);
    border-color: var(--wa-color-surface-border);
  }

  :host([appearance='filled']) details {
    background-color: var(--wa-color-neutral-fill-quiet);
    border-color: transparent;
  }

  :host([appearance='filled-outlined']) details {
    background-color: var(--wa-color-neutral-fill-quiet);
    border-color: var(--wa-color-neutral-border-quiet);
  }

  :host([disabled]) details {
    opacity: 0.5;
    cursor: not-allowed;
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing);
    padding: var(--spacing); /* Add padding here */
    border-radius: calc(var(--wa-panel-border-radius) - var(--wa-panel-border-width));
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;

    &::marker,
    &::-webkit-details-marker {
      display: none;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: var(--wa-focus-ring);
      outline-offset: calc(var(--wa-panel-border-width) + var(--wa-focus-ring-offset));
    }
  }

  :host([open]) summary {
    border-end-start-radius: 0;
    border-end-end-radius: 0;
  }

  /* 'Start' icon placement */
  :host([icon-placement='start']) summary {
    flex-direction: row-reverse;
    justify-content: start;
  }

  [part~='icon'] {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    color: var(--wa-color-text-quiet);
    transition: rotate var(--wa-transition-normal) var(--wa-transition-easing);
  }

  :host([open]) [part~='icon'] {
    rotate: 90deg;
  }

  :host([open]:dir(rtl)) [part~='icon'] {
    rotate: -90deg;
  }

  :host([open]) slot[name='expand-icon'],
  :host(:not([open])) slot[name='collapse-icon'] {
    display: none;
  }

  .body.animating {
    overflow: hidden;
  }

  .content {
    display: block;
    padding-block-start: var(--spacing);
    padding-inline: var(--spacing); /* Add horizontal padding */
    padding-block-end: var(--spacing); /* Add bottom padding */
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function waitForEvent(el, eventName) {
  return new Promise((resolve) => {
    function done(event) {
      if (event.target === el) {
        el.removeEventListener(eventName, done);
        resolve();
      }
    }
    el.addEventListener(eventName, done);
  });
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
async function animate(el, keyframes, options) {
  return el.animate(keyframes, options).finished.catch(() => {
  });
}
function animateWithClass(el, className) {
  return new Promise((resolve) => {
    const controller = new AbortController();
    const { signal } = controller;
    if (el.classList.contains(className)) {
      return;
    }
    el.classList.remove(className);
    el.classList.add(className);
    let onEnd = () => {
      el.classList.remove(className);
      resolve();
      controller.abort();
    };
    el.addEventListener("animationend", onEnd, { once: true, signal });
    el.addEventListener("animationcancel", onEnd, { once: true, signal });
  });
}
function parseDuration(duration) {
  duration = duration.toString().toLowerCase();
  if (duration.indexOf("ms") > -1) {
    return parseFloat(duration) || 0;
  }
  if (duration.indexOf("s") > -1) {
    return (parseFloat(duration) || 0) * 1e3;
  }
  return parseFloat(duration) || 0;
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __typeError$s = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i4 = decorators.length - 1, decorator; i4 >= 0; i4--)
    if (decorator = decorators[i4])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$s(target, key, result);
  return result;
};
var __accessCheck$o = (obj, member, msg) => member.has(obj) || __typeError$s("Cannot " + msg);
var __privateGet$o = (obj, member, getter) => (__accessCheck$o(obj, member, "read from private field"), member.get(obj));
var __privateAdd$o = (obj, member, value) => member.has(obj) ? __typeError$s("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$o = (obj, member, value, setter) => (__accessCheck$o(obj, member, "write to private field"), member.set(obj, value), value);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var host_styles_default = i$6`
  :host {
    box-sizing: border-box !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit !important;
  }

  [hidden] {
    display: none !important;
  }
`;
var _hasRecordedInitialProperties;
var WebAwesomeElement = class extends i$3 {
  constructor() {
    super();
    __privateAdd$o(this, _hasRecordedInitialProperties, false);
    this.initialReflectedProperties = /* @__PURE__ */ new Map();
    this.didSSR = Boolean(this.shadowRoot);
    this.customStates = {
      /** Adds or removes the specified custom state. */
      set: (customState, active) => {
        if (!Boolean(this.internals?.states)) return;
        try {
          if (active) {
            this.internals.states.add(customState);
          } else {
            this.internals.states.delete(customState);
          }
        } catch (e2) {
          if (String(e2).includes("must start with '--'")) {
            console.error("Your browser implements an outdated version of CustomStateSet. Consider using a polyfill");
          } else {
            throw e2;
          }
        }
      },
      /** Determines whether or not the element currently has the specified state. */
      has: (customState) => {
        if (!Boolean(this.internals?.states)) return false;
        try {
          return this.internals.states.has(customState);
        } catch {
          return false;
        }
      }
    };
    try {
      this.internals = this.attachInternals();
    } catch {
      console.error("Element internals are not supported in your browser. Consider using a polyfill");
    }
    this.customStates.set("wa-defined", true);
    let Self = this.constructor;
    for (let [property2, spec] of Self.elementProperties) {
      if (spec.default === "inherit" && spec.initial !== void 0 && typeof property2 === "string") {
        this.customStates.set(`initial-${property2}-${spec.initial}`, true);
      }
    }
  }
  /** Prepends host styles to the component's styles. */
  static get styles() {
    const styles = Array.isArray(this.css) ? this.css : this.css ? [this.css] : [];
    return [host_styles_default, ...styles];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (!__privateGet$o(this, _hasRecordedInitialProperties)) {
      this.constructor.elementProperties.forEach(
        (obj, prop) => {
          if (obj.reflect && this[prop] != null) {
            this.initialReflectedProperties.set(prop, this[prop]);
          }
        }
      );
      __privateSet$o(this, _hasRecordedInitialProperties, true);
    }
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.initialReflectedProperties.forEach((value, prop) => {
      if (changedProperties.has(prop) && this[prop] == null) {
        this[prop] = value;
      }
    });
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (this.didSSR) {
      this.shadowRoot?.querySelectorAll("slot").forEach((slotElement) => {
        slotElement.dispatchEvent(new Event("slotchange", { bubbles: true, composed: false, cancelable: false }));
      });
    }
  }
  update(changedProperties) {
    try {
      super.update(changedProperties);
    } catch (e2) {
      if (this.didSSR && !this.hasUpdated) {
        const event = new Event("lit-hydration-error", { bubbles: true, composed: true, cancelable: false });
        event.error = e2;
        this.dispatchEvent(event);
      }
      throw e2;
    }
  }
  /**
   * Given a native event, this function cancels it and dispatches it again from the host element using the desired
   * event options.
   */
  relayNativeEvent(event, eventOptions) {
    event.stopImmediatePropagation();
    this.dispatchEvent(
      new event.constructor(event.type, {
        ...event,
        ...eventOptions
      })
    );
  }
};
_hasRecordedInitialProperties = /* @__PURE__ */ new WeakMap();
__decorateClass([
  n$1()
], WebAwesomeElement.prototype, "dir", 2);
__decorateClass([
  n$1()
], WebAwesomeElement.prototype, "lang", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true, attribute: "did-ssr" })
], WebAwesomeElement.prototype, "didSSR", 2);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaInvalidEvent = class extends Event {
  constructor() {
    super("wa-invalid", { bubbles: true, cancelable: false, composed: true });
  }
};
var CustomErrorValidator = () => {
  return {
    observedAttributes: ["custom-error"],
    checkValidity(element) {
      const validity = {
        message: "",
        isValid: true,
        invalidKeys: []
      };
      if (element.customError) {
        validity.message = element.customError;
        validity.isValid = false;
        validity.invalidKeys = ["customError"];
      }
      return validity;
    }
  };
};
var WebAwesomeFormAssociatedElement = class extends WebAwesomeElement {
  constructor() {
    super();
    this.name = null;
    this.disabled = false;
    this.required = false;
    this.assumeInteractionOn = ["input"];
    this.validators = [];
    this.valueHasChanged = false;
    this.hasInteracted = false;
    this.customError = null;
    this.emittedEvents = [];
    this.emitInvalid = (e2) => {
      if (e2.target !== this) return;
      this.hasInteracted = true;
      this.dispatchEvent(new WaInvalidEvent());
    };
    this.handleInteraction = (event) => {
      const emittedEvents = this.emittedEvents;
      if (!emittedEvents.includes(event.type)) {
        emittedEvents.push(event.type);
      }
      if (emittedEvents.length === this.assumeInteractionOn?.length) {
        this.hasInteracted = true;
      }
    };
    {
      this.addEventListener("invalid", this.emitInvalid);
    }
  }
  /**
   * Validators are static because they have `observedAttributes`, essentially attributes to "watch"
   * for changes. Whenever these attributes change, we want to be notified and update the validator.
   */
  static get validators() {
    return [CustomErrorValidator()];
  }
  // Append all Validator "observedAttributes" into the "observedAttributes" so they can run.
  static get observedAttributes() {
    const parentAttrs = new Set(super.observedAttributes || []);
    for (const validator of this.validators) {
      if (!validator.observedAttributes) {
        continue;
      }
      for (const attr of validator.observedAttributes) {
        parentAttrs.add(attr);
      }
    }
    return [...parentAttrs];
  }
  connectedCallback() {
    super.connectedCallback();
    this.updateValidity();
    this.assumeInteractionOn.forEach((event) => {
      this.addEventListener(event, this.handleInteraction);
    });
  }
  firstUpdated(...args) {
    super.firstUpdated(...args);
    this.updateValidity();
  }
  willUpdate(changedProperties) {
    if (changedProperties.has("customError")) {
      if (!this.customError) {
        this.customError = null;
      }
      this.setCustomValidity(this.customError || "");
    }
    if (changedProperties.has("value") || changedProperties.has("disabled")) {
      const value = this.value;
      if (Array.isArray(value)) {
        if (this.name) {
          const formData = new FormData();
          for (const val of value) {
            formData.append(this.name, val);
          }
          this.setValue(formData, formData);
        }
      } else {
        this.setValue(value, value);
      }
    }
    if (changedProperties.has("disabled")) {
      this.customStates.set("disabled", this.disabled);
      if (this.hasAttribute("disabled") || !this.matches(":disabled")) {
        this.toggleAttribute("disabled", this.disabled);
      }
    }
    this.updateValidity();
    super.willUpdate(changedProperties);
  }
  get labels() {
    return this.internals.labels;
  }
  getForm() {
    return this.internals.form;
  }
  /**
   * By default, form controls are associated with the nearest containing `<form>` element. This attribute allows you
   * to place the form control outside of a form and associate it with the form that has this `id`. The form must be in
   * the same document or shadow root for this to work.
   */
  set form(val) {
    if (val) {
      this.setAttribute("form", val);
    } else {
      this.removeAttribute("form");
    }
  }
  get form() {
    return this.internals.form;
  }
  get validity() {
    return this.internals.validity;
  }
  // Not sure if this supports `novalidate`. Will need to test.
  get willValidate() {
    return this.internals.willValidate;
  }
  get validationMessage() {
    return this.internals.validationMessage;
  }
  checkValidity() {
    this.updateValidity();
    return this.internals.checkValidity();
  }
  reportValidity() {
    this.updateValidity();
    this.hasInteracted = true;
    return this.internals.reportValidity();
  }
  /**
   * Override this to change where constraint validation popups are anchored.
   */
  get validationTarget() {
    return this.input || void 0;
  }
  setValidity(...args) {
    const flags = args[0];
    const message = args[1];
    let anchor = args[2];
    if (!anchor) {
      anchor = this.validationTarget;
    }
    this.internals.setValidity(flags, message, anchor || void 0);
    this.requestUpdate("validity");
    this.setCustomStates();
  }
  setCustomStates() {
    const required = Boolean(this.required);
    const isValid = this.internals.validity.valid;
    const hasInteracted = this.hasInteracted;
    this.customStates.set("required", required);
    this.customStates.set("optional", !required);
    this.customStates.set("invalid", !isValid);
    this.customStates.set("valid", isValid);
    this.customStates.set("user-invalid", !isValid && hasInteracted);
    this.customStates.set("user-valid", isValid && hasInteracted);
  }
  /**
   * Do not use this when creating a "Validator". This is intended for end users of components.
   * We track manually defined custom errors so we don't clear them on accident in our validators.
   *
   */
  setCustomValidity(message) {
    if (!message) {
      this.customError = null;
      this.setValidity({});
      return;
    }
    this.customError = message;
    this.setValidity({ customError: true }, message, this.validationTarget);
  }
  formResetCallback() {
    this.resetValidity();
    this.hasInteracted = false;
    this.valueHasChanged = false;
    this.emittedEvents = [];
    this.updateValidity();
  }
  formDisabledCallback(isDisabled) {
    this.disabled = isDisabled;
    this.updateValidity();
  }
  /**
   * Called when the browser is trying to restore element’s state to state in which case reason is "restore", or when
   * the browser is trying to fulfill autofill on behalf of user in which case reason is "autocomplete". In the case of
   * "restore", state is a string, File, or FormData object previously set as the second argument to setFormValue.
   */
  formStateRestoreCallback(state, reason) {
    this.value = state;
    if (reason === "restore") {
      this.resetValidity();
    }
    this.updateValidity();
  }
  setValue(...args) {
    const [value, state] = args;
    this.internals.setFormValue(value, state);
  }
  get allValidators() {
    const staticValidators = this.constructor.validators || [];
    const validators = this.validators || [];
    return [...staticValidators, ...validators];
  }
  /**
   * Reset validity is a way of removing manual custom errors and native validation.
   */
  resetValidity() {
    this.setCustomValidity("");
    this.setValidity({});
  }
  updateValidity() {
    if (this.disabled || this.hasAttribute("disabled") || !this.willValidate) {
      this.resetValidity();
      return;
    }
    const validators = this.allValidators;
    if (!validators?.length) {
      return;
    }
    const flags = {
      // Don't trust custom errors from the Browser. Safari breaks the spec.
      customError: Boolean(this.customError)
    };
    const formControl = this.validationTarget || this.input || void 0;
    let finalMessage = "";
    for (const validator of validators) {
      const { isValid, message, invalidKeys } = validator.checkValidity(this);
      if (isValid) {
        continue;
      }
      if (!finalMessage) {
        finalMessage = message;
      }
      if (invalidKeys?.length >= 0) {
        invalidKeys.forEach((str) => flags[str] = true);
      }
    }
    if (!finalMessage) {
      finalMessage = this.validationMessage;
    }
    this.setValidity(flags, finalMessage, formControl);
  }
};
WebAwesomeFormAssociatedElement.formAssociated = true;
__decorateClass([
  n$1({ reflect: true })
], WebAwesomeFormAssociatedElement.prototype, "name", 2);
__decorateClass([
  n$1({ type: Boolean })
], WebAwesomeFormAssociatedElement.prototype, "disabled", 2);
__decorateClass([
  n$1({ state: true, attribute: false })
], WebAwesomeFormAssociatedElement.prototype, "valueHasChanged", 2);
__decorateClass([
  n$1({ state: true, attribute: false })
], WebAwesomeFormAssociatedElement.prototype, "hasInteracted", 2);
__decorateClass([
  n$1({ attribute: "custom-error", reflect: true })
], WebAwesomeFormAssociatedElement.prototype, "customError", 2);
__decorateClass([
  n$1({ attribute: false, state: true, type: Object })
], WebAwesomeFormAssociatedElement.prototype, "validity", 1);
const connectedElements = /* @__PURE__ */ new Set();
const translations = /* @__PURE__ */ new Map();
let fallback;
let documentDirection = "ltr";
let documentLanguage = "en";
const isClient = typeof MutationObserver !== "undefined" && typeof document !== "undefined" && typeof document.documentElement !== "undefined";
if (isClient) {
  const documentElementObserver = new MutationObserver(update);
  documentDirection = document.documentElement.dir || "ltr";
  documentLanguage = document.documentElement.lang || navigator.language;
  documentElementObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["dir", "lang"]
  });
}
function registerTranslation(...translation2) {
  translation2.map((t2) => {
    const code = t2.$code.toLowerCase();
    if (translations.has(code)) {
      translations.set(code, Object.assign(Object.assign({}, translations.get(code)), t2));
    } else {
      translations.set(code, t2);
    }
    if (!fallback) {
      fallback = t2;
    }
  });
  update();
}
function update() {
  if (isClient) {
    documentDirection = document.documentElement.dir || "ltr";
    documentLanguage = document.documentElement.lang || navigator.language;
  }
  [...connectedElements.keys()].map((el) => {
    if (typeof el.requestUpdate === "function") {
      el.requestUpdate();
    }
  });
}
let LocalizeController$1 = class LocalizeController {
  constructor(host) {
    this.host = host;
    this.host.addController(this);
  }
  hostConnected() {
    connectedElements.add(this.host);
  }
  hostDisconnected() {
    connectedElements.delete(this.host);
  }
  dir() {
    return `${this.host.dir || documentDirection}`.toLowerCase();
  }
  lang() {
    return `${this.host.lang || documentLanguage}`.toLowerCase();
  }
  getTranslationData(lang) {
    var _a2, _b;
    const locale = new Intl.Locale(lang.replace(/_/g, "-"));
    const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
    const region = (_b = (_a2 = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a2 === void 0 ? void 0 : _a2.toLowerCase()) !== null && _b !== void 0 ? _b : "";
    const primary = translations.get(`${language}-${region}`);
    const secondary = translations.get(language);
    return { locale, language, region, primary, secondary };
  }
  exists(key, options) {
    var _a2;
    const { primary, secondary } = this.getTranslationData((_a2 = options.lang) !== null && _a2 !== void 0 ? _a2 : this.lang());
    options = Object.assign({ includeFallback: false }, options);
    if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && fallback && fallback[key]) {
      return true;
    }
    return false;
  }
  term(key, ...args) {
    const { primary, secondary } = this.getTranslationData(this.lang());
    let term;
    if (primary && primary[key]) {
      term = primary[key];
    } else if (secondary && secondary[key]) {
      term = secondary[key];
    } else if (fallback && fallback[key]) {
      term = fallback[key];
    } else {
      console.error(`No translation found for: ${String(key)}`);
      return String(key);
    }
    if (typeof term === "function") {
      return term(...args);
    }
    return term;
  }
  date(dateToFormat, options) {
    dateToFormat = new Date(dateToFormat);
    return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
  }
  number(numberToFormat, options) {
    numberToFormat = Number(numberToFormat);
    return isNaN(numberToFormat) ? "" : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
  }
  relativeTime(value, unit, options) {
    return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
  }
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var translation = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  carousel: "Carousel",
  clearEntry: "Clear entry",
  close: "Close",
  copied: "Copied",
  copy: "Copy",
  currentValue: "Current value",
  error: "Error",
  goToSlide: (slide, count) => `Go to slide ${slide} of ${count}`,
  hidePassword: "Hide password",
  loading: "Loading",
  nextSlide: "Next slide",
  numOptionsSelected: (num) => {
    if (num === 0) return "No options selected";
    if (num === 1) return "1 option selected";
    return `${num} options selected`;
  },
  pauseAnimation: "Pause animation",
  playAnimation: "Play animation",
  previousSlide: "Previous slide",
  progress: "Progress",
  remove: "Remove",
  resize: "Resize",
  scrollableRegion: "Scrollable region",
  scrollToEnd: "Scroll to end",
  scrollToStart: "Scroll to start",
  selectAColorFromTheScreen: "Select a color from the screen",
  showPassword: "Show password",
  slideNum: (slide) => `Slide ${slide}`,
  toggleColorFormat: "Toggle color format",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out"
};
registerTranslation(translation);
var en_default = translation;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var LocalizeController2 = class extends LocalizeController$1 {
};
registerTranslation(en_default);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function watch(propertyName, options) {
  const resolvedOptions = {
    waitUntilFirstUpdate: false,
    ...options
  };
  return (proto, decoratedFnName) => {
    const { update: update2 } = proto;
    const watchedProperties = Array.isArray(propertyName) ? propertyName : [propertyName];
    proto.update = function(changedProps) {
      watchedProperties.forEach((property) => {
        const key = property;
        if (changedProps.has(key)) {
          const oldValue = changedProps.get(key);
          const newValue = this[key];
          if (oldValue !== newValue) {
            if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) {
              this[decoratedFnName](oldValue, newValue);
            }
          }
        }
      });
      update2.call(this, changedProps);
    };
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4 }, e$4 = (t2) => (...e2) => ({ _$litDirective$: t2, values: e2 });
let i$2 = class i2 {
  constructor(t2) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t2, e2, i4) {
    this._$Ct = t2, this._$AM = e2, this._$Ci = i4;
  }
  _$AS(t2, e2) {
    return this.update(t2, e2);
  }
  update(t2, e2) {
    return this.render(...e2);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$3 = e$4(class extends i$2 {
  constructor(t$12) {
    if (super(t$12), t$12.type !== t.ATTRIBUTE || "class" !== t$12.name || t$12.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(t2) {
    return " " + Object.keys(t2).filter((s2) => t2[s2]).join(" ") + " ";
  }
  update(s2, [i4]) {
    if (void 0 === this.st) {
      this.st = /* @__PURE__ */ new Set(), void 0 !== s2.strings && (this.nt = new Set(s2.strings.join(" ").split(/\s/).filter((t2) => "" !== t2)));
      for (const t2 in i4) i4[t2] && !this.nt?.has(t2) && this.st.add(t2);
      return this.render(i4);
    }
    const r2 = s2.element.classList;
    for (const t2 of this.st) t2 in i4 || (r2.remove(t2), this.st.delete(t2));
    for (const t2 in i4) {
      const s3 = !!i4[t2];
      s3 === this.st.has(t2) || this.nt?.has(t2) || (s3 ? (r2.add(t2), this.st.add(t2)) : (r2.remove(t2), this.st.delete(t2)));
    }
    return T;
  }
});
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaDetails = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController2(this);
    this.isAnimating = false;
    this.open = false;
    this.disabled = false;
    this.appearance = "outlined";
    this.iconPlacement = "end";
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.detailsObserver?.disconnect();
  }
  firstUpdated() {
    this.body.style.height = this.open ? "auto" : "0";
    if (this.open) {
      this.details.open = true;
    }
    this.detailsObserver = new MutationObserver((changes) => {
      for (const change of changes) {
        if (change.type === "attributes" && change.attributeName === "open") {
          if (this.details.open) {
            this.show();
          } else {
            this.hide();
          }
        }
      }
    });
    this.detailsObserver.observe(this.details, { attributes: true });
  }
  updated(changedProperties) {
    if (changedProperties.has("isAnimating")) {
      this.customStates.set("animating", this.isAnimating);
    }
  }
  handleSummaryClick(event) {
    const eventPath = event.composedPath();
    const hasInteractiveElement = eventPath.some((element) => {
      if (!(element instanceof HTMLElement)) return false;
      const tagName = element.tagName?.toLowerCase();
      if (["a", "button", "input", "textarea", "select"].includes(tagName)) {
        return true;
      }
      if (element instanceof WebAwesomeFormAssociatedElement) {
        return !("disabled" in element) || !element.disabled;
      }
      return false;
    });
    if (hasInteractiveElement) {
      return;
    }
    event.preventDefault();
    if (!this.disabled) {
      if (this.open) {
        this.hide();
      } else {
        this.show();
      }
      this.header.focus();
    }
  }
  handleSummaryKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (this.open) {
        this.hide();
      } else {
        this.show();
      }
    }
    if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
      event.preventDefault();
      this.hide();
    }
    if (event.key === "ArrowDown" || event.key === "ArrowRight") {
      event.preventDefault();
      this.show();
    }
  }
  /** Closes other <wa-details> elements in the same document when they have the same name. */
  closeOthersWithSameName() {
    if (!this.name) return;
    const root = this.getRootNode();
    const otherDetails = root.querySelectorAll(`wa-details[name="${this.name}"]`);
    otherDetails.forEach((detail) => {
      if (detail !== this && detail.open) {
        detail.open = false;
      }
    });
  }
  async handleOpenChange() {
    if (this.open) {
      this.details.open = true;
      const waShow = new WaShowEvent();
      this.dispatchEvent(waShow);
      if (waShow.defaultPrevented) {
        this.open = false;
        this.details.open = false;
        return;
      }
      this.closeOthersWithSameName();
      this.isAnimating = true;
      const duration = parseDuration(getComputedStyle(this.body).getPropertyValue("--show-duration"));
      await animate(
        this.body,
        [
          { height: "0", opacity: "0" },
          { height: `${this.body.scrollHeight}px`, opacity: "1" }
        ],
        {
          duration,
          easing: "linear"
        }
      );
      this.body.style.height = "auto";
      this.isAnimating = false;
      this.dispatchEvent(new WaAfterShowEvent());
    } else {
      const waHide = new WaHideEvent();
      this.dispatchEvent(waHide);
      if (waHide.defaultPrevented) {
        this.details.open = true;
        this.open = true;
        return;
      }
      this.isAnimating = true;
      const duration = parseDuration(getComputedStyle(this.body).getPropertyValue("--hide-duration"));
      await animate(
        this.body,
        [
          { height: `${this.body.scrollHeight}px`, opacity: "1" },
          { height: "0", opacity: "0" }
        ],
        { duration, easing: "linear" }
      );
      this.body.style.height = "auto";
      this.isAnimating = false;
      this.details.open = false;
      this.dispatchEvent(new WaAfterHideEvent());
    }
  }
  /** Shows the details. */
  async show() {
    if (this.open || this.disabled) {
      return void 0;
    }
    this.open = true;
    return waitForEvent(this, "wa-after-show");
  }
  /** Hides the details */
  async hide() {
    if (!this.open || this.disabled) {
      return void 0;
    }
    this.open = false;
    return waitForEvent(this, "wa-after-hide");
  }
  render() {
    const isRtl = !this.hasUpdated ? this.dir === "rtl" : this.localize.dir() === "rtl";
    return x`
      <details part="base">
        <summary
          part="header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary">${this.summary}</slot>

          <span part="icon">
            <slot name="expand-icon">
              <wa-icon library="system" variant="solid" name=${isRtl ? "chevron-left" : "chevron-right"}></wa-icon>
            </slot>
            <slot name="collapse-icon">
              <wa-icon library="system" variant="solid" name=${isRtl ? "chevron-left" : "chevron-right"}></wa-icon>
            </slot>
          </span>
        </summary>

        <div
          class=${e$3({
      body: true,
      animating: this.isAnimating
    })}
          role="region"
          aria-labelledby="header"
        >
          <slot part="content" id="content" class="content"></slot>
        </div>
      </details>
    `;
  }
};
WaDetails.css = details_styles_default;
__decorateClass([
  e$5("details")
], WaDetails.prototype, "details", 2);
__decorateClass([
  e$5("summary")
], WaDetails.prototype, "header", 2);
__decorateClass([
  e$5(".body")
], WaDetails.prototype, "body", 2);
__decorateClass([
  e$5(".expand-icon-slot")
], WaDetails.prototype, "expandIconSlot", 2);
__decorateClass([
  r$1()
], WaDetails.prototype, "isAnimating", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaDetails.prototype, "open", 2);
__decorateClass([
  n$1()
], WaDetails.prototype, "summary", 2);
__decorateClass([
  n$1({ reflect: true })
], WaDetails.prototype, "name", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaDetails.prototype, "disabled", 2);
__decorateClass([
  n$1({ reflect: true })
], WaDetails.prototype, "appearance", 2);
__decorateClass([
  n$1({ attribute: "icon-placement", reflect: true })
], WaDetails.prototype, "iconPlacement", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], WaDetails.prototype, "handleOpenChange", 1);
WaDetails = __decorateClass([
  t$1("wa-details")
], WaDetails);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaLoadEvent = class extends Event {
  constructor() {
    super("wa-load", { bubbles: true, cancelable: false, composed: true });
  }
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var icon_styles_default = i$6`
  :host {
    --primary-color: currentColor;
    --primary-opacity: 1;
    --secondary-color: currentColor;
    --secondary-opacity: 0.4;

    box-sizing: content-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: -0.125em;
  }

  /* Standard */
  :host(:not([auto-width])) {
    width: 1.25em;
    height: 1em;
  }

  /* Auto-width */
  :host([auto-width]) {
    width: auto;
    height: 1em;
  }

  svg {
    height: 1em;
    overflow: visible;

    /* Duotone colors with path-specific opacity fallback */
    path[data-duotone-primary] {
      color: var(--primary-color);
      opacity: var(--path-opacity, var(--primary-opacity));
    }

    path[data-duotone-secondary] {
      color: var(--secondary-color);
      opacity: var(--path-opacity, var(--secondary-opacity));
    }
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function dataUri(svg) {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
var icons = {
  //
  // Solid variant
  //
  solid: {
    check: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"/></svg>`,
    "chevron-down": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>`,
    "chevron-left": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>`,
    "chevron-right": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M311.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L243.2 256 73.9 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>`,
    circle: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"/></svg>`,
    eyedropper: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M341.6 29.2l-101.6 101.6-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.6-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4-26.6 39.9c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4l39.9-26.6 42.4 0c21.2 0 41.6-8.4 56.6-23.4l109.4-109.4-45.3-45.3-109.4 109.4c-3 3-7.1 4.7-11.3 4.7l-36.1 0 0-36.1c0-4.2 1.7-8.3 4.7-11.3l109.4-109.4-45.3-45.3-109.4 109.4z"/></svg>`,
    "grip-vertical": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M128 40c0-22.1-17.9-40-40-40L40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zM0 424l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM320 40c0-22.1-17.9-40-40-40L232 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zM192 232l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM320 424c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z"/></svg>`,
    indeterminate: `<svg part="indeterminate-icon" class="icon" viewBox="0 0 16 16"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g stroke="currentColor" stroke-width="2"><g transform="translate(2.285714 6.857143)"><path d="M10.2857143,1.14285714 L1.14285714,1.14285714"/></g></g></g></svg>`,
    minus: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z"/></svg>`,
    pause: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 32zm224 0c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0z"/></svg>`,
    play: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M91.2 36.9c-12.4-6.8-27.4-6.5-39.6 .7S32 57.9 32 72l0 368c0 14.1 7.5 27.2 19.6 34.4s27.2 7.5 39.6 .7l336-184c12.8-7 20.8-20.5 20.8-35.1s-8-28.1-20.8-35.1l-336-184z"/></svg>`,
    star: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1s-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9z"/></svg>`,
    user: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3l-59.4 0z"/></svg>`,
    xmark: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z"/></svg>`
  },
  //
  // Regular variant
  //
  regular: {
    "circle-question": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-80c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>`,
    "circle-xmark": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>`,
    copy: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l58.5 58.5c3 3 4.7 7.1 4.7 11.3L400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-197.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-48 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0 0-48-16 0z"/></svg>`,
    eye: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M288 80C222.8 80 169.2 109.6 128.1 147.7 89.6 183.5 63 226 49.4 256 63 286 89.6 328.5 128.1 364.3 169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256 513 226 486.4 183.5 447.9 147.7 406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1-47.1 43.7-111.8 80.6-192.6 80.6S142.5 443.2 95.4 399.4c-46.8-43.5-78.1-95.4-93-131.1-3.3-7.9-3.3-16.7 0-24.6 14.9-35.7 46.2-87.7 93-131.1zM288 336c44.2 0 80-35.8 80-80 0-29.6-16.1-55.5-40-69.3-1.4 59.7-49.6 107.9-109.3 109.3 13.8 23.9 39.7 40 69.3 40zm-79.6-88.4c2.5 .3 5 .4 7.6 .4 35.3 0 64-28.7 64-64 0-2.6-.2-5.1-.4-7.6-37.4 3.9-67.2 33.7-71.1 71.1zm45.6-115c10.8-3 22.2-4.5 33.9-4.5 8.8 0 17.5 .9 25.8 2.6 .3 .1 .5 .1 .8 .2 57.9 12.2 101.4 63.7 101.4 125.2 0 70.7-57.3 128-128 128-61.6 0-113-43.5-125.2-101.4-1.8-8.6-2.8-17.5-2.8-26.6 0-11 1.4-21.8 4-32 .2-.7 .3-1.3 .5-1.9 11.9-43.4 46.1-77.6 89.5-89.5z"/></svg>`,
    "eye-slash": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.4-96.4c2.7-2.4 5.4-4.8 8-7.2 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-56.8 0-105.6 18.2-146 44.2L41-24.9zM176.9 111.1c32.1-18.9 69.2-31.1 111.1-31.1 65.2 0 118.8 29.6 159.9 67.7 38.5 35.7 65.1 78.3 78.6 108.3-13.6 30-40.2 72.5-78.6 108.3-3.1 2.8-6.2 5.6-9.4 8.4L393.8 328c14-20.5 22.2-45.3 22.2-72 0-70.7-57.3-128-128-128-26.7 0-51.5 8.2-72 22.2l-39.1-39.1zm182 182l-108-108c11.1-5.8 23.7-9.1 37.1-9.1 44.2 0 80 35.8 80 80 0 13.4-3.3 26-9.1 37.1zM103.4 173.2l-34-34c-32.6 36.8-55 75.8-66.9 104.5-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 37.3 0 71.2-7.9 101.5-20.6L352.2 422c-20 6.4-41.4 10-64.2 10-65.2 0-118.8-29.6-159.9-67.7-38.5-35.7-65.1-78.3-78.6-108.3 10.4-23.1 28.6-53.6 54-82.8z"/></svg>`,
    star: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. --><path fill="currentColor" d="M288.1-32c9 0 17.3 5.1 21.4 13.1L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2s-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2c4.1-8 12.4-13.1 21.4-13.1zm0 76.8L230.3 158c-3.5 6.8-10 11.6-17.6 12.8l-125.5 20 89.8 89.9c5.4 5.4 7.9 13.1 6.7 20.7l-19.8 125.5 113.3-57.6c6.8-3.5 14.9-3.5 21.8 0l113.3 57.6-19.8-125.5c-1.2-7.6 1.3-15.3 6.7-20.7l89.8-89.9-125.5-20c-7.6-1.2-14.1-6-17.6-12.8L288.1 44.8z"/></svg>`
  }
};
var systemLibrary = {
  name: "system",
  resolver: (name, _family = "classic", variant = "solid") => {
    let collection = icons[variant];
    let svg = collection[name] ?? icons.regular[name] ?? icons.regular["circle-question"];
    if (svg) {
      return dataUri(svg);
    }
    return "";
  }
};
var library_system_default = systemLibrary;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var kitCode = "";
function setKitCode(code) {
  kitCode = code;
}
function getKitCode() {
  if (!kitCode) {
    const el = document.querySelector("[data-fa-kit-code]");
    if (el) {
      setKitCode(el.getAttribute("data-fa-kit-code") || "");
    }
  }
  return kitCode;
}
var FA_VERSION = "7.0.1";
function getIconUrl(name, family, variant) {
  const kitCode2 = getKitCode();
  const isPro = kitCode2.length > 0;
  let folder = "solid";
  if (family === "notdog") {
    if (variant === "solid") folder = "solid";
    if (variant === "duo-solid") folder = "duo-solid";
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/notdog-${folder}/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "chisel") {
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/chisel-regular/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "etch") {
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/etch-solid/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "jelly") {
    if (variant === "regular") folder = "regular";
    if (variant === "duo-regular") folder = "duo-regular";
    if (variant === "fill-regular") folder = "fill-regular";
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/jelly-${folder}/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "slab") {
    if (variant === "solid" || variant === "regular") folder = "regular";
    if (variant === "press-regular") folder = "press-regular";
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/slab-${folder}/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "thumbprint") {
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/thumbprint-light/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "whiteboard") {
    return `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/whiteboard-semibold/${name}.svg?token=${encodeURIComponent(kitCode2)}`;
  }
  if (family === "classic") {
    if (variant === "thin") folder = "thin";
    if (variant === "light") folder = "light";
    if (variant === "regular") folder = "regular";
    if (variant === "solid") folder = "solid";
  }
  if (family === "sharp") {
    if (variant === "thin") folder = "sharp-thin";
    if (variant === "light") folder = "sharp-light";
    if (variant === "regular") folder = "sharp-regular";
    if (variant === "solid") folder = "sharp-solid";
  }
  if (family === "duotone") {
    if (variant === "thin") folder = "duotone-thin";
    if (variant === "light") folder = "duotone-light";
    if (variant === "regular") folder = "duotone-regular";
    if (variant === "solid") folder = "duotone";
  }
  if (family === "sharp-duotone") {
    if (variant === "thin") folder = "sharp-duotone-thin";
    if (variant === "light") folder = "sharp-duotone-light";
    if (variant === "regular") folder = "sharp-duotone-regular";
    if (variant === "solid") folder = "sharp-duotone-solid";
  }
  if (family === "brands") {
    folder = "brands";
  }
  return isPro ? `https://ka-p.fontawesome.com/releases/v${FA_VERSION}/svgs/${folder}/${name}.svg?token=${encodeURIComponent(kitCode2)}` : `https://ka-f.fontawesome.com/releases/v${FA_VERSION}/svgs/${folder}/${name}.svg`;
}
var library = {
  name: "default",
  resolver: (name, family = "classic", variant = "solid") => {
    return getIconUrl(name, family, variant);
  },
  mutator: (svg, hostEl) => {
    if (hostEl?.family && !svg.hasAttribute("data-duotone-initialized")) {
      const { family, variant } = hostEl;
      if (
        // Duotone
        family === "duotone" || // Sharp duotone
        family === "sharp-duotone" || // Notdog duo-solid
        family === "notdog" && variant === "duo-solid" || // Jelly duo-regular
        family === "jelly" && variant === "duo-regular" || // Thumbprint
        family === "thumbprint"
      ) {
        const paths = [...svg.querySelectorAll("path")];
        const primaryPath = paths.find((p2) => !p2.hasAttribute("opacity"));
        const secondaryPath = paths.find((p2) => p2.hasAttribute("opacity"));
        if (!primaryPath || !secondaryPath) return;
        primaryPath.setAttribute("data-duotone-primary", "");
        secondaryPath.setAttribute("data-duotone-secondary", "");
        if (hostEl.swapOpacity && primaryPath && secondaryPath) {
          const originalOpacity = secondaryPath.getAttribute("opacity") || "0.4";
          primaryPath.style.setProperty("--path-opacity", originalOpacity);
          secondaryPath.style.setProperty("--path-opacity", "1");
        }
        svg.setAttribute("data-duotone-initialized", "");
      }
    }
  }
};
var library_default_default = library;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var defaultIconFamily = "classic";
var registry = [library_default_default, library_system_default];
var watchedIcons = [];
function watchIcon(icon) {
  watchedIcons.push(icon);
}
function unwatchIcon(icon) {
  watchedIcons = watchedIcons.filter((el) => el !== icon);
}
function getIconLibrary(name) {
  return registry.find((lib) => lib.name === name);
}
function getDefaultIconFamily() {
  return defaultIconFamily;
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$2 = (o2, t2) => void 0 !== o2?._$litType$, f = (o2) => void 0 === o2.strings, u$1 = {}, m = (o2, t2 = u$1) => o2._$AH = t2;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaErrorEvent = class extends Event {
  constructor() {
    super("wa-error", { bubbles: true, cancelable: false, composed: true });
  }
};
var CACHEABLE_ERROR = Symbol();
var RETRYABLE_ERROR = Symbol();
var parser;
var iconCache = /* @__PURE__ */ new Map();
var WaIcon = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.svg = null;
    this.autoWidth = false;
    this.swapOpacity = false;
    this.label = "";
    this.library = "default";
    this.resolveIcon = async (url, library2) => {
      let fileData;
      if (library2?.spriteSheet) {
        if (!this.hasUpdated) {
          await this.updateComplete;
        }
        this.svg = x`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
        await this.updateComplete;
        const svg = this.shadowRoot.querySelector("[part='svg']");
        if (typeof library2.mutator === "function") {
          library2.mutator(svg, this);
        }
        return this.svg;
      }
      try {
        fileData = await fetch(url, { mode: "cors" });
        if (!fileData.ok) return fileData.status === 410 ? CACHEABLE_ERROR : RETRYABLE_ERROR;
      } catch {
        return RETRYABLE_ERROR;
      }
      try {
        const div = document.createElement("div");
        div.innerHTML = await fileData.text();
        const svg = div.firstElementChild;
        if (svg?.tagName?.toLowerCase() !== "svg") return CACHEABLE_ERROR;
        if (!parser) parser = new DOMParser();
        const doc = parser.parseFromString(svg.outerHTML, "text/html");
        const svgEl = doc.body.querySelector("svg");
        if (!svgEl) return CACHEABLE_ERROR;
        svgEl.part.add("svg");
        return document.adoptNode(svgEl);
      } catch {
        return CACHEABLE_ERROR;
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    watchIcon(this);
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this.setIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    unwatchIcon(this);
  }
  getIconSource() {
    const library2 = getIconLibrary(this.library);
    const family = this.family || getDefaultIconFamily();
    if (this.name && library2) {
      return {
        url: library2.resolver(this.name, family, this.variant, this.autoWidth),
        fromLibrary: true
      };
    }
    return {
      url: this.src,
      fromLibrary: false
    };
  }
  handleLabelChange() {
    const hasLabel = typeof this.label === "string" && this.label.length > 0;
    if (hasLabel) {
      this.setAttribute("role", "img");
      this.setAttribute("aria-label", this.label);
      this.removeAttribute("aria-hidden");
    } else {
      this.removeAttribute("role");
      this.removeAttribute("aria-label");
      this.setAttribute("aria-hidden", "true");
    }
  }
  async setIcon() {
    const { url, fromLibrary } = this.getIconSource();
    const library2 = fromLibrary ? getIconLibrary(this.library) : void 0;
    if (!url) {
      this.svg = null;
      return;
    }
    let iconResolver = iconCache.get(url);
    if (!iconResolver) {
      iconResolver = this.resolveIcon(url, library2);
      iconCache.set(url, iconResolver);
    }
    const svg = await iconResolver;
    if (svg === RETRYABLE_ERROR) {
      iconCache.delete(url);
    }
    if (url !== this.getIconSource().url) {
      return;
    }
    if (e$2(svg)) {
      this.svg = svg;
      return;
    }
    switch (svg) {
      case RETRYABLE_ERROR:
      case CACHEABLE_ERROR:
        this.svg = null;
        this.dispatchEvent(new WaErrorEvent());
        break;
      default:
        this.svg = svg.cloneNode(true);
        library2?.mutator?.(this.svg, this);
        this.dispatchEvent(new WaLoadEvent());
    }
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    const library2 = getIconLibrary(this.library);
    const svg = this.shadowRoot?.querySelector("svg");
    if (svg) {
      library2?.mutator?.(svg, this);
    }
  }
  render() {
    if (this.hasUpdated) {
      return this.svg;
    }
    return x`<svg part="svg" width="16" height="16"></svg>`;
  }
};
WaIcon.css = icon_styles_default;
__decorateClass([
  r$1()
], WaIcon.prototype, "svg", 2);
__decorateClass([
  n$1({ reflect: true })
], WaIcon.prototype, "name", 2);
__decorateClass([
  n$1({ reflect: true })
], WaIcon.prototype, "family", 2);
__decorateClass([
  n$1({ reflect: true })
], WaIcon.prototype, "variant", 2);
__decorateClass([
  n$1({ attribute: "auto-width", type: Boolean, reflect: true })
], WaIcon.prototype, "autoWidth", 2);
__decorateClass([
  n$1({ attribute: "swap-opacity", type: Boolean, reflect: true })
], WaIcon.prototype, "swapOpacity", 2);
__decorateClass([
  n$1()
], WaIcon.prototype, "src", 2);
__decorateClass([
  n$1()
], WaIcon.prototype, "label", 2);
__decorateClass([
  n$1({ reflect: true })
], WaIcon.prototype, "library", 2);
__decorateClass([
  watch("label")
], WaIcon.prototype, "handleLabelChange", 1);
__decorateClass([
  watch(["family", "name", "library", "variant", "src", "autoWidth", "swapOpacity"], { waitUntilFirstUpdate: true })
], WaIcon.prototype, "setIcon", 1);
WaIcon = __decorateClass([
  t$1("wa-icon")
], WaIcon);
var __create$r = Object.create;
var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __knownSymbol$r = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$r = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$r = (target, value) => __defProp$r(target, "name", { value, configurable: true });
var __decoratorStart$r = (base) => [, , , __create$r(base?.[__knownSymbol$r("metadata")] ?? null)];
var __decoratorStrings$r = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$r = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$r("Function expected") : fn;
var __decoratorContext$r = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$r[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$r("Already initialized") : fns.push(__expectFn$r(fn || null)) });
var __decoratorMetadata$r = (array, target) => __defNormalProp$r(target, __knownSymbol$r("metadata"), array[3]);
var __runInitializers$r = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$r = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$r[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$r(k2 < 4 ? target : { get [name]() {
    return __privateGet$n(this, extra);
  }, set [name](x2) {
    return __privateSet$n(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$r(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$r(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$r(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$n(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$n : __privateMethod$n)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$n(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$r(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$r("Object expected");
    else __expectFn$r(fn = it.get) && (desc.get = fn), __expectFn$r(fn = it.set) && (desc.set = fn), __expectFn$r(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$r(array, target), desc && __defProp$r(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$n = (obj, member, msg) => member.has(obj) || __typeError$r("Cannot " + msg);
var __privateIn$n = (member, obj) => Object(obj) !== obj ? __typeError$r('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$n = (obj, member, getter) => (__accessCheck$n(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$n = (obj, member, value) => member.has(obj) ? __typeError$r("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$n = (obj, member, value, setter) => (__accessCheck$n(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$n = (obj, member, method) => (__accessCheck$n(obj, member, "access private method"), method);
var __waDetails_dec, __collapsedContentVisible_dec, _accordionGroup_dec, _bodyClass_dec, _maxHeight_dec, _isCollapsed_dec, _subtitle_dec, _title_dec$2, _visibilityKey_dec, _accordionId_dec, _a$r, _BriffaAccordianFilter_decorators, _init$r, _accordionId, _visibilityKey, _title$2, _subtitle, _isCollapsed, _maxHeight, _bodyClass, _accordionGroup, __collapsedContentVisible, __waDetails;
const accordianVisibilityMapKey = "accordian-visibility-map";
_BriffaAccordianFilter_decorators = [t$1("briffa-accordion-filter")];
let _BriffaAccordianFilter = class _BriffaAccordianFilter2 extends (_a$r = BaseDesignSystemComponent(
  accordionStyles
), _accordionId_dec = [n$1({ type: String, attribute: "accordion-id" })], _visibilityKey_dec = [n$1({ type: String, attribute: "visibility-key" })], _title_dec$2 = [n$1({ type: String })], _subtitle_dec = [n$1({ type: String })], _isCollapsed_dec = [n$1({ type: Boolean, attribute: "is-collapsed" })], _maxHeight_dec = [n$1({ type: String, attribute: "max-height" })], _bodyClass_dec = [n$1({ type: String, attribute: "body-class" })], _accordionGroup_dec = [n$1({ type: String, attribute: "accordion-group" })], __collapsedContentVisible_dec = [r$1()], __waDetails_dec = [e$5("wa-details")], _a$r) {
  constructor() {
    super(...arguments);
    __privateAdd$n(this, _accordionId, __runInitializers$r(_init$r, 8, this, "")), __runInitializers$r(_init$r, 11, this);
    __privateAdd$n(this, _visibilityKey, __runInitializers$r(_init$r, 12, this, "default")), __runInitializers$r(_init$r, 15, this);
    __privateAdd$n(this, _title$2, __runInitializers$r(_init$r, 16, this, "Title here")), __runInitializers$r(_init$r, 19, this);
    __privateAdd$n(this, _subtitle, __runInitializers$r(_init$r, 20, this, "")), __runInitializers$r(_init$r, 23, this);
    __privateAdd$n(this, _isCollapsed, __runInitializers$r(_init$r, 24, this, true)), __runInitializers$r(_init$r, 27, this);
    __privateAdd$n(this, _maxHeight, __runInitializers$r(_init$r, 28, this, "none")), __runInitializers$r(_init$r, 31, this);
    __privateAdd$n(this, _bodyClass, __runInitializers$r(_init$r, 32, this, "")), __runInitializers$r(_init$r, 35, this);
    __privateAdd$n(this, _accordionGroup, __runInitializers$r(_init$r, 36, this, "")), __runInitializers$r(_init$r, 39, this);
    __privateAdd$n(this, __collapsedContentVisible, __runInitializers$r(_init$r, 40, this, true)), __runInitializers$r(_init$r, 43, this);
    __privateAdd$n(this, __waDetails, __runInitializers$r(_init$r, 44, this)), __runInitializers$r(_init$r, 47, this);
    this._onToggleCallbacks = [];
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.accordionId) {
      const cachedVisibility = this.getCachedVisibility();
      if (cachedVisibility !== null) {
        this.isCollapsed = cachedVisibility;
      }
      this.cacheCollapsed(this.isCollapsed);
    }
    this._collapsedContentVisible = this.isCollapsed;
  }
  getCachedVisibility() {
    return _BriffaAccordianFilter2.visibilityMap[this.visibilityKey]?.[this.accordionId];
  }
  setCachedVisibility(isCollapsed) {
    if (!_BriffaAccordianFilter2.visibilityMap[this.visibilityKey]) {
      _BriffaAccordianFilter2.visibilityMap[this.visibilityKey] = {};
    }
    _BriffaAccordianFilter2.visibilityMap[this.visibilityKey][this.accordionId] = isCollapsed;
  }
  cacheCollapsed(collapsed) {
    this.setCachedVisibility(collapsed);
    localStorage.setItem(
      accordianVisibilityMapKey,
      JSON.stringify(_BriffaAccordianFilter2.visibilityMap)
    );
  }
  open() {
    this.isCollapsed = false;
    if (this._waDetails) {
      this._waDetails.open = true;
    }
  }
  collapse() {
    this.isCollapsed = true;
    if (this._waDetails) {
      this._waDetails.open = false;
    }
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.cacheCollapsed(this.isCollapsed);
    this._collapsedContentVisible = this.isCollapsed;
    this._dispatchToggleEvent(this.isCollapsed);
    if (this.isCollapsed) {
      this._dispatchCollapseEvent();
    }
  }
  getIsCollapsed() {
    return this.isCollapsed;
  }
  _handleWaShow(e2) {
    if (e2.target !== this._waDetails) {
      return;
    }
    if (this.isCollapsed) {
      this.isCollapsed = false;
      this._collapsedContentVisible = false;
      this.cacheCollapsed(this.isCollapsed);
      this._dispatchToggleEvent(this.isCollapsed);
      if (this.accordionGroup) {
        this._closeOthersInGroup();
      }
    }
  }
  /**
   * Close all other accordions in the same group (exclusive accordion behavior).
   * This mimics the native <details name="..."> behavior for wa-details.
   */
  _closeOthersInGroup() {
    const parent = this.parentElement;
    if (!parent) return;
    const siblings = parent.querySelectorAll(
      `briffa-accordion-filter[accordion-group="${this.accordionGroup}"]`
    );
    siblings.forEach((sibling) => {
      if (sibling !== this && !sibling.isCollapsed) {
        sibling.collapse();
        if (sibling.accordionId) {
          sibling.cacheCollapsed(true);
        }
      }
    });
  }
  _handleWaHide(e2) {
    if (e2.target !== this._waDetails) {
      return;
    }
    if (!this.isCollapsed) {
      this.isCollapsed = true;
      this._collapsedContentVisible = true;
      this.cacheCollapsed(this.isCollapsed);
      this._dispatchToggleEvent(this.isCollapsed);
      this._dispatchCollapseEvent();
    }
  }
  _handleCollapsedContentClick() {
    if (this.isCollapsed && this._waDetails) {
      this._waDetails.open = true;
    }
  }
  _dispatchToggleEvent(isCollapsed) {
    this._onToggleCallbacks.forEach((callback) => callback(isCollapsed));
    this.dispatchEvent(
      new CustomEvent("toggle-changed", {
        detail: { isCollapsed },
        bubbles: true
      })
    );
  }
  _dispatchCollapseEvent() {
    this.dispatchEvent(
      new CustomEvent("collapsed", {
        bubbles: true
      })
    );
  }
  setBodyContent(node) {
    const existingContent = this.querySelector('[slot="body"]');
    if (existingContent) {
      existingContent.remove();
    }
    node.slot = "body";
    this.appendChild(node);
  }
  subscribeToToggleCallback(callback, initialDispatch) {
    this._onToggleCallbacks.push(callback);
    if (initialDispatch) {
      callback(this.getIsCollapsed());
    }
  }
  render() {
    const titleStyle = `
            color: ${colors.text.secondary};
            font-size: ${typography.fontSize.lg};
        `;
    const subtitleStyle = `
            color: ${colors.text.secondary};
            font-size: ${typography.fontSize.sm};
            margin-top: 1px;
        `;
    const bodyStyle = this.maxHeight !== "none" ? `max-height: ${this.maxHeight}; overflow-y: auto;` : "";
    return x`
            <wa-details
                ?open=${!this.isCollapsed}
                @wa-show=${this._handleWaShow}
                @wa-hide=${this._handleWaHide}
                class="accordion-details"
                name=${this.accordionGroup || E}
            >
                <div slot="summary" class="summary-content">
                    <div class="titles">
                        <p class="title" style="${titleStyle}">${this.title}</p>
                        ${this.subtitle ? x`
                                  <p class="subtitle" style="${subtitleStyle}">
                                      ${this.subtitle}
                                  </p>
                              ` : ""}
                    </div>
                </div>

                <div
                    class="collapsed-content ${this._collapsedContentVisible ? "visible" : "hidden"}"
                    @click=${this._handleCollapsedContentClick}
                >
                    <slot name="collapsed-content"></slot>
                </div>

                <div class="px-1 ${this.bodyClass}" style="${bodyStyle}">
                    <slot name="body"></slot>
                </div>
            </wa-details>
        `;
  }
};
_init$r = __decoratorStart$r(_a$r);
_accordionId = /* @__PURE__ */ new WeakMap();
_visibilityKey = /* @__PURE__ */ new WeakMap();
_title$2 = /* @__PURE__ */ new WeakMap();
_subtitle = /* @__PURE__ */ new WeakMap();
_isCollapsed = /* @__PURE__ */ new WeakMap();
_maxHeight = /* @__PURE__ */ new WeakMap();
_bodyClass = /* @__PURE__ */ new WeakMap();
_accordionGroup = /* @__PURE__ */ new WeakMap();
__collapsedContentVisible = /* @__PURE__ */ new WeakMap();
__waDetails = /* @__PURE__ */ new WeakMap();
__decorateElement$r(_init$r, 4, "accordionId", _accordionId_dec, _BriffaAccordianFilter, _accordionId);
__decorateElement$r(_init$r, 4, "visibilityKey", _visibilityKey_dec, _BriffaAccordianFilter, _visibilityKey);
__decorateElement$r(_init$r, 4, "title", _title_dec$2, _BriffaAccordianFilter, _title$2);
__decorateElement$r(_init$r, 4, "subtitle", _subtitle_dec, _BriffaAccordianFilter, _subtitle);
__decorateElement$r(_init$r, 4, "isCollapsed", _isCollapsed_dec, _BriffaAccordianFilter, _isCollapsed);
__decorateElement$r(_init$r, 4, "maxHeight", _maxHeight_dec, _BriffaAccordianFilter, _maxHeight);
__decorateElement$r(_init$r, 4, "bodyClass", _bodyClass_dec, _BriffaAccordianFilter, _bodyClass);
__decorateElement$r(_init$r, 4, "accordionGroup", _accordionGroup_dec, _BriffaAccordianFilter, _accordionGroup);
__decorateElement$r(_init$r, 4, "_collapsedContentVisible", __collapsedContentVisible_dec, _BriffaAccordianFilter, __collapsedContentVisible);
__decorateElement$r(_init$r, 4, "_waDetails", __waDetails_dec, _BriffaAccordianFilter, __waDetails);
_BriffaAccordianFilter = __decorateElement$r(_init$r, 0, "BriffaAccordianFilter", _BriffaAccordianFilter_decorators, _BriffaAccordianFilter);
_BriffaAccordianFilter.visibilityMap = JSON.parse(
  localStorage.getItem(accordianVisibilityMapKey) ?? "{}"
);
__runInitializers$r(_init$r, 1, _BriffaAccordianFilter);
let BriffaAccordianFilter = _BriffaAccordianFilter;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var tooltip_styles_default = i$6`
  :host {
    --max-width: 30ch;

    /** These styles are added so we don't interfere in the DOM. */
    display: inline-block;
    position: absolute;

    /** Defaults for inherited CSS properties */
    color: var(--wa-tooltip-content-color);
    font-size: var(--wa-tooltip-font-size);
    line-height: var(--wa-tooltip-line-height);
    text-align: start;
    white-space: normal;
  }

  .tooltip {
    --arrow-size: var(--wa-tooltip-arrow-size);
    --arrow-color: var(--wa-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: 1000;
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--wa-tooltip-border-radius);
    background-color: var(--wa-tooltip-background-color);
    border: var(--wa-tooltip-border-width) var(--wa-tooltip-border-style) var(--wa-tooltip-border-color);
    padding: 0.25em 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  .tooltip::part(arrow) {
    border-bottom: var(--wa-tooltip-border-width) var(--wa-tooltip-border-style) var(--wa-tooltip-border-color);
    border-right: var(--wa-tooltip-border-width) var(--wa-tooltip-border-style) var(--wa-tooltip-border-color);
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaRepositionEvent = class extends Event {
  constructor() {
    super("wa-reposition", { bubbles: true, cancelable: false, composed: true });
  }
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var popup_styles_default = i$6`
  :host {
    --arrow-color: black;
    --arrow-size: var(--wa-tooltip-arrow-size);
    --show-duration: 100ms;
    --hide-duration: 100ms;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);

    /* Clear UA styles for [popover] */
    :where(&) {
      inset: unset;
      padding: unset;
      margin: unset;
      width: unset;
      height: unset;
      color: unset;
      background: unset;
      border: unset;
      overflow: unset;
    }
  }

  .popup-fixed {
    position: fixed;
  }

  .popup:not(.popup-active) {
    display: none;
  }

  .arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: 3;
  }

  :host([data-current-placement~='left']) .arrow {
    rotate: -45deg;
  }

  :host([data-current-placement~='right']) .arrow {
    rotate: 135deg;
  }

  :host([data-current-placement~='bottom']) .arrow {
    rotate: 225deg;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge-visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: 899;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }

  /* Built-in animations */
  .show {
    animation: show var(--show-duration) ease;
  }

  .hide {
    animation: show var(--hide-duration) ease reverse;
  }

  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .show-with-scale {
    animation: show-with-scale var(--show-duration) ease;
  }

  .hide-with-scale {
    animation: show-with-scale var(--hide-duration) ease reverse;
  }

  @keyframes show-with-scale {
    from {
      opacity: 0;
      scale: 0.8;
    }
    to {
      opacity: 1;
      scale: 1;
    }
  }
`;
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y3,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y3,
    left: x2,
    right: x2 + width,
    bottom: y3 + height,
    x: x2,
    y: y3
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y3
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i4 = 0; i4 < validMiddleware.length; i4++) {
    const {
      name,
      fn
    } = validMiddleware[i4];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y3,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y3 = nextY != null ? nextY : y3;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y3
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i4 = -1;
    }
  }
  return {
    x: x2,
    y: y3,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y3,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y3,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$1 = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x: x2,
      y: y3,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y3
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d2) => getSideAxis(d2.placement) === initialSideAxis ? d2.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y3,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y3 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x2,
        y: y3,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y4
            } = _ref;
            return {
              x: x3,
              y: y4
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x2,
        y: y3
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y3,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const size$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
const willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
const containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y3 = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y3 || !Number.isFinite(y3)) {
    y3 = 1;
  }
  return {
    x: x2,
    y: y3
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y3 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y3 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y3 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y: y3
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y3 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y3
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y3 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y3
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y3 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y3 = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x: x2,
    y: y3
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y3 = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y3
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y3 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y3,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update2, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update2, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update2);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update2) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update2();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update2();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update2();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update2);
      ancestorResize && ancestor.removeEventListener("resize", update2);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset = offset$1;
const shift = shift$1;
const flip = flip$1;
const size = size$1;
const arrow = arrow$1;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
function e$1(t2) {
  return i$1(t2);
}
function r(t2) {
  return t2.assignedSlot ? t2.assignedSlot : t2.parentNode instanceof ShadowRoot ? t2.parentNode.host : t2.parentNode;
}
function i$1(e2) {
  for (let t2 = e2; t2; t2 = r(t2)) if (t2 instanceof Element && "none" === getComputedStyle(t2).display) return null;
  for (let n3 = r(e2); n3; n3 = r(n3)) {
    if (!(n3 instanceof Element)) continue;
    const e3 = getComputedStyle(n3);
    if ("contents" !== e3.display) {
      if ("static" !== e3.position || isContainingBlock(e3)) return n3;
      if ("BODY" === n3.tagName) return n3;
    }
  }
  return null;
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function isVirtualElement(e2) {
  return e2 !== null && typeof e2 === "object" && "getBoundingClientRect" in e2 && ("contextElement" in e2 ? e2 instanceof Element : true);
}
var SUPPORTS_POPOVER = globalThis?.HTMLElement?.prototype.hasOwnProperty("popover");
var WaPopup = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController2(this);
    this.active = false;
    this.placement = "top";
    this.boundary = "viewport";
    this.distance = 0;
    this.skidding = 0;
    this.arrow = false;
    this.arrowPlacement = "anchor";
    this.arrowPadding = 10;
    this.flip = false;
    this.flipFallbackPlacements = "";
    this.flipFallbackStrategy = "best-fit";
    this.flipPadding = 0;
    this.shift = false;
    this.shiftPadding = 0;
    this.autoSizePadding = 0;
    this.hoverBridge = false;
    this.updateHoverBridge = () => {
      if (this.hoverBridge && this.anchorEl) {
        const anchorRect = this.anchorEl.getBoundingClientRect();
        const popupRect = this.popup.getBoundingClientRect();
        const isVertical = this.placement.includes("top") || this.placement.includes("bottom");
        let topLeftX = 0;
        let topLeftY = 0;
        let topRightX = 0;
        let topRightY = 0;
        let bottomLeftX = 0;
        let bottomLeftY = 0;
        let bottomRightX = 0;
        let bottomRightY = 0;
        if (isVertical) {
          if (anchorRect.top < popupRect.top) {
            topLeftX = anchorRect.left;
            topLeftY = anchorRect.bottom;
            topRightX = anchorRect.right;
            topRightY = anchorRect.bottom;
            bottomLeftX = popupRect.left;
            bottomLeftY = popupRect.top;
            bottomRightX = popupRect.right;
            bottomRightY = popupRect.top;
          } else {
            topLeftX = popupRect.left;
            topLeftY = popupRect.bottom;
            topRightX = popupRect.right;
            topRightY = popupRect.bottom;
            bottomLeftX = anchorRect.left;
            bottomLeftY = anchorRect.top;
            bottomRightX = anchorRect.right;
            bottomRightY = anchorRect.top;
          }
        } else {
          if (anchorRect.left < popupRect.left) {
            topLeftX = anchorRect.right;
            topLeftY = anchorRect.top;
            topRightX = popupRect.left;
            topRightY = popupRect.top;
            bottomLeftX = anchorRect.right;
            bottomLeftY = anchorRect.bottom;
            bottomRightX = popupRect.left;
            bottomRightY = popupRect.bottom;
          } else {
            topLeftX = popupRect.right;
            topLeftY = popupRect.top;
            topRightX = anchorRect.left;
            topRightY = anchorRect.top;
            bottomLeftX = popupRect.right;
            bottomLeftY = popupRect.bottom;
            bottomRightX = anchorRect.left;
            bottomRightY = anchorRect.bottom;
          }
        }
        this.style.setProperty("--hover-bridge-top-left-x", `${topLeftX}px`);
        this.style.setProperty("--hover-bridge-top-left-y", `${topLeftY}px`);
        this.style.setProperty("--hover-bridge-top-right-x", `${topRightX}px`);
        this.style.setProperty("--hover-bridge-top-right-y", `${topRightY}px`);
        this.style.setProperty("--hover-bridge-bottom-left-x", `${bottomLeftX}px`);
        this.style.setProperty("--hover-bridge-bottom-left-y", `${bottomLeftY}px`);
        this.style.setProperty("--hover-bridge-bottom-right-x", `${bottomRightX}px`);
        this.style.setProperty("--hover-bridge-bottom-right-y", `${bottomRightY}px`);
      }
    };
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.stop();
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("active")) {
      if (this.active) {
        this.start();
      } else {
        this.stop();
      }
    }
    if (changedProperties.has("anchor")) {
      this.handleAnchorChange();
    }
    if (this.active) {
      await this.updateComplete;
      this.reposition();
    }
  }
  async handleAnchorChange() {
    await this.stop();
    if (this.anchor && typeof this.anchor === "string") {
      const root = this.getRootNode();
      this.anchorEl = root.getElementById(this.anchor);
    } else if (this.anchor instanceof Element || isVirtualElement(this.anchor)) {
      this.anchorEl = this.anchor;
    } else {
      this.anchorEl = this.querySelector('[slot="anchor"]');
    }
    if (this.anchorEl instanceof HTMLSlotElement) {
      this.anchorEl = this.anchorEl.assignedElements({ flatten: true })[0];
    }
    if (this.anchorEl) {
      this.start();
    }
  }
  start() {
    if (!this.anchorEl || !this.active) {
      return;
    }
    this.popup.showPopover?.();
    this.cleanup = autoUpdate(this.anchorEl, this.popup, () => {
      this.reposition();
    });
  }
  async stop() {
    return new Promise((resolve) => {
      this.popup.hidePopover?.();
      if (this.cleanup) {
        this.cleanup();
        this.cleanup = void 0;
        this.removeAttribute("data-current-placement");
        this.style.removeProperty("--auto-size-available-width");
        this.style.removeProperty("--auto-size-available-height");
        requestAnimationFrame(() => resolve());
      } else {
        resolve();
      }
    });
  }
  /** Forces the popup to recalculate and reposition itself. */
  reposition() {
    if (!this.active || !this.anchorEl) {
      return;
    }
    const middleware = [
      // The offset middleware goes first
      offset({ mainAxis: this.distance, crossAxis: this.skidding })
    ];
    if (this.sync) {
      middleware.push(
        size({
          apply: ({ rects }) => {
            const syncWidth = this.sync === "width" || this.sync === "both";
            const syncHeight = this.sync === "height" || this.sync === "both";
            this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
            this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
          }
        })
      );
    } else {
      this.popup.style.width = "";
      this.popup.style.height = "";
    }
    let defaultBoundary;
    if (SUPPORTS_POPOVER && !isVirtualElement(this.anchor) && this.boundary === "scroll") {
      defaultBoundary = getOverflowAncestors(this.anchorEl).filter((el) => el instanceof Element);
    }
    if (this.flip) {
      middleware.push(
        flip({
          boundary: this.flipBoundary || defaultBoundary,
          // @ts-expect-error - We're converting a string attribute to an array here
          fallbackPlacements: this.flipFallbackPlacements,
          fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
          padding: this.flipPadding
        })
      );
    }
    if (this.shift) {
      middleware.push(
        shift({
          boundary: this.shiftBoundary || defaultBoundary,
          padding: this.shiftPadding
        })
      );
    }
    if (this.autoSize) {
      middleware.push(
        size({
          boundary: this.autoSizeBoundary || defaultBoundary,
          padding: this.autoSizePadding,
          apply: ({ availableWidth, availableHeight }) => {
            if (this.autoSize === "vertical" || this.autoSize === "both") {
              this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
            } else {
              this.style.removeProperty("--auto-size-available-height");
            }
            if (this.autoSize === "horizontal" || this.autoSize === "both") {
              this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
            } else {
              this.style.removeProperty("--auto-size-available-width");
            }
          }
        })
      );
    } else {
      this.style.removeProperty("--auto-size-available-width");
      this.style.removeProperty("--auto-size-available-height");
    }
    if (this.arrow) {
      middleware.push(
        arrow({
          element: this.arrowEl,
          padding: this.arrowPadding
        })
      );
    }
    const getOffsetParent2 = SUPPORTS_POPOVER ? (element) => platform.getOffsetParent(element, e$1) : platform.getOffsetParent;
    computePosition(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware,
      strategy: SUPPORTS_POPOVER ? "absolute" : "fixed",
      platform: {
        ...platform,
        getOffsetParent: getOffsetParent2
      }
    }).then(({ x: x2, y: y3, middlewareData, placement }) => {
      const isRtl = this.localize.dir() === "rtl";
      const staticSide = { top: "bottom", right: "left", bottom: "top", left: "right" }[placement.split("-")[0]];
      this.setAttribute("data-current-placement", placement);
      Object.assign(this.popup.style, {
        left: `${x2}px`,
        top: `${y3}px`
      });
      if (this.arrow) {
        const arrowX = middlewareData.arrow.x;
        const arrowY = middlewareData.arrow.y;
        let top = "";
        let right = "";
        let bottom = "";
        let left = "";
        if (this.arrowPlacement === "start") {
          const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          right = isRtl ? value : "";
          left = isRtl ? "" : value;
        } else if (this.arrowPlacement === "end") {
          const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          right = isRtl ? "" : value;
          left = isRtl ? value : "";
          bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else if (this.arrowPlacement === "center") {
          left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
          top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
        } else {
          left = typeof arrowX === "number" ? `${arrowX}px` : "";
          top = typeof arrowY === "number" ? `${arrowY}px` : "";
        }
        Object.assign(this.arrowEl.style, {
          top,
          right,
          bottom,
          left,
          [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
        });
      }
    });
    requestAnimationFrame(() => this.updateHoverBridge());
    this.dispatchEvent(new WaRepositionEvent());
  }
  render() {
    return x`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${e$3({
      "popup-hover-bridge": true,
      "popup-hover-bridge-visible": this.hoverBridge && this.active
    })}
      ></span>

      <div
        popover="manual"
        part="popup"
        class=${e$3({
      popup: true,
      "popup-active": this.active,
      "popup-fixed": !SUPPORTS_POPOVER,
      "popup-has-arrow": this.arrow
    })}
      >
        <slot></slot>
        ${this.arrow ? x`<div part="arrow" class="arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
WaPopup.css = popup_styles_default;
__decorateClass([
  e$5(".popup")
], WaPopup.prototype, "popup", 2);
__decorateClass([
  e$5(".arrow")
], WaPopup.prototype, "arrowEl", 2);
__decorateClass([
  n$1()
], WaPopup.prototype, "anchor", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaPopup.prototype, "active", 2);
__decorateClass([
  n$1({ reflect: true })
], WaPopup.prototype, "placement", 2);
__decorateClass([
  n$1()
], WaPopup.prototype, "boundary", 2);
__decorateClass([
  n$1({ type: Number })
], WaPopup.prototype, "distance", 2);
__decorateClass([
  n$1({ type: Number })
], WaPopup.prototype, "skidding", 2);
__decorateClass([
  n$1({ type: Boolean })
], WaPopup.prototype, "arrow", 2);
__decorateClass([
  n$1({ attribute: "arrow-placement" })
], WaPopup.prototype, "arrowPlacement", 2);
__decorateClass([
  n$1({ attribute: "arrow-padding", type: Number })
], WaPopup.prototype, "arrowPadding", 2);
__decorateClass([
  n$1({ type: Boolean })
], WaPopup.prototype, "flip", 2);
__decorateClass([
  n$1({
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (value) => {
        return value.split(" ").map((p2) => p2.trim()).filter((p2) => p2 !== "");
      },
      toAttribute: (value) => {
        return value.join(" ");
      }
    }
  })
], WaPopup.prototype, "flipFallbackPlacements", 2);
__decorateClass([
  n$1({ attribute: "flip-fallback-strategy" })
], WaPopup.prototype, "flipFallbackStrategy", 2);
__decorateClass([
  n$1({ type: Object })
], WaPopup.prototype, "flipBoundary", 2);
__decorateClass([
  n$1({ attribute: "flip-padding", type: Number })
], WaPopup.prototype, "flipPadding", 2);
__decorateClass([
  n$1({ type: Boolean })
], WaPopup.prototype, "shift", 2);
__decorateClass([
  n$1({ type: Object })
], WaPopup.prototype, "shiftBoundary", 2);
__decorateClass([
  n$1({ attribute: "shift-padding", type: Number })
], WaPopup.prototype, "shiftPadding", 2);
__decorateClass([
  n$1({ attribute: "auto-size" })
], WaPopup.prototype, "autoSize", 2);
__decorateClass([
  n$1()
], WaPopup.prototype, "sync", 2);
__decorateClass([
  n$1({ type: Object })
], WaPopup.prototype, "autoSizeBoundary", 2);
__decorateClass([
  n$1({ attribute: "auto-size-padding", type: Number })
], WaPopup.prototype, "autoSizePadding", 2);
__decorateClass([
  n$1({ attribute: "hover-bridge", type: Boolean })
], WaPopup.prototype, "hoverBridge", 2);
WaPopup = __decorateClass([
  t$1("wa-popup")
], WaPopup);
const urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let nanoid = (size2 = 21) => {
  let id = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size2 |= 0));
  while (size2--) {
    id += urlAlphabet[bytes[size2] & 63];
  }
  return id;
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function uniqueId(prefix = "") {
  return `${prefix}${nanoid()}`;
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaTooltip = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.placement = "top";
    this.disabled = false;
    this.distance = 8;
    this.open = false;
    this.skidding = 0;
    this.showDelay = 150;
    this.hideDelay = 0;
    this.trigger = "hover focus";
    this.withoutArrow = false;
    this.for = null;
    this.anchor = null;
    this.eventController = new AbortController();
    this.handleBlur = () => {
      if (this.hasTrigger("focus")) {
        this.hide();
      }
    };
    this.handleClick = () => {
      if (this.hasTrigger("click")) {
        if (this.open) {
          this.hide();
        } else {
          this.show();
        }
      }
    };
    this.handleFocus = () => {
      if (this.hasTrigger("focus")) {
        this.show();
      }
    };
    this.handleDocumentKeyDown = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        this.hide();
      }
    };
    this.handleMouseOver = () => {
      if (this.hasTrigger("hover")) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = window.setTimeout(() => this.show(), this.showDelay);
      }
    };
    this.handleMouseOut = () => {
      if (this.hasTrigger("hover")) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = window.setTimeout(() => this.hide(), this.hideDelay);
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.eventController.signal.aborted) {
      this.eventController = new AbortController();
    }
    if (this.open) {
      this.open = false;
      this.updateComplete.then(() => {
        this.open = true;
      });
    }
    if (!this.id) {
      this.id = uniqueId("wa-tooltip-");
    }
    if (this.for && this.anchor) {
      this.anchor = null;
      this.handleForChange();
    } else if (this.for) {
      this.handleForChange();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
    this.eventController.abort();
    if (this.anchor) {
      this.removeFromAriaLabelledBy(this.anchor, this.id);
    }
  }
  firstUpdated() {
    this.body.hidden = !this.open;
    if (this.open) {
      this.popup.active = true;
      this.popup.reposition();
    }
  }
  hasTrigger(triggerType) {
    const triggers = this.trigger.split(" ");
    return triggers.includes(triggerType);
  }
  /** Adds the tooltip ID to the aria-labelledby attribute */
  addToAriaLabelledBy(element, id) {
    const currentLabel = element.getAttribute("aria-labelledby") || "";
    const labels = currentLabel.split(/\s+/).filter(Boolean);
    if (!labels.includes(id)) {
      labels.push(id);
      element.setAttribute("aria-labelledby", labels.join(" "));
    }
  }
  /** Removes the tooltip ID from the aria-labelledby attribute */
  removeFromAriaLabelledBy(element, id) {
    const currentLabel = element.getAttribute("aria-labelledby") || "";
    const labels = currentLabel.split(/\s+/).filter(Boolean);
    const filteredLabels = labels.filter((label) => label !== id);
    if (filteredLabels.length > 0) {
      element.setAttribute("aria-labelledby", filteredLabels.join(" "));
    } else {
      element.removeAttribute("aria-labelledby");
    }
  }
  async handleOpenChange() {
    if (this.open) {
      if (this.disabled) {
        return;
      }
      const waShowEvent = new WaShowEvent();
      this.dispatchEvent(waShowEvent);
      if (waShowEvent.defaultPrevented) {
        this.open = false;
        return;
      }
      document.addEventListener("keydown", this.handleDocumentKeyDown, { signal: this.eventController.signal });
      this.body.hidden = false;
      this.popup.active = true;
      await animateWithClass(this.popup.popup, "show-with-scale");
      this.popup.reposition();
      this.dispatchEvent(new WaAfterShowEvent());
    } else {
      const waHideEvent = new WaHideEvent();
      this.dispatchEvent(waHideEvent);
      if (waHideEvent.defaultPrevented) {
        this.open = false;
        return;
      }
      document.removeEventListener("keydown", this.handleDocumentKeyDown);
      await animateWithClass(this.popup.popup, "hide-with-scale");
      this.popup.active = false;
      this.body.hidden = true;
      this.dispatchEvent(new WaAfterHideEvent());
    }
  }
  handleForChange() {
    const rootNode = this.getRootNode();
    if (!rootNode) {
      return;
    }
    const newAnchor = this.for ? rootNode.getElementById(this.for) : null;
    const oldAnchor = this.anchor;
    if (newAnchor === oldAnchor) {
      return;
    }
    const { signal } = this.eventController;
    if (newAnchor) {
      this.addToAriaLabelledBy(newAnchor, this.id);
      newAnchor.addEventListener("blur", this.handleBlur, { capture: true, signal });
      newAnchor.addEventListener("focus", this.handleFocus, { capture: true, signal });
      newAnchor.addEventListener("click", this.handleClick, { signal });
      newAnchor.addEventListener("mouseover", this.handleMouseOver, { signal });
      newAnchor.addEventListener("mouseout", this.handleMouseOut, { signal });
    }
    if (oldAnchor) {
      this.removeFromAriaLabelledBy(oldAnchor, this.id);
      oldAnchor.removeEventListener("blur", this.handleBlur, { capture: true });
      oldAnchor.removeEventListener("focus", this.handleFocus, { capture: true });
      oldAnchor.removeEventListener("click", this.handleClick);
      oldAnchor.removeEventListener("mouseover", this.handleMouseOver);
      oldAnchor.removeEventListener("mouseout", this.handleMouseOut);
    }
    this.anchor = newAnchor;
  }
  async handleOptionsChange() {
    if (this.hasUpdated) {
      await this.updateComplete;
      this.popup.reposition();
    }
  }
  handleDisabledChange() {
    if (this.disabled && this.open) {
      this.hide();
    }
  }
  /** Shows the tooltip. */
  async show() {
    if (this.open) {
      return void 0;
    }
    this.open = true;
    return waitForEvent(this, "wa-after-show");
  }
  /** Hides the tooltip */
  async hide() {
    if (!this.open) {
      return void 0;
    }
    this.open = false;
    return waitForEvent(this, "wa-after-hide");
  }
  render() {
    return x`
      <wa-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${e$3({
      tooltip: true,
      "tooltip-open": this.open
    })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        flip
        shift
        ?arrow=${!this.withoutArrow}
        hover-bridge
        .anchor=${this.anchor}
      >
        <div part="body" class="body">
          <slot></slot>
        </div>
      </wa-popup>
    `;
  }
};
WaTooltip.css = tooltip_styles_default;
WaTooltip.dependencies = { "wa-popup": WaPopup };
__decorateClass([
  e$5("slot:not([name])")
], WaTooltip.prototype, "defaultSlot", 2);
__decorateClass([
  e$5(".body")
], WaTooltip.prototype, "body", 2);
__decorateClass([
  e$5("wa-popup")
], WaTooltip.prototype, "popup", 2);
__decorateClass([
  n$1()
], WaTooltip.prototype, "placement", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaTooltip.prototype, "disabled", 2);
__decorateClass([
  n$1({ type: Number })
], WaTooltip.prototype, "distance", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaTooltip.prototype, "open", 2);
__decorateClass([
  n$1({ type: Number })
], WaTooltip.prototype, "skidding", 2);
__decorateClass([
  n$1({ attribute: "show-delay", type: Number })
], WaTooltip.prototype, "showDelay", 2);
__decorateClass([
  n$1({ attribute: "hide-delay", type: Number })
], WaTooltip.prototype, "hideDelay", 2);
__decorateClass([
  n$1()
], WaTooltip.prototype, "trigger", 2);
__decorateClass([
  n$1({ attribute: "without-arrow", type: Boolean, reflect: true })
], WaTooltip.prototype, "withoutArrow", 2);
__decorateClass([
  n$1()
], WaTooltip.prototype, "for", 2);
__decorateClass([
  r$1()
], WaTooltip.prototype, "anchor", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], WaTooltip.prototype, "handleOpenChange", 1);
__decorateClass([
  watch("for")
], WaTooltip.prototype, "handleForChange", 1);
__decorateClass([
  watch(["distance", "placement", "skidding"])
], WaTooltip.prototype, "handleOptionsChange", 1);
__decorateClass([
  watch("disabled")
], WaTooltip.prototype, "handleDisabledChange", 1);
WaTooltip = __decorateClass([
  t$1("wa-tooltip")
], WaTooltip);
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(formatProdErrorMessage$1(2));
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(formatProdErrorMessage$1(0));
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(formatProdErrorMessage$1(1));
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState2() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(3));
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(formatProdErrorMessage$1(4));
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(5));
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(formatProdErrorMessage$1(6));
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(formatProdErrorMessage$1(7));
    }
    if (typeof action.type === "undefined") {
      throw new Error(formatProdErrorMessage$1(8));
    }
    if (typeof action.type !== "string") {
      throw new Error(formatProdErrorMessage$1(17));
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(9));
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(formatProdErrorMessage$1(10));
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(formatProdErrorMessage$1(11));
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState2());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store2 = {
    dispatch,
    subscribe,
    getState: getState2,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store2;
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState2 = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState2 === "undefined") {
      throw new Error(formatProdErrorMessage$1(12));
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(formatProdErrorMessage$1(13));
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i4 = 0; i4 < reducerKeys.length; i4++) {
    const key = reducerKeys[i4];
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e2) {
    shapeAssertionError = e2;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    let hasChanged = false;
    const nextState = {};
    for (let i4 = 0; i4 < finalReducerKeys.length; i4++) {
      const key = finalReducerKeys[i4];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        action && action.type;
        throw new Error(formatProdErrorMessage$1(14));
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a2, b2) => (...args) => a2(b2(...args)));
}
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store2 = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(formatProdErrorMessage$1(15));
    };
    const middlewareAPI = {
      getState: store2.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store2.dispatch);
    return {
      ...store2,
      dispatch
    };
  };
}
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
function die(error, ...args) {
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = Object.getPrototypeOf(value);
  if (proto === null || proto === Object.prototype)
    return true;
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  if (typeof Ctor !== "function")
    return false;
  let ctorString = cachedCtorStrings.get(Ctor);
  if (ctorString === void 0) {
    ctorString = Function.toString.call(Ctor);
    cachedCtorStrings.set(Ctor, ctorString);
  }
  return ctorString === objectCtorString;
}
function each(obj, iter, strict = true) {
  if (getArchtype(obj) === 0) {
    const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
    keys.forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index2) => iter(index2, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 : isMap(thing) ? 2 : isSet(thing) ? 3 : 0;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t2 = getArchtype(thing);
  if (t2 === 2)
    thing.set(propOrOldValue, value);
  else if (t2 === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x2, y3) {
  if (x2 === y3) {
    return x2 !== 0 || 1 / x2 === 1 / y3;
  } else {
    return x2 !== x2 && y3 !== y3;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i4 = 0; i4 < keys.length; i4++) {
      const key = keys[i4];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    Object.defineProperties(obj, {
      set: dontMutateMethodOverride,
      add: dontMutateMethodOverride,
      clear: dontMutateMethodOverride,
      delete: dontMutateMethodOverride
    });
  }
  Object.freeze(obj);
  if (deep)
    Object.values(obj).forEach((value) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  value: dontMutateFrozenCollections
};
function isFrozen(obj) {
  if (obj === null || typeof obj !== "object")
    return true;
  return Object.isFrozen(obj);
}
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path),
      useStrictIteration
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(
        rootScope,
        state,
        result,
        key,
        childValue,
        path,
        isSet2
      ),
      useStrictIteration
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (childValue == null) {
    return;
  }
  if (typeof childValue !== "object" && !targetIsSet) {
    return;
  }
  const childIsFrozen = isFrozen(childValue);
  if (childIsFrozen && !targetIsSet) {
    return;
  }
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !childIsFrozen) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && (isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop)))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.useStrictIteration_ = true;
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self2 = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self2.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p2 = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p2, ip);
          patchListener(p2, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p2, ip) => {
        patches = p2;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    if (typeof config?.useStrictIteration === "boolean")
      this.setUseStrictIteration(config.useStrictIteration);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(value) {
    this.useStrictIteration_ = value;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(base, patches) {
    let i4;
    for (i4 = patches.length - 1; i4 >= 0; i4--) {
      const patch = patches[i4];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i4 > -1) {
      patches = patches.slice(i4 + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  let strict = true;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    strict = state.scope_.immer_.shouldUseStrictIteration();
  } else {
    copy = shallowCopy(value, true);
  }
  each(
    copy,
    (key, childValue) => {
      set(copy, key, currentImpl(childValue));
    },
    strict
  );
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}
var immer = new Immer2();
var produce = immer.produce;
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i4 = 0; i4 < length; i4++) {
    inputSelectorResults.push(dependencies[i4].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i4 = 0, l2 = length; i4 < l2; i4++) {
      const arg = arguments[i4];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = lastResult?.deref?.() ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = []
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index2) => {
          composition[inputSelectorKeys[index2]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState: getState2 }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState2, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
var createDraftSafeSelectorCreator = (...args) => {
  const createSelector2 = createSelectorCreator(...args);
  return (...args2) => {
    const selector = createSelector2(...args2);
    const wrappedSelector = (value, ...rest) => selector(isDraft(value) ? current(value) : value, ...rest);
    Object.assign(wrappedSelector, selector);
    return wrappedSelector;
  };
};
createDraftSafeSelectorCreator(weakMapMemoize);
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0)
    return void 0;
  if (typeof arguments[0] === "object")
    return compose;
  return compose.apply(null, arguments);
};
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(formatProdErrorMessage(0));
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function emplace(map, key, handler) {
  if (map.has(key)) {
    let value = map.get(key);
    if (handler.update) {
      value = handler.update(value, key, map);
      map.set(key, value);
    }
    return value;
  }
  if (!handler.insert)
    throw new Error(formatProdErrorMessage(10));
  const inserted = handler.insert(key, map);
  map.set(key, inserted);
  return inserted;
}
function isBoolean(x2) {
  return typeof x2 === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  return middlewareArray;
};
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store2 = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l2) => l2());
    }
  };
  return Object.assign({}, store2, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store2.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store2.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(formatProdErrorMessage(1));
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: false,
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(formatProdErrorMessage(28));
      }
      if (type in actionsMap) {
        throw new Error(formatProdErrorMessage(29));
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
function isStateFunction(x2) {
  return typeof x2 === "function";
}
function createReducer(initialState2, mapOrBuilderCallback) {
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState2)) {
    getInitialState = () => freezeDraftable(initialState2());
  } else {
    const frozenInitialState = freezeDraftable(initialState2);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw new Error(formatProdErrorMessage(9));
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
var asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error(formatProdErrorMessage(11));
    }
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(formatProdErrorMessage(12));
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(formatProdErrorMessage(13));
        }
        context.sliceCaseReducersByType[type] = reducer;
        return contextMethods;
      },
      addMatcher(matcher, reducer) {
        context.sliceMatchers.push({
          matcher,
          reducer
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer) {
        context.sliceCaseReducersByName[name2] = reducer;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m2 of actionMatchers) {
          builder.addMatcher(m2.matcher, m2.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new WeakMap();
    let _reducer;
    const slice = {
      name,
      reducerPath,
      reducer(state, action) {
        if (!_reducer)
          _reducer = buildReducer();
        return _reducer(state, action);
      },
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState() {
        if (!_reducer)
          _reducer = buildReducer();
        return _reducer.getInitialState();
      },
      getSelectors(selectState = selectSelf) {
        const selectorCache = emplace(injectedSelectorCache, this, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return emplace(selectorCache, selectState, {
          insert: () => {
            const map = {};
            for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
              map[name2] = wrapSelector(this, selector, selectState, this !== slice);
            }
            return map;
          }
        });
      },
      selectSlice(state) {
        let sliceState = state[this.reducerPath];
        if (typeof sliceState === "undefined") {
          if (this !== slice) {
            sliceState = this.getInitialState();
          }
        }
        return sliceState;
      },
      get selectors() {
        return this.getSelectors(this.selectSlice);
      },
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const reducerPath2 = pathOpt ?? this.reducerPath;
        injectable.inject({
          reducerPath: reducerPath2,
          reducer: this.reducer
        }, config);
        return {
          ...this,
          reducerPath: reducerPath2
        };
      }
    };
    return slice;
  };
}
function wrapSelector(slice, selector, selectState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState.call(slice, rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = slice.getInitialState();
      }
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(formatProdErrorMessage(17));
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(formatProdErrorMessage(18));
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk2 = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk2);
  if (fulfilled) {
    context.addCase(thunk2.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk2.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk2.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk2.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}
var alm = "listenerMiddleware";
createAction(`${alm}/add`);
createAction(`${alm}/removeAll`);
createAction(`${alm}/remove`);
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
const generateProductFilterKey = (filterType, filterValue) => {
  return `${filterType}:${filterValue}`.toLowerCase();
};
const initialState = {
  availableFilterTags: {},
  selectedFilterTags: {
    [PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY]: [
      generateProductFilterKey(
        PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
        "false"
      )
    ]
  },
  sizeFilterMode: SIZE_FILTER_MODE.BY_CATEGORY,
  sortBy: SortByType.RELEVANCE,
  availableSortByOptions: [
    SortByType.RELEVANCE,
    SortByType.NEWEST,
    SortByType.OLDEST,
    SortByType.PRICE_ASCENDING,
    SortByType.PRICE_DESCENDING
  ]
};
const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    /**
     * Set available filter tags from API response
     */
    setAvailableFilterTags: (state, action) => {
      state.availableFilterTags = action.payload;
    },
    /**
     * Set selected filter tags in bulk (e.g., from URL)
     */
    setSelectedFilterTags: (state, action) => {
      state.selectedFilterTags = action.payload;
    },
    /**
     * Toggle a single filter tag on or off
     */
    toggleFilterTag: (state, action) => {
      const { filterType, tagValue, selected } = action.payload;
      if (!state.selectedFilterTags[filterType]) {
        state.selectedFilterTags[filterType] = [];
      }
      const filterTags = state.selectedFilterTags[filterType];
      if (selected) {
        if (!filterTags.includes(tagValue)) {
          filterTags.push(tagValue);
        }
      } else {
        state.selectedFilterTags[filterType] = filterTags.filter(
          (v2) => v2 !== tagValue
        );
        if (state.selectedFilterTags[filterType].length === 0) {
          delete state.selectedFilterTags[filterType];
        }
      }
    },
    /**
     * Clear all selected filter tags
     */
    clearAllTags: (state) => {
      state.selectedFilterTags = {};
    },
    /**
     * Set size filter mode and clear size-related tags
     */
    setSizeFilterMode: (state, action) => {
      state.sizeFilterMode = action.payload;
      delete state.selectedFilterTags[PRODUCT_VARIANT_FILTER_TYPE.SIZE];
      delete state.selectedFilterTags[PRODUCT_GENERAL_FILTER_TYPE.CATEGORY_SIZE];
    },
    /**
     * Set size filter mode without clearing tags (for initialization from URL/localStorage)
     */
    initSizeFilterMode: (state, action) => {
      state.sizeFilterMode = action.payload;
    },
    /**
     * Set sort by value
     */
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    }
  }
});
const {
  setAvailableFilterTags,
  setSelectedFilterTags,
  toggleFilterTag,
  clearAllTags,
  setSizeFilterMode,
  initSizeFilterMode,
  setSortBy
} = filtersSlice.actions;
const filtersReducer = filtersSlice.reducer;
const searchResultsInitialState = {
  count: 0
};
const searchResultsSlice = createSlice({
  name: "searchResults",
  initialState: searchResultsInitialState,
  reducers: {
    /**
     * Set the search results count
     */
    setSearchResultsCount: (state, action) => {
      state.count = action.payload;
    }
  }
});
const { setSearchResultsCount } = searchResultsSlice.actions;
const pageResultsReducer = combineReducers({
  filters: filtersReducer,
  searchResults: searchResultsSlice.reducer
});
const getState = (state) => state.pageResults;
const getFiltersState = createSelector(
  [getState],
  (state) => state.filters
);
const getSearchResultsState = createSelector(
  [getState],
  (state) => state.searchResults
);
const getAvailableFilterTags = createSelector(
  [getFiltersState],
  (filters) => filters.availableFilterTags
);
const getSelectedFilterTags = createSelector(
  [getFiltersState],
  (filters) => filters.selectedFilterTags
);
const getSizeFilterMode = createSelector(
  [getFiltersState],
  (filters) => filters.sizeFilterMode
);
const getSortBy = createSelector(
  [getFiltersState],
  (filters) => filters.sortBy
);
const getAvailableSortByOptions = createSelector(
  [getFiltersState],
  (filters) => filters.availableSortByOptions
);
const getSelectedFilterTagsByType = (filterType) => createSelector(
  [getSelectedFilterTags],
  (selectedTags) => selectedTags[filterType] || []
);
const getAvailableFilterTagsByType = (filterType) => createSelector(
  [getAvailableFilterTags],
  (availableTags) => availableTags[filterType] || {}
);
const getSelectedFilterTagKeys = createSelector(
  [getSelectedFilterTags],
  (selectedTags) => Object.values(selectedTags).flat()
);
const getSelectedFiltersCount = createSelector(
  [getSelectedFilterTagKeys],
  (keys) => keys.length
);
const getSelectedSizeFilterCount = createSelector(
  [getSizeFilterMode, getSelectedFilterTags],
  (mode, selectedTags) => {
    if (mode === SIZE_FILTER_MODE.BY_CATEGORY) {
      return selectedTags[PRODUCT_GENERAL_FILTER_TYPE.CATEGORY_SIZE]?.length || 0;
    }
    return selectedTags[PRODUCT_VARIANT_FILTER_TYPE.SIZE]?.length || 0;
  }
);
const getSearchResultsCount = createSelector(
  [getSearchResultsState],
  (searchResults) => searchResults.count
);
const FILTER_TAGS_PARAM = "selectedFilterTags";
const SORT_BY_PARAM = "sortBy";
const actionsToSync = [
  setSelectedFilterTags.type,
  toggleFilterTag.type,
  clearAllTags.type,
  setSizeFilterMode.type,
  setSortBy.type
];
const isActionWithType = (action) => {
  return typeof action === "object" && action !== null && "type" in action && typeof action.type === "string";
};
const urlSyncMiddleware = (store2) => (next) => (action) => {
  const result = next(action);
  if (isActionWithType(action) && actionsToSync.includes(action.type)) {
    const state = store2.getState();
    const selectedFilterTags = getSelectedFilterTags(state);
    const sortBy = getSortBy(state);
    syncStateToURL(selectedFilterTags, sortBy);
  }
  return result;
};
function syncStateToURL(selectedFilterTags, sortBy) {
  const params = new URLSearchParams(window.location.search);
  if (Object.keys(selectedFilterTags).length > 0) {
    const encoded = encodeURIComponent(JSON.stringify(selectedFilterTags));
    params.set(FILTER_TAGS_PARAM, encoded);
  } else {
    params.delete(FILTER_TAGS_PARAM);
  }
  params.set(SORT_BY_PARAM, sortBy);
  const queryString = params.toString();
  const newUrl = queryString ? `${window.location.origin}${window.location.pathname}?${queryString}` : `${window.location.origin}${window.location.pathname}`;
  window.history.pushState({}, "", newUrl);
}
function getFiltersFromURL() {
  try {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get(FILTER_TAGS_PARAM);
    if (!encoded) {
      return null;
    }
    const decoded = decodeURIComponent(encoded);
    const parsed = JSON.parse(decoded);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      console.warn("Invalid filterTags structure in URL, using empty filters");
      return null;
    }
    for (const [key, value] of Object.entries(parsed)) {
      if (!Array.isArray(value)) {
        console.warn(`Invalid filterTags value for key "${key}" in URL, using empty filters`);
        return null;
      }
      for (const item of value) {
        if (typeof item !== "string") {
          console.warn(`Invalid filterTags item in key "${key}" in URL, using empty filters`);
          return null;
        }
      }
    }
    return parsed;
  } catch (error) {
    console.warn("Failed to parse filterTags from URL, using empty filters:", error);
    return null;
  }
}
function getSortByFromURL() {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(SORT_BY_PARAM);
  if (!value) {
    return null;
  }
  if (Object.values(SortByType).includes(value)) {
    return value;
  }
  return null;
}
const __vite_import_meta_env__ = { "BASE_URL": "/", "DEV": false, "MODE": "production", "PROD": true, "SSR": false, "VITE_RUNNING_LOCALLY": "false" };
const getViteEnv = (key) => {
  return __vite_import_meta_env__[key];
};
const isDevelopmentMode = () => Boolean(getViteEnv("VITE_RUNNING_LOCALLY") === "true");
const store = configureStore({
  reducer: {
    pageResults: pageResultsReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(urlSyncMiddleware),
  devTools: isDevelopmentMode()
});
function initializeStoreFromURL() {
  const filtersFromURL = getFiltersFromURL();
  const sortByFromURL = getSortByFromURL();
  if (filtersFromURL !== null) {
    store.dispatch(setSelectedFilterTags(filtersFromURL));
  }
  if (sortByFromURL !== null) {
    store.dispatch(setSortBy(sortByFromURL));
  }
}
initializeStoreFromURL();
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var lodash$1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var lodash = lodash$1.exports;
var hasRequiredLodash;
function requireLodash() {
  if (hasRequiredLodash) return lodash$1.exports;
  hasRequiredLodash = 1;
  (function(module, exports) {
    (function() {
      var undefined$1;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = exports && !exports.nodeType && exports;
      var freeModule = freeExports && true && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types2 = freeModule && freeModule.require && freeModule.require("util").types;
          if (types2) {
            return types2;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e2) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          var value = array[index2];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (iteratee(array[index2], index2, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (!predicate(array[index2], index2, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (comparator(value, array[index2])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index2 < length) {
          result[index2] = iteratee(array[index2], index2, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index2 = -1, length = values.length, offset2 = array.length;
        while (++index2 < length) {
          array[offset2 + index2] = values[index2];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index2 = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index2];
        }
        while (++index2 < length) {
          accumulator = iteratee(accumulator, array[index2], index2, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (predicate(array[index2], index2, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length) {
          if (predicate(array[index2], index2, array)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index2 = fromIndex - 1, length = array.length;
        while (++index2 < length) {
          if (comparator(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined$1 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined$1 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index2 = -1, length = array.length;
        while (++index2 < length) {
          var current2 = iteratee(array[index2]);
          if (current2 !== undefined$1) {
            result = result === undefined$1 ? current2 : result + current2;
          }
        }
        return result;
      }
      function baseTimes(n3, iteratee) {
        var index2 = -1, result = Array(n3);
        while (++index2 < n3) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index2 = -1, length = strSymbols.length;
        while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index2 = strSymbols.length;
        while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined$1 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index2] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index2 = -1, length = array.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index2] = PLACEHOLDER;
            result[resIndex++] = index2;
          }
        }
        return result;
      }
      function setToArray(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index2] = value;
        });
        return result;
      }
      function setToPairs(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index2] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index2 = fromIndex - 1, length = array.length;
        while (++index2 < length) {
          if (array[index2] === value) {
            return index2;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index2 = fromIndex + 1;
        while (index2--) {
          if (array[index2] === value) {
            return index2;
          }
        }
        return index2;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index2 = string.length;
        while (index2-- && reWhitespace.test(string.charAt(index2))) {
        }
        return index2;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString2 = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e2) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
        function lodash2(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined$1;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined$1;
        }
        lodash2.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash2
          }
        };
        lodash2.prototype = baseLodash.prototype;
        lodash2.prototype.constructor = lodash2;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index2 += dir;
              var iterIndex = -1, value = array[index2];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined$1 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index2 == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index2, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          return index2 < 0 ? undefined$1 : data[index2][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index2][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size3 = data.size;
          data.set(key, value);
          this.size += data.size == size3 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index2 = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index2 < length) {
            this.add(values2[index2]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined$1;
        }
        function arraySampleSize(array, n3) {
          return shuffleSelf(copyArray(array), baseClamp(n3, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index2 < length) {
            result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined$1) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined$1) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined$1) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet2(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap2(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined$1 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined$1 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined$1, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index2 < length) {
              var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index2, collection2) {
            result2 = !!predicate(value, index2, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index2 = -1, length = array.length;
          while (++index2 < length) {
            var value = array[index2], current2 = iteratee2(value);
            if (current2 != null && (computed === undefined$1 ? current2 === current2 && !isSymbol(current2) : comparator(current2, computed))) {
              var computed = current2, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined$1 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index2, collection2) {
            if (predicate(value, index2, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index2 = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index2 < length) {
            var value = array[index2];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index2 = 0, length = path.length;
          while (object != null && index2 < length) {
            object = object[toKey(path[index2++])];
          }
          return index2 && index2 == length ? object : undefined$1;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined$1 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
          }
          array = arrays[0];
          var index2 = -1, seen = caches[0];
          outer:
            while (++index2 < length && result2.length < maxLength) {
              var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined$1 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index2 = matchData.length, length = index2, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index2--) {
            var data = matchData[index2];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index2 < length) {
            data = matchData[index2];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined$1 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index2] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
              if (newValue === undefined$1) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
          var isCommon = newValue === undefined$1;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n3) {
          var length = array.length;
          if (!length) {
            return;
          }
          n3 += n3 < 0 ? length : 0;
          return isIndex(n3, length) ? array[n3] : undefined$1;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index2 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index2, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index2 = -1, length = paths.length, result2 = {};
          while (++index2 < length) {
            var path = paths[index2], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index2 < length) {
            var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index2 = indexes[length];
            if (length == lastIndex || index2 !== previous) {
              var previous = index2;
              if (isIndex(index2)) {
                splice.call(array, index2, 1);
              } else {
                baseUnset(array, index2);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index2] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n3) {
          var result2 = "";
          if (!string || n3 < 1 || n3 > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n3 % 2) {
              result2 += string;
            }
            n3 = nativeFloor(n3 / 2);
            if (n3) {
              string += string;
            }
          } while (n3);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n3) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n3, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index2 < length) {
            var key = toKey(path[index2]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index2 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
              if (newValue === undefined$1) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index2 = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index2 < length) {
            result2[index2] = array[index2 + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index2, collection2) {
            result2 = predicate(value, index2, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index2 = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            if (!index2 || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set3 = iteratee2 ? null : createSet(array);
            if (set3) {
              return setToArray(set3);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index2 < length) {
              var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index2 = fromRight ? length : -1;
          while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index2 = -1, result2 = Array2(length);
          while (++index2 < length) {
            var array = arrays[index2], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index2) {
                result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index2 < length) {
            var value = index2 < valsLength ? values2[index2] : undefined$1;
            assignFunc(result2, props[index2], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined$1 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index2 < length) {
            var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
            if (result2) {
              if (index2 >= ordersLength) {
                return result2;
              }
              var order = orders[index2];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset2 = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset2 + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index2 = -1, length = source.length;
          array || (array = Array2(length));
          while (++index2 < length) {
            array[index2] = source[index2];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index2 = -1, length = props.length;
          while (++index2 < length) {
            var key = props[index2];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
            if (newValue === undefined$1) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined$1 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index2 < length) {
              var source = sources[index2];
              if (source) {
                assigner(object, source, index2, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index2-- : ++index2 < length) {
              if (iteratee2(iterable[index2], index2, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index2];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
            while (index2--) {
              args[index2] = arguments[index2];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined$1,
                args,
                holders,
                undefined$1,
                undefined$1,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index2 = findIndexFunc(collection, predicate, fromIndex);
            return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index2--) {
              var func = funcs[index2];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index2 = wrapper ? index2 : length;
            while (++index2 < length) {
              func = funcs[index2];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
              while (++index3 < length) {
                result2 = funcs[index3].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length;
            while (index2--) {
              args[index2] = arguments[index2];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined$1 && other === undefined$1) {
              return defaultValue;
            }
            if (value !== undefined$1) {
              result2 = value;
            }
            if (other !== undefined$1) {
              if (result2 === undefined$1) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined$1 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined$1;
            }
            start = toFinite(start);
            if (end === undefined$1) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= -4;
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined$1, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= -97;
            partials = holders = undefined$1;
          }
          ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined$1 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined$1;
          }
          var data = isBindKey ? undefined$1 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= -25;
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined$1, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject2(value) ? undefined$1 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
          stack.set(array, other);
          stack.set(other, array);
          while (++index2 < arrLength) {
            var arrValue = array[index2], othValue = other[index2];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
            }
            if (compared !== undefined$1) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index2 = objLength;
          while (index2--) {
            var key = objProps[index2];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index2 < objLength) {
            key = objProps[index2];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined$1, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop2 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash2.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined$1;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined$1;
            var unmasked = true;
          } catch (e2) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index2 = -1, length = transforms.length;
          while (++index2 < length) {
            var data = transforms[index2], size3 = data.size;
            switch (data.type) {
              case "drop":
                start += size3;
                break;
              case "dropRight":
                end -= size3;
                break;
              case "take":
                end = nativeMin(end, start + size3);
                break;
              case "takeRight":
                start = nativeMax(start, end - size3);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index2 = -1, length = path.length, result2 = false;
          while (++index2 < length) {
            var key = toKey(path[index2]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index2 != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index2, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index2;
          if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
            return eq(object[index2], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash2[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index2 < length) {
              array[index2] = args[start + index2];
            }
            index2 = -1;
            var otherArgs = Array2(start + 1);
            while (++index2 < start) {
              otherArgs[index2] = args[index2];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index2 = indexes[length];
            array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined$1, arguments);
          };
        }
        function shuffleSelf(array, size3) {
          var index2 = -1, length = array.length, lastIndex = length - 1;
          size3 = size3 === undefined$1 ? length : size3;
          while (++index2 < size3) {
            var rand = baseRandom(index2, lastIndex), value = array[rand];
            array[rand] = array[index2];
            array[index2] = value;
          }
          array.length = size3;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e2) {
            }
            try {
              return func + "";
            } catch (e2) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size3, guard) {
          if (guard ? isIterateeCall(array, size3, guard) : size3 === undefined$1) {
            size3 = 1;
          } else {
            size3 = nativeMax(toInteger(size3), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size3 < 1) {
            return [];
          }
          var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size3));
          while (index2 < length) {
            result2[resIndex++] = baseSlice(array, index2, index2 += size3);
          }
          return result2;
        }
        function compact(array) {
          var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array[index2];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index2 = length;
          while (index2--) {
            args[index2 - 1] = arguments[index2];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
        });
        function drop(array, n3, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
          return baseSlice(array, n3 < 0 ? 0 : n3, length);
        }
        function dropRight(array, n3, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
          n3 = length - n3;
          return baseSlice(array, 0, n3 < 0 ? 0 : n3);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = length - 1;
          if (fromIndex !== undefined$1) {
            index2 = toInteger(fromIndex);
            index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index2 < length) {
            var pair = pairs[index2];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined$1;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseIndexOf(array, value, index2);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined$1;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined$1;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = length;
          if (fromIndex !== undefined$1) {
            index2 = toInteger(fromIndex);
            index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
        }
        function nth(array, n3) {
          return array && array.length ? baseNth(array, toInteger(n3)) : undefined$1;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index2) {
            return isIndex(index2, length) ? +index2 : index2;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index2 = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index2 < length) {
            var value = array[index2];
            if (predicate(value, index2, array)) {
              result2.push(value);
              indexes.push(index2);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined$1 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index2 = baseSortedIndex(array, value);
            if (index2 < length && eq(array[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index2 = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n3, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
          return baseSlice(array, 0, n3 < 0 ? 0 : n3);
        }
        function takeRight(array, n3, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
          n3 = length - n3;
          return baseSlice(array, n3 < 0 ? 0 : n3, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index2) {
            return arrayMap(array, baseProperty(index2));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined$1, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash2(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined$1
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined$1);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined$1) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined$1;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined$1
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined$1 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n3, guard) {
          if (guard ? isIterateeCall(collection, n3, guard) : n3 === undefined$1) {
            n3 = 1;
          } else {
            n3 = toInteger(n3);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n3);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size2(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n3, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n3 = toInteger(n3);
          return function() {
            if (--n3 < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n3, guard) {
          n3 = guard ? undefined$1 : n3;
          n3 = func && n3 == null ? func.length : n3;
          return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n3);
        }
        function before(n3, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n3 = toInteger(n3);
          return function() {
            if (--n3 > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n3 <= 1) {
              func = undefined$1;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined$1;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined$1;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined$1;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined$1) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined$1;
          }
          function flush() {
            return timerId === undefined$1 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined$1) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined$1) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip2(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index2 = -1, length = nativeMin(args.length, funcsLength);
            while (++index2 < length) {
              args[index2] = transforms[index2].call(this, args[index2]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined$1 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean2(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement2(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          var result2 = customizer ? customizer(value, other) : undefined$1;
          return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap2 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject2(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString2;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet2 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined$1;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index2 = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index2 < length) {
            var source = sources[index2];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined$1, customDefaultsMerge);
          return apply(mergeWith, undefined$1, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined$1 : baseGet(object, path);
          return result2 === undefined$1 ? defaultValue : result2;
        }
        function has2(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index2 = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined$1;
          }
          while (++index2 < length) {
            var value = object == null ? undefined$1 : object[toKey(path[index2])];
            if (value === undefined$1) {
              index2 = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set2(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
            return iteratee2(accumulator, value, index2, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update2(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp2(number, lower, upper) {
          if (upper === undefined$1) {
            upper = lower;
            lower = undefined$1;
          }
          if (upper !== undefined$1) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined$1) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined$1;
          }
          if (floating === undefined$1) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined$1;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined$1;
            }
          }
          if (lower === undefined$1 && upper === undefined$1) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined$1) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index2) {
          word = word.toLowerCase();
          return result2 + (index2 ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n3, guard) {
          if (guard ? isIterateeCall(string, n3, guard) : n3 === undefined$1) {
            n3 = 1;
          } else {
            n3 = toInteger(n3);
          }
          return baseRepeat(toString(string), n3);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined$1;
          }
          limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash2.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined$1;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index2 = offset2 + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined$1) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index2 = result2.lastIndexOf(separator);
            if (index2 > -1) {
              result2 = result2.slice(0, index2);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined$1 : pattern;
          if (pattern === undefined$1) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined$1, args);
          } catch (e2) {
            return isError(e2) ? e2 : new Error2(e2);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index2 = -1;
            while (++index2 < length) {
              var pair = pairs[index2];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop2() {
        }
        function nthArg(n3) {
          n3 = toInteger(n3);
          return baseRest(function(args) {
            return baseNth(args, n3);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined$1 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n3, iteratee2) {
          n3 = toInteger(n3);
          if (n3 < 1 || n3 > MAX_SAFE_INTEGER) {
            return [];
          }
          var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n3, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n3 -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index2 < n3) {
            iteratee2(index2);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId2(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor2 = createRound("floor");
        function max2(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min2(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round2 = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash2.after = after;
        lodash2.ary = ary;
        lodash2.assign = assign;
        lodash2.assignIn = assignIn;
        lodash2.assignInWith = assignInWith;
        lodash2.assignWith = assignWith;
        lodash2.at = at;
        lodash2.before = before;
        lodash2.bind = bind;
        lodash2.bindAll = bindAll;
        lodash2.bindKey = bindKey;
        lodash2.castArray = castArray;
        lodash2.chain = chain;
        lodash2.chunk = chunk;
        lodash2.compact = compact;
        lodash2.concat = concat;
        lodash2.cond = cond;
        lodash2.conforms = conforms;
        lodash2.constant = constant;
        lodash2.countBy = countBy;
        lodash2.create = create;
        lodash2.curry = curry;
        lodash2.curryRight = curryRight;
        lodash2.debounce = debounce;
        lodash2.defaults = defaults;
        lodash2.defaultsDeep = defaultsDeep;
        lodash2.defer = defer;
        lodash2.delay = delay;
        lodash2.difference = difference;
        lodash2.differenceBy = differenceBy;
        lodash2.differenceWith = differenceWith;
        lodash2.drop = drop;
        lodash2.dropRight = dropRight;
        lodash2.dropRightWhile = dropRightWhile;
        lodash2.dropWhile = dropWhile;
        lodash2.fill = fill;
        lodash2.filter = filter;
        lodash2.flatMap = flatMap;
        lodash2.flatMapDeep = flatMapDeep;
        lodash2.flatMapDepth = flatMapDepth;
        lodash2.flatten = flatten;
        lodash2.flattenDeep = flattenDeep;
        lodash2.flattenDepth = flattenDepth;
        lodash2.flip = flip2;
        lodash2.flow = flow;
        lodash2.flowRight = flowRight;
        lodash2.fromPairs = fromPairs;
        lodash2.functions = functions;
        lodash2.functionsIn = functionsIn;
        lodash2.groupBy = groupBy;
        lodash2.initial = initial;
        lodash2.intersection = intersection;
        lodash2.intersectionBy = intersectionBy;
        lodash2.intersectionWith = intersectionWith;
        lodash2.invert = invert;
        lodash2.invertBy = invertBy;
        lodash2.invokeMap = invokeMap;
        lodash2.iteratee = iteratee;
        lodash2.keyBy = keyBy;
        lodash2.keys = keys;
        lodash2.keysIn = keysIn;
        lodash2.map = map;
        lodash2.mapKeys = mapKeys;
        lodash2.mapValues = mapValues;
        lodash2.matches = matches;
        lodash2.matchesProperty = matchesProperty;
        lodash2.memoize = memoize;
        lodash2.merge = merge;
        lodash2.mergeWith = mergeWith;
        lodash2.method = method;
        lodash2.methodOf = methodOf;
        lodash2.mixin = mixin;
        lodash2.negate = negate;
        lodash2.nthArg = nthArg;
        lodash2.omit = omit;
        lodash2.omitBy = omitBy;
        lodash2.once = once;
        lodash2.orderBy = orderBy;
        lodash2.over = over;
        lodash2.overArgs = overArgs;
        lodash2.overEvery = overEvery;
        lodash2.overSome = overSome;
        lodash2.partial = partial;
        lodash2.partialRight = partialRight;
        lodash2.partition = partition;
        lodash2.pick = pick;
        lodash2.pickBy = pickBy;
        lodash2.property = property;
        lodash2.propertyOf = propertyOf;
        lodash2.pull = pull;
        lodash2.pullAll = pullAll;
        lodash2.pullAllBy = pullAllBy;
        lodash2.pullAllWith = pullAllWith;
        lodash2.pullAt = pullAt;
        lodash2.range = range;
        lodash2.rangeRight = rangeRight;
        lodash2.rearg = rearg;
        lodash2.reject = reject;
        lodash2.remove = remove;
        lodash2.rest = rest;
        lodash2.reverse = reverse;
        lodash2.sampleSize = sampleSize;
        lodash2.set = set2;
        lodash2.setWith = setWith;
        lodash2.shuffle = shuffle;
        lodash2.slice = slice;
        lodash2.sortBy = sortBy;
        lodash2.sortedUniq = sortedUniq;
        lodash2.sortedUniqBy = sortedUniqBy;
        lodash2.split = split;
        lodash2.spread = spread;
        lodash2.tail = tail;
        lodash2.take = take;
        lodash2.takeRight = takeRight;
        lodash2.takeRightWhile = takeRightWhile;
        lodash2.takeWhile = takeWhile;
        lodash2.tap = tap;
        lodash2.throttle = throttle;
        lodash2.thru = thru;
        lodash2.toArray = toArray;
        lodash2.toPairs = toPairs;
        lodash2.toPairsIn = toPairsIn;
        lodash2.toPath = toPath;
        lodash2.toPlainObject = toPlainObject;
        lodash2.transform = transform;
        lodash2.unary = unary;
        lodash2.union = union;
        lodash2.unionBy = unionBy;
        lodash2.unionWith = unionWith;
        lodash2.uniq = uniq;
        lodash2.uniqBy = uniqBy;
        lodash2.uniqWith = uniqWith;
        lodash2.unset = unset;
        lodash2.unzip = unzip;
        lodash2.unzipWith = unzipWith;
        lodash2.update = update2;
        lodash2.updateWith = updateWith;
        lodash2.values = values;
        lodash2.valuesIn = valuesIn;
        lodash2.without = without;
        lodash2.words = words;
        lodash2.wrap = wrap;
        lodash2.xor = xor;
        lodash2.xorBy = xorBy;
        lodash2.xorWith = xorWith;
        lodash2.zip = zip;
        lodash2.zipObject = zipObject;
        lodash2.zipObjectDeep = zipObjectDeep;
        lodash2.zipWith = zipWith;
        lodash2.entries = toPairs;
        lodash2.entriesIn = toPairsIn;
        lodash2.extend = assignIn;
        lodash2.extendWith = assignInWith;
        mixin(lodash2, lodash2);
        lodash2.add = add;
        lodash2.attempt = attempt;
        lodash2.camelCase = camelCase;
        lodash2.capitalize = capitalize;
        lodash2.ceil = ceil;
        lodash2.clamp = clamp2;
        lodash2.clone = clone;
        lodash2.cloneDeep = cloneDeep;
        lodash2.cloneDeepWith = cloneDeepWith;
        lodash2.cloneWith = cloneWith;
        lodash2.conformsTo = conformsTo;
        lodash2.deburr = deburr;
        lodash2.defaultTo = defaultTo;
        lodash2.divide = divide;
        lodash2.endsWith = endsWith;
        lodash2.eq = eq;
        lodash2.escape = escape;
        lodash2.escapeRegExp = escapeRegExp;
        lodash2.every = every;
        lodash2.find = find;
        lodash2.findIndex = findIndex;
        lodash2.findKey = findKey;
        lodash2.findLast = findLast;
        lodash2.findLastIndex = findLastIndex;
        lodash2.findLastKey = findLastKey;
        lodash2.floor = floor2;
        lodash2.forEach = forEach;
        lodash2.forEachRight = forEachRight;
        lodash2.forIn = forIn;
        lodash2.forInRight = forInRight;
        lodash2.forOwn = forOwn;
        lodash2.forOwnRight = forOwnRight;
        lodash2.get = get;
        lodash2.gt = gt;
        lodash2.gte = gte;
        lodash2.has = has2;
        lodash2.hasIn = hasIn;
        lodash2.head = head;
        lodash2.identity = identity;
        lodash2.includes = includes;
        lodash2.indexOf = indexOf;
        lodash2.inRange = inRange;
        lodash2.invoke = invoke;
        lodash2.isArguments = isArguments;
        lodash2.isArray = isArray;
        lodash2.isArrayBuffer = isArrayBuffer;
        lodash2.isArrayLike = isArrayLike;
        lodash2.isArrayLikeObject = isArrayLikeObject;
        lodash2.isBoolean = isBoolean2;
        lodash2.isBuffer = isBuffer;
        lodash2.isDate = isDate;
        lodash2.isElement = isElement2;
        lodash2.isEmpty = isEmpty;
        lodash2.isEqual = isEqual;
        lodash2.isEqualWith = isEqualWith;
        lodash2.isError = isError;
        lodash2.isFinite = isFinite;
        lodash2.isFunction = isFunction;
        lodash2.isInteger = isInteger;
        lodash2.isLength = isLength;
        lodash2.isMap = isMap2;
        lodash2.isMatch = isMatch;
        lodash2.isMatchWith = isMatchWith;
        lodash2.isNaN = isNaN2;
        lodash2.isNative = isNative;
        lodash2.isNil = isNil;
        lodash2.isNull = isNull;
        lodash2.isNumber = isNumber;
        lodash2.isObject = isObject;
        lodash2.isObjectLike = isObjectLike;
        lodash2.isPlainObject = isPlainObject2;
        lodash2.isRegExp = isRegExp;
        lodash2.isSafeInteger = isSafeInteger;
        lodash2.isSet = isSet2;
        lodash2.isString = isString;
        lodash2.isSymbol = isSymbol;
        lodash2.isTypedArray = isTypedArray;
        lodash2.isUndefined = isUndefined;
        lodash2.isWeakMap = isWeakMap;
        lodash2.isWeakSet = isWeakSet;
        lodash2.join = join;
        lodash2.kebabCase = kebabCase;
        lodash2.last = last;
        lodash2.lastIndexOf = lastIndexOf;
        lodash2.lowerCase = lowerCase;
        lodash2.lowerFirst = lowerFirst;
        lodash2.lt = lt;
        lodash2.lte = lte;
        lodash2.max = max2;
        lodash2.maxBy = maxBy;
        lodash2.mean = mean;
        lodash2.meanBy = meanBy;
        lodash2.min = min2;
        lodash2.minBy = minBy;
        lodash2.stubArray = stubArray;
        lodash2.stubFalse = stubFalse;
        lodash2.stubObject = stubObject;
        lodash2.stubString = stubString;
        lodash2.stubTrue = stubTrue;
        lodash2.multiply = multiply;
        lodash2.nth = nth;
        lodash2.noConflict = noConflict;
        lodash2.noop = noop2;
        lodash2.now = now;
        lodash2.pad = pad;
        lodash2.padEnd = padEnd;
        lodash2.padStart = padStart;
        lodash2.parseInt = parseInt2;
        lodash2.random = random;
        lodash2.reduce = reduce;
        lodash2.reduceRight = reduceRight;
        lodash2.repeat = repeat;
        lodash2.replace = replace;
        lodash2.result = result;
        lodash2.round = round2;
        lodash2.runInContext = runInContext2;
        lodash2.sample = sample;
        lodash2.size = size2;
        lodash2.snakeCase = snakeCase;
        lodash2.some = some;
        lodash2.sortedIndex = sortedIndex;
        lodash2.sortedIndexBy = sortedIndexBy;
        lodash2.sortedIndexOf = sortedIndexOf;
        lodash2.sortedLastIndex = sortedLastIndex;
        lodash2.sortedLastIndexBy = sortedLastIndexBy;
        lodash2.sortedLastIndexOf = sortedLastIndexOf;
        lodash2.startCase = startCase;
        lodash2.startsWith = startsWith;
        lodash2.subtract = subtract;
        lodash2.sum = sum;
        lodash2.sumBy = sumBy;
        lodash2.template = template;
        lodash2.times = times;
        lodash2.toFinite = toFinite;
        lodash2.toInteger = toInteger;
        lodash2.toLength = toLength;
        lodash2.toLower = toLower;
        lodash2.toNumber = toNumber;
        lodash2.toSafeInteger = toSafeInteger;
        lodash2.toString = toString;
        lodash2.toUpper = toUpper;
        lodash2.trim = trim;
        lodash2.trimEnd = trimEnd;
        lodash2.trimStart = trimStart;
        lodash2.truncate = truncate;
        lodash2.unescape = unescape;
        lodash2.uniqueId = uniqueId2;
        lodash2.upperCase = upperCase;
        lodash2.upperFirst = upperFirst;
        lodash2.each = forEach;
        lodash2.eachRight = forEachRight;
        lodash2.first = head;
        mixin(lodash2, function() {
          var source = {};
          baseForOwn(lodash2, function(func, methodName) {
            if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash2.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash2[methodName].placeholder = lodash2;
        });
        arrayEach(["drop", "take"], function(methodName, index2) {
          LazyWrapper.prototype[methodName] = function(n3) {
            n3 = n3 === undefined$1 ? 1 : nativeMax(toInteger(n3), 0);
            var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n3, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n3, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n3) {
            return this.reverse()[methodName](n3).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
          var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index2) {
          var takeName = "take" + (index2 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index2) {
          var dropName = "drop" + (index2 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined$1) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash2.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash2.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash2[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined$1
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash2.prototype.at = wrapperAt;
        lodash2.prototype.chain = wrapperChain;
        lodash2.prototype.commit = wrapperCommit;
        lodash2.prototype.next = wrapperNext;
        lodash2.prototype.plant = wrapperPlant;
        lodash2.prototype.reverse = wrapperReverse;
        lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
        lodash2.prototype.first = lodash2.prototype.head;
        if (symIterator) {
          lodash2.prototype[symIterator] = wrapperToIterator;
        }
        return lodash2;
      };
      var _2 = runInContext();
      if (freeModule) {
        (freeModule.exports = _2)._ = _2;
        freeExports._ = _2;
      } else {
        root._ = _2;
      }
    }).call(lodash);
  })(lodash$1, lodash$1.exports);
  return lodash$1.exports;
}
var lodashExports = requireLodash();
class MemoizedSelector {
  /**
   * Creates a new MemoizedSelector controller.
   *
   * @param host - The Lit component that will host this controller
   * @param selector - A selector function that extracts the desired state slice
   */
  constructor(host, selector) {
    this.unsubscribe = null;
    this.host = host;
    this.selector = selector;
    this._value = selector(store.getState());
    host.addController(this);
  }
  /**
   * Gets the current value from the selector.
   *
   * This getter provides access to the latest selected state value.
   * The value is automatically updated when the store changes and
   * the selected slice differs from the previous value.
   *
   * @returns The current selected state value
   */
  get value() {
    return this._value;
  }
  /**
   * Called when the host component is connected to the DOM.
   *
   * Sets up the store subscription to listen for state changes.
   * When state changes, performs a deep equality check using lodash isEqual.
   * Only triggers a component re-render if the selected state actually changed.
   */
  hostConnected() {
    this.unsubscribe = store.subscribe(() => {
      const newValue = this.selector(store.getState());
      if (!lodashExports.isEqual(this._value, newValue)) {
        this._value = newValue;
        this.host.requestUpdate();
      }
    });
  }
  /**
   * Called when the host component is disconnected from the DOM.
   *
   * Cleans up the store subscription to prevent memory leaks
   * and avoid updating disconnected components.
   */
  hostDisconnected() {
    this.unsubscribe?.();
    this.unsubscribe = null;
  }
}
var __create$q = Object.create;
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __knownSymbol$q = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$q = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$q = (target, value) => __defProp$q(target, "name", { value, configurable: true });
var __decoratorStart$q = (base) => [, , , __create$q(base?.[__knownSymbol$q("metadata")] ?? null)];
var __decoratorStrings$q = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$q = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$q("Function expected") : fn;
var __decoratorContext$q = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$q[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$q("Already initialized") : fns.push(__expectFn$q(fn || null)) });
var __decoratorMetadata$q = (array, target) => __defNormalProp$q(target, __knownSymbol$q("metadata"), array[3]);
var __runInitializers$q = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$q = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$q[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$q(k2 < 4 ? target : { get [name]() {
    return __privateGet$m(this, extra);
  }, set [name](x2) {
    return __privateSet$m(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$q(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$q(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$q(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$m(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$m : __privateMethod$m)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$m(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$q(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$q("Object expected");
    else __expectFn$q(fn = it.get) && (desc.get = fn), __expectFn$q(fn = it.set) && (desc.set = fn), __expectFn$q(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$q(array, target), desc && __defProp$q(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$m = (obj, member, msg) => member.has(obj) || __typeError$q("Cannot " + msg);
var __privateIn$m = (member, obj) => Object(obj) !== obj ? __typeError$q('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$m = (obj, member, getter) => (__accessCheck$m(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$m = (obj, member, value) => member.has(obj) ? __typeError$q("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$m = (obj, member, value, setter) => (__accessCheck$m(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$m = (obj, member, method) => (__accessCheck$m(obj, member, "access private method"), method);
var _visible_dec$8, _a$q, _SizeFilter_decorators, _init$q, _visible$8;
_SizeFilter_decorators = [t$1("briffa-size-filter")];
class SizeFilter extends (_a$q = BaseDesignSystemComponent(), _visible_dec$8 = [n$1({ type: Boolean })], _a$q) {
  constructor() {
    super();
    __privateAdd$m(this, _visible$8, __runInitializers$q(_init$q, 8, this, false)), __runInitializers$q(_init$q, 11, this);
    this.availableSizesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_VARIANT_FILTER_TYPE.SIZE)
    );
    this.availableCategorySizesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.CATEGORY_SIZE)
    );
    this.selectedSizesSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_VARIANT_FILTER_TYPE.SIZE)
    );
    this.selectedCategorySizesSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.CATEGORY_SIZE)
    );
    this.sizeFilterModeSelector = new MemoizedSelector(
      this,
      getSizeFilterMode
    );
    this.selectedSizeCountSelector = new MemoizedSelector(
      this,
      getSelectedSizeFilterCount
    );
    this.localStorageCategoriseSizes = "briffa-categorize-sizes";
    {
      store.dispatch(initSizeFilterMode(SIZE_FILTER_MODE.ALL_VALUES));
      return;
    }
  }
  _handleSizeTagToggle(tag, selected) {
    const currentMode = this.sizeFilterModeSelector.value;
    const filterType = currentMode === SIZE_FILTER_MODE.BY_CATEGORY ? PRODUCT_GENERAL_FILTER_TYPE.CATEGORY_SIZE : PRODUCT_VARIANT_FILTER_TYPE.SIZE;
    store.dispatch(
      toggleFilterTag({
        filterType,
        tagValue: tag,
        selected
      })
    );
  }
  _handleModeToggle(toggled) {
    const newMode = toggled ? SIZE_FILTER_MODE.BY_CATEGORY : SIZE_FILTER_MODE.ALL_VALUES;
    localStorage.setItem(this.localStorageCategoriseSizes, toggled.toString());
    store.dispatch(setSizeFilterMode(newMode));
  }
  /**
   * Get the count of selected size filters.
   * Uses the centralized selector that handles both modes.
   */
  getSelectedValuesTotalCount() {
    return this.selectedSizeCountSelector.value;
  }
  /**
   * Check if component should be visible based on available sizes.
   */
  _checkVisibility() {
    const availableSizes = this.availableSizesSelector.value;
    const availableCategorySizes = this.availableCategorySizesSelector.value;
    return Object.keys(availableSizes).length > 0 || Object.keys(availableCategorySizes).length > 0;
  }
  render() {
    const isVisible = this._checkVisibility();
    if (!isVisible) {
      return x``;
    }
    {
      return x`
                <div>
                    ${this._renderAllSizes()}
                </div>
            `;
    }
  }
  _renderModeSelector() {
    const currentMode = this.sizeFilterModeSelector.value;
    const isToggled = currentMode === SIZE_FILTER_MODE.BY_CATEGORY;
    return x`
            <div class="flex gap-2 items-center py-2 mb-2">
                <wa-icon id="size-filter-info" name="circle-info" class="text-gray-500 cursor-help"></wa-icon>
                <wa-tooltip for="size-filter-info">Filter sizes by product type</wa-tooltip>
                <span>Filter by product type</span>
                <wa-switch
                    ?checked=${isToggled}
                    @change=${(e2) => {
      const target = e2.target;
      this._handleModeToggle(target.checked);
    }}
                ></wa-switch>
            </div>
        `;
  }
  _renderAllSizes() {
    const availableSizes = this.availableSizesSelector.value;
    const selectedTags = this.selectedSizesSelector.value;
    const tags = Object.values(availableSizes);
    return x`
            <div class="flex flex-wrap gap-4 pt-2">
                ${tags.map((tagDetails) => {
      const isSelected = selectedTags.includes(tagDetails.tag);
      const visibleCount = tagDetails.resultsCount || 0;
      return x`
                        <briffa-toggle-filter
                            class="text-sm uppercase"
                            style="order: ${tagDetails.sortOrder}"
                            .text=${tagDetails.displayValue}
                            .count=${visibleCount}
                            .selected=${isSelected}
                            @selected-changed=${(e2) => {
        e2.stopPropagation();
        this._handleSizeTagToggle(tagDetails.tag, e2.detail.selected);
      }}
                        >
                        </briffa-toggle-filter>
                    `;
    })}
            </div>
        `;
  }
  _renderCategorySizes() {
    const availableCategorySizes = this.availableCategorySizesSelector.value;
    const selectedTags = this.selectedCategorySizesSelector.value;
    const categoryTags = Object.values(availableCategorySizes);
    const groupedByCategory = {};
    categoryTags.forEach((tagDetails) => {
      const match = tagDetails.tag.match(/^category-size:([^-]+)-/);
      if (match) {
        const category = match[1];
        if (!groupedByCategory[category]) {
          groupedByCategory[category] = [];
        }
        groupedByCategory[category].push(tagDetails);
      }
    });
    const categories = Object.keys(groupedByCategory);
    if (categories.length === 0) {
      return x`<p class="text-sm text-gray-500 pt-2">No sizes available</p>`;
    }
    return x`
            <div class="flex flex-col space-y-2">
                ${categories.map((category) => {
      const categoryTagsList = groupedByCategory[category];
      categoryTagsList.sort((a2, b2) => a2.sortOrder - b2.sortOrder);
      const selectedCount = categoryTagsList.filter((t2) => selectedTags.includes(t2.tag)).length;
      const subtitle = selectedCount > 0 ? `(${selectedCount} selected)` : "";
      const displayName = category.charAt(0).toUpperCase() + category.slice(1);
      return x`
                        <briffa-accordion-filter
                            accordion-id="size-category-${category}"
                            accordion-group="size-categories"
                            visibility-key="size-filter-categories"
                            .title=${displayName}
                            .subtitle=${subtitle}
                            .isCollapsed=${true}
                            body-class="pb-2"
                        >
                            <div slot="body" class="flex flex-wrap gap-1">
                                ${categoryTagsList.map((tagDetails) => {
        const isSelected = selectedTags.includes(tagDetails.tag);
        const visibleCount = tagDetails.resultsCount || 0;
        return x`
                                        <briffa-toggle-filter
                                            class="text-sm uppercase"
                                            style="order: ${tagDetails.sortOrder}"
                                            .text=${tagDetails.displayValue}
                                            .count=${visibleCount}
                                            .selected=${isSelected}
                                            @selected-changed=${(e2) => {
          e2.stopPropagation();
          this._handleSizeTagToggle(
            tagDetails.tag,
            e2.detail.selected
          );
        }}
                                        >
                                        </briffa-toggle-filter>
                                    `;
      })}
                            </div>
                        </briffa-accordion-filter>
                    `;
    })}
            </div>
        `;
  }
}
_init$q = __decoratorStart$q(_a$q);
_visible$8 = /* @__PURE__ */ new WeakMap();
__decorateElement$q(_init$q, 4, "visible", _visible_dec$8, SizeFilter, _visible$8);
SizeFilter = __decorateElement$q(_init$q, 0, "SizeFilter", _SizeFilter_decorators, SizeFilter);
__runInitializers$q(_init$q, 1, SizeFilter);
const toggleFilterStyles = safeCss(`
    :host {
        display: inline-block;
        cursor: pointer;
        user-select: none;
    }

    .toggle-container {
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid transparent;
        border-radius: ${borderRadius.md};
        padding: ${spacing["gutter-sm"]} ${spacing["gutter-md"]};
        background-color: transparent;
        cursor: pointer;
        transition: all 0.2s ease;
        border-color: ${colors.border.light};
        box-shadow: inset 0px 0px 1px 0 rgba(0,0,0,0.5);
        color: ${colors.text.secondary};
    }

    .toggle-container:focus {
        background-color: ${colors.background.secondary};
        outline: none;
    }

    .toggle-container:hover {
        border-color: ${colors.border.hover};
    }

    .toggle-container.selected {
        background-color: ${colors.gray[100]};
        border-color: ${colors.primary[600]};
        box-shadow: inset 0px 0px 0px 1px ${colors.primary[600]};
        color: ${colors.text.brand};
    }
    
    .toggle-container.selected:hover {
        background-color: transparent;
    }

    .text {
        margin: 0;
        font-weight: inherit;
        color: inherit;
    }

    .counter {
        margin-left: ${spacing["gutter-xs"]};
        color: inherit;
    }
`);
const counterLabelStyles = safeCss(`
    :host {
        display: inline-flex;
        align-items: center;
    }

    .counter {
        margin-left: ${spacing["gutter-sm"]};
        color: ${colors.text.tertiary};
    }

    .counter.hidden {
        display: none;
    }
`);
var __create$p = Object.create;
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __knownSymbol$p = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$p = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$p = (target, value) => __defProp$p(target, "name", { value, configurable: true });
var __decoratorStart$p = (base) => [, , , __create$p(base?.[__knownSymbol$p("metadata")] ?? null)];
var __decoratorStrings$p = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$p = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$p("Function expected") : fn;
var __decoratorContext$p = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$p[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$p("Already initialized") : fns.push(__expectFn$p(fn || null)) });
var __decoratorMetadata$p = (array, target) => __defNormalProp$p(target, __knownSymbol$p("metadata"), array[3]);
var __runInitializers$p = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$p = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$p[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$p(k2 < 4 ? target : { get [name]() {
    return __privateGet$l(this, extra);
  }, set [name](x2) {
    return __privateSet$l(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$p(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$p(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$p(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$l(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$l : __privateMethod$l)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$l(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$p(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$p("Object expected");
    else __expectFn$p(fn = it.get) && (desc.get = fn), __expectFn$p(fn = it.set) && (desc.set = fn), __expectFn$p(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$p(array, target), desc && __defProp$p(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$l = (obj, member, msg) => member.has(obj) || __typeError$p("Cannot " + msg);
var __privateIn$l = (member, obj) => Object(obj) !== obj ? __typeError$p('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$l = (obj, member, getter) => (__accessCheck$l(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$l = (obj, member, value) => member.has(obj) ? __typeError$p("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$l = (obj, member, value, setter) => (__accessCheck$l(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$l = (obj, member, method) => (__accessCheck$l(obj, member, "access private method"), method);
var _showCounter_dec$2, _count_dec$2, _a$p, _BriffaCounterLabel_decorators, _init$p, _count$2, _showCounter$2;
_BriffaCounterLabel_decorators = [t$1("briffa-counter-label")];
class BriffaCounterLabel extends (_a$p = BaseDesignSystemComponent(
  counterLabelStyles
), _count_dec$2 = [n$1({ type: Number })], _showCounter_dec$2 = [n$1({ type: Boolean, attribute: "show-counter" })], _a$p) {
  constructor() {
    super(...arguments);
    __privateAdd$l(this, _count$2, __runInitializers$p(_init$p, 8, this, 0)), __runInitializers$p(_init$p, 11, this);
    __privateAdd$l(this, _showCounter$2, __runInitializers$p(_init$p, 12, this, true)), __runInitializers$p(_init$p, 15, this);
  }
  setCounterNumber(count) {
    this.count = count;
  }
  hideCounterNumber() {
    this.showCounter = false;
  }
  showCounterNumber() {
    this.showCounter = true;
  }
  render() {
    return x`
            <span class="counter ${!this.showCounter ? "hidden" : ""}"
                >(${this.count})</span
            >
        `;
  }
}
_init$p = __decoratorStart$p(_a$p);
_count$2 = /* @__PURE__ */ new WeakMap();
_showCounter$2 = /* @__PURE__ */ new WeakMap();
__decorateElement$p(_init$p, 4, "count", _count_dec$2, BriffaCounterLabel, _count$2);
__decorateElement$p(_init$p, 4, "showCounter", _showCounter_dec$2, BriffaCounterLabel, _showCounter$2);
BriffaCounterLabel = __decorateElement$p(_init$p, 0, "BriffaCounterLabel", _BriffaCounterLabel_decorators, BriffaCounterLabel);
__runInitializers$p(_init$p, 1, BriffaCounterLabel);
var __create$o = Object.create;
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __knownSymbol$o = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$o = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$o = (target, value) => __defProp$o(target, "name", { value, configurable: true });
var __decoratorStart$o = (base) => [, , , __create$o(base?.[__knownSymbol$o("metadata")] ?? null)];
var __decoratorStrings$o = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$o = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$o("Function expected") : fn;
var __decoratorContext$o = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$o[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$o("Already initialized") : fns.push(__expectFn$o(fn || null)) });
var __decoratorMetadata$o = (array, target) => __defNormalProp$o(target, __knownSymbol$o("metadata"), array[3]);
var __runInitializers$o = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$o = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$o[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$o(k2 < 4 ? target : { get [name]() {
    return __privateGet$k(this, extra);
  }, set [name](x2) {
    return __privateSet$k(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$o(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$o(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$o(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$k(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$k : __privateMethod$k)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$k(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$o(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$o("Object expected");
    else __expectFn$o(fn = it.get) && (desc.get = fn), __expectFn$o(fn = it.set) && (desc.set = fn), __expectFn$o(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$o(array, target), desc && __defProp$o(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$k = (obj, member, msg) => member.has(obj) || __typeError$o("Cannot " + msg);
var __privateIn$k = (member, obj) => Object(obj) !== obj ? __typeError$o('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$k = (obj, member, getter) => (__accessCheck$k(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$k = (obj, member, value) => member.has(obj) ? __typeError$o("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$k = (obj, member, value, setter) => (__accessCheck$k(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$k = (obj, member, method) => (__accessCheck$k(obj, member, "access private method"), method);
var _showCounter_dec$1, _selected_dec, _count_dec$1, _text_dec, _a$o, _BriffaToggleFilter_decorators, _init$o, _text, _count$1, _selected, _showCounter$1;
_BriffaToggleFilter_decorators = [t$1("briffa-toggle-filter")];
class BriffaToggleFilter extends (_a$o = BaseDesignSystemComponent(
  toggleFilterStyles
), _text_dec = [n$1({ type: String })], _count_dec$1 = [n$1({ type: Number })], _selected_dec = [n$1({ type: Boolean })], _showCounter_dec$1 = [n$1({ type: Boolean, attribute: "show-counter" })], _a$o) {
  constructor(config) {
    super();
    __privateAdd$k(this, _text, __runInitializers$o(_init$o, 8, this, "Text")), __runInitializers$o(_init$o, 11, this);
    __privateAdd$k(this, _count$1, __runInitializers$o(_init$o, 12, this, 0)), __runInitializers$o(_init$o, 15, this);
    __privateAdd$k(this, _selected, __runInitializers$o(_init$o, 16, this, false)), __runInitializers$o(_init$o, 19, this);
    __privateAdd$k(this, _showCounter$1, __runInitializers$o(_init$o, 20, this, true)), __runInitializers$o(_init$o, 23, this);
    if (config) {
      this.text = config.text || "Text";
      this.count = config.count || 0;
      this.selected = config.selected || false;
      this.showCounter = config.showCounter !== false;
    }
  }
  get isSelected() {
    return this.selected;
  }
  set isSelected(value) {
    this.selected = value;
    this._notifySelectedChanged();
  }
  _handleClick() {
    this.selected = !this.selected;
    this._notifySelectedChanged();
  }
  _handleKeyDown(event) {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      this._handleClick();
    }
  }
  // TODO: clean this up
  _notifySelectedChanged() {
    this.dispatchEvent(
      new CustomEvent("selected-changed", {
        detail: { selected: this.selected },
        bubbles: true
      })
    );
  }
  render() {
    return x`
            <button
                class="toggle-container ${this.selected ? "selected" : ""}"
                @click=${this._handleClick}
                @keydown=${this._handleKeyDown}
                tabindex="0"
                role="button"
                aria-pressed=${this.selected}
                aria-label=${this.text}
            >
                <span class="text">${this.text}</span>
                <briffa-counter-label
                    class="counter"
                    .count=${this.count}
                    .showCounter=${this.showCounter}
                >
                </briffa-counter-label>
            </button>
        `;
  }
}
_init$o = __decoratorStart$o(_a$o);
_text = /* @__PURE__ */ new WeakMap();
_count$1 = /* @__PURE__ */ new WeakMap();
_selected = /* @__PURE__ */ new WeakMap();
_showCounter$1 = /* @__PURE__ */ new WeakMap();
__decorateElement$o(_init$o, 4, "text", _text_dec, BriffaToggleFilter, _text);
__decorateElement$o(_init$o, 4, "count", _count_dec$1, BriffaToggleFilter, _count$1);
__decorateElement$o(_init$o, 4, "selected", _selected_dec, BriffaToggleFilter, _selected);
__decorateElement$o(_init$o, 4, "showCounter", _showCounter_dec$1, BriffaToggleFilter, _showCounter$1);
BriffaToggleFilter = __decorateElement$o(_init$o, 0, "BriffaToggleFilter", _BriffaToggleFilter_decorators, BriffaToggleFilter);
__runInitializers$o(_init$o, 1, BriffaToggleFilter);
var __create$n = Object.create;
var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __knownSymbol$n = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$n = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$n = (target, value) => __defProp$n(target, "name", { value, configurable: true });
var __decoratorStart$n = (base) => [, , , __create$n(base?.[__knownSymbol$n("metadata")] ?? null)];
var __decoratorStrings$n = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$n = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$n("Function expected") : fn;
var __decoratorContext$n = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$n[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$n("Already initialized") : fns.push(__expectFn$n(fn || null)) });
var __decoratorMetadata$n = (array, target) => __defNormalProp$n(target, __knownSymbol$n("metadata"), array[3]);
var __runInitializers$n = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) fns[i4].call(self2);
  return value;
};
var __decorateElement$n = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, k2 = flags & 7, p2 = false;
  var j2 = 0;
  var extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (target = target.prototype, k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$n(target, name));
  __name$n(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$n(k2, name, done = {}, array[3], extraInitializers);
    it = (0, decorators[i4])(target, ctx), done._ = 1;
    __expectFn$n(it) && (target = it);
  }
  return __decoratorMetadata$n(array, target), desc && __defProp$n(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var _BriffaPriceFilter_decorators, _init$n, _a$n;
_BriffaPriceFilter_decorators = [t$1("briffa-price-filter")];
class BriffaPriceFilter extends (_a$n = BaseDesignSystemComponent()) {
  constructor() {
    super(...arguments);
    this.availablePriceRangesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_VARIANT_FILTER_TYPE.PRICE)
    );
    this.selectedPriceTagsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_VARIANT_FILTER_TYPE.PRICE)
    );
  }
  _handlePriceTagToggle(tag, selected) {
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_VARIANT_FILTER_TYPE.PRICE,
        tagValue: tag,
        selected
      })
    );
  }
  /**
   * Get the count of selected price filters.
   * Uses selector value instead of internal state.
   */
  getSelectedValuesTotalCount() {
    return this.selectedPriceTagsSelector.value.length;
  }
  render() {
    const availablePriceRanges = this.availablePriceRangesSelector.value;
    const selectedTags = this.selectedPriceTagsSelector.value;
    const tags = Object.values(availablePriceRanges);
    if (tags.length === 0) {
      return x``;
    }
    return x`
            <div class="flex flex-wrap gap-4 py-2">
                ${tags.map((tagDetails) => {
      const isSelected = selectedTags.includes(tagDetails.tag);
      const visibleCount = tagDetails.resultsCount || 0;
      return x`
                        <briffa-toggle-filter
                            class="text-sm uppercase"
                            .text=${tagDetails.displayValue}
                            .count=${visibleCount}
                            .selected=${isSelected}
                            style="order: ${tagDetails.sortOrder}"
                            @selected-changed=${(e2) => {
        e2.stopPropagation();
        this._handlePriceTagToggle(
          tagDetails.tag,
          e2.detail.selected
        );
      }}
                        >
                        </briffa-toggle-filter>
                    `;
    })}
            </div>
        `;
  }
}
_init$n = __decoratorStart$n(_a$n);
BriffaPriceFilter = __decorateElement$n(_init$n, 0, "BriffaPriceFilter", _BriffaPriceFilter_decorators, BriffaPriceFilter);
__runInitializers$n(_init$n, 1, BriffaPriceFilter);
const brandsFilterStyles = safeCss(`
    :host {
        display: block;
        width: 100%;
    }

    .brands-container {
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-sm"]} 0;
    }

    .brand-item {
        display: flex;
        align-items: center;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-xs"]} ${spacing["gutter-sm"]};
        border-radius: ${borderRadius.sm};
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

    .brand-item:hover {
        background-color: ${colors.background.secondary};
    }

    .brand-checkbox {
        width: 16px;
        height: 16px;
        border: 1px solid ${colors.border.light};
        border-radius: ${borderRadius.xs};
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        transition: all 0.2s ease;
    }

    .brand-checkbox.checked {
        background-color: ${colors.primary[600]};
        border-color: ${colors.primary[600]};
    }

    .brand-checkbox .checkmark {
        color: white;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    .brand-checkbox.checked .checkmark {
        opacity: 1;
    }

    .brand-label {
        flex: 1;
        font-size: 14px;
        color: ${colors.text.primary};
        margin: 0;
    }

    .brand-count {
        font-size: 12px;
        color: ${colors.text.secondary};
        background-color: ${colors.background.tertiary};
        padding: 2px 6px;
        border-radius: ${borderRadius.xs};
    }

    .hidden {
        display: none;
    }

    .visible {
        display: block;
    }
`);
var __create$m = Object.create;
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __knownSymbol$m = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$m = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$m = (target, value) => __defProp$m(target, "name", { value, configurable: true });
var __decoratorStart$m = (base) => [, , , __create$m(base?.[__knownSymbol$m("metadata")] ?? null)];
var __decoratorStrings$m = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$m = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$m("Function expected") : fn;
var __decoratorContext$m = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$m[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$m("Already initialized") : fns.push(__expectFn$m(fn || null)) });
var __decoratorMetadata$m = (array, target) => __defNormalProp$m(target, __knownSymbol$m("metadata"), array[3]);
var __runInitializers$m = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$m = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$m[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$m(k2 < 4 ? target : { get [name]() {
    return __privateGet$j(this, extra);
  }, set [name](x2) {
    return __privateSet$j(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$m(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$m(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$m(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$j(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$j : __privateMethod$j)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$j(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$m(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$m("Object expected");
    else __expectFn$m(fn = it.get) && (desc.get = fn), __expectFn$m(fn = it.set) && (desc.set = fn), __expectFn$m(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$m(array, target), desc && __defProp$m(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$j = (obj, member, msg) => member.has(obj) || __typeError$m("Cannot " + msg);
var __privateIn$j = (member, obj) => Object(obj) !== obj ? __typeError$m('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$j = (obj, member, getter) => (__accessCheck$j(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$j = (obj, member, value) => member.has(obj) ? __typeError$m("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$j = (obj, member, value, setter) => (__accessCheck$j(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$j = (obj, member, method) => (__accessCheck$j(obj, member, "access private method"), method);
var _visible_dec$7, _a$m, _BriffaBrandsFilter_decorators, _init$m, _visible$7;
_BriffaBrandsFilter_decorators = [t$1("briffa-brands-filter")];
class BriffaBrandsFilter extends (_a$m = BaseDesignSystemComponent(
  brandsFilterStyles
), _visible_dec$7 = [n$1({ type: Boolean })], _a$m) {
  constructor() {
    super(...arguments);
    __privateAdd$j(this, _visible$7, __runInitializers$m(_init$m, 8, this, false)), __runInitializers$m(_init$m, 11, this);
    this.availableBrandsSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.BRAND)
    );
    this.selectedBrandsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.BRAND)
    );
  }
  _handleBrandTagToggle(tag) {
    const selectedTags = this.selectedBrandsSelector.value;
    const isCurrentlySelected = selectedTags.includes(tag);
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_GENERAL_FILTER_TYPE.BRAND,
        tagValue: tag,
        selected: !isCurrentlySelected
      })
    );
  }
  /**
   * Get the count of selected brand filters.
   * Uses selector value instead of internal state.
   */
  getSelectedValuesTotalCount() {
    return this.selectedBrandsSelector.value.length;
  }
  render() {
    if (!this.visible) {
      return x``;
    }
    const availableBrands = this.availableBrandsSelector.value;
    const selectedTags = this.selectedBrandsSelector.value;
    const tags = Object.values(availableBrands);
    return x`
            <div class="brands-container">
                ${tags.map((tagDetails) => {
      const isSelected = selectedTags.includes(tagDetails.tag);
      const visibleCount = tagDetails.resultsCount || 0;
      return x`
                        <briffa-toggle-filter
                            class="text-sm uppercase"
                            .text=${tagDetails.displayValue}
                            .count=${visibleCount}
                            .selected=${isSelected}
                            @selected-changed=${(e2) => {
        e2.stopPropagation();
        this._handleBrandTagToggle(tagDetails.tag);
      }}
                        >
                        </briffa-toggle-filter>
                    `;
    })}
            </div>
        `;
  }
}
_init$m = __decoratorStart$m(_a$m);
_visible$7 = /* @__PURE__ */ new WeakMap();
__decorateElement$m(_init$m, 4, "visible", _visible_dec$7, BriffaBrandsFilter, _visible$7);
BriffaBrandsFilter = __decorateElement$m(_init$m, 0, "BriffaBrandsFilter", _BriffaBrandsFilter_decorators, BriffaBrandsFilter);
__runInitializers$m(_init$m, 1, BriffaBrandsFilter);
const genderFilterStyles = safeCss(`
    :host {
        display: block;
        width: 100%;
    }

    .genders-container {
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-sm"]} 0;
    }

    .gender-item {
        display: flex;
        align-items: center;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-xs"]} ${spacing["gutter-sm"]};
        border-radius: ${borderRadius.sm};
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

    .gender-item:hover {
        background-color: ${colors.background.secondary};
    }

    .gender-checkbox {
        width: 16px;
        height: 16px;
        border: 1px solid ${colors.border.light};
        border-radius: ${borderRadius.xs};
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        transition: all 0.2s ease;
    }

    .gender-checkbox.checked {
        background-color: ${colors.primary[600]};
        border-color: ${colors.primary[600]};
    }

    .gender-checkbox .checkmark {
        color: white;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    .gender-checkbox.checked .checkmark {
        opacity: 1;
    }

    .gender-label {
        flex: 1;
        font-size: 14px;
        color: ${colors.text.primary};
        margin: 0;
    }

    .gender-count {
        font-size: 12px;
        color: ${colors.text.secondary};
        background-color: ${colors.background.tertiary};
        padding: 2px 6px;
        border-radius: ${borderRadius.xs};
    }

    .hidden {
        display: none;
    }

    .visible {
        display: block;
    }
`);
var __create$l = Object.create;
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __knownSymbol$l = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$l = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$l = (target, value) => __defProp$l(target, "name", { value, configurable: true });
var __decoratorStart$l = (base) => [, , , __create$l(base?.[__knownSymbol$l("metadata")] ?? null)];
var __decoratorStrings$l = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$l = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$l("Function expected") : fn;
var __decoratorContext$l = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$l[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$l("Already initialized") : fns.push(__expectFn$l(fn || null)) });
var __decoratorMetadata$l = (array, target) => __defNormalProp$l(target, __knownSymbol$l("metadata"), array[3]);
var __runInitializers$l = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$l = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$l[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$l(k2 < 4 ? target : { get [name]() {
    return __privateGet$i(this, extra);
  }, set [name](x2) {
    return __privateSet$i(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$l(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$l(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$l(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$i(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$i : __privateMethod$i)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$i(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$l(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$l("Object expected");
    else __expectFn$l(fn = it.get) && (desc.get = fn), __expectFn$l(fn = it.set) && (desc.set = fn), __expectFn$l(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$l(array, target), desc && __defProp$l(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$i = (obj, member, msg) => member.has(obj) || __typeError$l("Cannot " + msg);
var __privateIn$i = (member, obj) => Object(obj) !== obj ? __typeError$l('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$i = (obj, member, getter) => (__accessCheck$i(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$i = (obj, member, value) => member.has(obj) ? __typeError$l("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$i = (obj, member, value, setter) => (__accessCheck$i(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$i = (obj, member, method) => (__accessCheck$i(obj, member, "access private method"), method);
var _visible_dec$6, _a$l, _BriffaGenderFilter_decorators, _init$l, _visible$6;
_BriffaGenderFilter_decorators = [t$1("briffa-gender-filter")];
class BriffaGenderFilter extends (_a$l = BaseDesignSystemComponent(
  genderFilterStyles
), _visible_dec$6 = [n$1({ type: Boolean })], _a$l) {
  constructor() {
    super(...arguments);
    __privateAdd$i(this, _visible$6, __runInitializers$l(_init$l, 8, this, false)), __runInitializers$l(_init$l, 11, this);
    this.availableGendersSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.GENDER)
    );
    this.selectedGendersSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.GENDER)
    );
  }
  _handleGenderTagToggle(tag) {
    const selectedTags = this.selectedGendersSelector.value;
    const isCurrentlySelected = selectedTags.includes(tag);
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_GENERAL_FILTER_TYPE.GENDER,
        tagValue: tag,
        selected: !isCurrentlySelected
      })
    );
  }
  /**
   * Get the count of selected gender filters.
   * Uses selector value instead of internal state.
   */
  getSelectedValuesTotalCount() {
    return this.selectedGendersSelector.value.length;
  }
  render() {
    if (!this.visible) {
      return x``;
    }
    const availableGenders = this.availableGendersSelector.value;
    const selectedTags = this.selectedGendersSelector.value;
    const tags = Object.values(availableGenders).filter(
      (val) => val.tag !== generateProductFilterKey(PRODUCT_GENERAL_FILTER_TYPE.GENDER, ProductGender["N/A"])
    );
    return x`
            <div class="genders-container">
                ${tags.map((tagDetails) => {
      const isSelected = selectedTags.includes(tagDetails.tag);
      const visibleCount = tagDetails.resultsCount || 0;
      return x`
                        <briffa-toggle-filter
                            class="text-sm uppercase"
                            .text=${tagDetails.displayValue}
                            .count=${visibleCount}
                            .selected=${isSelected}
                            @selected-changed=${(e2) => {
        e2.stopPropagation();
        this._handleGenderTagToggle(tagDetails.tag);
      }}
                        >
                        </briffa-toggle-filter>
                    `;
    })}
            </div>
        `;
  }
}
_init$l = __decoratorStart$l(_a$l);
_visible$6 = /* @__PURE__ */ new WeakMap();
__decorateElement$l(_init$l, 4, "visible", _visible_dec$6, BriffaGenderFilter, _visible$6);
BriffaGenderFilter = __decorateElement$l(_init$l, 0, "BriffaGenderFilter", _BriffaGenderFilter_decorators, BriffaGenderFilter);
__runInitializers$l(_init$l, 1, BriffaGenderFilter);
const productTypeFilterStyles = safeCss(`
    :host {
        display: block;
        width: 100%;
    }

    .product-types-container {
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-sm"]} 0;
    }

    .product-type-item {
        display: flex;
        align-items: center;
        gap: ${spacing["gutter-sm"]};
        padding: ${spacing["gutter-xs"]} ${spacing["gutter-sm"]};
        border-radius: ${borderRadius.sm};
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

    .product-type-item:hover {
        background-color: ${colors.background.secondary};
    }

    .product-type-checkbox {
        width: 16px;
        height: 16px;
        border: 1px solid ${colors.border.light};
        border-radius: ${borderRadius.xs};
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        transition: all 0.2s ease;
    }

    .product-type-checkbox.checked {
        background-color: ${colors.primary[600]};
        border-color: ${colors.primary[600]};
    }

    .product-type-checkbox .checkmark {
        color: white;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    .product-type-checkbox.checked .checkmark {
        opacity: 1;
    }

    .product-type-label {
        flex: 1;
        font-size: 14px;
        color: ${colors.text.primary};
        margin: 0;
    }

    .product-type-count {
        font-size: 12px;
        color: ${colors.text.secondary};
        background-color: ${colors.background.tertiary};
        padding: 2px 6px;
        border-radius: ${borderRadius.xs};
    }

    .hidden {
        display: none;
    }

    .visible {
        display: block;
    }
`);
var __create$k = Object.create;
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __knownSymbol$k = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$k = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$k = (target, value) => __defProp$k(target, "name", { value, configurable: true });
var __decoratorStart$k = (base) => [, , , __create$k(base?.[__knownSymbol$k("metadata")] ?? null)];
var __decoratorStrings$k = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$k = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$k("Function expected") : fn;
var __decoratorContext$k = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$k[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$k("Already initialized") : fns.push(__expectFn$k(fn || null)) });
var __decoratorMetadata$k = (array, target) => __defNormalProp$k(target, __knownSymbol$k("metadata"), array[3]);
var __runInitializers$k = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$k = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$k[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$k(k2 < 4 ? target : { get [name]() {
    return __privateGet$h(this, extra);
  }, set [name](x2) {
    return __privateSet$h(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$k(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$k(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$k(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$h(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$h : __privateMethod$h)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$h(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$k(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$k("Object expected");
    else __expectFn$k(fn = it.get) && (desc.get = fn), __expectFn$k(fn = it.set) && (desc.set = fn), __expectFn$k(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$k(array, target), desc && __defProp$k(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$h = (obj, member, msg) => member.has(obj) || __typeError$k("Cannot " + msg);
var __privateIn$h = (member, obj) => Object(obj) !== obj ? __typeError$k('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$h = (obj, member, getter) => (__accessCheck$h(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$h = (obj, member, value) => member.has(obj) ? __typeError$k("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$h = (obj, member, value, setter) => (__accessCheck$h(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$h = (obj, member, method) => (__accessCheck$h(obj, member, "access private method"), method);
var _visible_dec$5, _a$k, _BriffaProductTypeFilter_decorators, _init$k, _visible$5;
_BriffaProductTypeFilter_decorators = [t$1("briffa-product-type-filter")];
class BriffaProductTypeFilter extends (_a$k = BaseDesignSystemComponent(
  productTypeFilterStyles
), _visible_dec$5 = [n$1({ type: Boolean })], _a$k) {
  constructor() {
    super(...arguments);
    __privateAdd$h(this, _visible$5, __runInitializers$k(_init$k, 8, this, false)), __runInitializers$k(_init$k, 11, this);
    this.availableCategoriesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.CATEGORY)
    );
    this.selectedCategoriesSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.CATEGORY)
    );
  }
  _handleProductTypeTagToggle(tag) {
    const selectedTags = this.selectedCategoriesSelector.value;
    const isCurrentlySelected = selectedTags.includes(tag);
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_GENERAL_FILTER_TYPE.CATEGORY,
        tagValue: tag,
        selected: !isCurrentlySelected
      })
    );
  }
  /**
   * Get the count of selected product type filters.
   * Uses selector value instead of internal state.
   */
  getSelectedValuesTotalCount() {
    return this.selectedCategoriesSelector.value.length;
  }
  render() {
    if (!this.visible) {
      return x``;
    }
    const availableCategories = this.availableCategoriesSelector.value;
    const selectedTags = this.selectedCategoriesSelector.value;
    const tags = Object.values(availableCategories);
    return x`
            <div class="product-types-container">
                ${tags.map((tagDetails) => {
      const isSelected = selectedTags.includes(tagDetails.tag);
      const visibleCount = tagDetails.resultsCount || 0;
      return x`
                        <briffa-toggle-filter
                            class="text-sm uppercase"
                            .text=${tagDetails.displayValue}
                            .count=${visibleCount}
                            .selected=${isSelected}
                            @selected-changed=${(e2) => {
        e2.stopPropagation();
        this._handleProductTypeTagToggle(tagDetails.tag);
      }}
                        >
                        </briffa-toggle-filter>
                    `;
    })}
            </div>
        `;
  }
}
_init$k = __decoratorStart$k(_a$k);
_visible$5 = /* @__PURE__ */ new WeakMap();
__decorateElement$k(_init$k, 4, "visible", _visible_dec$5, BriffaProductTypeFilter, _visible$5);
BriffaProductTypeFilter = __decorateElement$k(_init$k, 0, "BriffaProductTypeFilter", _BriffaProductTypeFilter_decorators, BriffaProductTypeFilter);
__runInitializers$k(_init$k, 1, BriffaProductTypeFilter);
const expanderVisibilityMapKey = "expander-visibility-map";
const HEADING_SMALL_CLASSES = [`text-[${tokens.color.gray[700]}]`, "text-sm"];
const _BriffaShowMoreExpander = class _BriffaShowMoreExpander {
  constructor({ id = "", visibilityKey = "" }) {
    this.latestScrollHeight = null;
    this.heightLimit = 200;
    this.showAllContent = false;
    this.croppedContent = false;
    this.containerNode = null;
    this.contentNode = null;
    this.showMoreLabelNode = null;
    this.showLessLabelNode = null;
    this.contentClassNames = ["mb-2", "overflow-scroll"];
    this.labelClassNames = HEADING_SMALL_CLASSES;
    this.showMoreVisibleClassNames = ["block"];
    this.showMoreHiddenClassNames = ["hidden"];
    this.showLessVisibleClassNames = ["block"];
    this.showLessHiddenClassNames = ["hidden"];
    this.heightChangedCallbacks = [];
    this.id = id;
    this.visibilityKey = visibilityKey;
    this.initialize();
    this.subscribeToHeightChangedCallbacks(
      (() => {
        this.handleHeightChange();
      }).bind(this),
      true
    );
    this.showAllContent = this.getCachedVisibility();
  }
  getCachedVisibility() {
    return _BriffaShowMoreExpander.visibilityMap[this.visibilityKey]?.[this.id];
  }
  setCachedVisibility(showingAll) {
    if (!_BriffaShowMoreExpander.visibilityMap[this.visibilityKey]) {
      _BriffaShowMoreExpander.visibilityMap[this.visibilityKey] = {};
    }
    _BriffaShowMoreExpander.visibilityMap[this.visibilityKey][this.id] = showingAll;
  }
  handleHeightChange() {
    if (this.exceedsLimit()) {
      if (this.showAllContent) {
        this.enableShowLess();
      } else {
        this.enableShowMore();
      }
    } else {
      this.disableShowMoreLess();
    }
  }
  exceedsLimit() {
    return this.getScrollHeight() > this.heightLimit;
  }
  enableShowMore() {
    this.showMoreLabelNode.classList.remove(
      ...this.showMoreHiddenClassNames
    );
    this.showMoreLabelNode.classList.add(...this.showMoreVisibleClassNames);
    this.showLessLabelNode.classList.remove(
      ...this.showLessVisibleClassNames
    );
    this.showLessLabelNode.classList.add(...this.showLessHiddenClassNames);
    this.contentNode.style.maxHeight = `${this.heightLimit}px`;
  }
  enableShowLess() {
    this.showMoreLabelNode.classList.remove(
      ...this.showMoreVisibleClassNames
    );
    this.showMoreLabelNode.classList.add(...this.showMoreHiddenClassNames);
    this.showLessLabelNode.classList.remove(
      ...this.showLessHiddenClassNames
    );
    this.showLessLabelNode.classList.add(...this.showLessVisibleClassNames);
    this.contentNode.style.maxHeight = `${this.latestScrollHeight}px`;
  }
  disableShowMoreLess() {
    this.showMoreLabelNode.classList.remove(
      ...this.showMoreVisibleClassNames
    );
    this.showMoreLabelNode.classList.add(...this.showMoreHiddenClassNames);
    this.showLessLabelNode.classList.remove(
      ...this.showLessVisibleClassNames
    );
    this.showLessLabelNode.classList.add(...this.showLessHiddenClassNames);
  }
  initialize() {
    let containerNode = document.createElement("div");
    containerNode.className = "briffa-show-more-expander";
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (this.latestScrollHeight !== this.getScrollHeight() || this.latestScrollHeight === null) {
          this.latestScrollHeight = this.getScrollHeight();
          this.heightChanged();
        }
      }
    });
    let contentNode = document.createElement("div");
    contentNode.classList.add(...this.contentClassNames);
    resizeObserver.observe(contentNode);
    const showMoreLabel = document.createElement("p");
    showMoreLabel.innerText = "Show more";
    const showLessLabel = document.createElement("p");
    showLessLabel.innerText = "Show less";
    showMoreLabel.addEventListener("click", () => {
      this.toggleShowAll();
    });
    showLessLabel.addEventListener("click", () => {
      this.toggleShowAll();
    });
    containerNode.appendChild(contentNode);
    containerNode.appendChild(showMoreLabel);
    containerNode.appendChild(showLessLabel);
    this.contentNode = contentNode;
    this.showMoreLabelNode = showMoreLabel;
    this.showLessLabelNode = showLessLabel;
    this.containerNode = containerNode;
  }
  toggleShowAll() {
    this.showAllContent = !this.showAllContent;
    this.setCachedVisibility(this.showAllContent);
    if (this.showAllContent) {
      this.enableShowLess();
      return;
    }
    this.enableShowMore();
  }
  // Force 'close'
  forceCollapse() {
    this.showAllContent = false;
    this.setCachedVisibility(this.showAllContent);
    if (this.exceedsLimit()) {
      this.enableShowMore();
    }
  }
  subscribeToHeightChangedCallbacks(callback, initialDispatch) {
    this.heightChangedCallbacks.push(callback);
    if (initialDispatch) {
      callback(this.getScrollHeight());
    }
  }
  heightChanged() {
    this.heightChangedCallbacks.forEach(
      (callback) => callback(this.getScrollHeight())
    );
  }
  //     GETTERS     //
  getScrollHeight() {
    return this.contentNode.scrollHeight;
  }
  getHtml() {
    return this.containerNode;
  }
  //     SETTERS     //
  setHeightLimit(limitPx) {
    this.heightLimit = limitPx;
  }
  setContent(node) {
    this.contentNode.innerHTML = "";
    this.contentNode.appendChild(node);
  }
  setShowMoreLabelText(text) {
    this.showMoreLabelNode.innerText = text;
  }
  setShowLessLabelText(text) {
    this.showLessLabelNode.innerText = text;
  }
};
_BriffaShowMoreExpander.visibilityMap = JSON.parse(
  localStorage.getItem(expanderVisibilityMapKey) ?? "{}"
);
let BriffaShowMoreExpander = _BriffaShowMoreExpander;
const Localization = {
  Filters: {
    "sort.filter.label.include-out-of-stock": "Show out of Stock",
    "sort.filter.title.n/a": "Sort by",
    "sort.filter.title.relevance": "Sort by",
    "sort.filter.title.newest": "Newest first",
    "sort.filter.title.oldest": "Oldest first",
    "sort.filter.title.price_ascending": "Price ascending",
    "sort.filter.title.price_descending": "Price descending",
    "sort.filter.label.n/a": "Sort by",
    "sort.filter.label.relevance": "Sort by",
    "sort.filter.label.newest": "Newest first",
    "sort.filter.label.oldest": "Oldest first",
    "sort.filter.label.price_ascending": "Price ascending",
    "sort.filter.label.price_descending": "Price descending"
  },
  Badges: {
    "New Arrivals": "New Arrivals",
    "Arriving Soon": "Arriving Soon"
  },
  OutOfStock: "Out of stock",
  ColorUnavailable: "Color Unavailable",
  ProductCard: {
    StartingFrom: "Starting from"
  }
};
const R2 = {
  Localization
};
const resources = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  R: R2
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends i$2 {
  constructor(i4) {
    if (super(i4), this.it = E, i4.type !== t.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(r2) {
    if (r2 === E || null == r2) return this._t = void 0, this.it = r2;
    if (r2 === T) return r2;
    if ("string" != typeof r2) throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (r2 === this.it) return this._t;
    this.it = r2;
    const s2 = [r2];
    return s2.raw = s2, this._t = { _$litType$: this.constructor.resultType, strings: s2, values: [] };
  }
}
e.directiveName = "unsafeHTML", e.resultType = 1;
const o$2 = e$4(e);
const checkboxFilterStyles = safeCss(`
    :host {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }

    .checkbox-container {
        position: relative;
        display: inline-flex;
        align-items: center;
    }

    .checkbox {
        all: unset;
        width: ${spacing["gutter-xl"]};
        height: ${spacing["gutter-xl"]};
        border: 1px solid ${colors.border.default};
        border-radius: ${borderRadius.sm};
        position: relative;
        background-color: ${colors.background.primary};
        cursor: pointer;
        transition: background-color 0.2s ease, border-color 0.2s ease;
    }

    .checkbox:focus {
        outline: 2px solid ${colors.border.focus};
        outline-offset: 2px;
    }

    .checkbox:hover {
        border-color: ${colors.border.hover};
    }

    .checkbox.checked {
        background-color: ${colors.text.secondary};
        border-color: ${colors.text.secondary};
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .check-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(0);
        pointer-events: none;
    }

    .check-icon.checked {
        transition: transform 0.2s ease;
        transform: scale(1);
    }

    .label {
        margin-left: ${spacing["gutter-sm"]};
        color: ${colors.text.secondary};
    }
`);
class BriffaIcons {
  static getFiltersIcon(color = tokens.color.white, height = "20px", width = "20px") {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="${color}" fill="none"><line x1="50.69" y1="32" x2="56.32" y2="32"/><line x1="7.68" y1="32" x2="38.69" y2="32"/><line x1="26.54" y1="15.97" x2="56.32" y2="15.97"/><line x1="7.68" y1="15.97" x2="14.56" y2="15.97"/><line x1="35" y1="48.03" x2="56.32" y2="48.03"/><line x1="7.68" y1="48.03" x2="23" y2="48.03"/><circle cx="20.55" cy="15.66" r="6"/><circle cx="44.69" cy="32" r="6"/><circle cx="29" cy="48.03" r="6"/></svg>`;
    return icon.childNodes[0];
  }
  static getSortIcon(color = tokens.color.white, height = "20px", width = "20px") {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.7071 0.292893C23.3166 -0.0976311 22.6834 -0.0976311 22.2929 0.292893L15.9289 6.65685C15.5384 7.04738 15.5384 7.68054 15.9289 8.07107C16.3195 8.46159 16.9526 8.46159 17.3431 8.07107L23 2.41421L28.6569 8.07107C29.0474 8.46159 29.6805 8.46159 30.0711 8.07107C30.4616 7.68054 30.4616 7.04738 30.0711 6.65685L23.7071 0.292893ZM23 23H24L24 1H23H22L22 23H23Z" fill="${color}"/>
<path d="M7.29289 29.7071C7.68342 30.0976 8.31658 30.0976 8.70711 29.7071L15.0711 23.3431C15.4616 22.9526 15.4616 22.3195 15.0711 21.9289C14.6805 21.5384 14.0474 21.5384 13.6569 21.9289L8 27.5858L2.34315 21.9289C1.95262 21.5384 1.31946 21.5384 0.928932 21.9289C0.538407 22.3195 0.538407 22.9526 0.928931 23.3431L7.29289 29.7071ZM8 7L7 7L7 29L8 29L9 29L9 7L8 7Z" fill="${color}"/>
</svg>`;
    return icon.childNodes[0];
  }
  static getXMarkIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  }) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>`;
    return icon.children.item(0);
  }
  static getPlusIcon({
    color = "#000",
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>`;
    return icon.children.item(0);
  }
  static getMinusIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
    </svg>`;
    return icon.childNodes[0];
  }
  static getCurvedArrowIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 7H5C2.79086 7 1 5.20914 1 3V0.634766" stroke="${color}" stroke-linecap="round"/>
        <path d="M13 10L16 6.99998L13 4" stroke="${color}" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    return icon.children.item(0);
  }
  static getInfoIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
  <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>
`;
    return icon.children.item(0);
  }
  static getLeftChevron({
    color = tokens.color.white,
    height = "20px",
    width = "20px",
    className = "",
    onClick = () => {
    }
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/>
    </svg>`;
    const svg = icon.children.item(0);
    svg.setAttribute("class", className);
    svg.onclick = onClick;
    return svg;
  }
  static getMagnifyIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="${color}">
      <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>`;
    return icon.children.item(0);
  }
  static getCheckIcon({
    color = tokens.color.white,
    height = "20px",
    width = "20px"
  } = {}) {
    const icon = document.createElement("div");
    icon.innerHTML = `<svg width="${width}" height="${height}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="${color}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    </svg>`;
    return icon.children.item(0);
  }
}
const swatchesMap = {
  navy: ["#000068"],
  "dark navy": ["#000435"],
  black: ["#020202"],
  "black/yellow": ["#020202", "#FFD300"],
  "onyx grey": ["#353839"],
  carmin: ["#960018"],
  "clementine orange": ["#E96E00"],
  sunburst: ["#ec9b4a"],
  "fresh green": ["#f0f076"],
  "night blue": ["#000080"],
  "cool grey": ["#8C92AC"],
  "elemental blue": ["#558beb"],
  "red glow": ["#db251b"],
  "gecko green": ["#616661"],
  "strong red": ["#d90b0e"],
  "light umber": ["#bca291"],
  "lazuli blue": ["#0060ff"],
  signal: ["#ffae00"],
  "sports red": ["#c50212"],
  fig: ["#6c6647"],
  "midnight sky": ["#3f5566"],
  phantom: ["#262d33"],
  seal: ["#c5c1bd"],
  safflower: ["#f1801e"],
  "black ii": ["#1c1f1e"],
  "smokey grey": ["#6b6862"],
  "blood orange": ["#e65800"],
  "cold coffee ii": ["#5c4a3f"],
  "black olive": ["#2c3635"],
  ebony: ["#36373e"],
  "cold coffee": ["#6c5b5c"],
  greenwood: ["#494d36"],
  "burly yellow xt": ["#f0a017", "#111"],
  "winter pearl": ["#dbd2ca"],
  "thunder blue": ["#314054"],
  pollen: ["#feda1a"],
  "night blue i": ["#292b38"],
  "night blue ii": ["#293337"],
  "dragon fire": ["#fe8223"],
  "everest blue": ["#00607a"],
  "misty green": ["#857e71"],
  "adrenaline red": ["#bd0020"],
  "light grey": ["#D3D3D3"],
  octane: ["#e74b33"],
  white: ["#ffffff"],
  "mint leaf": ["#808274"],
  "tnf yellow/tnf black": ["#f4c369", "#000"],
  "fiery red/tnf black": ["#e04035", "#000"],
  "moroccan blue": ["#446f93"],
  "kelp tan dark heather/asphalt grey light heather": ["#a38462"],
  silver: ["#c0c0c0"],
  green: ["#008000"],
  "sand storm": ["#ad957c"],
  egret: ["#e1ddd4"],
  slate: ["#545454"],
  dove: ["#c6bfc6"],
  "rose dawn": ["#c29083"],
  "ruby red": ["#c02c3d"],
  glacier: ["#b4c8d7"],
  "honey yellow": ["#d4b161"],
  nature: ["#c0b580"],
  "picnic green": ["#707f71"],
  "tango orange": ["#d65347"],
  graphite: ["#3f3f4b"],
  cayenne: ["#c13f41"],
  "asphalt grey": ["#2d3145"],
  "dune beige": ["#af9976"],
  "high rise grey": ["#bfc7ce"],
  "zinc grey": ["#878787"],
  "shark/titanium": ["#454547"],
  "dark compass": ["#2d5ea7"],
  shark: ["#333333"],
  "phoenix blue/shark": ["#2d4f75"],
  "slate/jade green": ["#77b58d"],
  "cobalt blue": ["#264b8a"],
  "orange/copper": ["#bf7131"],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""],
  "": [""]
};
const constants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BriffaIcons,
  swatchesMap
}, Symbol.toStringTag, { value: "Module" }));
var __create$j = Object.create;
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __knownSymbol$j = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$j = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$j = (target, value) => __defProp$j(target, "name", { value, configurable: true });
var __decoratorStart$j = (base) => [, , , __create$j(base?.[__knownSymbol$j("metadata")] ?? null)];
var __decoratorStrings$j = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$j = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$j("Function expected") : fn;
var __decoratorContext$j = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$j[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$j("Already initialized") : fns.push(__expectFn$j(fn || null)) });
var __decoratorMetadata$j = (array, target) => __defNormalProp$j(target, __knownSymbol$j("metadata"), array[3]);
var __runInitializers$j = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$j = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$j[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$j(k2 < 4 ? target : { get [name]() {
    return __privateGet$g(this, extra);
  }, set [name](x2) {
    return __privateSet$g(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$j(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$j(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$j(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$g(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$g : __privateMethod$g)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$g(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$j(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$j("Object expected");
    else __expectFn$j(fn = it.get) && (desc.get = fn), __expectFn$j(fn = it.set) && (desc.set = fn), __expectFn$j(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$j(array, target), desc && __defProp$j(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$g = (obj, member, msg) => member.has(obj) || __typeError$j("Cannot " + msg);
var __privateIn$g = (member, obj) => Object(obj) !== obj ? __typeError$j('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$g = (obj, member, getter) => (__accessCheck$g(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$g = (obj, member, value) => member.has(obj) ? __typeError$j("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$g = (obj, member, value, setter) => (__accessCheck$g(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$g = (obj, member, method) => (__accessCheck$g(obj, member, "access private method"), method);
var _showCounter_dec, _checked_dec, _count_dec, _label_dec, _a$j, _BriffaCheckboxFilter_decorators, _init$j, _label, _count, _checked, _showCounter;
_BriffaCheckboxFilter_decorators = [t$1("briffa-checkbox-filter")];
class BriffaCheckboxFilter extends (_a$j = BaseDesignSystemComponent(
  checkboxFilterStyles
), _label_dec = [n$1({ type: String })], _count_dec = [n$1({ type: Number })], _checked_dec = [n$1({ type: Boolean })], _showCounter_dec = [n$1({ type: Boolean, attribute: "show-counter" })], _a$j) {
  constructor(config) {
    super();
    __privateAdd$g(this, _label, __runInitializers$j(_init$j, 8, this, "")), __runInitializers$j(_init$j, 11, this);
    __privateAdd$g(this, _count, __runInitializers$j(_init$j, 12, this, 0)), __runInitializers$j(_init$j, 15, this);
    __privateAdd$g(this, _checked, __runInitializers$j(_init$j, 16, this, false)), __runInitializers$j(_init$j, 19, this);
    __privateAdd$g(this, _showCounter, __runInitializers$j(_init$j, 20, this, true)), __runInitializers$j(_init$j, 23, this);
    this._changeCallbacks = [];
    if (config) {
      this.label = config.label || "";
      this.count = config.count || 0;
      this.checked = config.checked || false;
      this.showCounter = config.showCounter !== false;
    }
  }
  setLabelText(text) {
    this.label = text;
  }
  setCounterNumber(count) {
    this.count = count;
  }
  hideCounterNumber() {
    this.showCounter = false;
  }
  showCounterNumber() {
    this.showCounter = true;
  }
  setCheckedStatus(checked) {
    this.checked = checked;
  }
  getCheckedStatus() {
    return this.checked;
  }
  getHtml() {
    return this;
  }
  subscribeToCheckedChanged(callback, initialDispatch) {
    this._changeCallbacks.push(callback);
    if (initialDispatch) {
      callback(this.checked);
    }
  }
  _handleClick() {
    this.checked = !this.checked;
    this._notifyChange();
  }
  _handleKeyDown(event) {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      this._handleClick();
    }
  }
  _notifyChange() {
    this._changeCallbacks.forEach((callback) => callback(this.checked));
    this.dispatchEvent(
      new CustomEvent("checked-changed", {
        detail: { checked: this.checked },
        bubbles: true
      })
    );
  }
  render() {
    const checkIcon = BriffaIcons.getCheckIcon({
      color: "white",
      height: "16px",
      width: "16px"
    });
    return x`
            <div
                class="checkbox-container"
                @click=${this._handleClick}
                @keydown=${this._handleKeyDown}
                tabindex="0"
                role="checkbox"
                aria-checked=${this.checked}
                aria-label=${this.label}
            >
                <div class="checkbox ${this.checked ? "checked" : ""}">
                    <div class="check-icon ${this.checked ? "checked" : ""}">
                        ${o$2(checkIcon.outerHTML)}
                    </div>
                </div>
                <span class="label">${this.label}</span>
                <briffa-counter-label
                    .count=${this.count}
                    .showCounter=${this.showCounter}
                >
                </briffa-counter-label>
            </div>
        `;
  }
}
_init$j = __decoratorStart$j(_a$j);
_label = /* @__PURE__ */ new WeakMap();
_count = /* @__PURE__ */ new WeakMap();
_checked = /* @__PURE__ */ new WeakMap();
_showCounter = /* @__PURE__ */ new WeakMap();
__decorateElement$j(_init$j, 4, "label", _label_dec, BriffaCheckboxFilter, _label);
__decorateElement$j(_init$j, 4, "count", _count_dec, BriffaCheckboxFilter, _count);
__decorateElement$j(_init$j, 4, "checked", _checked_dec, BriffaCheckboxFilter, _checked);
__decorateElement$j(_init$j, 4, "showCounter", _showCounter_dec, BriffaCheckboxFilter, _showCounter);
BriffaCheckboxFilter = __decorateElement$j(_init$j, 0, "BriffaCheckboxFilter", _BriffaCheckboxFilter_decorators, BriffaCheckboxFilter);
__runInitializers$j(_init$j, 1, BriffaCheckboxFilter);
var __create$i = Object.create;
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __knownSymbol$i = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$i = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$i = (target, value) => __defProp$i(target, "name", { value, configurable: true });
var __decoratorStart$i = (base) => [, , , __create$i(base?.[__knownSymbol$i("metadata")] ?? null)];
var __decoratorStrings$i = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$i = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$i("Function expected") : fn;
var __decoratorContext$i = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$i[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$i("Already initialized") : fns.push(__expectFn$i(fn || null)) });
var __decoratorMetadata$i = (array, target) => __defNormalProp$i(target, __knownSymbol$i("metadata"), array[3]);
var __runInitializers$i = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) fns[i4].call(self2);
  return value;
};
var __decorateElement$i = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, k2 = flags & 7, p2 = false;
  var j2 = 0;
  var extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (target = target.prototype, k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$i(target, name));
  __name$i(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$i(k2, name, done = {}, array[3], extraInitializers);
    it = (0, decorators[i4])(target, ctx), done._ = 1;
    __expectFn$i(it) && (target = it);
  }
  return __decoratorMetadata$i(array, target), desc && __defProp$i(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var _BriffaIncludeOutOfStockFilter_decorators, _init$i, _a$i;
const FILTER_TITLE_STYLES$1 = `
    font-size: ${typography.fontSize.lg};
    margin-bottom: 0.5rem;
    color: ${colors.text.primary};
`;
_BriffaIncludeOutOfStockFilter_decorators = [t$1("briffa-include-out-of-stock-filter")];
class BriffaIncludeOutOfStockFilter extends (_a$i = BaseDesignSystemComponent()) {
  constructor() {
    super(...arguments);
    this.IN_STOCK_TAG = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:true`;
    this.OUT_OF_STOCK_TAG = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:false`;
    this.availableStockStatusesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY)
    );
    this.selectedTagsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY)
    );
  }
  /**
   * Handle checkbox change by dispatching Redux actions.
   * When checked, adds OUT_OF_STOCK_TAG to show all products.
   * When unchecked, removes both tags to show only in-stock products (default).
   */
  _handleCheckboxChange(e2) {
    const checked = e2.detail.checked;
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
        tagValue: this.OUT_OF_STOCK_TAG,
        selected: checked
      })
    );
  }
  render() {
    const availableStockStatuses = this.availableStockStatusesSelector.value;
    const selectedTags = this.selectedTagsSelector.value;
    const isSelected = selectedTags.includes(this.OUT_OF_STOCK_TAG);
    const displayCount = availableStockStatuses[this.OUT_OF_STOCK_TAG]?.resultsCount ?? 0;
    if (!availableStockStatuses[this.OUT_OF_STOCK_TAG]) {
      return x``;
    }
    return x`
            <div>
                <p style="${FILTER_TITLE_STYLES$1}">Availability</p>
                <briffa-checkbox-filter
                    .label=${R2.Localization.Filters["sort.filter.label.include-out-of-stock"]}
                    .checked=${isSelected}
                    .count=${displayCount}
                    @checked-changed=${this._handleCheckboxChange}
                >
                </briffa-checkbox-filter>
            </div>
        `;
  }
}
_init$i = __decoratorStart$i(_a$i);
BriffaIncludeOutOfStockFilter = __decorateElement$i(_init$i, 0, "BriffaIncludeOutOfStockFilter", _BriffaIncludeOutOfStockFilter_decorators, BriffaIncludeOutOfStockFilter);
__runInitializers$i(_init$i, 1, BriffaIncludeOutOfStockFilter);
var __create$h = Object.create;
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __knownSymbol$h = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$h = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$h = (target, value) => __defProp$h(target, "name", { value, configurable: true });
var __decoratorStart$h = (base) => [, , , __create$h(base?.[__knownSymbol$h("metadata")] ?? null)];
var __decoratorStrings$h = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$h = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$h("Function expected") : fn;
var __decoratorContext$h = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$h[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$h("Already initialized") : fns.push(__expectFn$h(fn || null)) });
var __decoratorMetadata$h = (array, target) => __defNormalProp$h(target, __knownSymbol$h("metadata"), array[3]);
var __runInitializers$h = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) fns[i4].call(self2);
  return value;
};
var __decorateElement$h = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, k2 = flags & 7, p2 = false;
  var j2 = 0;
  var extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (target = target.prototype, k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$h(target, name));
  __name$h(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$h(k2, name, done = {}, array[3], extraInitializers);
    it = (0, decorators[i4])(target, ctx), done._ = 1;
    __expectFn$h(it) && (target = it);
  }
  return __decoratorMetadata$h(array, target), desc && __defProp$h(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var _BriffaHideOutOfStockFilter_decorators, _init$h, _a$h;
const FILTER_TITLE_STYLES = `
    font-size: ${typography.fontSize.lg};
    margin-bottom: 0.5rem;
    color: ${colors.text.primary};
`;
_BriffaHideOutOfStockFilter_decorators = [t$1("briffa-hide-out-of-stock-filter")];
class BriffaHideOutOfStockFilter extends (_a$h = BaseDesignSystemComponent()) {
  constructor() {
    super(...arguments);
    this.IN_STOCK_TAG = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:true`;
    this.availableStockStatusesSelector = new MemoizedSelector(
      this,
      getAvailableFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY)
    );
    this.selectedTagsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY)
    );
  }
  _handleStockTagToggle(checked) {
    store.dispatch(
      toggleFilterTag({
        filterType: PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
        tagValue: this.IN_STOCK_TAG,
        selected: checked
      })
    );
  }
  _handleCheckboxChange(e2) {
    const checked = e2.detail.checked;
    this._handleStockTagToggle(checked);
  }
  render() {
    const availableStockStatuses = this.availableStockStatusesSelector.value;
    const selectedTags = this.selectedTagsSelector.value;
    const isSelected = selectedTags.includes(this.IN_STOCK_TAG);
    const inStockDetails = availableStockStatuses[this.IN_STOCK_TAG];
    const displayCount = inStockDetails?.resultsCount || 0;
    if (!inStockDetails) {
      return x``;
    }
    return x`
            <div>
                <p style="${FILTER_TITLE_STYLES}">Availability</p>
                <briffa-checkbox-filter
                    .label=${"In stock"}
                    .checked=${isSelected}
                    .count=${displayCount}
                    @checked-changed=${this._handleCheckboxChange}
                >
                </briffa-checkbox-filter>
            </div>
        `;
  }
}
_init$h = __decoratorStart$h(_a$h);
BriffaHideOutOfStockFilter = __decorateElement$h(_init$h, 0, "BriffaHideOutOfStockFilter", _BriffaHideOutOfStockFilter_decorators, BriffaHideOutOfStockFilter);
__runInitializers$h(_init$h, 1, BriffaHideOutOfStockFilter);
var __create$g = Object.create;
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __knownSymbol$g = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$g = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$g = (target, value) => __defProp$g(target, "name", { value, configurable: true });
var __decoratorStart$g = (base) => [, , , __create$g(base?.[__knownSymbol$g("metadata")] ?? null)];
var __decoratorStrings$g = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$g = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$g("Function expected") : fn;
var __decoratorContext$g = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$g[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$g("Already initialized") : fns.push(__expectFn$g(fn || null)) });
var __decoratorMetadata$g = (array, target) => __defNormalProp$g(target, __knownSymbol$g("metadata"), array[3]);
var __runInitializers$g = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$g = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$g[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$g(k2 < 4 ? target : { get [name]() {
    return __privateGet$f(this, extra);
  }, set [name](x2) {
    return __privateSet$f(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$g(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$g(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$g(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$f(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$f : __privateMethod$f)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$f(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$g(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$g("Object expected");
    else __expectFn$g(fn = it.get) && (desc.get = fn), __expectFn$g(fn = it.set) && (desc.set = fn), __expectFn$g(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$g(array, target), desc && __defProp$g(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$f = (obj, member, msg) => member.has(obj) || __typeError$g("Cannot " + msg);
var __privateIn$f = (member, obj) => Object(obj) !== obj ? __typeError$g('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$f = (obj, member, getter) => (__accessCheck$f(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$f = (obj, member, value) => member.has(obj) ? __typeError$g("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$f = (obj, member, value, setter) => (__accessCheck$f(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$f = (obj, member, method) => (__accessCheck$f(obj, member, "access private method"), method);
var _container_dec, _a$g, _Portal_decorators, _init$g, _container;
_Portal_decorators = [t$1("briffa-portal")];
class Portal extends (_a$g = i$3, _container_dec = [n$1({ type: String })], _a$g) {
  constructor() {
    super(...arguments);
    __privateAdd$f(this, _container, __runInitializers$g(_init$g, 8, this, "body")), __runInitializers$g(_init$g, 11, this);
    this.portalContainer = null;
    this.slotElement = null;
  }
  // Don't use shadow DOM for the portal itself - we want direct access to slot
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setupPortal();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.cleanupPortal();
  }
  setupPortal() {
    this.portalContainer = document.createElement("div");
    this.portalContainer.classList.add("briffa-portal-container");
    const target = this.container === "body" ? document.body : document.querySelector(this.container);
    if (target) {
      target.appendChild(this.portalContainer);
    }
  }
  cleanupPortal() {
    if (this.portalContainer && this.portalContainer.parentNode) {
      this.portalContainer.parentNode.removeChild(this.portalContainer);
    }
    this.portalContainer = null;
  }
  firstUpdated() {
    this.moveContentToPortal();
  }
  updated() {
    this.moveContentToPortal();
  }
  moveContentToPortal() {
    if (!this.portalContainer) return;
    const children = Array.from(this.children).filter(
      (child) => !child.classList.contains("briffa-portal-placeholder")
    );
    children.forEach((child) => {
      if (child.parentNode !== this.portalContainer) {
        this.portalContainer.appendChild(child);
      }
    });
  }
  render() {
    return x``;
  }
}
_init$g = __decoratorStart$g(_a$g);
_container = /* @__PURE__ */ new WeakMap();
__decorateElement$g(_init$g, 4, "container", _container_dec, Portal, _container);
Portal = __decorateElement$g(_init$g, 0, "Portal", _Portal_decorators, Portal);
__runInitializers$g(_init$g, 1, Portal);
class InViewDirective extends i$2 {
  render(callback, threshold, rootMargin) {
    return "";
  }
  update(part, [callback, threshold, rootMargin]) {
    const options = {
      root: null,
      rootMargin: rootMargin || "50px",
      threshold: threshold || 0.1
    };
    const optionsChanged = !this.lastOptions || this.lastOptions.threshold !== options.threshold || this.lastOptions.rootMargin !== options.rootMargin;
    if (!this.observer || optionsChanged) {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          callback(entry.isIntersecting, entry.target);
        });
      }, options);
      this.observer.observe(part.element);
      this.lastOptions = {
        threshold: options.threshold,
        rootMargin: options.rootMargin
      };
    }
    return this.render(callback, threshold, rootMargin);
  }
  disconnected() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = void 0;
    }
  }
}
const inView = e$4(InViewDirective);
const CustomEventScrollProductIntoViewKey = "scroll-product-into-view";
const productCardStyles = safeCss(`
    .product-card {
        position: relative;
        max-width: 320px;
        cursor: pointer;
    }
    
    @media (min-width: 640px) {
        .product-card {
            max-width: 360px;
        }
    }
    
    @media (min-width: 768px) {
        .product-card {
            max-width: 400px;
        }
    }
    
    .slider-container {
        border-radius: 12px;
        position: relative;
        scrollbar-width: none;
        -ms-overflow-style: none;
        scroll-snap-type: x mandatory;
        aspect-ratio: 0.8;
        overflow-x: auto;
        overflow-y: hidden;
    }
    
    .slider-container::-webkit-scrollbar {
        display: none;
    }
    
    .slider {
        aspect-ratio: inherit;
        display: flex;
        gap: 0;
        height: 100%;
        max-height: 100%;
        max-width: 100%;
    }
    
    .slide {
        height: inherit;
        aspect-ratio: inherit;
        max-width: inherit;
        flex: 0 0 100%;
        position: relative;
        scroll-snap-align: start;
        background: ${colors.gray[100]};
    }
    
    .slide img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    
    .slide.portrait img {
        object-fit: cover;
    }
    
    .swatch {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        overflow: hidden;
        margin: 1px;
        cursor: pointer;
    }
    
    .swatch-center {
        position: relative;
        width: 75%;
        height: 75%;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        margin: auto;
        border: 1px solid #dddddd;
    }
    
    .swatch-segment {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    
    .swatches-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 8px;
        margin-bottom: 4px;
        align-items: center;
    }
    
    .vendor-container {
        display: flex;
        gap: 8px;
        align-items: center;
    }
    
    .vendor, .gender {
        margin-bottom: 0;
    }
    
    .separator {
        display: inline-block;
        background-color: #EED9C4;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }
    
    .description-container {
        margin-top: 8px;
        position: relative;
    }
    
    .price {
        font: ${typographyClasses["text-heading-5"]};
    }
    
    .badges {
        display: flex;
        gap: 6px;
    }
    
    .badges wa-badge {
        --wa-badge-font-size: 12px;
        padding: 4px 8px;
    }
    
    .badges wa-badge::part(base) {
        padding: 4px 10px;
        border-radius: 4px;
    }
    
    .overlay {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(8px);
    }
    
    .overlay-color-unavailable {
        background-color: rgba(0, 0, 0, 0.2);
    }
    
    .overlay-text {
        color: white;
    }
`);
var __create$f = Object.create;
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __knownSymbol$f = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$f = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$f = (target, value) => __defProp$f(target, "name", { value, configurable: true });
var __decoratorStart$f = (base) => [, , , __create$f(base?.[__knownSymbol$f("metadata")] ?? null)];
var __decoratorStrings$f = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$f = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$f("Function expected") : fn;
var __decoratorContext$f = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$f[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$f("Already initialized") : fns.push(__expectFn$f(fn || null)) });
var __decoratorMetadata$f = (array, target) => __defNormalProp$f(target, __knownSymbol$f("metadata"), array[3]);
var __runInitializers$f = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$f = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$f[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$f(k2 < 4 ? target : { get [name]() {
    return __privateGet$e(this, extra);
  }, set [name](x2) {
    return __privateSet$e(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$f(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$f(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$f(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$e(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$e : __privateMethod$e)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$e(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$f(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$f("Object expected");
    else __expectFn$f(fn = it.get) && (desc.get = fn), __expectFn$f(fn = it.set) && (desc.set = fn), __expectFn$f(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$f(array, target), desc && __defProp$f(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$e = (obj, member, msg) => member.has(obj) || __typeError$f("Cannot " + msg);
var __privateIn$e = (member, obj) => Object(obj) !== obj ? __typeError$f('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$e = (obj, member, getter) => (__accessCheck$e(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$e = (obj, member, value) => member.has(obj) ? __typeError$f("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$e = (obj, member, value, setter) => (__accessCheck$e(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$e = (obj, member, method) => (__accessCheck$e(obj, member, "access private method"), method);
var _sliderEl_dec, _containerEl_dec, _inView_dec, _showPreviewImages_dec, _showAllImages_dec, _variantColorMap_dec, _swatchesOrder_dec, _activeColor_dec, _productCard_dec, _onClickCallbacks_dec, _idPrefix_dec, _product_dec, _index_dec, _virtualWidth_dec, _virtualHeight_dec, _showVirtual_dec, _a$f, _ProductCard_decorators, _init$f, _showVirtual, _virtualHeight, _virtualWidth, _index, _product, _idPrefix, _onClickCallbacks, _productCard, _activeColor, _swatchesOrder, _variantColorMap, _showAllImages, _showPreviewImages, _inView, _containerEl, _sliderEl;
const HEADING_LARGE_STYLE$1 = `color: ${tokens.color.gray[700]}; font-size: ${typography.fontSize.lg};`;
const portraitProductTypes = [
  "t-shirt",
  "polo shirt",
  "jacket",
  "ski & snowboard jacket",
  "fleece",
  "hoodie",
  "midlayer",
  "baselayer",
  "coats & jackets"
];
function roundToTwoDecimals(num) {
  return num % 1 === 0 ? num : num.toFixed(2);
}
const menTitlePatterns = [/men's/i, /men’s/i];
const womenTitlePatterns = [/women's/i, /women’s/i];
const unisexTitlePatterns = [/\bunisex\b/i, /\buniversal\b/i];
const optionColorNames = ["color", "colour"];
function removeOccurrences(str, patterns) {
  return patterns.reduce((result, pattern) => {
    return result.replace(pattern, "");
  }, str);
}
const isMobile$1 = () => {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(navigator.userAgent);
};
const getAvailableFilterColorValues = (availableFiltersValues) => {
  return availableFiltersValues["color"] || availableFiltersValues["colour"];
};
const getImageSource = (imgSrc, widthPx) => {
  return `${imgSrc}${imgSrc.includes("?") ? "&" : "?"}width=${widthPx}`;
};
_ProductCard_decorators = [t$1("briffa-product-card")];
class ProductCard extends (_a$f = BaseDesignSystemComponent(productCardStyles), _showVirtual_dec = [n$1({ type: Boolean })], _virtualHeight_dec = [n$1({ type: Number })], _virtualWidth_dec = [n$1({ type: Number })], _index_dec = [n$1({ type: Number })], _product_dec = [n$1({ type: Object })], _idPrefix_dec = [n$1({ type: String })], _onClickCallbacks_dec = [n$1({ type: Array })], _productCard_dec = [r$1()], _activeColor_dec = [r$1()], _swatchesOrder_dec = [r$1()], _variantColorMap_dec = [r$1()], _showAllImages_dec = [r$1()], _showPreviewImages_dec = [r$1()], _inView_dec = [r$1()], _containerEl_dec = [e$5("#container")], _sliderEl_dec = [e$5(".slider-container")], _a$f) {
  constructor() {
    super(...arguments);
    __privateAdd$e(this, _showVirtual, __runInitializers$f(_init$f, 8, this, false)), __runInitializers$f(_init$f, 11, this);
    __privateAdd$e(this, _virtualHeight, __runInitializers$f(_init$f, 12, this, 0)), __runInitializers$f(_init$f, 15, this);
    __privateAdd$e(this, _virtualWidth, __runInitializers$f(_init$f, 16, this, 0)), __runInitializers$f(_init$f, 19, this);
    __privateAdd$e(this, _index, __runInitializers$f(_init$f, 20, this)), __runInitializers$f(_init$f, 23, this);
    __privateAdd$e(this, _product, __runInitializers$f(_init$f, 24, this)), __runInitializers$f(_init$f, 27, this);
    __privateAdd$e(this, _idPrefix, __runInitializers$f(_init$f, 28, this, "")), __runInitializers$f(_init$f, 31, this);
    __privateAdd$e(this, _onClickCallbacks, __runInitializers$f(_init$f, 32, this, [])), __runInitializers$f(_init$f, 35, this);
    __privateAdd$e(this, _productCard, __runInitializers$f(_init$f, 36, this, null)), __runInitializers$f(_init$f, 39, this);
    __privateAdd$e(this, _activeColor, __runInitializers$f(_init$f, 40, this, "")), __runInitializers$f(_init$f, 43, this);
    __privateAdd$e(this, _swatchesOrder, __runInitializers$f(_init$f, 44, this, {})), __runInitializers$f(_init$f, 47, this);
    __privateAdd$e(this, _variantColorMap, __runInitializers$f(_init$f, 48, this, {})), __runInitializers$f(_init$f, 51, this);
    __privateAdd$e(this, _showAllImages, __runInitializers$f(_init$f, 52, this, false)), __runInitializers$f(_init$f, 55, this);
    __privateAdd$e(this, _showPreviewImages, __runInitializers$f(_init$f, 56, this, false)), __runInitializers$f(_init$f, 59, this);
    __privateAdd$e(this, _inView, __runInitializers$f(_init$f, 60, this, false)), __runInitializers$f(_init$f, 63, this);
    __privateAdd$e(this, _containerEl, __runInitializers$f(_init$f, 64, this)), __runInitializers$f(_init$f, 67, this);
    __privateAdd$e(this, _sliderEl, __runInitializers$f(_init$f, 68, this)), __runInitializers$f(_init$f, 71, this);
    this.imageRenderFinishedMap = { 0: true };
    this.handleCardClick = () => {
      this.onClickCallbacks.forEach(
        (callback) => callback({
          productId: this.productCard.id,
          handle: this.productCard.handle
        })
      );
      window.location.pathname = `/products/${this.productCard.handle}`;
    };
    this.handleSwatchSelection = (event, color) => {
      this.showAllImages = true;
      event.stopPropagation();
      this.activeColor = color;
      this.scrollToColorImage(color);
    };
    this.handleImageSwatchInView = (inView2, imageColor) => {
      if (inView2 && imageColor && imageColor !== this.activeColor) {
        this.activeColor = imageColor;
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.initializeProductCard();
    document.addEventListener(
      CustomEventScrollProductIntoViewKey,
      (event) => {
        const productId = event.detail.productId;
        if (productId === this.productCard.id) {
          this.containerEl.scrollIntoView({
            behavior: "auto",
            block: "center"
          });
        }
      }
    );
  }
  initializeProductCard() {
    const totalPrices = this.product.variants.map(
      (variant) => variant.price
    );
    const computedMin = Math.min(...totalPrices);
    const computedMax = Math.max(...totalPrices);
    const caseInsensitiveProductType = Array.isArray(
      this.product.productType
    ) ? this.product.productType[0] : this.product.productType;
    this.productCard = {
      availableFilters: this.product.availableFilters,
      briffaEnabled: this.product.briffaEnabled,
      createdAt: this.product.createdAt,
      status: this.product.status,
      totalInventory: this.product.totalInventory,
      updatedAt: this.product.updatedAt,
      id: this.product.id,
      available: this.product.available,
      handle: this.product.handle,
      title: this.product.title,
      url: `/products/${this.product.handle}`,
      vendor: this.product.vendor,
      priceRange: this.product.priceRange,
      collections: this.product.collections,
      featuredImage: this.product.featuredImage,
      availableFiltersValues: this.product.availableFiltersValues,
      currency: this.product.currency ?? "€",
      productType: caseInsensitiveProductType,
      priceMin: roundToTwoDecimals(computedMin),
      priceMax: roundToTwoDecimals(computedMax),
      price: roundToTwoDecimals(
        computedMin === computedMax ? computedMax : null
      ),
      images: this.product.images,
      media: this.product.media,
      variants: this.product.variants,
      options: this.product.options,
      swatchesMap: this.product.swatchesMap
    };
    this.initializeVariantColorMap();
    this.initializeSwatchesOrder();
  }
  initializeVariantColorMap() {
    this.variantColorMap = this.productCard.variants.reduce(
      (acc, variant) => {
        const colorOption = variant.selectedOptions.find(
          (option) => option.name === "Color" || option.name === "Colour"
        );
        if (colorOption) {
          acc[variant.id] = colorOption.value;
        }
        return acc;
      },
      {}
    );
  }
  initializeSwatchesOrder() {
    let swatchCounter = 0;
    const order = {};
    this.productCard.images.forEach((image) => {
      if (image.variantIds?.length > 0) {
        let foundVariant = false;
        image.variantIds.forEach((variantId) => {
          if (!foundVariant) {
            const color = this.variantColorMap[variantId];
            if (color && !order[color]) {
              foundVariant = true;
              order[color] = swatchCounter;
              swatchCounter++;
            }
          }
        });
      }
    });
    this.swatchesOrder = order;
  }
  scrollToColorImage(color) {
    const targetImage = this.shadowRoot?.querySelector(
      `img[data-color="${color}"]`
    );
    if (targetImage) {
      this.sliderEl.scrollTo({
        left: targetImage.parentElement.offsetLeft,
        behavior: "instant"
      });
    }
  }
  loadImage(imageElement, imgIndex, lowRes = false) {
    const resMultiplier = lowRes ? 0.1 : 1;
    const deviceMultiplier = isMobile$1() ? 1 : 3;
    const imgPixelWidth = window.devicePixelRatio * 400 * deviceMultiplier * resMultiplier;
    if (imageElement) {
      const src = imageElement.getAttribute("data-src");
      if (src) {
        imageElement.src = getImageSource(src, imgPixelWidth);
        imageElement.loading = "eager";
        this.imageRenderFinishedMap[imgIndex] = true;
      }
    }
  }
  // Renders all images in carousel
  loadCarousel(event) {
    if (this.showAllImages) {
      return;
    }
    this.showAllImages = true;
  }
  showCarouselSecondImage(inView2, element) {
    this.showPreviewImages = inView2;
  }
  createColorSwatch(color) {
    const colorLowerCase = color.toLowerCase();
    const colors2 = this.productCard.swatchesMap[colorLowerCase] ?? [
      "#a72bb5"
    ];
    const colorFilterValues = getAvailableFilterColorValues(
      this.productCard.availableFiltersValues
    );
    const unavailableVariant = !colorFilterValues[colorLowerCase]?.available;
    const swatchColor = this.productCard.swatchesMap[colorLowerCase]?.[0] ?? "#000000";
    return x`
            <div
                class="swatch flex justify-center items-center !m-[1px]"
                style="order: ${this.swatchesOrder[color]}; ${this.activeColor === color ? `box-shadow: inset 0 0 0 1.5px ${swatchColor};` : ""}"
                @click=${(e2) => this.handleSwatchSelection(e2, color)}
                @mouseenter=${(e2) => this.handleSwatchSelection(e2, color)}
            >
                <div
                    class="swatch-center ${unavailableVariant ? "opacity-50" : ""}"
                >
                    ${colors2.map(
      (colorValue, index2) => x`
                            <div
                                class="swatch-segment"
                                style="
                                background-color: ${colorValue};
                                ${colors2.length === 2 ? `clip-path: ${index2 === 0 ? "polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%, 50% 50%)" : "polygon(100% 0px, 100% 100%, 0px 100%, 0px 0px, 50% 50%, 100% 100%)"}` : ""}
                            "
                                aria-label="Color swatch ${colorValue}"
                                role="img"
                            ></div>
                        `
    )}
                    ${unavailableVariant ? x`
                              <div
                                  class="absolute inset-0 bg-white opacity-50"
                              ></div>
                              <div
                                  class="absolute inset-0 overflow-hidden rounded-full"
                              >
                                  <div
                                      class="absolute left-0 top-0 h-full w-[1px] bg-white rotate-45 scale-y-[141.42%] left-[48%] opacity-40"
                                  ></div>
                              </div>
                          ` : ""}
                </div>
            </div>
        `;
  }
  renderBadges() {
    const { variants } = this.productCard;
    const originalPrice = variants.length ? variants[0].compareAtPrice : null;
    const currentPrice = variants.length ? variants[0].price : null;
    const salePercentage = originalPrice && currentPrice && originalPrice !== currentPrice ? (100 - Number(currentPrice) * 100 / originalPrice).toFixed(
      0
    ) : null;
    return x`
            <div class="badges">
                ${this.productCard.collections.map(({ title }) => {
      const badgeText = R2.Localization.Badges[title];
      if (!badgeText) return "";
      return x`
                        <wa-badge variant="brand">
                            ${badgeText}
                        </wa-badge>
                    `;
    })}
                ${salePercentage ? x`
                          <wa-badge variant="brand">
                              ${salePercentage}% off
                          </wa-badge>
                      ` : null}
            </div>
        `;
  }
  renderGenderAndTitle() {
    let parsedTitle = this.productCard.title;
    let gender = "";
    const containsMenInTitle = menTitlePatterns.some(
      (pattern) => pattern.test(this.productCard.title)
    );
    const containsWomenInTitle = womenTitlePatterns.some(
      (pattern) => pattern.test(this.productCard.title)
    );
    const containsUnisexInTitle = unisexTitlePatterns.some(
      (pattern) => pattern.test(this.productCard.title)
    );
    if (containsWomenInTitle) {
      gender = "Women";
      parsedTitle = removeOccurrences(
        this.productCard.title,
        womenTitlePatterns
      );
    } else if (containsMenInTitle) {
      gender = "Men";
      parsedTitle = removeOccurrences(
        this.productCard.title,
        menTitlePatterns
      );
    } else if (containsUnisexInTitle) {
      gender = "Unisex";
      parsedTitle = removeOccurrences(
        this.productCard.title,
        unisexTitlePatterns
      );
    }
    return x`
            <div class="vendor-container mt-1">
                <p class="vendor">${this.productCard.vendor}</p>
                ${gender ? x`
                          <span class="separator"></span>
                          <p class="gender">${gender}</p>
                      ` : ""}
            </div>
            <p class="font-semibold">${parsedTitle}</p>
        `;
  }
  renderPrice() {
    const compareAtPrice = this.productCard.variants[0].compareAtPrice;
    let commonClassNames = `price mt-1`;
    const commonSmallStyles = `color: ${colors.gray["500"]};`;
    const showFixed = !!this.productCard.price || this.productCard.priceMin === this.productCard.priceMax;
    const priceText = !showFixed ? x`<span
                      style="font-size: ${typography.fontSize.sm};${commonSmallStyles}"
                      >${R2.Localization.ProductCard.StartingFrom}</span
                  >
                  ${this.productCard.currency}${this.productCard.priceMin}` : x`${this.productCard.currency}${this.productCard.price}`;
    if (compareAtPrice != null) {
      return x`<p
                class="${commonClassNames}"
                style="font-size: ${typography.fontSize.base};"
            >
                <span class="price">${priceText}</span>
                <s
                    style="font-size: ${typography.fontSize.base};${commonSmallStyles}"
                    >${this.productCard.currency}${compareAtPrice}</s
                >
            </p>`;
    }
    return x`<p class="${commonClassNames}">${priceText}</p>`;
  }
  renderSwatches() {
    const colorOption = this.productCard.options.find(
      (option) => optionColorNames.includes(option.name.toLowerCase())
    );
    if (!colorOption) return "";
    if (!this.activeColor) {
      this.activeColor = colorOption.values[0];
    }
    return x`
            <div class="swatches-container">
                ${colorOption.values.map(
      (color) => this.createColorSwatch(color)
    )}
            </div>
        `;
  }
  renderImageSlider() {
    const deviceMultiplier = isMobile$1() ? 1 : 3;
    const imgPixelWidth = window.devicePixelRatio * 500 * deviceMultiplier;
    let cachedColor = "";
    return x`
            <div
                class="slider-container"
                @pointermove=${!this.showAllImages ? this.loadCarousel : void 0}
                @touchstart=${!this.showAllImages ? this.loadCarousel : void 0}
                @pointerdown=${!this.showAllImages ? this.loadCarousel : void 0}
                ${inView(this.showCarouselSecondImage.bind(this))}
            >
                <div id="slider" class="slider">
                    ${this.productCard.images.slice(
      0,
      this.showPreviewImages || this.showAllImages ? void 0 : 1
    ).map((image, imgIndex) => {
      if (image.variantIds?.length > 0) {
        let foundVariant = false;
        cachedColor = "";
        image.variantIds.forEach((variantId) => {
          if (!foundVariant) {
            const color = this.variantColorMap[variantId];
            if (color) {
              foundVariant = true;
              cachedColor = color;
            }
          }
        });
      }
      const isPortrait = portraitProductTypes.includes(
        (this.productCard.productType ?? "").toLowerCase()
      );
      const colorFilterValues = getAvailableFilterColorValues(
        this.productCard.availableFiltersValues
      );
      const unavailableVariant = !!cachedColor && !colorFilterValues[cachedColor.toLowerCase()]?.available;
      const progressiveLoader = (inView2, targetEl) => {
        if (!inView2 || !this.showAllImages) {
          return;
        }
        const targetImg = targetEl.children[0];
        const targetIndex = Number(
          targetImg.getAttribute("data-index")
        );
        if (isNaN(targetIndex)) {
          return;
        }
        const alreadyRendered = this.imageRenderFinishedMap[targetIndex];
        if (!alreadyRendered) {
          this.loadImage(targetImg, targetIndex);
        }
        let prevIndex = targetIndex - 1;
        let nextIndex = targetIndex + 1;
        let prevImg = this.containerEl.querySelector(
          `[data-index='${prevIndex}']`
        );
        let nextImg = this.containerEl.querySelector(
          `[data-index='${nextIndex}']`
        );
        if (nextImg && !this.imageRenderFinishedMap[nextIndex]) {
          this.loadImage(nextImg, nextIndex);
        }
        if (prevImg && !this.imageRenderFinishedMap[prevIndex]) {
          this.loadImage(prevImg, prevIndex);
        }
        const colorFromElement = targetImg?.getAttribute("data-color");
        if (colorFromElement) {
          this.handleImageSwatchInView(
            inView2,
            colorFromElement
          );
        }
      };
      return x`
                            <div
                                class="slide ${isPortrait ? "portrait" : ""}"
                                ${progressiveLoader ? inView(progressiveLoader.bind(this)) : ""}
                            >
                                <img
                                    src=${getImageSource(
        image.src,
        imgIndex === 0 ? imgPixelWidth : imgPixelWidth / 3
      )}
                                    data-src=${image.src}
                                    data-color=${cachedColor}
                                    data-index=${imgIndex}
                                    alt=""
                                    loading="${this.showAllImages ? "eager" : "lazy"}"
                                />
                                ${!this.productCard.available ? x`
                                          <div class="overlay">
                                              <p
                                                  class="overlay-text"
                                                  style="${HEADING_LARGE_STYLE$1}"
                                              >
                                                  ${R2.Localization.OutOfStock}
                                              </p>
                                          </div>
                                      ` : unavailableVariant && this.productCard.available ? x`
                                            <div
                                                class="overlay overlay-color-unavailable"
                                            >
                                                <p
                                                    class="overlay-text"
                                                    style="${HEADING_LARGE_STYLE$1}"
                                                >
                                                    ${R2.Localization.ColorUnavailable}
                                                </p>
                                            </div>
                                        ` : ""}
                            </div>
                        `;
    })}
                </div>
            </div>
        `;
  }
  render() {
    if (!this.productCard) return x``;
    if (this.showVirtual && this.virtualWidth && this.virtualHeight) {
      return x` <div
                style="height: ${this.virtualHeight}px; width: ${this.virtualWidth}px;"
            ></div>`;
    }
    const inViewVirtualHandler = (inView2, _targetEl) => {
      this.inView = inView2;
    };
    return x`
            <div
                ${inView(inViewVirtualHandler)}
                id="container"
                class="product-card"
                data-briffa-product-card-id="${this.productCard.id}"
                @click=${this.handleCardClick}
                data-card-index="${this.index}"
            >
                ${this.renderImageSlider()}
                <div class="description-container">
                    ${this.renderBadges()} ${this.renderSwatches()}
                    ${this.renderGenderAndTitle()} ${this.renderPrice()}
                </div>
            </div>
        `;
  }
  // Public API methods for compatibility
  subscribeToOnClick(callback) {
    this.onClickCallbacks.push(callback);
  }
}
_init$f = __decoratorStart$f(_a$f);
_showVirtual = /* @__PURE__ */ new WeakMap();
_virtualHeight = /* @__PURE__ */ new WeakMap();
_virtualWidth = /* @__PURE__ */ new WeakMap();
_index = /* @__PURE__ */ new WeakMap();
_product = /* @__PURE__ */ new WeakMap();
_idPrefix = /* @__PURE__ */ new WeakMap();
_onClickCallbacks = /* @__PURE__ */ new WeakMap();
_productCard = /* @__PURE__ */ new WeakMap();
_activeColor = /* @__PURE__ */ new WeakMap();
_swatchesOrder = /* @__PURE__ */ new WeakMap();
_variantColorMap = /* @__PURE__ */ new WeakMap();
_showAllImages = /* @__PURE__ */ new WeakMap();
_showPreviewImages = /* @__PURE__ */ new WeakMap();
_inView = /* @__PURE__ */ new WeakMap();
_containerEl = /* @__PURE__ */ new WeakMap();
_sliderEl = /* @__PURE__ */ new WeakMap();
__decorateElement$f(_init$f, 4, "showVirtual", _showVirtual_dec, ProductCard, _showVirtual);
__decorateElement$f(_init$f, 4, "virtualHeight", _virtualHeight_dec, ProductCard, _virtualHeight);
__decorateElement$f(_init$f, 4, "virtualWidth", _virtualWidth_dec, ProductCard, _virtualWidth);
__decorateElement$f(_init$f, 4, "index", _index_dec, ProductCard, _index);
__decorateElement$f(_init$f, 4, "product", _product_dec, ProductCard, _product);
__decorateElement$f(_init$f, 4, "idPrefix", _idPrefix_dec, ProductCard, _idPrefix);
__decorateElement$f(_init$f, 4, "onClickCallbacks", _onClickCallbacks_dec, ProductCard, _onClickCallbacks);
__decorateElement$f(_init$f, 4, "productCard", _productCard_dec, ProductCard, _productCard);
__decorateElement$f(_init$f, 4, "activeColor", _activeColor_dec, ProductCard, _activeColor);
__decorateElement$f(_init$f, 4, "swatchesOrder", _swatchesOrder_dec, ProductCard, _swatchesOrder);
__decorateElement$f(_init$f, 4, "variantColorMap", _variantColorMap_dec, ProductCard, _variantColorMap);
__decorateElement$f(_init$f, 4, "showAllImages", _showAllImages_dec, ProductCard, _showAllImages);
__decorateElement$f(_init$f, 4, "showPreviewImages", _showPreviewImages_dec, ProductCard, _showPreviewImages);
__decorateElement$f(_init$f, 4, "inView", _inView_dec, ProductCard, _inView);
__decorateElement$f(_init$f, 4, "containerEl", _containerEl_dec, ProductCard, _containerEl);
__decorateElement$f(_init$f, 4, "sliderEl", _sliderEl_dec, ProductCard, _sliderEl);
ProductCard = __decorateElement$f(_init$f, 0, "ProductCard", _ProductCard_decorators, ProductCard);
__runInitializers$f(_init$f, 1, ProductCard);
function createProductCard(product, productIndex) {
  const card = new ProductCard();
  card.product = product;
  card.idPrefix = "search-results-";
  card.index = productIndex;
  return card;
}
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BriffaAccordianFilter,
  get BriffaBrandsFilter() {
    return BriffaBrandsFilter;
  },
  get BriffaCheckboxFilter() {
    return BriffaCheckboxFilter;
  },
  get BriffaCounterLabel() {
    return BriffaCounterLabel;
  },
  get BriffaGenderFilter() {
    return BriffaGenderFilter;
  },
  get BriffaHideOutOfStockFilter() {
    return BriffaHideOutOfStockFilter;
  },
  get BriffaIncludeOutOfStockFilter() {
    return BriffaIncludeOutOfStockFilter;
  },
  get BriffaPriceFilter() {
    return BriffaPriceFilter;
  },
  get BriffaProductTypeFilter() {
    return BriffaProductTypeFilter;
  },
  BriffaShowMoreExpander,
  BriffaToggleButton,
  get BriffaToggleFilter() {
    return BriffaToggleFilter;
  },
  get Portal() {
    return Portal;
  },
  get ProductCard() {
    return ProductCard;
  },
  get SizeFilter() {
    return SizeFilter;
  },
  TailwindElement,
  createProductCard
}, Symbol.toStringTag, { value: "Module" }));
const index = {};
const services = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index
}, Symbol.toStringTag, { value: "Module" }));
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
class BroadcastController {
  constructor(host, broadcastAPI) {
    this.subscriptions = [];
    this.host = host;
    this.broadcastAPI = broadcastAPI;
    host.addController(this);
  }
  /**
   * Subscribe to a broadcast topic. The subscription will be automatically
   * cleaned up when the host component disconnects.
   *
   * @param options.topic - The topic to subscribe to
   * @param options.callback - The callback to invoke when data is broadcast
   * @param options.getSeed - Whether to immediately receive the cached value (if any)
   * @returns A function to manually unsubscribe (rarely needed)
   */
  subscribe({
    topic,
    callback,
    getSeed
  }) {
    const { subscriptionId, unsubscribe } = this.broadcastAPI.subscribe({
      topic,
      callback,
      getSeed
    });
    const handle = {
      topic,
      subscriptionId,
      unsubscribe
    };
    this.subscriptions.push(handle);
    return () => this.unsubscribeSingle(handle);
  }
  /**
   * Manually unsubscribe from a specific subscription
   */
  unsubscribeSingle(handle) {
    handle.unsubscribe();
    const index2 = this.subscriptions.indexOf(handle);
    if (index2 !== -1) {
      this.subscriptions.splice(index2, 1);
    }
  }
  /**
   * Unsubscribe from all subscriptions managed by this controller
   */
  unsubscribeAll() {
    this.subscriptions.forEach((handle) => handle.unsubscribe());
    this.subscriptions = [];
  }
  // ReactiveController lifecycle methods
  hostConnected() {
  }
  hostDisconnected() {
    this.unsubscribeAll();
  }
}
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BroadcastController,
  getViteEnv,
  isDevelopmentMode
}, Symbol.toStringTag, { value: "Module" }));
const sectionTitleClassList = [
  "!mt-2",
  "!mb-2",
  "!px-4",
  "!text-black",
  "font-semibold",
  "uppercase"
];
const localRoute = "https://localhost:3000";
const cloudRoute = "https://adventureshopapi.andreabriffa.com";
const getAPIUrl = () => isDevelopmentMode() ? localRoute : cloudRoute;
const getDeviceFingerPrint = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    if (crypto.randomUUID) {
      deviceId = crypto.randomUUID();
    } else {
      deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c2) {
          const r2 = Math.random() * 16 | 0;
          const v2 = c2 === "x" ? r2 : r2 & 3 | 8;
          return v2.toString(16);
        }
      );
    }
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};
const allAvailabilityTags = {
  [PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY]: [
    generateProductFilterKey(
      PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
      "false"
    ),
    generateProductFilterKey(
      PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
      "true"
    )
  ]
};
class BriffaCloudSearchApi {
  constructor() {
    this.maxFailedKeepAliveAttempts = 3;
    this.failedKeepAliveAttempts = 0;
    this.activeRoute = "";
    this.keepAliveMaxAttemptsFailedCallbacks = [];
    this.activeRoute = getAPIUrl();
  }
  incrementFailedAttempts() {
    this.failedKeepAliveAttempts = this.failedKeepAliveAttempts + 1;
    if (this.hasReachedMaxFailedAttempts()) {
      this.maxAttemptsReached();
    }
  }
  decrementFailedAttempts() {
    this.failedKeepAliveAttempts = Math.max(
      0,
      this.failedKeepAliveAttempts - 1
    );
  }
  hasReachedMaxFailedAttempts() {
    return this.failedKeepAliveAttempts >= this.maxFailedKeepAliveAttempts;
  }
  resetMaxAttempts() {
    this.failedKeepAliveAttempts = 0;
  }
  // TODO: make `getInStockFilterDetails` endpoint
  // IMPORTANT... REMOVE 'inStock' from selected filters, to get proper count
  async paginationKeepAlive(paginationKey) {
    const url = `${this.activeRoute}/pagination/heartbeat`;
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Device-ID": getDeviceFingerPrint()
      },
      body: JSON.stringify({ paginationKey })
    };
    return await fetch(url, options).then(({ status }) => {
      if (status !== 200) {
        this.incrementFailedAttempts();
        return false;
      }
      this.decrementFailedAttempts();
      return true;
    }).catch((error) => {
      this.incrementFailedAttempts();
      console.error("Error:", error);
    });
  }
  // TODO: Add filters option
  /**
   * Here we expect that pagination details are included in the request
   * request: {pageIndex, paginationKey}
   */
  async performPaginatedSearch(request) {
    const requestWithFilters = {
      ...request,
      selectedFilterTags: this.getSelectedFilterTags(),
      sortBy: this.getSortByValue()
    };
    const url = `${this.activeRoute}/pagination/search`;
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Device-ID": getDeviceFingerPrint()
      },
      body: JSON.stringify(requestWithFilters)
    };
    return await fetch(url, options).then((response) => response.json()).then((response) => {
      return response ?? {};
    }).catch((error) => console.error("Error:", error));
  }
  /**
   * Get selected filter tags from Redux store
   */
  getSelectedFilterTags(overrides = {}) {
    return {
      ...getSelectedFilterTags(store.getState()),
      [PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY]: [
        ...getSelectedFilterTags(store.getState())[PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY] ?? [],
        generateProductFilterKey(
          PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY,
          "true"
        )
      ],
      ...overrides
    };
  }
  /**
   * Get current sort by value from Redux store
   */
  getSortByValue() {
    return getSortBy(store.getState());
  }
  /**
   * Prepares API for pagination and returns first page
   * searchTerm: string
   */
  async initializeSearchBucket({
    searchTerm,
    pageSize = 20,
    getAvailableFilters,
    tillPageIndex
  }) {
    const url = `${this.activeRoute}/pagination/search`;
    const data = {
      searchString: searchTerm,
      pageIndex: 0,
      pageSize,
      getAvailableFilters,
      selectedFilterTags: this.getSelectedFilterTags(allAvailabilityTags),
      // NEW: Add selectedFilterTags
      sortBy: this.getSortByValue(),
      tillPageIndex
    };
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Device-ID": getDeviceFingerPrint()
      },
      body: JSON.stringify(data)
    };
    return await fetch(url, options).then((response) => response.json()).then((firstPage) => {
      return firstPage ?? {};
    }).catch((error) => {
      this.incrementFailedAttempts();
      console.error("Error:", error);
    });
  }
  /**
   * Prepares API for pagination and returns first page
   * collectionId: string | number
   */
  async initializeCollectionBucket({
    collectionId,
    getAvailableFilters,
    tillPageIndex
  }) {
    const url = `${this.activeRoute}/pagination/collection`;
    const data = {
      collectionId,
      matchAll: true,
      pageIndex: 0,
      pageSize: 40,
      getAvailableFilters,
      selectedFilterTags: this.getSelectedFilterTags(allAvailabilityTags),
      sortBy: this.getSortByValue(),
      tillPageIndex
    };
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Device-ID": getDeviceFingerPrint()
      },
      body: JSON.stringify(data)
    };
    return await fetch(url, options).then((response) => response.json()).then((firstPage) => {
      return firstPage ?? {};
    }).catch((error) => {
      this.incrementFailedAttempts();
      console.error("Error:", error);
    });
  }
  /**
   * searchTerm: string
   * sortBy: string
   * signal: AbortController signal
   */
  async searchProducts({
    searchTerm,
    limit,
    signal
  }) {
    const url = `${this.activeRoute}/products/search`;
    const data = {
      searchString: searchTerm,
      limit,
      getAvailableFilters: true,
      selectedFilterTags: this.getSelectedFilterTags(allAvailabilityTags)
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Device-ID": getDeviceFingerPrint()
      },
      body: JSON.stringify(data),
      signal
    };
    return await fetch(url, options).then((response) => response.json()).then((data2) => {
      return data2 ?? {};
    }).catch((error) => console.error("Error:", error));
  }
  // Changed methods
  maxAttemptsReached() {
    this.keepAliveMaxAttemptsFailedCallbacks.forEach(
      (callback) => callback()
    );
  }
  // Subscriptions
  subscribeToMaxAttemptsFailed(callback) {
    this.keepAliveMaxAttemptsFailedCallbacks.push(callback);
  }
}
const briffaCloudSearchApiSingleton = new BriffaCloudSearchApi();
class BriffaCloudSearchFactory {
  constructor() {
    this.latestResponse = {
      searchTerm: "",
      results: {},
      suggestedCollectionTitles: []
    };
    this.defaultSuggestedCollectionTitles = ["Jackets", "Shirts", "Tent"];
    this.suggestedCategories = null;
    this.suggestedCategories = this.fetchSuggestedCategoryTitles();
  }
  getFrequentCollectionsTally(products) {
    const collectionMap = {};
    const frequentCollectionsTally = {};
    products.forEach(({ collections: productCollections }) => {
      productCollections.forEach(({ handle, title, id }) => {
        if (!collectionMap[id] && !frequentCollectionsTally[id]) {
          frequentCollectionsTally[id] = 0;
          collectionMap[id] = {
            handle,
            title,
            id
          };
        }
        frequentCollectionsTally[id] = frequentCollectionsTally[id] + 1;
      });
    });
    const sortedFrequentCollectionsTally = Object.entries(
      frequentCollectionsTally
    ).sort((a2, b2) => b2[1] - a2[1]);
    return sortedFrequentCollectionsTally.map(
      ([collectionId]) => collectionMap[collectionId]
    );
  }
  getPredefinedCollections(searchTerm) {
    return this.defaultSuggestedCollectionTitles.filter(
      (title) => title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  // Removes duplicates with case insensitivity
  removeCaseInsensitiveDuplicates(arr) {
    const seen = /* @__PURE__ */ new Set();
    return arr.filter((item) => {
      const lowercase = item.toLowerCase();
      if (!seen.has(lowercase)) {
        seen.add(lowercase);
        return true;
      }
      return false;
    });
  }
  getMatchScore(word, term) {
    const regex = new RegExp(term, "gi");
    return (word.match(regex) || []).length;
  }
  sortByTermOccurrence(stringList, term) {
    return stringList.sort((a2, b2) => {
      const countA = this.getMatchScore(a2, term);
      const countB = this.getMatchScore(b2, term);
      return countB - countA;
    });
  }
  fetchSuggestedCategoryTitles(searchTerm = "", products = []) {
    if (!products || !searchTerm) {
      return this.defaultSuggestedCollectionTitles;
    }
    const predefinedCollectionTitles = this.getPredefinedCollections(searchTerm);
    let frequentCollections = {};
    let frequentCollectionTitles = [];
    frequentCollections = this.getFrequentCollectionsTally(products);
    frequentCollectionTitles = frequentCollections.map(
      (collection) => collection.title
    );
    frequentCollectionTitles = this.sortByTermOccurrence(
      frequentCollectionTitles,
      searchTerm
    );
    frequentCollectionTitles = frequentCollectionTitles.filter(
      (title) => title.toLowerCase() !== searchTerm.toLowerCase()
    );
    let combinedCollectionsTitles = [
      ...predefinedCollectionTitles,
      ...frequentCollectionTitles
    ];
    combinedCollectionsTitles = this.removeCaseInsensitiveDuplicates(
      combinedCollectionsTitles
    );
    return combinedCollectionsTitles;
  }
  /*
    Must return following properties:
      - searchTerm,
      - results,
      - suggestedCollectionTitles
  */
  createSearchResponse(response) {
    const suggestedCollectionTitles = [];
    return {
      ...response,
      suggestedCollectionTitles,
      trendingSearchTitles: [],
      recentlySearchedTerms: []
    };
  }
  async searchProducts({ searchTerm, limit, signal }) {
    const res = await briffaCloudSearchApiSingleton.searchProducts({
      searchTerm,
      limit,
      signal
    });
    return this.createSearchResponse(res);
  }
}
const briffaCloudSearchFactory = new BriffaCloudSearchFactory();
class BriffaGenericSearchFactory {
  constructor() {
    this.localStorageRecentlyViewedItemsKey = "briffa-recently-viewed-items";
    this.localStorageRecentlySearchedTermsKey = "briffa-recently-searched-terms";
    this.searchTermChangedCallbacks = [];
    this.recentlySearchedTermsChangedCallbacks = [];
    this.loadingStatusChangedCallbacks = [];
    this.focusedStateChangeSubscribers = [];
    this.searchObjectChangedCallbacks = [];
    this.searchAbortController = null;
    this.previousSearchTerm = null;
    this.isLoadingResults = false;
    this.lastLoadingTimestamp = -1;
    this.searchTerm = "";
    this.focusedOn = false;
    this.trendingSearchTitles = [
      "Jackets",
      "Shirts",
      "Tent",
      "Backpacks",
      "Baselayers"
    ];
    this.latestResponse = void 0;
    this.defaultSuggestedCollectionTitles = ["Jackets", "Shirts", "Tent"];
    this.suggestedCategories = null;
    this.recentlyViewedItems = null;
    this.recentlySearchedTerms = null;
    this.trendingItems = null;
    this.debouncedSearchTermChanged = lodashExports.debounce(
      this.searchTermChanged.bind(this),
      100
    );
    this.suggestedCategories = this.fetchSuggestedCategoryTitles();
    this.recentlyViewedItems = this.fetchRecentlyViewedItems();
    this.recentlySearchedTerms = this.fetchRecentlySearchedTerms();
    this.trendingItems = this.fetchTrendingItems();
  }
  getFrequentCollectionsTally(products) {
    const collectionMap = {};
    const frequentCollectionsTally = {};
    products.forEach(({ collections: productCollections }) => {
      productCollections.forEach(({ handle, title, id }) => {
        if (!collectionMap[id] && !frequentCollectionsTally[id]) {
          frequentCollectionsTally[id] = 0;
          collectionMap[id] = {
            handle,
            title,
            id
          };
        }
        frequentCollectionsTally[id] = frequentCollectionsTally[id] + 1;
      });
    });
    const sortedFrequentCollectionsTally = Object.entries(
      frequentCollectionsTally
    ).sort((a2, b2) => b2[1] - a2[1]);
    return sortedFrequentCollectionsTally.map(
      ([collectionId]) => collectionMap[collectionId]
    );
  }
  getPredefinedCollections(searchTerm) {
    return this.defaultSuggestedCollectionTitles.filter(
      (title) => title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  // Removes duplicates with case insensitivity
  removeCaseInsensitiveDuplicates(arr) {
    const seen = /* @__PURE__ */ new Set();
    return arr.filter((item) => {
      const lowercase = item.toLowerCase();
      if (!seen.has(lowercase)) {
        seen.add(lowercase);
        return true;
      }
      return false;
    });
  }
  getMatchScore(word, term) {
    const regex = new RegExp(term, "gi");
    return (word.match(regex) || []).length;
  }
  sortByTermOccurrence(stringList, term) {
    return stringList.sort((a2, b2) => {
      const countA = this.getMatchScore(a2, term);
      const countB = this.getMatchScore(b2, term);
      return countB - countA;
    });
  }
  fetchSuggestedCategoryTitles(searchTerm = "", products = []) {
    if (!products || !searchTerm) {
      return this.defaultSuggestedCollectionTitles;
    }
    const predefinedCollectionTitles = this.getPredefinedCollections(searchTerm);
    let frequentCollections = {};
    let frequentCollectionTitles = [];
    frequentCollections = this.getFrequentCollectionsTally(products);
    frequentCollectionTitles = frequentCollections.map(
      (collection) => collection.title
    );
    frequentCollectionTitles = this.sortByTermOccurrence(
      frequentCollectionTitles,
      searchTerm
    );
    frequentCollectionTitles = frequentCollectionTitles.filter(
      (title) => title.toLowerCase() !== searchTerm.toLowerCase()
    );
    let combinedCollectionsTitles = [
      ...predefinedCollectionTitles,
      ...frequentCollectionTitles
    ];
    combinedCollectionsTitles = this.removeCaseInsensitiveDuplicates(
      combinedCollectionsTitles
    );
    return combinedCollectionsTitles;
  }
  fetchRecentlyViewedItems() {
  }
  fetchRecentlySearchedTerms() {
  }
  fetchTrendingItems() {
    return [9699974414672];
  }
  // Adds item to localStorage and the "recentlyViewedItems" field
  addRecentlyViewedItem(product) {
  }
  // Adds search term to localStorage and "recentlySearchedTerms" field
  addRecentlySearchedTerm() {
  }
  addLoadingStatusChangedSubscriber(callback, initialDispatch) {
    this.loadingStatusChangedCallbacks.push(callback);
    if (!initialDispatch) {
      return;
    }
    callback(this.isLoadingResults);
  }
  addFocusedChangedSubscriber(callback, initialDispatch) {
    this.focusedStateChangeSubscribers.push(callback);
    if (!initialDispatch) {
      return;
    }
    callback(this.focusedOn);
  }
  focusedChanged(status) {
    this.focusedOn = status;
    this.focusedStateChangeSubscribers.forEach((sub) => sub(status));
  }
  parseResponse(res) {
    return {
      ...res,
      suggestedCollectionTitles: [],
      trendingSearchTitles: this.trendingSearchTitles,
      recentlySearchedTerms: this.getLocalStorageRecentlySearchedTerms()
    };
  }
  async searchTermChanged(term) {
    const { signal } = this.searchAbortController ?? {};
    if (this.previousSearchTerm !== term && signal) {
      this.searchAbortController.abort("search input changed");
    }
    this.searchTerm = term;
    this.searchTermChangedCallbacks.forEach((callback) => callback(term));
    this.loadingStatusChangedCallbacks.forEach(
      (callback) => callback(true)
    );
    this.searchAbortController = new AbortController();
    const newSignal = this.searchAbortController.signal;
    try {
      this.isLoadingResults = true;
      const res = await briffaCloudSearchFactory.searchProducts({
        searchTerm: term,
        limit: 12,
        signal: newSignal
      });
      const response = this.parseResponse(res);
      if (newSignal.aborted) {
        return;
      }
      this.latestResponse = response;
      this.searchObjectChangedCallbacks.forEach(
        (callback) => callback(response)
      );
      this.loadingStatusChangedCallbacks.forEach(
        (callback) => callback(false)
      );
      this.isLoadingResults = false;
      this.lastLoadingTimestamp = Date.now();
    } catch (err) {
      if (newSignal.aborted) {
        return;
      }
      this.isLoadingResults = false;
      this.lastLoadingTimestamp = Date.now();
      this.loadingStatusChangedCallbacks.forEach(
        (callback) => callback(false)
      );
    }
  }
  //     SUBSCRIPTIONS     //
  subscribeToSearchObjectChanged(callback, initialDispatch = false) {
    this.searchObjectChangedCallbacks.push(callback);
    if (!initialDispatch) {
      return;
    }
    const res = briffaCloudSearchFactory.createSearchResponse(
      this.latestResponse
    );
    const response = this.parseResponse(res);
    callback(response);
  }
  subscribeToSearchTermChanged(callback, initialDispatch) {
    this.searchTermChangedCallbacks.push(callback);
    if (!initialDispatch) {
      return;
    }
    callback(this.latestResponse.query);
  }
  subscribeToRecentlySearchedTermsChanged(callback, initialDispatch) {
    this.recentlySearchedTermsChangedCallbacks.push(callback);
    if (initialDispatch) {
      callback(this.getLocalStorageRecentlySearchedTerms());
    }
  }
  //     CHANGED CALLBACKS     //
  recentlySearchedTermsChanged() {
    this.recentlySearchedTermsChangedCallbacks.forEach(
      (callback) => callback(this.getLocalStorageRecentlySearchedTerms())
    );
  }
  recentSearchTermAdded(term) {
    const newTerms = this.getLocalStorageRecentlySearchedTerms();
    if (!newTerms.includes(term)) {
      newTerms.push(term);
    } else {
      newTerms.splice(newTerms.indexOf(term), 1);
      newTerms.push(term);
    }
    this.setLocalStorageRecentlySearchedTerms(newTerms);
    this.recentlySearchedTermsChanged();
  }
  clearRecentlySearchedTerms() {
    this.setLocalStorageRecentlySearchedTerms([]);
    this.recentlySearchedTermsChanged();
  }
  //     STORAGE FUNCTIONS     //
  getLocalStorageRecentlySearchedTerms() {
    return JSON.parse(
      localStorage.getItem(this.localStorageRecentlySearchedTermsKey)
    ) ?? [];
  }
  setLocalStorageRecentlySearchedTerms(terms) {
    localStorage.setItem(
      this.localStorageRecentlySearchedTermsKey,
      JSON.stringify(terms)
    );
  }
}
const briffaGenericSearchFactory = new BriffaGenericSearchFactory();
const getTrendingSection = (trendingTitles) => {
  const section = document.createElement("div");
  if (!trendingTitles || trendingTitles.length === 0) {
    return section;
  }
  const title = document.createElement("p");
  title.classList.add(...sectionTitleClassList);
  title.innerHTML = "Trending Searches";
  const trendingNodes = document.createElement("div");
  trendingNodes.classList.add(
    "overflow-x-scroll",
    "flex",
    "gap-3",
    "[&::-webkit-scrollbar]:hidden",
    "[-ms-overflow-style:none]",
    "[scrollbar-width:none]"
  );
  trendingTitles.forEach((title2, index2) => {
    const node = document.createElement("span");
    node.classList.add(
      "!px-2",
      "!py-1",
      "font-semibold",
      "bg-[#f4f4f4]",
      "!text-black",
      "rounded-sm",
      "uppercase",
      "!text-[0.85rem]",
      "flex",
      "items-middle",
      "justify-center"
    );
    if (index2 === 0) {
      node.classList.add("!ml-4");
    }
    if (index2 === trendingTitles.length - 1) {
      node.classList.add("!mr-4");
    }
    node.innerHTML = title2;
    node.addEventListener("click", () => {
      briffaGenericSearchFactory.debouncedSearchTermChanged(title2);
    });
    trendingNodes.appendChild(node);
  });
  section.appendChild(title);
  section.appendChild(trendingNodes);
  return section;
};
const getRecentSearchesSection = () => {
  const container = document.createElement("div");
  container.classList.add("mt-2");
  const headerEl = document.createElement("div");
  headerEl.classList.add("flex", "justify-between", "items-center");
  const titleEl = document.createElement("p");
  titleEl.classList.add(...sectionTitleClassList);
  titleEl.innerHTML = "Recent Searches";
  const clearAll = document.createElement("span");
  clearAll.innerHTML = "Clear all";
  clearAll.classList.add("mr-4", "underline", "decoration-black");
  clearAll.addEventListener("click", () => {
    briffaGenericSearchFactory.clearRecentlySearchedTerms();
  });
  headerEl.appendChild(titleEl);
  headerEl.appendChild(clearAll);
  const resultsEl = document.createElement("div");
  resultsEl.classList.add("ml-4");
  resultsEl.innerHTML = "recent searches here...";
  container.appendChild(headerEl);
  container.appendChild(resultsEl);
  briffaGenericSearchFactory.subscribeToRecentlySearchedTermsChanged(
    ((terms) => {
      terms.length ? container.classList.remove("!hidden") : container.classList.add("!hidden");
      resultsEl.innerHTML = "";
      terms.reverse().forEach((term) => {
        const recentSearchEl = document.createElement("div");
        recentSearchEl.innerHTML = term;
        recentSearchEl.addEventListener(
          "click",
          (() => {
            briffaGenericSearchFactory.debouncedSearchTermChanged(
              term
            );
          }).bind(void 0)
        );
        resultsEl.appendChild(recentSearchEl);
      });
    }).bind(void 0),
    true
  );
  return container;
};
const highlightTerm = (word, term) => {
  const regex = new RegExp(term, "gi");
  return word.replace(regex, (match) => `<b>${match}</b>`);
};
const getSuggestionsSection = (searchTerm, suggestionTitles) => {
  const section = document.createElement("div");
  const suggestions = suggestionTitles.slice(0, 3);
  const titleEl = document.createElement("p");
  titleEl.classList.add(...sectionTitleClassList);
  titleEl.innerHTML = "Suggestions";
  const suggestionNodes = [];
  suggestions.forEach((suggestion) => {
    const node = document.createElement("div");
    node.classList.add("!text-black", "!px-4", "!mb-1");
    node.innerHTML = highlightTerm(suggestion, searchTerm);
    node.addEventListener("click", () => {
      briffaGenericSearchFactory.debouncedSearchTermChanged(suggestion);
    });
    suggestionNodes.push(node);
  });
  section.appendChild(titleEl);
  suggestionNodes.forEach((node) => section.appendChild(node));
  return section;
};
const searchPage = (inputValue) => {
  let containsOutOfStock = false;
  const availabilityTags = getAvailableFilterTagsByType(
    PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY
  )(store.getState());
  const inStockTag = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:true`;
  const outOfStockTag = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:false`;
  const inStockDetails = availabilityTags[inStockTag];
  const outOfStockDetails = availabilityTags[outOfStockTag];
  if (inStockDetails && outOfStockDetails) {
    if (inStockDetails.resultsCount < outOfStockDetails.resultsCount) {
      containsOutOfStock = true;
    }
  }
  briffaGenericSearchFactory.recentSearchTermAdded(inputValue);
  const filterTags = containsOutOfStock ? [] : [inStockTag];
  const url = "/search?q=" + encodeURIComponent(inputValue) + (filterTags.length > 0 ? "&filterTags=" + encodeURIComponent(JSON.stringify(filterTags)) : "");
  window.location.href = url;
};
const goToCollection = (collectionId, containsOutOfStock = false) => {
  const inStockTag = `${PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY}:true`;
  const filterTags = containsOutOfStock ? [] : [inStockTag];
  const filterTagsParam = filterTags.length > 0 ? `?filterTags=${encodeURIComponent(JSON.stringify(filterTags))}` : "";
  window.location.href = `/collections/${collectionId}${filterTagsParam}`;
};
const searchDesktopFactoryStyles = safeCss(`
    :host {
        display: contents;
    }
    
    .search-container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 1999999999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .briffa-search-overlay {
        height: 100vh;
        width: 100vw;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(17, 17, 17, 0.628);
    }

    .modal {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 8px;
        min-height: 40rem;
        height: 60vh;
        width: 80vw;
        max-width: 100rem;
        z-index: 101;
        background-color: white;
        border-radius: 12px;
        transition: width 300ms ease-out;
        container-type: inline-size;
    }

    .close-icon {
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
        z-index: 1000;
    }

    .input-container {
        padding: ${spacing["gutter-base"]}
    }

    .briffa-search-input {
        border: 2px solid #999;
        border-radius: 2px;
        width: 100%;
        font-size: 1.5rem;
        line-height: 2rem;
        color: black;
        padding: ${spacing["gutter-xs"]};
    }

    .briffa-search-input:active,
    .briffa-search-input:focus {
        border-color: black;
        outline: none;
    }

    .description-container {
        padding: 0 ${spacing["gutter-base"]};
        margin-bottom: 8px;
    }

    .description-container.hidden {
        display: none;
    }

    .results-count {
        margin-bottom: 4px;
    }

    .results-count.hidden {
        display: none;
    }

    .divider {
        margin: 4px 0;
        border: none;
        border-top: 1px solid #e5e7eb;
    }

    .suggestions-container {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
    }

    .suggestions-container.hidden {
        display: none;
    }

    .suggestions-title {
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.75rem;
    }

    .suggestions-pills {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .suggestion-link {
        background-color: #f6f6f6;
        padding: 4px 8px;
        font-weight: 600;
        border-radius: 6px;
        color: black;
        text-decoration: none;
    }

    .suggestion-text {
        margin: 0;
    }

    .results-container {
        margin-top: 4px;
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
    }

    .results-wrapper {
        margin-top: 4px;
    }

    .results-title {
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.75rem;
        margin-bottom: 8px;
    }

    .results-grid {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        max-height: min(50vh, 30rem);
        overflow-y: auto;
        gap: 1rem;
        margin-top: 8px;
    }

    @container (min-width: 48rem) {
        .results-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @container (min-width: 64rem) {
        .results-grid {
            grid-template-columns: repeat(4, 1fr);
        }
    }
`);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var MirrorValidator = () => {
  return {
    checkValidity(element) {
      const formControl = element.input;
      const validity = {
        message: "",
        isValid: true,
        invalidKeys: []
      };
      if (!formControl) {
        return validity;
      }
      let isValid = true;
      if ("checkValidity" in formControl) {
        isValid = formControl.checkValidity();
      }
      if (isValid) {
        return validity;
      }
      validity.isValid = false;
      if ("validationMessage" in formControl) {
        validity.message = formControl.validationMessage;
      }
      if (!("validity" in formControl)) {
        validity.invalidKeys.push("customError");
        return validity;
      }
      for (const key in formControl.validity) {
        if (key === "valid") {
          continue;
        }
        const checkedKey = key;
        if (formControl.validity[checkedKey]) {
          validity.invalidKeys.push(checkedKey);
        }
      }
      return validity;
    }
  };
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var button_styles_default = i$6`
  @layer wa-component {
    :host {
      display: inline-block;

      /* Workaround because Chrome doesn't like :host(:has()) below
       * https://issues.chromium.org/issues/40062355
       * Firefox doesn't like this nested rule, so both are needed */
      &:has(wa-badge) {
        position: relative;
      }
    }

    /* Apply relative positioning only when needed to position wa-badge
     * This avoids creating a new stacking context for every button */
    :host(:has(wa-badge)) {
      position: relative;
    }
  }

  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    transition-property: background, border, box-shadow, color, opacity;
    transition-duration: var(--wa-transition-fast);
    transition-timing-function: var(--wa-transition-easing);
    cursor: pointer;
    padding: 0 var(--wa-form-control-padding-inline);
    font-family: inherit;
    font-size: inherit;
    font-weight: var(--wa-font-weight-action);
    line-height: calc(var(--wa-form-control-height) - var(--border-width) * 2);
    height: var(--wa-form-control-height);
    width: 100%;

    background-color: var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud));
    border-color: transparent;
    color: var(--wa-color-on-loud, var(--wa-color-neutral-on-loud));
    border-radius: var(--wa-form-control-border-radius);
    border-style: var(--wa-border-style);
    border-width: var(--wa-border-width-s);
  }

  /* Appearance modifiers */
  :host([appearance='plain']) {
    .button {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: transparent;
      border-color: transparent;
    }
    @media (hover: hover) {
      .button:not(.disabled):not(.loading):hover {
        color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
        background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));
      }
    }
    .button:not(.disabled):not(.loading):active {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: color-mix(
        in oklab,
        var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet)),
        var(--wa-color-mix-active)
      );
    }
  }

  :host([appearance='outlined']) {
    .button {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: transparent;
      border-color: var(--wa-color-border-loud, var(--wa-color-neutral-border-loud));
    }
    @media (hover: hover) {
      .button:not(.disabled):not(.loading):hover {
        color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
        background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));
      }
    }
    .button:not(.disabled):not(.loading):active {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: color-mix(
        in oklab,
        var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet)),
        var(--wa-color-mix-active)
      );
    }
  }

  :host([appearance='filled']) {
    .button {
      color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
      background-color: var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal));
      border-color: transparent;
    }
    @media (hover: hover) {
      .button:not(.disabled):not(.loading):hover {
        color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
        background-color: color-mix(
          in oklab,
          var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),
          var(--wa-color-mix-hover)
        );
      }
    }
    .button:not(.disabled):not(.loading):active {
      color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
      background-color: color-mix(
        in oklab,
        var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),
        var(--wa-color-mix-active)
      );
    }
  }

  :host([appearance='filled-outlined']) {
    .button {
      color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
      background-color: var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal));
      border-color: var(--wa-color-border-normal, var(--wa-color-neutral-border-normal));
    }
    @media (hover: hover) {
      .button:not(.disabled):not(.loading):hover {
        color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
        background-color: color-mix(
          in oklab,
          var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),
          var(--wa-color-mix-hover)
        );
      }
    }
    .button:not(.disabled):not(.loading):active {
      color: var(--wa-color-on-normal, var(--wa-color-neutral-on-normal));
      background-color: color-mix(
        in oklab,
        var(--wa-color-fill-normal, var(--wa-color-neutral-fill-normal)),
        var(--wa-color-mix-active)
      );
    }
  }

  :host([appearance='accent']) {
    .button {
      color: var(--wa-color-on-loud, var(--wa-color-neutral-on-loud));
      background-color: var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud));
      border-color: transparent;
    }
    @media (hover: hover) {
      .button:not(.disabled):not(.loading):hover {
        background-color: color-mix(
          in oklab,
          var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud)),
          var(--wa-color-mix-hover)
        );
      }
    }
    .button:not(.disabled):not(.loading):active {
      background-color: color-mix(
        in oklab,
        var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud)),
        var(--wa-color-mix-active)
      );
    }
  }

  /* Focus states */
  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--wa-focus-ring);
    outline-offset: var(--wa-focus-ring-offset);
  }

  /* Disabled state */
  .button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button.disabled * {
    pointer-events: none;
  }

  /* Keep it last so Safari doesn't stop parsing this block */
  .button::-moz-focus-inner {
    border: 0;
  }

  /* Icon buttons */
  .button.is-icon-button {
    outline-offset: 2px;
    width: var(--wa-form-control-height);
    aspect-ratio: 1;
  }

  .button.is-icon-button:has(wa-icon) {
    width: auto;
  }

  /* Pill modifier */
  :host([pill]) .button {
    border-radius: var(--wa-border-radius-pill);
  }

  /*
   * Label
   */

  .start,
  .end {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .label {
    display: inline-block;
  }

  .is-icon-button .label {
    display: flex;
  }

  .label::slotted(wa-icon) {
    align-self: center;
  }

  /*
   * Caret modifier
   */

  wa-icon[part='caret'] {
    display: flex;
    align-self: center;
    align-items: center;

    &::part(svg) {
      width: 0.875em;
      height: 0.875em;
    }

    .button:has(&) .end {
      display: none;
    }
  }

  /*
   * Loading modifier
   */

  .loading {
    position: relative;
    cursor: wait;

    .start,
    .label,
    .end,
    .caret {
      visibility: hidden;
    }

    wa-spinner {
      --indicator-color: currentColor;
      --track-color: color-mix(in oklab, currentColor, transparent 90%);

      position: absolute;
      font-size: 1em;
      height: 1em;
      width: 1em;
      top: calc(50% - 0.5em);
      left: calc(50% - 0.5em);
    }
  }

  /*
   * Badges
   */

  .button ::slotted(wa-badge) {
    border-color: var(--wa-color-surface-default);
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  :host(:dir(rtl)) ::slotted(wa-badge) {
    translate: -50% -50%;
  }

  /*
  * Button spacing
  */

  slot[name='start']::slotted(*) {
    margin-inline-end: 0.75em;
  }

  slot[name='end']::slotted(*),
  .button:not(.visually-hidden-label) [part='caret'] {
    margin-inline-start: 0.75em;
  }

  /*
   * Button group border radius modifications
   */

  /* Remove border radius from all grouped buttons by default */
  :host(.wa-button-group__button) .button {
    border-radius: 0;
  }

  /* Horizontal orientation */
  :host(.wa-button-group__horizontal.wa-button-group__button-first) .button {
    border-start-start-radius: var(--wa-form-control-border-radius);
    border-end-start-radius: var(--wa-form-control-border-radius);
  }

  :host(.wa-button-group__horizontal.wa-button-group__button-last) .button {
    border-start-end-radius: var(--wa-form-control-border-radius);
    border-end-end-radius: var(--wa-form-control-border-radius);
  }

  /* Vertical orientation */
  :host(.wa-button-group__vertical) {
    flex: 1 1 auto;
  }

  :host(.wa-button-group__vertical) .button {
    width: 100%;
    justify-content: start;
  }

  :host(.wa-button-group__vertical.wa-button-group__button-first) .button {
    border-start-start-radius: var(--wa-form-control-border-radius);
    border-start-end-radius: var(--wa-form-control-border-radius);
  }

  :host(.wa-button-group__vertical.wa-button-group__button-last) .button {
    border-end-start-radius: var(--wa-form-control-border-radius);
    border-end-end-radius: var(--wa-form-control-border-radius);
  }

  /* Handle pill modifier for button groups */
  :host([pill].wa-button-group__horizontal.wa-button-group__button-first) .button {
    border-start-start-radius: var(--wa-border-radius-pill);
    border-end-start-radius: var(--wa-border-radius-pill);
  }

  :host([pill].wa-button-group__horizontal.wa-button-group__button-last) .button {
    border-start-end-radius: var(--wa-border-radius-pill);
    border-end-end-radius: var(--wa-border-radius-pill);
  }

  :host([pill].wa-button-group__vertical.wa-button-group__button-first) .button {
    border-start-start-radius: var(--wa-border-radius-pill);
    border-start-end-radius: var(--wa-border-radius-pill);
  }

  :host([pill].wa-button-group__vertical.wa-button-group__button-last) .button {
    border-end-start-radius: var(--wa-border-radius-pill);
    border-end-end-radius: var(--wa-border-radius-pill);
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var HasSlotController = class {
  constructor(host, ...slotNames) {
    this.slotNames = [];
    this.handleSlotChange = (event) => {
      const slot = event.target;
      if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) {
        this.host.requestUpdate();
      }
    };
    (this.host = host).addController(this);
    this.slotNames = slotNames;
  }
  hasDefaultSlot() {
    return [...this.host.childNodes].some((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        return true;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        const tagName = el.tagName.toLowerCase();
        if (tagName === "wa-visually-hidden") {
          return false;
        }
        if (!el.hasAttribute("slot")) {
          return true;
        }
      }
      return false;
    });
  }
  hasNamedSlot(name) {
    return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
  }
  test(slotName) {
    return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
  }
  hostConnected() {
    this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
  }
};
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var size_styles_default = i$6`
  :host([size='small']),
  .wa-size-s {
    font-size: var(--wa-font-size-s);
  }

  :host([size='medium']),
  .wa-size-m {
    font-size: var(--wa-font-size-m);
  }

  :host([size='large']),
  .wa-size-l {
    font-size: var(--wa-font-size-l);
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var variants_styles_default = i$6`
  :where(:root),
  .wa-neutral,
  :host([variant='neutral']) {
    --wa-color-fill-loud: var(--wa-color-neutral-fill-loud);
    --wa-color-fill-normal: var(--wa-color-neutral-fill-normal);
    --wa-color-fill-quiet: var(--wa-color-neutral-fill-quiet);
    --wa-color-border-loud: var(--wa-color-neutral-border-loud);
    --wa-color-border-normal: var(--wa-color-neutral-border-normal);
    --wa-color-border-quiet: var(--wa-color-neutral-border-quiet);
    --wa-color-on-loud: var(--wa-color-neutral-on-loud);
    --wa-color-on-normal: var(--wa-color-neutral-on-normal);
    --wa-color-on-quiet: var(--wa-color-neutral-on-quiet);
  }

  .wa-brand,
  :host([variant='brand']) {
    --wa-color-fill-loud: var(--wa-color-brand-fill-loud);
    --wa-color-fill-normal: var(--wa-color-brand-fill-normal);
    --wa-color-fill-quiet: var(--wa-color-brand-fill-quiet);
    --wa-color-border-loud: var(--wa-color-brand-border-loud);
    --wa-color-border-normal: var(--wa-color-brand-border-normal);
    --wa-color-border-quiet: var(--wa-color-brand-border-quiet);
    --wa-color-on-loud: var(--wa-color-brand-on-loud);
    --wa-color-on-normal: var(--wa-color-brand-on-normal);
    --wa-color-on-quiet: var(--wa-color-brand-on-quiet);
  }

  .wa-success,
  :host([variant='success']) {
    --wa-color-fill-loud: var(--wa-color-success-fill-loud);
    --wa-color-fill-normal: var(--wa-color-success-fill-normal);
    --wa-color-fill-quiet: var(--wa-color-success-fill-quiet);
    --wa-color-border-loud: var(--wa-color-success-border-loud);
    --wa-color-border-normal: var(--wa-color-success-border-normal);
    --wa-color-border-quiet: var(--wa-color-success-border-quiet);
    --wa-color-on-loud: var(--wa-color-success-on-loud);
    --wa-color-on-normal: var(--wa-color-success-on-normal);
    --wa-color-on-quiet: var(--wa-color-success-on-quiet);
  }

  .wa-warning,
  :host([variant='warning']) {
    --wa-color-fill-loud: var(--wa-color-warning-fill-loud);
    --wa-color-fill-normal: var(--wa-color-warning-fill-normal);
    --wa-color-fill-quiet: var(--wa-color-warning-fill-quiet);
    --wa-color-border-loud: var(--wa-color-warning-border-loud);
    --wa-color-border-normal: var(--wa-color-warning-border-normal);
    --wa-color-border-quiet: var(--wa-color-warning-border-quiet);
    --wa-color-on-loud: var(--wa-color-warning-on-loud);
    --wa-color-on-normal: var(--wa-color-warning-on-normal);
    --wa-color-on-quiet: var(--wa-color-warning-on-quiet);
  }

  .wa-danger,
  :host([variant='danger']) {
    --wa-color-fill-loud: var(--wa-color-danger-fill-loud);
    --wa-color-fill-normal: var(--wa-color-danger-fill-normal);
    --wa-color-fill-quiet: var(--wa-color-danger-fill-quiet);
    --wa-color-border-loud: var(--wa-color-danger-border-loud);
    --wa-color-border-normal: var(--wa-color-danger-border-normal);
    --wa-color-border-quiet: var(--wa-color-danger-border-quiet);
    --wa-color-on-loud: var(--wa-color-danger-on-loud);
    --wa-color-on-normal: var(--wa-color-danger-on-normal);
    --wa-color-on-quiet: var(--wa-color-danger-on-quiet);
  }
`;
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o$1 = (o2) => o2 ?? E;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const a = Symbol.for(""), o = (t2) => {
  if (t2?.r === a) return t2?._$litStatic$;
}, i3 = (t2, ...r2) => ({ _$litStatic$: r2.reduce((r3, e2, a2) => r3 + ((t3) => {
  if (void 0 !== t3._$litStatic$) return t3._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t3}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(e2) + t2[a2 + 1], t2[0]), r: a }), l$1 = /* @__PURE__ */ new Map(), n2 = (t2) => (r2, ...e2) => {
  const a2 = e2.length;
  let s2, i4;
  const n3 = [], u2 = [];
  let c2, $2 = 0, f2 = false;
  for (; $2 < a2; ) {
    for (c2 = r2[$2]; $2 < a2 && void 0 !== (i4 = e2[$2], s2 = o(i4)); ) c2 += s2 + r2[++$2], f2 = true;
    $2 !== a2 && u2.push(i4), n3.push(c2), $2++;
  }
  if ($2 === a2 && n3.push(r2[a2]), f2) {
    const t3 = n3.join("$$lit$$");
    void 0 === (r2 = l$1.get(t3)) && (n3.raw = n3, l$1.set(t3, r2 = n3)), e2 = u2;
  }
  return t2(r2, ...e2);
}, u = n2(x);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaButton = class extends WebAwesomeFormAssociatedElement {
  constructor() {
    super(...arguments);
    this.assumeInteractionOn = ["click"];
    this.hasSlotController = new HasSlotController(this, "[default]", "start", "end");
    this.localize = new LocalizeController2(this);
    this.invalid = false;
    this.isIconButton = false;
    this.title = "";
    this.variant = "neutral";
    this.appearance = "accent";
    this.size = "medium";
    this.withCaret = false;
    this.disabled = false;
    this.loading = false;
    this.pill = false;
    this.type = "button";
  }
  static get validators() {
    return [...super.validators, MirrorValidator()];
  }
  constructLightDOMButton() {
    const button = document.createElement("button");
    for (const attribute of this.attributes) {
      if (attribute.name === "style") {
        continue;
      }
      button.setAttribute(attribute.name, attribute.value);
    }
    button.type = this.type;
    button.style.position = "absolute !important";
    button.style.width = "0 !important";
    button.style.height = "0 !important";
    button.style.clipPath = "inset(50%) !important";
    button.style.overflow = "hidden !important";
    button.style.whiteSpace = "nowrap !important";
    if (this.name) {
      button.name = this.name;
    }
    button.value = this.value || "";
    return button;
  }
  handleClick() {
    const form = this.getForm();
    if (!form) return;
    const lightDOMButton = this.constructLightDOMButton();
    this.parentElement?.append(lightDOMButton);
    lightDOMButton.click();
    lightDOMButton.remove();
  }
  handleInvalid() {
    this.dispatchEvent(new WaInvalidEvent());
  }
  handleLabelSlotChange() {
    const nodes = this.labelSlot.assignedNodes({ flatten: true });
    let hasIconLabel = false;
    let hasIcon = false;
    let hasText = false;
    let hasOtherElements = false;
    [...nodes].forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;
        if (element.localName === "wa-icon") {
          hasIcon = true;
          if (!hasIconLabel) hasIconLabel = element.label !== void 0;
        } else {
          hasOtherElements = true;
        }
      } else if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent?.trim() || "";
        if (text.length > 0) {
          hasText = true;
        }
      }
    });
    this.isIconButton = hasIcon && !hasText && !hasOtherElements;
    if (this.isIconButton && !hasIconLabel) {
      console.warn(
        'Icon buttons must have a label for screen readers. Add <wa-icon label="..."> to remove this warning.',
        this
      );
    }
  }
  isButton() {
    return this.href ? false : true;
  }
  isLink() {
    return this.href ? true : false;
  }
  handleDisabledChange() {
    this.updateValidity();
  }
  // eslint-disable-next-line
  setValue(..._args) {
  }
  /** Simulates a click on the button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the button. */
  focus(options) {
    this.button.focus(options);
  }
  /** Removes focus from the button. */
  blur() {
    this.button.blur();
  }
  render() {
    const isLink = this.isLink();
    const tag = isLink ? i3`a` : i3`button`;
    return u`
      <${tag}
        part="base"
        class=${e$3({
      button: true,
      caret: this.withCaret,
      disabled: this.disabled,
      loading: this.loading,
      rtl: this.localize.dir() === "rtl",
      "has-label": this.hasSlotController.test("[default]"),
      "has-start": this.hasSlotController.test("start"),
      "has-end": this.hasSlotController.test("end"),
      "is-icon-button": this.isIconButton
    })}
        ?disabled=${o$1(isLink ? void 0 : this.disabled)}
        type=${o$1(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${o$1(isLink ? void 0 : this.name)}
        value=${o$1(isLink ? void 0 : this.value)}
        href=${o$1(isLink ? this.href : void 0)}
        target=${o$1(isLink ? this.target : void 0)}
        download=${o$1(isLink ? this.download : void 0)}
        rel=${o$1(isLink && this.rel ? this.rel : void 0)}
        role=${o$1(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="start" part="start" class="start"></slot>
        <slot part="label" class="label" @slotchange=${this.handleLabelSlotChange}></slot>
        <slot name="end" part="end" class="end"></slot>
        ${this.withCaret ? u`
                <wa-icon part="caret" class="caret" library="system" name="chevron-down" variant="solid"></wa-icon>
              ` : ""}
        ${this.loading ? u`<wa-spinner part="spinner"></wa-spinner>` : ""}
      </${tag}>
    `;
  }
};
WaButton.shadowRootOptions = { ...WebAwesomeFormAssociatedElement.shadowRootOptions, delegatesFocus: true };
WaButton.css = [button_styles_default, variants_styles_default, size_styles_default];
__decorateClass([
  e$5(".button")
], WaButton.prototype, "button", 2);
__decorateClass([
  e$5("slot:not([name])")
], WaButton.prototype, "labelSlot", 2);
__decorateClass([
  r$1()
], WaButton.prototype, "invalid", 2);
__decorateClass([
  r$1()
], WaButton.prototype, "isIconButton", 2);
__decorateClass([
  n$1()
], WaButton.prototype, "title", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "variant", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "appearance", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "size", 2);
__decorateClass([
  n$1({ attribute: "with-caret", type: Boolean, reflect: true })
], WaButton.prototype, "withCaret", 2);
__decorateClass([
  n$1({ type: Boolean })
], WaButton.prototype, "disabled", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaButton.prototype, "loading", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaButton.prototype, "pill", 2);
__decorateClass([
  n$1()
], WaButton.prototype, "type", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "name", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "value", 2);
__decorateClass([
  n$1({ reflect: true })
], WaButton.prototype, "href", 2);
__decorateClass([
  n$1()
], WaButton.prototype, "target", 2);
__decorateClass([
  n$1()
], WaButton.prototype, "rel", 2);
__decorateClass([
  n$1()
], WaButton.prototype, "download", 2);
__decorateClass([
  n$1({ attribute: "formaction" })
], WaButton.prototype, "formAction", 2);
__decorateClass([
  n$1({ attribute: "formenctype" })
], WaButton.prototype, "formEnctype", 2);
__decorateClass([
  n$1({ attribute: "formmethod" })
], WaButton.prototype, "formMethod", 2);
__decorateClass([
  n$1({ attribute: "formnovalidate", type: Boolean })
], WaButton.prototype, "formNoValidate", 2);
__decorateClass([
  n$1({ attribute: "formtarget" })
], WaButton.prototype, "formTarget", 2);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], WaButton.prototype, "handleDisabledChange", 1);
WaButton = __decorateClass([
  t$1("wa-button")
], WaButton);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var spinner_styles_default = i$6`
  :host {
    --track-width: 2px;
    --track-color: var(--wa-color-neutral-fill-normal);
    --indicator-color: var(--wa-color-brand-fill-loud);
    --speed: 2s;

    /*
      Resizing a spinner element using anything but font-size will break the animation because the animation uses em
      units. Therefore, if a spinner is used in a flex container without \`flex: none\` applied, the spinner can
      grow/shrink and break the animation. The use of \`flex: none\` on the host element prevents this by always having
      the spinner sized according to its actual dimensions.
    */
    flex: none;
    display: inline-flex;
    width: 1em;
    height: 1em;
  }

  svg {
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    animation: spin var(--speed) linear infinite;
  }

  .track {
    stroke: var(--track-color);
  }

  .indicator {
    stroke: var(--indicator-color);
    stroke-dasharray: 75, 100;
    stroke-dashoffset: -5;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaSpinner = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController2(this);
  }
  render() {
    return x`
      <svg
        part="base"
        role="progressbar"
        aria-label=${this.localize.term("loading")}
        fill="none"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="track" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
        <circle class="indicator" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
      </svg>
    `;
  }
};
WaSpinner.css = spinner_styles_default;
WaSpinner = __decorateClass([
  t$1("wa-spinner")
], WaSpinner);
var __create$e = Object.create;
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __knownSymbol$e = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$e = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$e = (target, value) => __defProp$e(target, "name", { value, configurable: true });
var __decoratorStart$e = (base) => [, , , __create$e(base?.[__knownSymbol$e("metadata")] ?? null)];
var __decoratorStrings$e = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$e = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$e("Function expected") : fn;
var __decoratorContext$e = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$e[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$e("Already initialized") : fns.push(__expectFn$e(fn || null)) });
var __decoratorMetadata$e = (array, target) => __defNormalProp$e(target, __knownSymbol$e("metadata"), array[3]);
var __runInitializers$e = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$e = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$e[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$e(k2 < 4 ? target : { get [name]() {
    return __privateGet$d(this, extra);
  }, set [name](x2) {
    return __privateSet$d(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$e(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$e(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$e(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$d(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$d : __privateMethod$d)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$d(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$e(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$e("Object expected");
    else __expectFn$e(fn = it.get) && (desc.get = fn), __expectFn$e(fn = it.set) && (desc.set = fn), __expectFn$e(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$e(array, target), desc && __defProp$e(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$d = (obj, member, msg) => member.has(obj) || __typeError$e("Cannot " + msg);
var __privateIn$d = (member, obj) => Object(obj) !== obj ? __typeError$e('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$d = (obj, member, getter) => (__accessCheck$d(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$d = (obj, member, value) => member.has(obj) ? __typeError$e("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$d = (obj, member, value, setter) => (__accessCheck$d(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$d = (obj, member, method) => (__accessCheck$d(obj, member, "access private method"), method);
var _modalNode_dec, _overlayNode_dec, _resultsNode_dec$1, _inputNode_dec$1, _isEmpty_dec, _suggestions_dec, _resultsCount_dec$1, _searchTerm_dec$2, _searchResults_dec$1, _visible_dec$4, _a$e, _BriffaSearchDesktopFactory_decorators, _init$e, _visible$4, _searchResults$1, _searchTerm$2, _resultsCount$1, _suggestions, _isEmpty, _inputNode$1, _resultsNode$1, _overlayNode, _modalNode;
_BriffaSearchDesktopFactory_decorators = [t$1("briffa-search-desktop-factory")];
class BriffaSearchDesktopFactory extends (_a$e = BaseDesignSystemComponent(
  searchDesktopFactoryStyles
), _visible_dec$4 = [r$1()], _searchResults_dec$1 = [r$1()], _searchTerm_dec$2 = [r$1()], _resultsCount_dec$1 = [r$1()], _suggestions_dec = [r$1()], _isEmpty_dec = [r$1()], _inputNode_dec$1 = [e$5(".briffa-search-input")], _resultsNode_dec$1 = [e$5(".results-container")], _overlayNode_dec = [e$5(".briffa-search-overlay")], _modalNode_dec = [e$5(".modal")], _a$e) {
  constructor() {
    super();
    __privateAdd$d(this, _visible$4, __runInitializers$e(_init$e, 8, this, false)), __runInitializers$e(_init$e, 11, this);
    __privateAdd$d(this, _searchResults$1, __runInitializers$e(_init$e, 12, this)), __runInitializers$e(_init$e, 15, this);
    __privateAdd$d(this, _searchTerm$2, __runInitializers$e(_init$e, 16, this, "")), __runInitializers$e(_init$e, 19, this);
    __privateAdd$d(this, _resultsCount$1, __runInitializers$e(_init$e, 20, this, 0)), __runInitializers$e(_init$e, 23, this);
    __privateAdd$d(this, _suggestions, __runInitializers$e(_init$e, 24, this, [])), __runInitializers$e(_init$e, 27, this);
    __privateAdd$d(this, _isEmpty, __runInitializers$e(_init$e, 28, this, true)), __runInitializers$e(_init$e, 31, this);
    __privateAdd$d(this, _inputNode$1, __runInitializers$e(_init$e, 32, this)), __runInitializers$e(_init$e, 35, this);
    __privateAdd$d(this, _resultsNode$1, __runInitializers$e(_init$e, 36, this)), __runInitializers$e(_init$e, 39, this);
    __privateAdd$d(this, _overlayNode, __runInitializers$e(_init$e, 40, this)), __runInitializers$e(_init$e, 43, this);
    __privateAdd$d(this, _modalNode, __runInitializers$e(_init$e, 44, this)), __runInitializers$e(_init$e, 47, this);
    this.handleKeydown = (event) => {
      if (event.key === "Escape") {
        this.hideElement();
      }
    };
    this.handleInput = (event) => {
      const target = event.target;
      const text = target.value;
      briffaGenericSearchFactory.debouncedSearchTermChanged(text);
    };
    this.handleInputKeydown = (event) => {
      if (event.key === "Enter") {
        this.searchPage();
      }
    };
    this.searchPage = () => {
      const inputValue = this.inputNode.value;
      searchPage(inputValue);
    };
    this.handleOverlayClick = () => {
      this.hideElement();
    };
    this.getViewResultsSection = (count) => {
      const btn = document.createElement("wa-button");
      btn.size = "medium";
      btn.variant = "brand";
      btn.classList.add("cursor-pointer");
      btn.addEventListener("click", this.searchPage);
      btn.innerHTML = `View results (${count})`;
      return btn;
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.initializeSubscription();
    this.setupKeyboardListeners();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeKeyboardListeners();
  }
  setupKeyboardListeners() {
    document.addEventListener("keydown", this.handleKeydown.bind(this));
  }
  removeKeyboardListeners() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this));
  }
  updateInputText(searchTerm) {
    this.searchTerm = searchTerm;
    if (this.inputNode) {
      this.inputNode.value = searchTerm;
    }
  }
  initializeSubscription() {
    const callback = this.showResults.bind(this);
    briffaGenericSearchFactory.subscribeToSearchObjectChanged(
      callback,
      true
    );
    const inputElCallback = this.updateInputText.bind(this);
    briffaGenericSearchFactory.subscribeToSearchTermChanged(
      inputElCallback,
      false
    );
  }
  // Function to prevent scroll propagation
  preventScroll(event) {
    event.preventDefault();
    event.stopPropagation();
  }
  disableBackgroundScroll(element) {
    element.addEventListener("wheel", this.preventScroll);
    element.addEventListener("touchmove", this.preventScroll);
    element.addEventListener("scroll", this.preventScroll);
  }
  showResults(res) {
    this.searchResults = res;
    this.searchTerm = res.query || "";
    this.resultsCount = res.results?.length || 0;
    this.suggestions = res.suggestedCollectionTitles || [];
    this.isEmpty = !briffaGenericSearchFactory.isLoadingResults && !res.query && (!res.results || res.results.length === 0);
    this.requestUpdate();
  }
  showElement() {
    this.visible = true;
    this.updateComplete.then(() => {
      if (this.overlayNode) {
        this.disableBackgroundScroll(this.overlayNode);
      }
    });
  }
  hideElement() {
    this.visible = false;
    this.enableBackgroundScroll();
  }
  enableBackgroundScroll() {
    if (this.overlayNode) {
      this.overlayNode.removeEventListener("wheel", this.preventScroll);
      this.overlayNode.removeEventListener(
        "touchmove",
        this.preventScroll
      );
      this.overlayNode.removeEventListener("scroll", this.preventScroll);
    }
  }
  render() {
    if (!this.visible) {
      return x``;
    }
    return x`
            <div class="search-container">
                <div
                    class="briffa-search-overlay"
                    @click=${this.handleOverlayClick}
                >
                    <div class="close-icon" @click=${this.handleOverlayClick}>
                        ${this.renderCloseIcon()}
                    </div>
                </div>
                <div class="modal">
                    <div class="input-container">
                        <input
                            class="briffa-search-input"
                            placeholder="Search products"
                            @input=${this.handleInput}
                            @keydown=${this.handleInputKeydown}
                        />
                    </div>
                    ${this.searchResults.results?.length ? x`<div class="flex justify-end mr-4.5">
                              ${this.getViewResultsSection(
      this.searchResults.actualResultsCount
    )}
                          </div>` : null}
                    ${this.renderResultsCount()}
                    <div class="results-container">${this.renderResults()}</div>
                </div>
            </div>
        `;
  }
  renderCloseIcon() {
    const iconElement = BriffaIcons.getXMarkIcon({
      color: "#FFFFFF",
      width: "40px",
      height: "40px"
    });
    return iconElement;
  }
  renderResultsCount() {
    if (!this.resultsCount || this.isEmpty && !this.searchTerm) {
      return x``;
    }
    return x`
            <div class="description-container">
                <div class="results-count">
                    Showing ${this.resultsCount} results out of
                    ${briffaGenericSearchFactory.latestResponse.actualResultsCount}
                </div>
                ${this.renderSuggestions()}
            </div>
        `;
  }
  renderSuggestions() {
    if (!this.suggestions || this.suggestions.length === 0) {
      return x``;
    }
    return x`
            <div class="suggestions-container">
                <p class="suggestions-title">Suggestions</p>
                <div class="suggestions-pills">
                    ${this.suggestions.slice(0, 5).map(
      (suggestion) => x`
                            <a
                                href="/search?q=${suggestion}"
                                class="suggestion-link"
                            >
                                <p class="suggestion-text">${suggestion}</p>
                            </a>
                        `
    )}
                </div>
            </div>
        `;
  }
  renderResults() {
    if (!this.searchResults) {
      return x``;
    }
    const { isLoadingResults } = briffaGenericSearchFactory;
    const {
      results: products,
      suggestedCollectionTitles,
      trendingSearchTitles,
      query: query2
    } = this.searchResults;
    if (!isLoadingResults && (!query2 || query2 === "")) {
      return x`
                <div class="empty-state-sections">
                    ${this.renderSection(
        () => getTrendingSection(trendingSearchTitles)
      )}
                    ${this.renderSection(() => getRecentSearchesSection())}
                </div>
            `;
    } else {
      if (products?.length > 0) {
        return x`
                    <div class="search-results-sections">
                        ${this.isEmpty ? this.renderSection(
          () => getSuggestionsSection(
            query2,
            suggestedCollectionTitles
          )
        ) : ""}
                        ${this.renderProductsSection(products)}
                    </div>
                `;
      }
    }
    return x``;
  }
  renderSection(sectionFactory) {
    return sectionFactory();
  }
  renderProductsSection(products) {
    return x`
            <div
                class="products-section p-2 pt-4 pb-0 overflow-auto grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-x-4"
            >
                ${products.map((product, index2) => {
      const card = createProductCard(product, index2);
      card.classList.add(
        "mb-4",
        "transition-width",
        "duration-200",
        "ease-in-out"
      );
      return card;
    })}
            </div>
        `;
  }
}
_init$e = __decoratorStart$e(_a$e);
_visible$4 = /* @__PURE__ */ new WeakMap();
_searchResults$1 = /* @__PURE__ */ new WeakMap();
_searchTerm$2 = /* @__PURE__ */ new WeakMap();
_resultsCount$1 = /* @__PURE__ */ new WeakMap();
_suggestions = /* @__PURE__ */ new WeakMap();
_isEmpty = /* @__PURE__ */ new WeakMap();
_inputNode$1 = /* @__PURE__ */ new WeakMap();
_resultsNode$1 = /* @__PURE__ */ new WeakMap();
_overlayNode = /* @__PURE__ */ new WeakMap();
_modalNode = /* @__PURE__ */ new WeakMap();
__decorateElement$e(_init$e, 4, "visible", _visible_dec$4, BriffaSearchDesktopFactory, _visible$4);
__decorateElement$e(_init$e, 4, "searchResults", _searchResults_dec$1, BriffaSearchDesktopFactory, _searchResults$1);
__decorateElement$e(_init$e, 4, "searchTerm", _searchTerm_dec$2, BriffaSearchDesktopFactory, _searchTerm$2);
__decorateElement$e(_init$e, 4, "resultsCount", _resultsCount_dec$1, BriffaSearchDesktopFactory, _resultsCount$1);
__decorateElement$e(_init$e, 4, "suggestions", _suggestions_dec, BriffaSearchDesktopFactory, _suggestions);
__decorateElement$e(_init$e, 4, "isEmpty", _isEmpty_dec, BriffaSearchDesktopFactory, _isEmpty);
__decorateElement$e(_init$e, 4, "inputNode", _inputNode_dec$1, BriffaSearchDesktopFactory, _inputNode$1);
__decorateElement$e(_init$e, 4, "resultsNode", _resultsNode_dec$1, BriffaSearchDesktopFactory, _resultsNode$1);
__decorateElement$e(_init$e, 4, "overlayNode", _overlayNode_dec, BriffaSearchDesktopFactory, _overlayNode);
__decorateElement$e(_init$e, 4, "modalNode", _modalNode_dec, BriffaSearchDesktopFactory, _modalNode);
BriffaSearchDesktopFactory = __decorateElement$e(_init$e, 0, "BriffaSearchDesktopFactory", _BriffaSearchDesktopFactory_decorators, BriffaSearchDesktopFactory);
__runInitializers$e(_init$e, 1, BriffaSearchDesktopFactory);
const SORTED_SIZES = [
  // Price segments
  "0-25",
  "25-50",
  "50-100",
  "100-150",
  "200-250",
  "250-300",
  "300-400",
  "400-500",
  "500-600",
  "600-700",
  "700-800",
  "800-900",
  "900-1000",
  "1000-1100",
  "1100-1200",
  "1200-1300",
  "1300-1400",
  "1400-1500",
  "1500-1600",
  "1600-1700",
  "1700-1800",
  "1800-1900",
  "1900-2000",
  // Size values
  "xxs",
  "xxs | 5 years",
  "xs",
  "xs | 6 years",
  "xs | s",
  "xs/s",
  "34 | xs",
  "46 | xs",
  "94 | xs",
  "us 2 | xs",
  "s",
  "s | 7-8 years",
  "s | m",
  "s/m",
  "s|m",
  "18 | s",
  "24 | s",
  "36 | s",
  "38 | s+",
  "48 | s",
  "98 | s",
  "us 6 | s",
  "m",
  "m | 10-12 years",
  "m | l",
  "25 | m",
  "20 | m",
  "102 | m",
  "50 | m",
  "us 10 | m",
  "us 6 | uk 10",
  "l",
  "l | 14-16 years",
  "l | xl",
  "l/xl",
  "l|xl",
  "106 | l",
  "21 | l",
  "42 | l",
  "44 | l+",
  "us 14 | l",
  "us 14 | uk 18",
  "xl",
  "23 | xl",
  "27 | xl",
  "28 | xl+",
  "29 | xxl",
  "54 | xl",
  "56 | xl+",
  "58 | xxl",
  "46 | xl",
  "xl | 18 years",
  "xxl",
  "3xl",
  "4xl",
  "0-3 months",
  "2 years",
  "us 2 | uk 6",
  "3-6 months",
  "4 years",
  "us 4 | uk 8",
  "6 years",
  "6-12 months",
  "8 years",
  "us 8 | uk 12",
  "10 years",
  "us 10 | uk 14",
  "12 years",
  "12-18 months",
  "us 12 | uk 16",
  "14 years",
  "16 years",
  "18-24 months",
  "19 | s+",
  "22 | l+",
  "26",
  "26 | l",
  "27",
  "28",
  "29",
  "29.5",
  "30",
  "31",
  "32",
  "33",
  "33.5",
  "34",
  "34.5",
  "35",
  "35 ½",
  "35.5",
  "36",
  "36 - 38",
  "36 ⅓",
  "36 ⅔",
  "36.5",
  "37",
  "37 ½",
  "37.5",
  "38",
  "38 ⅔",
  "38.5",
  "39",
  "39 - 41",
  "39 ⅓",
  "39.5",
  "40",
  "40 | m",
  "40 ½",
  "40 ⅔",
  "40.5",
  "40.5 - 42.5",
  "41",
  "41 ⅓",
  "41.5",
  "42",
  "42.5",
  "43",
  "43 ⅓",
  "43.5",
  "44",
  "44 ½",
  "44.5",
  "45",
  "45.5",
  "45.5 - 48",
  "46",
  "46.5",
  "47",
  "47.5",
  "48",
  "48 ⅓",
  "49",
  "50",
  "52 | l",
  "92 | 1-2 years",
  "104 | 2-4 years",
  "116 | 4-6 years",
  "128 | 6-8 years",
  "140 | 8-10 years",
  "152 | 10-12 years",
  "164 | 12-14 years",
  "176 | 14+ years",
  "large",
  "one size",
  "regular",
  "short",
  // Stock filters
  "out-of-stock-filter"
];
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var tag_styles_default = i$6`
  @layer wa-component {
    :host {
      display: inline-flex;
      gap: 0.5em;
      border-radius: var(--wa-border-radius-m);
      align-items: center;
      background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));
      border-color: var(--wa-color-border-normal, var(--wa-color-neutral-border-normal));
      border-style: var(--wa-border-style);
      border-width: var(--wa-border-width-s);
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      font-size: inherit;
      line-height: 1;
      white-space: nowrap;
      user-select: none;
      -webkit-user-select: none;
      height: calc(var(--wa-form-control-height) * 0.8);
      line-height: calc(var(--wa-form-control-height) - var(--wa-form-control-border-width) * 2);
      padding: 0 0.75em;
    }

    /* Appearance modifiers */
    :host([appearance='outlined']) {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: transparent;
      border-color: var(--wa-color-border-loud, var(--wa-color-neutral-border-loud));
    }

    :host([appearance='filled']) {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));
      border-color: transparent;
    }

    :host([appearance='filled-outlined']) {
      color: var(--wa-color-on-quiet, var(--wa-color-neutral-on-quiet));
      background-color: var(--wa-color-fill-quiet, var(--wa-color-neutral-fill-quiet));
      border-color: var(--wa-color-border-normal, var(--wa-color-neutral-border-normal));
    }

    :host([appearance='accent']) {
      color: var(--wa-color-on-loud, var(--wa-color-neutral-on-loud));
      background-color: var(--wa-color-fill-loud, var(--wa-color-neutral-fill-loud));
      border-color: transparent;
    }
  }

  .content {
    font-size: var(--wa-font-size-smaller);
  }

  [part='remove-button'] {
    color: inherit;
    line-height: 1;
  }

  [part='remove-button']::part(base) {
    padding: 0;
    height: 1em;
    width: 1em;
  }

  @media (hover: hover) {
    :host(:hover) > [part='remove-button']::part(base) {
      color: color-mix(in oklab, currentColor, var(--wa-color-mix-hover));
    }
  }

  :host(:active) > [part='remove-button']::part(base) {
    color: color-mix(in oklab, currentColor, var(--wa-color-mix-active));
  }

  /*
   * Pill modifier
   */
  :host([pill]) {
    border-radius: var(--wa-border-radius-pill);
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaRemoveEvent = class extends Event {
  constructor() {
    super("wa-remove", { bubbles: true, cancelable: false, composed: true });
  }
};
var WaTag = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController2(this);
    this.variant = "neutral";
    this.appearance = "filled-outlined";
    this.size = "medium";
    this.pill = false;
    this.withRemove = false;
  }
  handleRemoveClick() {
    this.dispatchEvent(new WaRemoveEvent());
  }
  render() {
    return x`
      <slot part="content" class="content"></slot>

      ${this.withRemove ? x`
            <wa-button
              part="remove-button"
              exportparts="base:remove-button__base"
              class="remove"
              appearance="plain"
              @click=${this.handleRemoveClick}
              tabindex="-1"
            >
              <wa-icon name="xmark" library="system" variant="solid" label=${this.localize.term("remove")}></wa-icon>
            </wa-button>
          ` : ""}
    `;
  }
};
WaTag.css = [tag_styles_default, variants_styles_default, size_styles_default];
__decorateClass([
  n$1({ reflect: true })
], WaTag.prototype, "variant", 2);
__decorateClass([
  n$1({ reflect: true })
], WaTag.prototype, "appearance", 2);
__decorateClass([
  n$1({ reflect: true })
], WaTag.prototype, "size", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaTag.prototype, "pill", 2);
__decorateClass([
  n$1({ attribute: "with-remove", type: Boolean })
], WaTag.prototype, "withRemove", 2);
WaTag = __decorateClass([
  t$1("wa-tag")
], WaTag);
var __create$d = Object.create;
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __knownSymbol$d = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$d = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$d = (target, value) => __defProp$d(target, "name", { value, configurable: true });
var __decoratorStart$d = (base) => [, , , __create$d(base?.[__knownSymbol$d("metadata")] ?? null)];
var __decoratorStrings$d = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$d = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$d("Function expected") : fn;
var __decoratorContext$d = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$d[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$d("Already initialized") : fns.push(__expectFn$d(fn || null)) });
var __decoratorMetadata$d = (array, target) => __defNormalProp$d(target, __knownSymbol$d("metadata"), array[3]);
var __runInitializers$d = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$d = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$d[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$d(k2 < 4 ? target : { get [name]() {
    return __privateGet$c(this, extra);
  }, set [name](x2) {
    return __privateSet$c(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$d(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$d(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$d(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$c(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$c : __privateMethod$c)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$c(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$d(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$d("Object expected");
    else __expectFn$d(fn = it.get) && (desc.get = fn), __expectFn$d(fn = it.set) && (desc.set = fn), __expectFn$d(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$d(array, target), desc && __defProp$d(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$c = (obj, member, msg) => member.has(obj) || __typeError$d("Cannot " + msg);
var __privateIn$c = (member, obj) => Object(obj) !== obj ? __typeError$d('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$c = (obj, member, getter) => (__accessCheck$c(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$c = (obj, member, value) => member.has(obj) ? __typeError$d("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$c = (obj, member, value, setter) => (__accessCheck$c(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$c = (obj, member, method) => (__accessCheck$c(obj, member, "access private method"), method);
var _contentEl_dec, _visible_dec$3, _classNames_dec$1, _titleText_dec, _a$d, _SelectedFilters_decorators, _init$d, _titleText, _classNames$1, _visible$3, _contentEl;
const HEADING_LARGE_STYLE = `color: ${tokens.color.gray[700]}; font-size: ${typography.fontSize.lg};`;
_SelectedFilters_decorators = [t$1("selected-filters")];
class SelectedFilters extends (_a$d = BaseDesignSystemComponent(""), _titleText_dec = [n$1()], _classNames_dec$1 = [n$1()], _visible_dec$3 = [r$1()], _contentEl_dec = [e$5("#contentEl")], _a$d) {
  constructor() {
    super(...arguments);
    this.selectedFiltersSelector = new MemoizedSelector(
      this,
      getSelectedFilterTags
    );
    this.availableFilterTagsSelector = new MemoizedSelector(
      this,
      getAvailableFilterTags
    );
    this.titleClassNames = ["underline", "decoration-black", "mb-2"].join(
      " "
    );
    this.titleStyle = HEADING_LARGE_STYLE;
    this.pillsContainerClassNames = [
      "flex",
      "flex-wrap",
      "mr-[24px]",
      "gap-x-3",
      "gap-y-2"
    ].join(" ");
    __privateAdd$c(this, _titleText, __runInitializers$d(_init$d, 8, this, "Selected Filters")), __runInitializers$d(_init$d, 11, this);
    __privateAdd$c(this, _classNames$1, __runInitializers$d(_init$d, 12, this, [])), __runInitializers$d(_init$d, 15, this);
    __privateAdd$c(this, _visible$3, __runInitializers$d(_init$d, 16, this, false)), __runInitializers$d(_init$d, 19, this);
    __privateAdd$c(this, _contentEl, __runInitializers$d(_init$d, 20, this)), __runInitializers$d(_init$d, 23, this);
  }
  /**
   * Format display text based on filter type
   * @param type - The filter type
   * @param value - The filter value
   * @returns Formatted display text for the pill
   */
  formatDisplayText(type, value) {
    switch (type) {
      case "brand":
        return `Brand: ${value}`;
      case "size":
        return `Size: ${value}`;
      case "gender":
        return `Gender: ${value}`;
      case "category":
        return `Category: ${value}`;
      case "price":
        return `Price: ${value}`;
      case "availability":
        return value;
      default:
        return value || `${type}:${value}`;
    }
  }
  getFilterPillsData() {
    const selectedTags = this.selectedFiltersSelector.value;
    const availableFilterTags = this.availableFilterTagsSelector.value;
    const pillsData = [];
    for (const [filterType, tagValues] of Object.entries(selectedTags)) {
      if (!tagValues || tagValues.length === 0) continue;
      for (const tagValue of tagValues) {
        const filterDetails = availableFilterTags[filterType]?.[tagValue];
        const displayValue = filterDetails?.displayValue;
        const [type] = tagValue.split(":");
        const text = displayValue ? this.formatDisplayText(type, displayValue) : "";
        pillsData.push({
          text,
          filterType,
          tagValue
        });
      }
    }
    return pillsData;
  }
  handlePillRemove(filterType, tagValue) {
    store.dispatch(
      toggleFilterTag({
        filterType,
        tagValue,
        selected: false
      })
    );
  }
  /**
   * Create DOM elements for filter pills using Web Awesome wa-tag component.
   * Replicates the createSelectedFilterPills logic from PaginationFiltersController.
   */
  createPillElements(pillsData) {
    return pillsData.map((pillData) => {
      const { text, filterType, tagValue } = pillData;
      const tag = document.createElement("wa-tag");
      tag.setAttribute("size", "medium");
      tag.setAttribute("with-remove", "");
      tag.textContent = text;
      tag.style.setProperty("--wa-spacing-x-small", "0.5rem");
      tag.style.setProperty("padding", "0.25rem 0.5rem");
      tag.addEventListener("wa-remove", () => {
        this.handlePillRemove(filterType, tagValue);
      });
      tag.style.setProperty(
        "order",
        `${SORTED_SIZES.indexOf(tagValue)}`
      );
      return tag;
    });
  }
  render() {
    const availableFilterTags = this.availableFilterTagsSelector.value;
    const hasAvailableTags = Object.keys(availableFilterTags).length > 0;
    const pillsData = this.getFilterPillsData();
    this.visible = hasAvailableTags && pillsData.length > 0;
    return x`<div
            class="${this.classNames.join(" ")}"
            style="display: ${this.visible ? "block" : "none"} ;"
        >
            <p class="${this.titleClassNames}" style="${this.titleStyle}">
                ${this.titleText}
            </p>
            <div id="contentEl" class="${this.pillsContainerClassNames}"></div>
        </div>`;
  }
  updated() {
    if (this.contentEl) {
      const pillsData = this.getFilterPillsData();
      const pillElements = this.createPillElements(pillsData);
      this.contentEl.innerHTML = "";
      pillElements.forEach((pill) => {
        this.contentEl.appendChild(pill);
      });
    }
  }
}
_init$d = __decoratorStart$d(_a$d);
_titleText = /* @__PURE__ */ new WeakMap();
_classNames$1 = /* @__PURE__ */ new WeakMap();
_visible$3 = /* @__PURE__ */ new WeakMap();
_contentEl = /* @__PURE__ */ new WeakMap();
__decorateElement$d(_init$d, 4, "titleText", _titleText_dec, SelectedFilters, _titleText);
__decorateElement$d(_init$d, 4, "classNames", _classNames_dec$1, SelectedFilters, _classNames$1);
__decorateElement$d(_init$d, 4, "visible", _visible_dec$3, SelectedFilters, _visible$3);
__decorateElement$d(_init$d, 4, "contentEl", _contentEl_dec, SelectedFilters, _contentEl);
SelectedFilters = __decorateElement$d(_init$d, 0, "SelectedFilters", _SelectedFilters_decorators, SelectedFilters);
__runInitializers$d(_init$d, 1, SelectedFilters);
const searchMobileFactoryStyles = safeCss(`
    :host {
        display: contents;
    }

    /* Container - Full screen overlay */
    .search-container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 1999999999;
        display: flex;
        flex-direction: column;
    }

    .search-container.hidden {
        display: none;
    }

    /* Modal - Full screen white background */
    .briffa-search-modal {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: #fff;
        padding-top: ${spacing["gutter-base"]};
        display: flex;
        flex-direction: column;
    }

    /* Header section */
    .briffa-search-header {
        position: relative;
        display: flex;
        gap: ${spacing["gutter-sm"]};
        padding: 0 ${spacing["gutter-base"]};
        padding-bottom: ${spacing["gutter-sm"]};
        flex-wrap: wrap;
    }

    /* Back button */
    .back-button {
        display: flex;
        align-self: center;
        cursor: pointer;
    }

    /* Search bar container */
    .search-bar {
        position: relative;
        flex-grow: 1;
        display: flex;
        gap: ${spacing["gutter-sm"]};
        overflow: hidden;
        margin-right: ${spacing["gutter-base"]};
        padding: ${spacing["gutter-xs"]} ${spacing["gutter-sm"]};
        padding-top: ${spacing["gutter-md"]};
        padding-bottom: ${spacing["gutter-md"]};
        align-items: center;
        border-radius: 2px;
        background-color: #f3f4f6;
        border: 1px solid transparent;
        transition: border-color 0.2s ease;
    }

    .search-bar.focused {
        border-color: #6b7280;
    }

    /* Search icon */
    .search-icon {
        display: flex;
        align-items: center;
    }

    /* Search input */
    .briffa-search-input {
        flex-grow: 1;
        border: none;
        background: transparent;
        color: #000;
        font-size: 1rem;
        outline: none;
    }

    .briffa-search-input::placeholder {
        color: #9ca3af;
    }

    /* Clear search button */
    .clear-search {
        position: absolute;
        right: ${spacing["gutter-base"]};
        cursor: pointer;
        display: none;
    }

    .clear-search.visible {
        display: block;
    }

    /* Animated search bar wrapper */
    .animated-search-bar-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
    }

    /* View results section */
    .view-results-section {
        display: none;
        justify-content: flex-end;
        margin-right: ${spacing["gutter-base"]};
        padding-bottom: ${spacing["gutter-sm"]};
        flex-grow: 1;
    }

    .view-results-section.visible {
        display: flex;
    }

    /* Header box shadow */
    .header-shadow {
        position: absolute;
        bottom: -10px;
        width: 100%;
        height: 10px;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), transparent);
        z-index: 1;
    }

    /* Body container */
    .briffa-search-mobile-body {
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
        overscroll-behavior: contain;
        flex: 1;
    }
`);
class BriffaSearchFactory {
  constructor() {
    this.searchIcons = null;
    this.addedToHtml = false;
    this.addedToHtml = false;
    this.searchObject = this.isMobile() ? document.createElement("briffa-search-mobile-factory") : document.createElement("briffa-search-desktop-factory");
    this.node = this.searchObject;
    this.appendToHtml(this.node);
    this.setupSearchIcon();
  }
  getSearchIcons() {
    return document.documentElement.getElementsByClassName(
      "show-search-link"
    );
  }
  async setupSearchIcon() {
    const icons2 = Array.from(this.getSearchIcons());
    if (this.searchIcons) {
      return;
    }
    if (!icons2.length && !this.searchIcons) {
      await new Promise((resolve) => setTimeout(resolve, 500));
      return this.setupSearchIcon();
    }
    this.searchIcons = icons2;
    icons2.forEach((icon) => {
      const clonedIcon = document.createElement("div");
      clonedIcon.classList.add("show-search-link", "inline-block");
      clonedIcon.innerHTML = icon.innerHTML;
      clonedIcon.id = "briffa-search-link";
      clonedIcon.onclick = () => {
        console.log(`>> Clicked`);
        this.showSearch();
      };
      icon.replaceWith(clonedIcon);
    });
  }
  appendToHtml(node) {
    try {
      const mainEl = document.getElementById("content");
      if (mainEl && node) {
        mainEl.appendChild(node);
        this.addedToHtml = true;
      }
    } catch (err) {
    }
  }
  showSearch() {
    if (!this.addedToHtml) {
      this.appendToHtml(this.node);
    }
    this.searchObject.showElement();
    setTimeout(() => {
      this.searchObject.inputNode.focus();
    }, 1e3);
  }
  hideSearch() {
    this.searchObject.hideElement();
  }
  // return 'true' or 'false'
  isMobile() {
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;
  }
}
const briffaSearchSingleton = new BriffaSearchFactory();
class BriffaSearchAnimationBar {
  // make array of classes...
  constructor() {
    this.barElement = null;
    this.activePosition = null;
    this.classNamesLeft = ["-translate-x-full"];
    this.classNamesCenter = ["translate-x-0"];
    this.classNamesRight = ["translate-x-full"];
    this.animationInterval = 800;
    this.classNamesVisible = [
      "transition-transform",
      `duration-[${this.animationInterval}ms]`,
      "ease-in-out"
    ];
    this.classNamesHidden = ["opacity-0"];
    this.animationTimeoutId = null;
    const focusCallback = this.onFocusChange.bind(this);
    briffaGenericSearchFactory.addFocusedChangedSubscriber(focusCallback);
    const loadingCallback = this.onLoadingChange.bind(this);
    briffaGenericSearchFactory.addLoadingStatusChangedSubscriber(
      loadingCallback
    );
    this.initializeElement();
  }
  animateLoadingPosition() {
    switch (this.activePosition) {
      case "left":
        this.showBarRight();
        break;
      case "center":
        this.showBarRight();
        break;
      case "right":
        this.hideBar();
        this.resetPositionBarLeft();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.showBar();
          });
        });
        break;
      case null:
        this.resetPositionBarLeft();
        break;
    }
    if (!briffaGenericSearchFactory.isLoadingResults && this.activePosition == "left") {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.showBarCenter();
        });
      });
      this.animationTimeoutId = null;
      return;
    }
    this.animationTimeoutId = setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.animateLoadingPosition();
        });
      });
    }, this.animationInterval);
  }
  startLoadingAnimation() {
    if (this.animationTimeoutId) {
      return null;
    }
    this.animateLoadingPosition();
  }
  stopLoadingAnimation() {
  }
  onLoadingChange(isLoading) {
    const recentlyLoading = isLoading || briffaGenericSearchFactory.lastLoadingTimestamp + this.animationInterval > Date.now();
    if (!recentlyLoading && briffaGenericSearchFactory.searchTerm.length) {
      this.startLoadingAnimation();
    } else {
      this.stopLoadingAnimation();
    }
  }
  onFocusChange(isFocusedOn) {
    if (isFocusedOn && !briffaGenericSearchFactory.isLoadingResults) {
      this.showBar();
      this.showBarCenter();
    }
    const hideBar = !isFocusedOn && briffaGenericSearchFactory.searchTerm.length === 0 && this.activePosition == "center";
    if (hideBar) {
      this.resetPositionBarLeft();
    }
  }
  hideBar() {
    this.barElement.classList.remove(...this.classNamesVisible);
    this.barElement.classList.add(...this.classNamesHidden);
  }
  clearBarPosition() {
    this.barElement.classList.remove(...this.classNamesLeft);
    this.barElement.classList.remove(...this.classNamesCenter);
    this.barElement.classList.remove(...this.classNamesRight);
  }
  showBar() {
    this.barElement.classList.remove(...this.classNamesHidden);
    this.barElement.classList.add(...this.classNamesVisible);
  }
  resetPositionBarLeft() {
    this.clearBarPosition();
    this.barElement.classList.add(...this.classNamesLeft);
    this.activePosition = "left";
  }
  showBarCenter() {
    this.clearBarPosition();
    this.barElement.classList.add(...this.classNamesCenter);
    this.activePosition = "center";
  }
  showBarRight() {
    this.clearBarPosition();
    this.barElement.classList.add(...this.classNamesRight);
    this.activePosition = "right";
  }
  initializeElement() {
    const barElement = document.createElement("div");
    barElement.classList.add("h-full", "bg-[#964B00]", "w-full");
    this.barElement = barElement;
    this.resetPositionBarLeft();
  }
  getElement() {
    return this.barElement;
  }
}
const briffaSearchAnimationBarSingleton = new BriffaSearchAnimationBar();
const getProductsSection = (products) => {
  const section = document.createElement("div");
  section.classList.add(
    "p-2",
    "pt-4",
    "pb-0",
    "overflow-auto",
    "grid",
    "grid-cols-[repeat(auto-fit,minmax(150px,1fr))]",
    "gap-x-4"
  );
  if (products) {
    const cardNodes = products.map(
      (product) => createProductCard(product)
    );
    cardNodes.forEach((node) => {
      node.classList.add(
        "mb-4",
        "transition-width",
        "duration-200",
        "ease-in-out"
      );
      section.appendChild(node);
    });
  }
  return section;
};
var __create$c = Object.create;
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __knownSymbol$c = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$c = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$c = (target, value) => __defProp$c(target, "name", { value, configurable: true });
var __decoratorStart$c = (base) => [, , , __create$c(base?.[__knownSymbol$c("metadata")] ?? null)];
var __decoratorStrings$c = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$c = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$c("Function expected") : fn;
var __decoratorContext$c = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$c[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$c("Already initialized") : fns.push(__expectFn$c(fn || null)) });
var __decoratorMetadata$c = (array, target) => __defNormalProp$c(target, __knownSymbol$c("metadata"), array[3]);
var __runInitializers$c = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$c = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$c[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$c(k2 < 4 ? target : { get [name]() {
    return __privateGet$b(this, extra);
  }, set [name](x2) {
    return __privateSet$b(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$c(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$c(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$c(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$b(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$b : __privateMethod$b)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$b(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$c(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$c("Object expected");
    else __expectFn$c(fn = it.get) && (desc.get = fn), __expectFn$c(fn = it.set) && (desc.set = fn), __expectFn$c(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$c(array, target), desc && __defProp$c(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$b = (obj, member, msg) => member.has(obj) || __typeError$c("Cannot " + msg);
var __privateIn$b = (member, obj) => Object(obj) !== obj ? __typeError$c('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$b = (obj, member, getter) => (__accessCheck$b(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$b = (obj, member, value) => member.has(obj) ? __typeError$c("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$b = (obj, member, value, setter) => (__accessCheck$b(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$b = (obj, member, method) => (__accessCheck$b(obj, member, "access private method"), method);
var _bodyNode_dec, _inputNode_dec, _clearedSearchTimestamp_dec, _searchTerm_dec$1, _searchResults_dec, _visible_dec$2, _a$c, _BriffaSearchMobileFactory_decorators, _init$c, _visible$2, _searchResults, _searchTerm$1, _clearedSearchTimestamp, _inputNode, _bodyNode;
_BriffaSearchMobileFactory_decorators = [t$1("briffa-search-mobile-factory")];
class BriffaSearchMobileFactory extends (_a$c = BaseDesignSystemComponent(
  searchMobileFactoryStyles
), _visible_dec$2 = [r$1()], _searchResults_dec = [r$1()], _searchTerm_dec$1 = [r$1()], _clearedSearchTimestamp_dec = [r$1()], _inputNode_dec = [e$5(".briffa-search-input")], _bodyNode_dec = [e$5(".briffa-search-mobile-body")], _a$c) {
  constructor() {
    super();
    __privateAdd$b(this, _visible$2, __runInitializers$c(_init$c, 8, this, false)), __runInitializers$c(_init$c, 11, this);
    __privateAdd$b(this, _searchResults, __runInitializers$c(_init$c, 12, this)), __runInitializers$c(_init$c, 15, this);
    __privateAdd$b(this, _searchTerm$1, __runInitializers$c(_init$c, 16, this, "")), __runInitializers$c(_init$c, 19, this);
    __privateAdd$b(this, _clearedSearchTimestamp, __runInitializers$c(_init$c, 20, this, -1)), __runInitializers$c(_init$c, 23, this);
    __privateAdd$b(this, _inputNode, __runInitializers$c(_init$c, 24, this)), __runInitializers$c(_init$c, 27, this);
    __privateAdd$b(this, _bodyNode, __runInitializers$c(_init$c, 28, this)), __runInitializers$c(_init$c, 31, this);
    this.handleBackClick = () => {
      briffaSearchSingleton.hideSearch();
    };
    this.handleInput = (event) => {
      const target = event.target;
      const text = target.value;
      briffaGenericSearchFactory.debouncedSearchTermChanged(text);
    };
    this.handleInputKeydown = (event) => {
      if (event.key === "Enter") {
        const inputValue = this.inputNode?.value || "";
        searchPage(inputValue);
      }
    };
    this.handleClearSearch = (event) => {
      briffaGenericSearchFactory.debouncedSearchTermChanged("");
      briffaGenericSearchFactory.focusedChanged(true);
      this.inputNode?.focus();
      this.clearedSearchTimestamp = Date.now();
      event.stopPropagation();
    };
    this.inputElFocused = false;
    this.handleInputFocus = () => {
      this.inputElFocused = true;
      this.requestUpdate();
      briffaGenericSearchFactory.focusedChanged(true);
    };
    this.handleInputBlur = () => {
      setTimeout(() => {
        const clearedSearchRecently = this.clearedSearchTimestamp + 500 > Date.now();
        if (clearedSearchRecently) {
          return;
        }
        this.inputElFocused = false;
        this.requestUpdate();
        briffaGenericSearchFactory.focusedChanged(false);
      }, 100);
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.initializeSubscription();
  }
  initializeSubscription() {
    const callback = this.showResults.bind(this);
    briffaGenericSearchFactory.subscribeToSearchObjectChanged(
      callback,
      true
    );
    const inputElCallback = this.updateInputText.bind(this);
    briffaGenericSearchFactory.subscribeToSearchTermChanged(
      inputElCallback,
      false
    );
  }
  showResults(res) {
    this.searchResults = res;
    this.searchTerm = res.query || "";
  }
  updateInputText(searchTerm) {
    this.searchTerm = searchTerm;
    if (this.inputNode) {
      this.inputNode.value = searchTerm;
    }
  }
  showElement() {
    this.visible = true;
  }
  hideElement() {
    this.visible = false;
  }
  render() {
    if (!this.visible) {
      return x``;
    }
    return x`
            <div class="search-container">
                <div class="briffa-search-modal">
                    ${this.renderHeader()}
                    ${this.renderBody()}
                </div>
            </div>
        `;
  }
  renderHeader() {
    return x`
            <div class="briffa-search-header">
                <div class="back-button" @click=${this.handleBackClick}>
                    ${this.renderBackChevron()}
                </div>
                ${this.renderSearchBar()}
                ${this.renderViewResultsSection()}
                <div class="header-shadow"></div>
            </div>
        `;
  }
  renderSearchBar() {
    const searchBarClasses = this.inputElFocused ? "search-bar focused" : "search-bar";
    const clearSearchClasses = this.searchTerm.length > 0 ? "clear-search visible" : "clear-search";
    return x`
            <div class="${searchBarClasses}">
                <div class="search-icon">
                    ${this.renderSearchIcon()}
                </div>
                <input
                    class="briffa-search-input"
                    placeholder="What are you looking for today?"
                    .value=${this.searchTerm}
                    @input=${this.handleInput}
                    @keydown=${this.handleInputKeydown}
                    @focus=${this.handleInputFocus}
                    @blur=${this.handleInputBlur}
                />
                <div class="${clearSearchClasses}" @click=${this.handleClearSearch}>
                    ${this.renderClearIcon()}
                </div>
                <div class="animated-search-bar-wrapper">
                    ${briffaSearchAnimationBarSingleton.getElement()}
                </div>
            </div>
        `;
  }
  renderViewResultsSection() {
    const hasResults = this.searchResults?.results?.length > 0;
    const sectionClasses = hasResults ? "view-results-section visible" : "view-results-section";
    return x`
            <div class="${sectionClasses}">
                ${hasResults ? this.createViewResultsButton() : E}
            </div>
        `;
  }
  createViewResultsButton() {
    const btn = document.createElement("wa-button");
    btn.size = "medium";
    btn.variant = "brand";
    btn.classList.add("cursor-pointer");
    btn.addEventListener("click", () => {
      const inputValue = this.inputNode?.value || "";
      searchPage(inputValue);
    });
    btn.innerHTML = `View results (${this.searchResults?.actualResultsCount || 0})`;
    return btn;
  }
  renderBody() {
    return x`
            <div class="briffa-search-mobile-body">
                ${this.renderBodyContent()}
            </div>
        `;
  }
  renderBodyContent() {
    const container = document.createElement("div");
    if (!this.searchResults) {
      return container;
    }
    const {
      results: products,
      suggestedCollectionTitles,
      trendingSearchTitles,
      query: query2
    } = this.searchResults;
    const sections = [];
    if (!query2 || query2 === "") {
      sections.push(getTrendingSection(trendingSearchTitles));
      sections.push(getRecentSearchesSection());
    } else {
      if (products?.length > 0) {
        sections.push(getSuggestionsSection(query2, suggestedCollectionTitles));
        sections.push(getProductsSection(products));
      }
    }
    sections.forEach((section) => {
      container.appendChild(section);
    });
    return container;
  }
  renderBackChevron() {
    return BriffaIcons.getLeftChevron({
      color: tokens.color.gray[900],
      height: "24px",
      width: "24px"
    });
  }
  renderSearchIcon() {
    return BriffaIcons.getMagnifyIcon({
      color: tokens.color.gray[900],
      height: "24px",
      width: "24px"
    });
  }
  renderClearIcon() {
    return BriffaIcons.getXMarkIcon({
      color: tokens.color.gray[500],
      width: "20px",
      height: "20px"
    });
  }
}
_init$c = __decoratorStart$c(_a$c);
_visible$2 = /* @__PURE__ */ new WeakMap();
_searchResults = /* @__PURE__ */ new WeakMap();
_searchTerm$1 = /* @__PURE__ */ new WeakMap();
_clearedSearchTimestamp = /* @__PURE__ */ new WeakMap();
_inputNode = /* @__PURE__ */ new WeakMap();
_bodyNode = /* @__PURE__ */ new WeakMap();
__decorateElement$c(_init$c, 4, "visible", _visible_dec$2, BriffaSearchMobileFactory, _visible$2);
__decorateElement$c(_init$c, 4, "searchResults", _searchResults_dec, BriffaSearchMobileFactory, _searchResults);
__decorateElement$c(_init$c, 4, "searchTerm", _searchTerm_dec$1, BriffaSearchMobileFactory, _searchTerm$1);
__decorateElement$c(_init$c, 4, "clearedSearchTimestamp", _clearedSearchTimestamp_dec, BriffaSearchMobileFactory, _clearedSearchTimestamp);
__decorateElement$c(_init$c, 4, "inputNode", _inputNode_dec, BriffaSearchMobileFactory, _inputNode);
__decorateElement$c(_init$c, 4, "bodyNode", _bodyNode_dec, BriffaSearchMobileFactory, _bodyNode);
BriffaSearchMobileFactory = __decorateElement$c(_init$c, 0, "BriffaSearchMobileFactory", _BriffaSearchMobileFactory_decorators, BriffaSearchMobileFactory);
__runInitializers$c(_init$c, 1, BriffaSearchMobileFactory);
class PaginationManager {
  constructor() {
    this.state = {
      totalItemsCount: -1,
      actualResultsCount: -1,
      paginationKey: null,
      activeBucket: null,
      activePage: -1,
      pageCount: -1,
      pageSize: 20,
      collectionId: null,
      searchTerm: null,
      resultsType: null
    };
    this.keepAliveIntervalId = null;
  }
  getState() {
    return { ...this.state };
  }
  updateState(updates) {
    this.state = { ...this.state, ...updates };
  }
  setPaginationDetails(res) {
    const {
      paginationKey,
      pageSize,
      currentPage,
      pageCount,
      totalItemsCount,
      actualResultsCount
    } = res;
    this.updateState({
      paginationKey,
      pageSize,
      activePage: currentPage,
      pageCount,
      totalItemsCount,
      actualResultsCount
    });
  }
  getHasMorePages(pageCount, pageIndex) {
    pageCount = pageCount ?? this.state.pageCount;
    pageIndex = pageIndex ?? this.state.activePage;
    return pageCount > pageIndex + 1;
  }
  async initializePaginatedCollection(params) {
    this.updateState({
      resultsType: "collection",
      collectionId: params.collectionId
    });
    return await briffaCloudSearchApiSingleton.initializeCollectionBucket({
      collectionId: params.collectionId,
      getAvailableFilters: true,
      tillPageIndex: params.tillPageIndex
    });
  }
  async initializePaginatedSearch(params) {
    this.updateState({
      resultsType: "search",
      searchTerm: params.searchTerm
    });
    return await briffaCloudSearchApiSingleton.initializeSearchBucket({
      searchTerm: params.searchTerm,
      getAvailableFilters: true,
      tillPageIndex: params.tillPageIndex
    });
  }
  async fetchFirstPage() {
    this.updateState({ activePage: 0 });
    return await briffaCloudSearchApiSingleton.performPaginatedSearch({
      pageIndex: 0,
      pageSize: this.state.pageSize,
      paginationKey: this.state.paginationKey
    });
  }
  async fetchNextPage() {
    if (!this.getHasMorePages()) {
      return null;
    }
    return briffaCloudSearchApiSingleton.performPaginatedSearch({
      pageIndex: this.state.activePage + 1,
      pageSize: this.state.pageSize,
      paginationKey: this.state.paginationKey
    }).then((res) => {
      if (!!res) {
        this.updateState({ activePage: this.state.activePage + 1 });
      }
      return res;
    });
  }
  initializeKeepAliveTimeout() {
    this.stopKeepAliveCheck();
    this.keepAliveIntervalId = setInterval(() => {
      briffaCloudSearchApiSingleton.paginationKeepAlive(
        this.state.paginationKey
      );
    }, 5e3);
  }
  stopKeepAliveCheck() {
    if (this.keepAliveIntervalId) {
      clearInterval(this.keepAliveIntervalId);
      this.keepAliveIntervalId = null;
    }
  }
  async handleKeepAliveMaxAttemptsReached() {
    this.stopKeepAliveCheck();
    briffaCloudSearchApiSingleton.resetMaxAttempts();
    let response;
    if (this.state.resultsType === "collection") {
      response = await this.initializePaginatedCollection({
        collectionId: this.state.collectionId
      });
    } else if (this.state.resultsType === "search") {
      response = await this.initializePaginatedSearch({
        searchTerm: this.state.searchTerm
      });
    } else {
      throw new Error("Invalid results type for keep alive restart");
    }
    this.initializeKeepAliveTimeout();
    return response;
  }
  updateFilters(res) {
    const { availableFilterTags, actualResultsCount } = res;
    store.dispatch(setAvailableFilterTags(availableFilterTags ?? {}));
    store.dispatch(setSearchResultsCount(actualResultsCount));
  }
  initializePaginationFilters(res, initialLoad) {
    if (!initialLoad) {
      return;
    }
    const { availableFilterTags } = res;
    if (!availableFilterTags) {
      throw Error("No filter tags in pagination request");
    }
    store.dispatch(setAvailableFilterTags(availableFilterTags));
  }
}
class ScrollManager {
  constructor(storageManager2, pageSize = 20) {
    this.scrollListenerAttached = false;
    this.handleScrollToProduct = (event) => {
      const productId = event.detail.productId;
      const productCards = document.querySelectorAll("briffa-product-card");
      productCards?.forEach((card) => {
        if (card.product?.id === productId) {
          card.scrollIntoView({
            behavior: "auto",
            block: "center"
          });
        }
      });
    };
    this.storageManager = storageManager2;
    this.pageSize = pageSize;
  }
  setPageSize(pageSize) {
    this.pageSize = pageSize;
  }
  getVisibleProductCards(shadowRoot) {
    const elements = shadowRoot?.querySelectorAll("briffa-product-card");
    if (!elements) return [];
    return Array.from(elements).filter((element) => {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;
      return rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0;
    });
  }
  handleBeaconScroll() {
    const beacon = this.storageManager.getProductCardBeacon();
    this.storageManager.deleteProductCardBeacon();
    if (beacon?.productId) {
      requestAnimationFrame(() => {
        const event = new CustomEvent(
          CustomEventScrollProductIntoViewKey,
          {
            detail: { productId: beacon.productId },
            bubbles: true,
            composed: true
          }
        );
        document.body.dispatchEvent(event);
      });
      return;
    }
    const sessionBeacon = this.storageManager.getSessionStorageScrollBeacon();
    const currentUrl = window.location.href;
    if (sessionBeacon && !Number.isNaN(sessionBeacon.scrollY) && sessionBeacon.url === currentUrl) {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: parseInt(sessionBeacon.scrollY.toString(), 10),
          left: 0,
          behavior: "auto"
        });
      });
    }
  }
  attachScrollListeners(shadowRoot) {
    if (this.scrollListenerAttached) {
      return;
    }
    window.addEventListener(
      "scroll",
      lodashExports.debounce(() => {
        const visibleCards = this.getVisibleProductCards(shadowRoot);
        if (visibleCards.length === 0) return;
        const bottomMostVisibleCard = visibleCards[visibleCards.length - 1];
        const parentNode = bottomMostVisibleCard.parentNode;
        if (!parentNode) return;
        const currentPageIndex = Math.floor(
          Array.from(parentNode.children).indexOf(
            bottomMostVisibleCard
          ) / this.pageSize
        );
        this.storageManager.setLocalStorageScrollBeacon({
          pageIndex: currentPageIndex,
          url: window.location.href
        });
      }, 500)
    );
    window.addEventListener("scroll", () => {
      this.storageManager.setSessionStorageScrollBeacon({
        scrollY: window.scrollY,
        url: window.location.href
      });
    });
    this.scrollListenerAttached = true;
  }
  detachScrollListeners() {
    this.scrollListenerAttached = false;
  }
  markProductCardBeacon(params) {
    this.storageManager.setProductCardBeacon({
      resultsType: params.resultsType,
      collectionId: params.collectionId,
      searchTerm: params.searchTerm,
      handle: params.handle,
      productId: params.productId,
      signedOff: false,
      activePageIndex: params.activePage
    });
  }
  getAdditionalInitialFetchParams() {
    const beacon = this.storageManager.getProductCardBeacon();
    const { activePageIndex, signedOff } = beacon ?? {};
    const savedScrollBeacon = this.storageManager.getLocalStorageScrollBeacon();
    const { pageIndex } = savedScrollBeacon ?? {};
    if (signedOff && !isNaN(activePageIndex)) {
      return { tillPageIndex: activePageIndex };
    }
    if (pageIndex !== null && !isNaN(pageIndex)) {
      return { tillPageIndex: pageIndex };
    }
    return {};
  }
}
class StorageManager {
  // Product Card Beacon Methods
  setProductCardBeacon(beacon) {
    localStorage.setItem(
      localStorageProductCardBeaconKey,
      JSON.stringify(beacon)
    );
  }
  getProductCardBeacon() {
    const data = localStorage.getItem(localStorageProductCardBeaconKey);
    return data ? JSON.parse(data) : null;
  }
  deleteProductCardBeacon() {
    localStorage.removeItem(localStorageProductCardBeaconKey);
  }
  // LocalStorage Scroll Beacon Methods
  setLocalStorageScrollBeacon(beacon) {
    localStorage.setItem(
      localStorageSavedProductsScrollBeaconKey,
      JSON.stringify(beacon)
    );
  }
  getLocalStorageScrollBeacon() {
    const data = localStorage.getItem(
      localStorageSavedProductsScrollBeaconKey
    );
    return data ? JSON.parse(data) : null;
  }
  clearLocalStorageScrollBeacon() {
    const beacon = this.getLocalStorageScrollBeacon();
    const currentUrl = window.location.href;
    if (beacon?.url !== currentUrl) {
      localStorage.removeItem(localStorageSavedProductsScrollBeaconKey);
    }
  }
  // SessionStorage Scroll Beacon Methods
  setSessionStorageScrollBeacon(beacon) {
    sessionStorage.setItem(
      sessionStorageSavedScrollBeaconKey,
      JSON.stringify(beacon)
    );
  }
  getSessionStorageScrollBeacon() {
    const data = sessionStorage.getItem(sessionStorageSavedScrollBeaconKey);
    return data ? JSON.parse(data) : null;
  }
  clearSessionStorageScrollBeacon() {
    sessionStorage.removeItem(sessionStorageSavedScrollBeaconKey);
  }
}
const storageManager = new StorageManager();
class ResultsRenderer {
  constructor() {
    this.isVirtualizing = false;
    this.virtualScrollAbortController = void 0;
    this.nextPageObserverEl = void 0;
    this.nextPageObserverAbortController = void 0;
    this.productCounter = 0;
    this.cardRects = [];
    this.cards = [];
  }
  getGridClassNames(isMobile2) {
    const baseClasses = ["grid", "gap-x-4", "gap-y-4", "relative"];
    const mobileClasses = [
      "grid-cols-[repeat(auto-fit,minmax(150px,1fr))]",
      "p-4"
    ];
    const desktopClasses = [
      "grid-cols-[repeat(auto-fit,minmax(250px,1fr))]",
      "px-4"
    ];
    return [
      ...baseClasses,
      ...isMobile2 ? mobileClasses : desktopClasses
    ].join(" ");
  }
  getContainerClassNames(isMobile2) {
    const baseClasses = ["min-h-[50vh]"];
    const mobileClasses = ["flex-col"];
    const desktopClasses = ["px-0"];
    return [
      ...baseClasses,
      ...isMobile2 ? mobileClasses : desktopClasses
    ].join(" ");
  }
  getClassNames(isMobile2) {
    return {
      container: this.getContainerClassNames(isMobile2),
      grid: this.getGridClassNames(isMobile2)
    };
  }
  initializeVirtualScrolling() {
    const virtualRowBuffer = 3;
    this.virtualScrollAbortController = new AbortController();
    const virtualizeCards = () => {
      let visibleCards = this.cards.filter((card) => card.inView);
      let [firstInView, lastInView] = [
        visibleCards[0],
        visibleCards[visibleCards.length - 1]
      ];
      let uniqueYPositions = /* @__PURE__ */ new Set();
      visibleCards.forEach((card) => {
        const y3 = card.containerEl.getBoundingClientRect().y;
        uniqueYPositions.add(y3);
      });
      const cardsPerRow = visibleCards.length / uniqueYPositions.size;
      const showFrom = Math.floor(
        firstInView.index - cardsPerRow * virtualRowBuffer
      );
      const showUntil = Math.ceil(
        lastInView.index + cardsPerRow * virtualRowBuffer
      );
      this.cards.slice(showFrom, showUntil).forEach((card) => {
      });
      this.cards.forEach((card) => {
        let index2 = card.index;
        if (index2 < showFrom || index2 > showUntil) {
          if (card.showVirtual) {
            return;
          }
          card.virtualHeight = this.cardRects[card.index].height;
          card.virtualWidth = this.cardRects[card.index].width;
          card.showVirtual = true;
          return;
        }
        if (!card.showVirtual) {
          return;
        }
        card.showVirtual = false;
      });
    };
    const handler = () => {
      if (this.restoringVirtualization || this.isVirtualizing) {
        return;
      }
      this.isVirtualizing = true;
      if (this.cards.length !== this.cardRects.length) {
        this.cardRects = this.cards.map(
          (el) => el.getBoundingClientRect()
        );
      }
      try {
        virtualizeCards();
      } catch (error) {
        console.error(error);
      }
      this.isVirtualizing = false;
    };
    window.addEventListener(
      "scroll",
      () => {
        handler();
      },
      {
        signal: this.virtualScrollAbortController.signal
      }
    );
    const areCardsVisible = () => {
      let cardsVisible = this.cards.some(
        (card) => card.inView && isElementInView({ element: card, fullyInView: true })
      );
      return this.cards.length && cardsVisible;
    };
    const checkVirtualization = () => {
      if (this.restoringVirtualization || areCardsVisible()) {
        return;
      }
      this.restoringVirtualization = true;
      const reEnableTimeout = 1e3;
      this.cards.forEach((card) => card.showVirtual = false);
      this.restoreVirtualizationTimeout = setTimeout(() => {
        this.restoringVirtualization = false;
        if (areCardsVisible()) {
          handler();
        }
      }, reEnableTimeout);
    };
    this.virtualScrollRestorationIntervalId = setInterval(
      () => checkVirtualization(),
      100
    );
    window.addEventListener(
      "resize",
      lodashExports.debounce(() => {
        this.cards.forEach((card) => card.showVirtual = false);
        this.cardRects = this.cards.map(
          (el) => el.getBoundingClientRect()
        );
      }, 1e3),
      {
        signal: this.virtualScrollAbortController.signal
      }
    );
  }
  cleanupVirtualScrolling() {
    this.restoringVirtualization = false;
    this.isVirtualizing = false;
    this.virtualScrollAbortController?.abort();
    clearInterval(this.virtualScrollRestorationIntervalId);
    clearTimeout(this.restoreVirtualizationTimeout);
  }
  disconnectedCallback() {
    this.cleanupNextPageObservers();
    this.cleanupVirtualScrolling();
  }
  showResults(res, gridNode, onProductClick, onFetchNextPage) {
    const { results, currentPage, pageCount, isFirstPage } = res;
    this.cleanupVirtualScrolling();
    if (isFirstPage) {
      this.productCounter = 0;
      this.cards = [];
      this.cleanupNextPageObservers();
      gridNode.innerHTML = "";
    }
    results.forEach((result) => {
      const card = createProductCard(result, this.productCounter);
      card.subscribeToOnClick(
        (({ productId, handle }) => {
          onProductClick({ productId, handle });
        }).bind(this)
      );
      gridNode.appendChild(card);
      this.productCounter = this.productCounter + 1;
      this.cards.push(card);
    });
    const hasMorePages = pageCount > currentPage + 1;
    if (isFirstPage && hasMorePages) {
      this.initializeNextPageObserver(gridNode, onFetchNextPage);
    }
    if (!isFirstPage && !hasMorePages) {
      this.cleanupNextPageObservers();
    }
    this.initializeVirtualScrolling();
  }
  initializeNextPageObserver(gridNode, onFetchNextPage) {
    const observerNode = document.createElement("div");
    observerNode.classList.add(
      "absolute",
      "bottom-0",
      "right-0",
      "left-0",
      "h-[10000px]",
      "pointer-events-none"
    );
    let observerEnabled = true;
    const callback = () => {
      if (!observerEnabled) {
        return;
      }
      observerEnabled = false;
      observerNode.classList.add("!hidden");
      onFetchNextPage().catch((error) => {
        console.error("Error fetching next page:", error);
      }).finally(
        () => (
          // Timeout is crucial else glitch behaviour prevails
          setTimeout(() => {
            observerEnabled = true;
            observerNode.classList.remove("!hidden");
          }, 1e3)
        )
      );
    };
    gridNode.appendChild(observerNode);
    const abortController = new AbortController();
    window.addEventListener(
      "scroll",
      lodashExports.throttle(() => {
        const isInView = isElementInView({ element: observerNode });
        if (isInView) {
          callback();
        }
      }, 100),
      { signal: abortController.signal }
    );
    this.nextPageObserverEl = observerNode;
    this.nextPageObserverAbortController = abortController;
  }
  cleanupNextPageObservers() {
    this.nextPageObserverEl?.remove();
    this.nextPageObserverAbortController?.abort();
  }
}
const paginationGridStyles = safeCss(`
    :host {
        display: contents;
    }

    #container {
        margin: 0 auto;
            max-width: ${cssVariables["page-content-max-width"]};
    }
`);
const getProductCardWidth = () => {
  if (isMobile()) {
    return `min-w-[70vw]`;
  } else {
    return "min-w-[320px]";
  }
};
const isMobile = () => {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(navigator.userAgent);
};
var __create$b = Object.create;
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __knownSymbol$b = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$b = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$b = (target, value) => __defProp$b(target, "name", { value, configurable: true });
var __decoratorStart$b = (base) => [, , , __create$b(base?.[__knownSymbol$b("metadata")] ?? null)];
var __decoratorStrings$b = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$b = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$b("Function expected") : fn;
var __decoratorContext$b = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$b[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$b("Already initialized") : fns.push(__expectFn$b(fn || null)) });
var __decoratorMetadata$b = (array, target) => __defNormalProp$b(target, __knownSymbol$b("metadata"), array[3]);
var __runInitializers$b = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$b = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$b[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$b(k2 < 4 ? target : { get [name]() {
    return __privateGet$a(this, extra);
  }, set [name](x2) {
    return __privateSet$a(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$b(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$b(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$b(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$a(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$a : __privateMethod$a)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$a(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$b(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$b("Object expected");
    else __expectFn$b(fn = it.get) && (desc.get = fn), __expectFn$b(fn = it.set) && (desc.set = fn), __expectFn$b(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$b(array, target), desc && __defProp$b(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$a = (obj, member, msg) => member.has(obj) || __typeError$b("Cannot " + msg);
var __privateIn$a = (member, obj) => Object(obj) !== obj ? __typeError$b('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$a = (obj, member, getter) => (__accessCheck$a(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$a = (obj, member, value) => member.has(obj) ? __typeError$b("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$a = (obj, member, value, setter) => (__accessCheck$a(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$a = (obj, member, method) => (__accessCheck$a(obj, member, "access private method"), method);
var _isLoading_dec$2, _scrollTopBeacon_dec, _resultsNode_dec, _gridNode_dec, _a$b, _BriffaPaginatedResultsGrid_decorators, _init$b, _gridNode, _resultsNode, _scrollTopBeacon, _isLoading$2;
_BriffaPaginatedResultsGrid_decorators = [t$1("briffa-paginated-results-grid")];
class BriffaPaginatedResultsGrid extends (_a$b = BaseDesignSystemComponent(
  paginationGridStyles
), _gridNode_dec = [e$5("#grid-container")], _resultsNode_dec = [e$5("#results-container")], _scrollTopBeacon_dec = [e$5("#scroll-top-beacon")], _isLoading_dec$2 = [r$1()], _a$b) {
  constructor() {
    super();
    __privateAdd$a(this, _gridNode, __runInitializers$b(_init$b, 8, this)), __runInitializers$b(_init$b, 11, this);
    __privateAdd$a(this, _resultsNode, __runInitializers$b(_init$b, 12, this)), __runInitializers$b(_init$b, 15, this);
    __privateAdd$a(this, _scrollTopBeacon, __runInitializers$b(_init$b, 16, this)), __runInitializers$b(_init$b, 19, this);
    __privateAdd$a(this, _isLoading$2, __runInitializers$b(_init$b, 20, this, true)), __runInitializers$b(_init$b, 23, this);
    this.paginationManager = void 0;
    this.scrollManager = void 0;
    this.resultsRenderer = void 0;
    this.searchResultsFiltersElement = null;
    this.callbacks = void 0;
    this.selectedFilterTagsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTags
    );
    this.sortBySelector = new MemoizedSelector(this, getSortBy);
    this.previousSelectedFilterTags = null;
    this.previousSortBy = null;
    this.isInitialLoad = true;
    this.onSelectedFilterTagsChanged = lodashExports.debounce(() => {
      this.fetchFirstPage();
      window.scrollTo(0, 0);
    }, 500);
    this.paginationManager = new PaginationManager();
    this.scrollManager = new ScrollManager(storageManager);
    this.resultsRenderer = new ResultsRenderer();
    this.callbacks = {
      onPaginationResults: [],
      onInitialPaginationResults: []
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.initializeComponent();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.paginationManager.stopKeepAliveCheck();
    this.scrollManager.detachScrollListeners();
    this.resultsRenderer.cleanupNextPageObservers();
    document.removeEventListener(
      CustomEventScrollProductIntoViewKey,
      this.scrollManager.handleScrollToProduct
    );
  }
  initializeComponent() {
    this.paginationManager.initializeKeepAliveTimeout();
    this.searchResultsFiltersElement = isMobile() ? document.createElement(
      "briffa-mobile-search-results-filters"
    ) : new BriffaDesktopSearchResultsFilters();
    this.callbacks.onPaginationResults.push(this.updateFilters.bind(this));
    this.callbacks.onPaginationResults.push(this.showResults.bind(this));
    this.callbacks.onInitialPaginationResults.push(
      this.setPaginationDetails.bind(this)
    );
    this.callbacks.onInitialPaginationResults.push(
      this.initializePaginationFilters.bind(this)
    );
    briffaCloudSearchApiSingleton.subscribeToMaxAttemptsFailed(
      this.keepAliveMaxAttemptsReached.bind(this)
    );
    document.addEventListener(
      CustomEventScrollProductIntoViewKey,
      this.scrollManager.handleScrollToProduct
    );
  }
  firstUpdated() {
    if (this.searchResultsFiltersElement) {
      const resultsContainer = this.shadowRoot?.querySelector(
        ".grow"
      );
      if (this.resultsNode && resultsContainer) {
        this.searchResultsFiltersElement.attachToResults(
          this.resultsNode,
          resultsContainer
        );
      }
    }
    this.previousSelectedFilterTags = this.selectedFilterTagsSelector.value;
    this.previousSortBy = this.sortBySelector.value;
  }
  updated() {
    const currentFilterTags = this.selectedFilterTagsSelector.value;
    const currentSortBy = this.sortBySelector.value;
    if (this.isInitialLoad || this.previousSelectedFilterTags === null) {
      return;
    }
    let changed = false;
    if (!lodashExports.isEqual(currentFilterTags, this.previousSelectedFilterTags)) {
      this.previousSelectedFilterTags = currentFilterTags;
      changed = true;
    }
    if (currentSortBy !== this.previousSortBy) {
      this.previousSortBy = currentSortBy;
      changed = true;
    }
    if (changed) {
      this.onSelectedFilterTagsChanged();
    }
  }
  render() {
    const classNames = this.resultsRenderer.getClassNames(isMobile());
    return x`
            <div
                id="scroll-top-beacon"
                class="scroll-top-beacon absolute top-0"
            ></div>
            <div id="container">
                <div
                    id="results-container"
                    class="${classNames.container}"
                >
                    <div class="grow">
                        <div
                            id="grid-container"
                            class="${classNames.grid}"
                        >
                            <!-- Products will be added here dynamically -->
                        </div>
                    </div>
                </div>
            </div>
        `;
  }
  // Public API methods
  initializePaginatedCollection({ collectionId }) {
    storageManager.clearLocalStorageScrollBeacon();
    const additionalParams = this.scrollManager.getAdditionalInitialFetchParams();
    this.isLoading = true;
    this.paginationManager.initializePaginatedCollection({
      collectionId,
      ...additionalParams
    }).then((response) => {
      this.isInitialLoad = false;
      this.isLoading = false;
      this.callbacks.onInitialPaginationResults.forEach(
        (callback) => callback(response, true)
      );
      this.callbacks.onPaginationResults.forEach(
        (callback) => callback(response)
      );
    });
  }
  initializePaginatedSearch({ searchTerm }) {
    storageManager.clearLocalStorageScrollBeacon();
    const additionalParams = this.scrollManager.getAdditionalInitialFetchParams();
    this.isLoading = true;
    this.paginationManager.initializePaginatedSearch({
      searchTerm,
      ...additionalParams
    }).then((response) => {
      this.isInitialLoad = false;
      this.isLoading = false;
      this.callbacks.onInitialPaginationResults.forEach(
        (callback) => callback(response, true)
      );
      this.callbacks.onPaginationResults.forEach(
        (callback) => callback(response)
      );
    });
  }
  async fetchFirstPage() {
    this.isLoading = true;
    const response = await this.paginationManager.fetchFirstPage();
    this.isLoading = false;
    this.callbacks.onInitialPaginationResults.forEach(
      (callback) => callback(response)
    );
    this.callbacks.onPaginationResults.forEach(
      (callback) => callback(response)
    );
  }
  async fetchNextPage() {
    const response = await this.paginationManager.fetchNextPage();
    if (response) {
      this.callbacks.onPaginationResults.forEach(
        (callback) => callback(response)
      );
    }
  }
  async keepAliveMaxAttemptsReached() {
    this.isLoading = true;
    const response = await this.paginationManager.handleKeepAliveMaxAttemptsReached();
    this.isLoading = false;
    this.callbacks.onInitialPaginationResults.forEach(
      (callback) => callback(response, true)
    );
    this.callbacks.onPaginationResults.forEach(
      (callback) => callback(response)
    );
  }
  initializePaginationFilters(res, initialLoad) {
    this.paginationManager.initializePaginationFilters(res, initialLoad);
  }
  updateFilters(res) {
    this.paginationManager.updateFilters(res);
  }
  showResults(res) {
    const state2 = this.paginationManager.getState();
    this.scrollManager.setPageSize(state2.pageSize);
    if (res.isFirstPage) {
      this.scrollManager.attachScrollListeners(this.shadowRoot);
    }
    this.resultsRenderer.showResults(
      res,
      this.gridNode,
      ({ productId, handle }) => {
        this.scrollManager.markProductCardBeacon({
          productId,
          handle,
          resultsType: state2.resultsType,
          collectionId: state2.collectionId,
          searchTerm: state2.searchTerm,
          activePage: state2.activePage
        });
      },
      () => this.fetchNextPage()
    );
    if (res.isFirstPage) {
      this.scrollManager.handleBeaconScroll();
    }
  }
  setPaginationDetails(res) {
    this.paginationManager.setPaginationDetails(res);
  }
}
_init$b = __decoratorStart$b(_a$b);
_gridNode = /* @__PURE__ */ new WeakMap();
_resultsNode = /* @__PURE__ */ new WeakMap();
_scrollTopBeacon = /* @__PURE__ */ new WeakMap();
_isLoading$2 = /* @__PURE__ */ new WeakMap();
__decorateElement$b(_init$b, 4, "gridNode", _gridNode_dec, BriffaPaginatedResultsGrid, _gridNode);
__decorateElement$b(_init$b, 4, "resultsNode", _resultsNode_dec, BriffaPaginatedResultsGrid, _resultsNode);
__decorateElement$b(_init$b, 4, "scrollTopBeacon", _scrollTopBeacon_dec, BriffaPaginatedResultsGrid, _scrollTopBeacon);
__decorateElement$b(_init$b, 4, "isLoading", _isLoading_dec$2, BriffaPaginatedResultsGrid, _isLoading$2);
BriffaPaginatedResultsGrid = __decorateElement$b(_init$b, 0, "BriffaPaginatedResultsGrid", _BriffaPaginatedResultsGrid_decorators, BriffaPaginatedResultsGrid);
__runInitializers$b(_init$b, 1, BriffaPaginatedResultsGrid);
const getEncodedSlug = (input) => {
  const slug = input.toLowerCase().replace(/'/g, "").replace(/\s+/g, "-");
  const encoded = encodeURIComponent(slug);
  return encoded;
};
const isElementInView = ({ element, fullyInView = false }) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  if (fullyInView) {
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth;
  } else {
    return rect.bottom > 0 && rect.right > 0 && rect.top < windowHeight && rect.left < windowWidth;
  }
};
const useResultsGridScrollMiddleware = () => {
  const pathname = window.location.pathname;
  const briffaPaginatedResultsCardBeacon = JSON.parse(
    localStorage.getItem(localStorageProductCardBeaconKey)
  );
  const { handle = "non-existing-product-handle" } = briffaPaginatedResultsCardBeacon ?? {};
  const isCollectionsPage = pathname.includes(`/collections/`);
  const isSearchPage = pathname.includes(`/search?`);
  const isProductPage = pathname.includes(
    "/products/" + getEncodedSlug(handle)
  );
  if (isProductPage) {
    localStorage.setItem(
      localStorageProductCardBeaconKey,
      JSON.stringify({
        ...briffaPaginatedResultsCardBeacon,
        signedOff: true
      })
    );
  } else if (isCollectionsPage || isSearchPage) ;
  else {
    storageManager.clearSessionStorageScrollBeacon();
    storageManager.clearLocalStorageScrollBeacon();
    localStorage.removeItem(localStorageProductCardBeaconKey);
  }
};
setTimeout(() => {
  useResultsGridScrollMiddleware();
}, 10);
const localStorageProductCardBeaconKey = "briffa-paginated-results-card-beacon";
const localStorageSavedProductsScrollBeaconKey = "briffa-paginated-results-scroll-page-index-beacon";
const sessionStorageSavedScrollBeaconKey = "briffa-paginated-results-scroll-position-beacon";
var __create$a = Object.create;
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __knownSymbol$a = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$a = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$a = (target, value) => __defProp$a(target, "name", { value, configurable: true });
var __decoratorStart$a = (base) => [, , , __create$a(base?.[__knownSymbol$a("metadata")] ?? null)];
var __decoratorStrings$a = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$a = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$a("Function expected") : fn;
var __decoratorContext$a = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$a[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$a("Already initialized") : fns.push(__expectFn$a(fn || null)) });
var __decoratorMetadata$a = (array, target) => __defNormalProp$a(target, __knownSymbol$a("metadata"), array[3]);
var __runInitializers$a = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$a = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$a[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$a(k2 < 4 ? target : { get [name]() {
    return __privateGet$9(this, extra);
  }, set [name](x2) {
    return __privateSet$9(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$a(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$a(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$a(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$9(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$9 : __privateMethod$9)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$9(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$a(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$a("Object expected");
    else __expectFn$a(fn = it.get) && (desc.get = fn), __expectFn$a(fn = it.set) && (desc.set = fn), __expectFn$a(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$a(array, target), desc && __defProp$a(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$9 = (obj, member, msg) => member.has(obj) || __typeError$a("Cannot " + msg);
var __privateIn$9 = (member, obj) => Object(obj) !== obj ? __typeError$a('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$9 = (obj, member, getter) => (__accessCheck$9(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$9 = (obj, member, value) => member.has(obj) ? __typeError$a("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$9 = (obj, member, value, setter) => (__accessCheck$9(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$9 = (obj, member, method) => (__accessCheck$9(obj, member, "access private method"), method);
var _isDropdownOpen_dec, _textClassNames_dec, _sortIconSize_dec, _a$a, _SortFilter_decorators, _init$a, _sortIconSize, _textClassNames, _isDropdownOpen;
_SortFilter_decorators = [t$1("sort-filter")];
class SortFilter extends (_a$a = BaseDesignSystemComponent(""), _sortIconSize_dec = [n$1()], _textClassNames_dec = [n$1()], _isDropdownOpen_dec = [r$1()], _a$a) {
  constructor() {
    super(...arguments);
    __privateAdd$9(this, _sortIconSize, __runInitializers$a(_init$a, 8, this, {
      width: "30px",
      height: "26px"
    })), __runInitializers$a(_init$a, 11, this);
    __privateAdd$9(this, _textClassNames, __runInitializers$a(_init$a, 12, this, [])), __runInitializers$a(_init$a, 15, this);
    __privateAdd$9(this, _isDropdownOpen, __runInitializers$a(_init$a, 16, this, false)), __runInitializers$a(_init$a, 19, this);
    this.sortBySelector = new MemoizedSelector(this, getSortBy);
    this.availableSortByOptionsSelector = new MemoizedSelector(
      this,
      getAvailableSortByOptions
    );
    this.iconWrapperClassNames = [
      "w-6",
      "h-6",
      "flex",
      "items-center",
      "justify-center"
    ];
  }
  handleOverlayClick() {
    this.isDropdownOpen = false;
  }
  handleSortChange(option) {
    store.dispatch(setSortBy(option));
    this.isDropdownOpen = false;
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  getSortTitle() {
    const currentSortBy = this.sortBySelector.value;
    if (!currentSortBy) return "";
    return R2.Localization.Filters[`sort.filter.title.${currentSortBy.toLowerCase()}`];
  }
  getSortLabel(option) {
    return R2.Localization.Filters[`sort.filter.label.${option.toLowerCase()}`];
  }
  render() {
    const textStyle = `color: ${tokens.color.black};`;
    const availableOptions = this.availableSortByOptionsSelector.value;
    const currentSortBy = this.sortBySelector.value;
    return x`
            ${this.isDropdownOpen ? x`
                      <div
                          class="fixed inset-0 z-0"
                          @click="${this.handleOverlayClick}"
                      ></div>
                  ` : ""}
            <div class="relative">
                <button
                    class="flex gap-2 items-center min-w-[180px]"
                    @click="${this.toggleDropdown}"
                >
                    <div class="${this.iconWrapperClassNames.join(" ")}">
                        ${BriffaIcons.getSortIcon(
      tokens.color.black,
      this.sortIconSize.height,
      this.sortIconSize.width
    )}
                    </div>
                    <p
                        class="${this.textClassNames.join(" ")} sort-cta-title whitespace-nowrap"
                        style="${textStyle}"
                    >
                        ${this.getSortTitle()}
                    </p>
                </button>

                ${this.isDropdownOpen ? x`
                          <div
                              class="min-w-[180px] absolute top-full left-0 rounded-md p-4 mt-1 bg-white border border-gray-200 z-10"
                              style="box-shadow: 0 0 6px -4px;"
                              @click="${(e2) => e2.stopPropagation()}"
                          >
                              <div class="flex flex-col gap-1">
                                  ${availableOptions.map(
      (option) => x`
                                          <div class="flex gap-2 items-center">
                                              <input
                                                  type="radio"
                                                  id="sort-option-${option}"
                                                  name="sort-options"
                                                  .checked="${currentSortBy === option}"
                                                  @change="${() => this.handleSortChange(
        option
      )}"
                                              />
                                              <label
                                                  for="sort-option-${option}"
                                              >
                                                  ${this.getSortLabel(option)}
                                              </label>
                                          </div>
                                      `
    )}
                              </div>
                          </div>
                      ` : ""}
            </div>
        `;
  }
}
_init$a = __decoratorStart$a(_a$a);
_sortIconSize = /* @__PURE__ */ new WeakMap();
_textClassNames = /* @__PURE__ */ new WeakMap();
_isDropdownOpen = /* @__PURE__ */ new WeakMap();
__decorateElement$a(_init$a, 4, "sortIconSize", _sortIconSize_dec, SortFilter, _sortIconSize);
__decorateElement$a(_init$a, 4, "textClassNames", _textClassNames_dec, SortFilter, _textClassNames);
__decorateElement$a(_init$a, 4, "isDropdownOpen", _isDropdownOpen_dec, SortFilter, _isDropdownOpen);
SortFilter = __decorateElement$a(_init$a, 0, "SortFilter", _SortFilter_decorators, SortFilter);
__runInitializers$a(_init$a, 1, SortFilter);
var __create$9 = Object.create;
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __knownSymbol$9 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$9 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$9 = (target, value) => __defProp$9(target, "name", { value, configurable: true });
var __decoratorStart$9 = (base) => [, , , __create$9(base?.[__knownSymbol$9("metadata")] ?? null)];
var __decoratorStrings$9 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$9 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$9("Function expected") : fn;
var __decoratorContext$9 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$9[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$9("Already initialized") : fns.push(__expectFn$9(fn || null)) });
var __decoratorMetadata$9 = (array, target) => __defNormalProp$9(target, __knownSymbol$9("metadata"), array[3]);
var __runInitializers$9 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$9 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$9[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$9(k2 < 4 ? target : { get [name]() {
    return __privateGet$8(this, extra);
  }, set [name](x2) {
    return __privateSet$8(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$9(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$9(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$9(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$8(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$8 : __privateMethod$8)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$8(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$9(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$9("Object expected");
    else __expectFn$9(fn = it.get) && (desc.get = fn), __expectFn$9(fn = it.set) && (desc.set = fn), __expectFn$9(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$9(array, target), desc && __defProp$9(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$8 = (obj, member, msg) => member.has(obj) || __typeError$9("Cannot " + msg);
var __privateIn$8 = (member, obj) => Object(obj) !== obj ? __typeError$9('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$8 = (obj, member, getter) => (__accessCheck$8(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$8 = (obj, member, value) => member.has(obj) ? __typeError$9("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$8 = (obj, member, value, setter) => (__accessCheck$8(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$8 = (obj, member, method) => (__accessCheck$8(obj, member, "access private method"), method);
var _stickyElement_dec$3, _resultsContainer_dec, _parentContainer_dec, _drawerOpen_dec$1, _a$9, _BriffaMobileSearchResultsFilters_decorators, _init$9, _drawerOpen$1, _parentContainer, _resultsContainer, _stickyElement$3;
const TEXT_STYLES = {
  BLACK: `color: ${tokens.color.black};`,
  GREY: `color: ${tokens.color.gray[500]};`
};
const HEADING_STYLES$1 = {
  REGULAR: `color: ${tokens.color.gray[700]}; font-size: ${typography.fontSize.base};`,
  LARGE: `color: ${tokens.color.gray[700]}; font-size: ${typography.fontSize.lg};`
};
_BriffaMobileSearchResultsFilters_decorators = [t$1("briffa-mobile-search-results-filters")];
class BriffaMobileSearchResultsFilters extends (_a$9 = BaseDesignSystemComponent(
  ``
), _drawerOpen_dec$1 = [r$1()], _parentContainer_dec = [n$1({ type: Object })], _resultsContainer_dec = [n$1({ type: Object })], _stickyElement_dec$3 = [e$5("sticky-element")], _a$9) {
  constructor() {
    super();
    __privateAdd$8(this, _drawerOpen$1, __runInitializers$9(_init$9, 8, this, false)), __runInitializers$9(_init$9, 11, this);
    __privateAdd$8(this, _parentContainer, __runInitializers$9(_init$9, 12, this, null)), __runInitializers$9(_init$9, 15, this);
    __privateAdd$8(this, _resultsContainer, __runInitializers$9(_init$9, 16, this, null)), __runInitializers$9(_init$9, 19, this);
    __privateAdd$8(this, _stickyElement$3, __runInitializers$9(_init$9, 20, this)), __runInitializers$9(_init$9, 23, this);
    this.selectedFiltersCountSelector = new MemoizedSelector(
      this,
      getSelectedFiltersCount
    );
    this.searchResultsCountSelector = new MemoizedSelector(
      this,
      getSearchResultsCount
    );
    this.genericSearchResultsFilters = null;
    this.controlCtaClassNames = [
      "briffa-search-result-filters-cta",
      "mb-4",
      "sticky",
      "z-[10]",
      "p-4",
      "transition-top",
      "duration-[200ms]",
      "bg-white"
    ];
    this.genericSearchResultsFilters = document.createElement(
      "briffa-generic-search-results-filters"
    );
  }
  connectedCallback() {
    super.connectedCallback();
    this.genericSearchResultsFilters?.assignSearchResultsFiltersFactoryInstance();
  }
  setupStickyElement() {
    if (this.stickyElement) {
      const pageHeader = document.getElementsByTagName(
        "page-header"
      )[0];
      if (pageHeader) {
        this.stickyElement.targetElement = pageHeader;
      }
    }
  }
  firstUpdated() {
    this.setupStickyElement();
  }
  openDrawer() {
    this.drawerOpen = true;
  }
  closeDrawer() {
    this.drawerOpen = false;
  }
  handleDrawerAfterHide(e2) {
    if (e2.target === e2.currentTarget) {
      this.drawerOpen = false;
    }
  }
  handleClearAll() {
    store.dispatch(clearAllTags());
  }
  handleApply() {
    this.closeDrawer();
  }
  renderDrawer() {
    const selectedFiltersCount = this.selectedFiltersCountSelector.value;
    const searchResultsCount = this.searchResultsCountSelector.value;
    const showButtons = selectedFiltersCount > 0;
    return x`
            <wa-drawer
                placement="bottom"
                style="--size: 90dvh;"
                .open=${this.drawerOpen}
                @wa-after-hide=${this.handleDrawerAfterHide}
            >
                <div
                    slot="header"
                    class="flex justify-between items-center w-full"
                >
                    <span></span>
                    <p style="${HEADING_STYLES$1.LARGE}">Filters</p>
                    <span
                        style="${HEADING_STYLES$1.REGULAR} ${TEXT_STYLES.GREY}"
                        class="cursor-pointer"
                        @click=${this.closeDrawer}
                    >
                        Close
                    </span>
                </div>

                <div class="max-h-[70vh] overflow-scroll">
                    ${this.genericSearchResultsFilters}
                    <selected-filters class="mt-2"></selected-filters>
                </div>

                <div slot="footer" class="flex gap-1 items-center w-full">
                        <wa-button
                            size="medium"
                            pill
                            variant="neutral"
                            class="grow ${showButtons ? "" : "!hidden"}"
                            @click=${this.handleClearAll}
                        >
                            Clear all (${selectedFiltersCount})
                        </wa-button>
                        <wa-button
                            size="medium"
                            pill
                            variant="neutral"
                            class="grow ${showButtons ? "" : "!hidden"}"
                            @click=${this.handleApply}
                        >
                            Apply (${searchResultsCount})
                        </wa-button>
                </div>
            </wa-drawer>
        `;
  }
  render() {
    const textStyle = TEXT_STYLES.BLACK;
    const iconWrapperClassNames = [
      "w-[38px]",
      "h-[38px]",
      "flex",
      "justify-center",
      "items-center",
      "bg-[#F5F5F5]",
      "rounded-lg",
      "p-2"
    ];
    const searchResultsCount = this.searchResultsCountSelector.value;
    return x`
            ${this.renderDrawer()}
            <sticky-element>
                <div class="${this.controlCtaClassNames.join(" ")}">
                    <div class="flex justify-between">
                        <div class="flex items-start">
                            <div
                                class="flex gap-2 items-center"
                                @click=${this.openDrawer}
                            >
                                <div class="${iconWrapperClassNames.join(" ")}">
                                    ${BriffaIcons.getFiltersIcon(
      tokens.color.black,
      "24px",
      "24px"
    )}
                                </div>
                                <p style="${textStyle} ${HEADING_STYLES$1.REGULAR}">
                                    Filter Products
                                </p>
                            </div>
                        </div>
                        <div class="mt-1 flex flex-col gap-4">
                            <sort-filter
                                .textClassNames="${["text-base"]}"
                                .sortIconSize="${{ width: "20px", height: "20px" }}"
                                popoverTarget="mobile-sort-by"
                            ></sort-filter>
                            <span style="${HEADING_STYLES$1.REGULAR}">
                                Showing ${searchResultsCount} products
                            </span>
                        </div>
                    </div>
                </div>
            </sticky-element>
        `;
  }
  attachToResults(parentContainer, resultsContainer) {
    this.parentContainer = parentContainer;
    this.resultsContainer = resultsContainer;
    parentContainer.prepend(this);
  }
  getHtmlElement() {
    return this;
  }
}
_init$9 = __decoratorStart$9(_a$9);
_drawerOpen$1 = /* @__PURE__ */ new WeakMap();
_parentContainer = /* @__PURE__ */ new WeakMap();
_resultsContainer = /* @__PURE__ */ new WeakMap();
_stickyElement$3 = /* @__PURE__ */ new WeakMap();
__decorateElement$9(_init$9, 4, "drawerOpen", _drawerOpen_dec$1, BriffaMobileSearchResultsFilters, _drawerOpen$1);
__decorateElement$9(_init$9, 4, "parentContainer", _parentContainer_dec, BriffaMobileSearchResultsFilters, _parentContainer);
__decorateElement$9(_init$9, 4, "resultsContainer", _resultsContainer_dec, BriffaMobileSearchResultsFilters, _resultsContainer);
__decorateElement$9(_init$9, 4, "stickyElement", _stickyElement_dec$3, BriffaMobileSearchResultsFilters, _stickyElement$3);
BriffaMobileSearchResultsFilters = __decorateElement$9(_init$9, 0, "BriffaMobileSearchResultsFilters", _BriffaMobileSearchResultsFilters_decorators, BriffaMobileSearchResultsFilters);
__runInitializers$9(_init$9, 1, BriffaMobileSearchResultsFilters);
const genericSearchResultsFiltersStyles = `
  :host {
    display: block;
  }

  .generic-results-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .separator {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.75rem;
  }
`;
var __create$8 = Object.create;
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __knownSymbol$8 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$8 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$8 = (target, value) => __defProp$8(target, "name", { value, configurable: true });
var __decoratorStart$8 = (base) => [, , , __create$8(base?.[__knownSymbol$8("metadata")] ?? null)];
var __decoratorStrings$8 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$8 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$8("Function expected") : fn;
var __decoratorContext$8 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$8[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$8("Already initialized") : fns.push(__expectFn$8(fn || null)) });
var __decoratorMetadata$8 = (array, target) => __defNormalProp$8(target, __knownSymbol$8("metadata"), array[3]);
var __runInitializers$8 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) fns[i4].call(self2);
  return value;
};
var __decorateElement$8 = (array, flags, name, decorators, target, extra) => {
  var it, done, ctx, k2 = flags & 7, p2 = false;
  var j2 = 0;
  var extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (target = target.prototype, k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$8(target, name));
  __name$8(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$8(k2, name, done = {}, array[3], extraInitializers);
    it = (0, decorators[i4])(target, ctx), done._ = 1;
    __expectFn$8(it) && (target = it);
  }
  return __decoratorMetadata$8(array, target), desc && __defProp$8(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var _BriffaGenericSearchResultsFilters_decorators, _init$8, _a$8;
_BriffaGenericSearchResultsFilters_decorators = [t$1("briffa-generic-search-results-filters")];
class BriffaGenericSearchResultsFilters extends (_a$8 = BaseDesignSystemComponent(
  genericSearchResultsFiltersStyles
)) {
  constructor() {
    super(...arguments);
    this.selectedGendersSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.GENDER)
    );
    this.selectedCategoriesSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.CATEGORY)
    );
    this.selectedPricesSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_VARIANT_FILTER_TYPE.PRICE)
    );
    this.selectedBrandsSelector = new MemoizedSelector(
      this,
      getSelectedFilterTagsByType(PRODUCT_GENERAL_FILTER_TYPE.BRAND)
    );
    this.selectedSizesCountSelector = new MemoizedSelector(
      this,
      getSelectedSizeFilterCount
    );
  }
  getSubtitle(count) {
    return count > 0 ? `(${count} selected)` : "";
  }
  /**
   * Called by parent components to initialize filters.
   * No longer needed with declarative rendering, but kept for API compatibility.
   */
  assignSearchResultsFiltersFactoryInstance() {
  }
  render() {
    return x`
            <div class="generic-results-content">
                <briffa-include-out-of-stock-filter></briffa-include-out-of-stock-filter>
                
                <briffa-accordion-filter
                    class="mt-2"
                    accordion-id="gender-filter-accordian"
                    visibility-key="gender-filter"
                    title="Gender"
                    .subtitle=${this.getSubtitle(this.selectedGendersSelector.value.length)}
                >
                    <briffa-gender-filter slot="body" .visible=${true}></briffa-gender-filter>
                </briffa-accordion-filter>
                
                <briffa-accordion-filter
                    accordion-id="product-type-filter-accordian"
                    visibility-key="product-type-filter"
                    title="Product Type"
                    .subtitle=${this.getSubtitle(this.selectedCategoriesSelector.value.length)}
                >
                    <briffa-product-type-filter slot="body" .visible=${true}></briffa-product-type-filter>
                </briffa-accordion-filter>
                
                <briffa-accordion-filter
                    accordion-id="size-filter-accordian"
                    visibility-key="size-filter"
                    title="Sizes"
                    .subtitle=${this.getSubtitle(this.selectedSizesCountSelector.value)}
                >
                    <briffa-size-filter slot="body"></briffa-size-filter>
                </briffa-accordion-filter>
                
                <briffa-accordion-filter
                    accordion-id="price-filter-accordian"
                    visibility-key="price-filter"
                    title="Price"
                    .subtitle=${this.getSubtitle(this.selectedPricesSelector.value.length)}
                >
                    <briffa-price-filter slot="body"></briffa-price-filter>
                </briffa-accordion-filter>
                
                <briffa-accordion-filter
                    accordion-id="brand-filter-accordian"
                    visibility-key="brand-filter"
                    title="Brands"
                    .subtitle=${this.getSubtitle(this.selectedBrandsSelector.value.length)}
                >
                    <briffa-brands-filter slot="body" .visible=${true}></briffa-brands-filter>
                </briffa-accordion-filter>
            </div>
        `;
  }
}
_init$8 = __decoratorStart$8(_a$8);
BriffaGenericSearchResultsFilters = __decorateElement$8(_init$8, 0, "BriffaGenericSearchResultsFilters", _BriffaGenericSearchResultsFilters_decorators, BriffaGenericSearchResultsFilters);
__runInitializers$8(_init$8, 1, BriffaGenericSearchResultsFilters);
class BriffaDesktopSearchResultsFilters {
  constructor() {
    this.ASIDE_FILTERS_MIN_DOCUMENT_WIDTH = 1e3;
    this.htmlNode = null;
    this.parentContainer = null;
    this.resultsContainer = null;
    this.narrowFiltersInstance = null;
    this.asideFiltersInstance = null;
    this.paginatedContainerAsideClassNames = ["flex", "gap-4"];
    this.paginatedContainerNarrowClassNames = [];
    this.narrowFiltersInstance = document.createElement(
      "briffa-desktop-narrow-filters"
    );
    this.asideFiltersInstance = document.createElement(
      "briffa-desktop-wide-filters"
    );
    this.initialize();
  }
  initialize() {
    const container = document.createElement("div");
    container.appendChild(this.narrowFiltersInstance);
    container.appendChild(this.asideFiltersInstance);
    this.htmlNode = container;
    this.initializeResizeObserver();
  }
  // Set up resize observer to determine which filters to show based on viewport width
  initializeResizeObserver() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        this.setClassNames(width);
      }
    });
    resizeObserver.observe(document.documentElement);
  }
  // Set appropriate classnames based on document width
  setClassNames(documentWidth) {
    if (documentWidth < this.ASIDE_FILTERS_MIN_DOCUMENT_WIDTH) {
      this.parentContainer.classList.remove(
        ...this.paginatedContainerAsideClassNames
      );
      this.parentContainer.classList.add(
        ...this.paginatedContainerNarrowClassNames
      );
      this.asideFiltersInstance.hide();
      this.narrowFiltersInstance.show();
      return;
    }
    this.parentContainer.classList.remove(
      ...this.paginatedContainerNarrowClassNames
    );
    this.parentContainer.classList.add(
      ...this.paginatedContainerAsideClassNames
    );
    this.asideFiltersInstance.show();
    this.narrowFiltersInstance.hide();
  }
  attachToResults(parentContainer, resultsContainer) {
    this.parentContainer = parentContainer;
    this.resultsContainer = resultsContainer;
    parentContainer.prepend(this.narrowFiltersInstance);
    parentContainer.prepend(this.asideFiltersInstance);
    resultsContainer.prepend(
      this.asideFiltersInstance.getFiltersBarElement()
    );
    this.setClassNames(document.documentElement.offsetWidth);
  }
}
const desktopNarrowFiltersStyles = safeCss(`
  :host {
    display: contents;
  }

  .narrow-filters-node {
    position: sticky;
    z-index: 10;
    padding: 1rem;
    transition-property: top;
    transition-duration: 200ms;
    background-color: white;
  }

  .narrow-filters-node-visible {
    display: block;
  }

  .narrow-filters-node-hidden {
    display: none;
  }

  .container-row {
    display: flex;
    justify-content: space-between;
  }

  .left-row {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .right-row {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .filter-cta {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 0.5rem;
    padding: 0.5rem;
  }

  .filter-title {
    color: black;
    font-size: 1.125rem;
  }

  .products-count {
    font-size: 1.125rem;
    line-height: 1.75rem;
    letter-spacing: 0.025em;
  }

  .left-sheet {
    position: fixed;
    padding: 18px;
  }

  .sheet-header {
    padding-bottom: 0.25rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
  }

  .sheet-title {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  .sheet-content {
    overflow: scroll;
  }

  .sheet-footer {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-top: 8px;
  }

  .ctas-container {
    display: flex;
    gap: 1.5rem;
    width: 100%;
  }

  .selected-filters-in-sheet {
    margin-bottom: 1rem;
  }

  .clear-cta {
    border-radius: 0.375rem;
    border: 1px solid #374151;
    color: #374151;
    padding: 0.7rem;
  }

  .clear-cta-hidden {
    display: none !important;
  }

  .clear-cta-visible {
    display: block !important;
  }

  .apply-cta {
    border-radius: 0.375rem;
    background-color: #f5f5f5;
    color: #374151;
    padding: 0.7rem;
    flex-grow: 1;
  }

  .apply-cta-hidden {
    display: none !important;
  }

  .apply-cta-visible {
    display: block !important;
  }
`);
var __create$7 = Object.create;
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __knownSymbol$7 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$7 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$7 = (target, value) => __defProp$7(target, "name", { value, configurable: true });
var __decoratorStart$7 = (base) => [, , , __create$7(base?.[__knownSymbol$7("metadata")] ?? null)];
var __decoratorStrings$7 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$7 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$7("Function expected") : fn;
var __decoratorContext$7 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$7[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$7("Already initialized") : fns.push(__expectFn$7(fn || null)) });
var __decoratorMetadata$7 = (array, target) => __defNormalProp$7(target, __knownSymbol$7("metadata"), array[3]);
var __runInitializers$7 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$7 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$7[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$7(k2 < 4 ? target : { get [name]() {
    return __privateGet$7(this, extra);
  }, set [name](x2) {
    return __privateSet$7(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$7(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$7(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$7(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$7(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$7 : __privateMethod$7)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$7(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$7(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$7("Object expected");
    else __expectFn$7(fn = it.get) && (desc.get = fn), __expectFn$7(fn = it.set) && (desc.set = fn), __expectFn$7(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$7(array, target), desc && __defProp$7(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$7 = (obj, member, msg) => member.has(obj) || __typeError$7("Cannot " + msg);
var __privateIn$7 = (member, obj) => Object(obj) !== obj ? __typeError$7('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$7 = (obj, member, getter) => (__accessCheck$7(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$7 = (obj, member, value) => member.has(obj) ? __typeError$7("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$7 = (obj, member, value, setter) => (__accessCheck$7(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$7 = (obj, member, method) => (__accessCheck$7(obj, member, "access private method"), method);
var _filtersCta_dec, _productsCountEl_dec, _narrowSortByFiltersNode_dec, _narrowFiltersNode_dec, _stickyElement_dec$2, _resultsCount_dec, _drawerOpen_dec, _visible_dec$1, _a$7, _BriffaDesktopNarrowFilters_decorators, _init$7, _visible$1, _drawerOpen, _resultsCount, _stickyElement$2, _narrowFiltersNode, _narrowSortByFiltersNode, _productsCountEl, _filtersCta;
const HEADING_STYLES = {
  XL: `color: ${tokens.color.black}; font-size: ${typography.fontSize["2xl"]};`
};
_BriffaDesktopNarrowFilters_decorators = [t$1("briffa-desktop-narrow-filters")];
class BriffaDesktopNarrowFilters extends (_a$7 = BaseDesignSystemComponent(
  desktopNarrowFiltersStyles
), _visible_dec$1 = [r$1()], _drawerOpen_dec = [r$1()], _resultsCount_dec = [r$1()], _stickyElement_dec$2 = [e$5("sticky-element")], _narrowFiltersNode_dec = [e$5(".narrow-filters-node")], _narrowSortByFiltersNode_dec = [e$5(".sort-container")], _productsCountEl_dec = [e$5(".products-count")], _filtersCta_dec = [e$5(".filter-cta")], _a$7) {
  constructor() {
    super();
    this.searchResultsCountSelector = new MemoizedSelector(
      this,
      getSearchResultsCount
    );
    this.selectedFiltersCountSelector = new MemoizedSelector(
      this,
      getSelectedFiltersCount
    );
    __privateAdd$7(this, _visible$1, __runInitializers$7(_init$7, 8, this, true)), __runInitializers$7(_init$7, 11, this);
    __privateAdd$7(this, _drawerOpen, __runInitializers$7(_init$7, 12, this, false)), __runInitializers$7(_init$7, 15, this);
    __privateAdd$7(this, _resultsCount, __runInitializers$7(_init$7, 16, this, 0)), __runInitializers$7(_init$7, 19, this);
    __privateAdd$7(this, _stickyElement$2, __runInitializers$7(_init$7, 20, this)), __runInitializers$7(_init$7, 23, this);
    __privateAdd$7(this, _narrowFiltersNode, __runInitializers$7(_init$7, 24, this)), __runInitializers$7(_init$7, 27, this);
    __privateAdd$7(this, _narrowSortByFiltersNode, __runInitializers$7(_init$7, 28, this)), __runInitializers$7(_init$7, 31, this);
    __privateAdd$7(this, _productsCountEl, __runInitializers$7(_init$7, 32, this)), __runInitializers$7(_init$7, 35, this);
    __privateAdd$7(this, _filtersCta, __runInitializers$7(_init$7, 36, this)), __runInitializers$7(_init$7, 39, this);
    this.genericSearchResultsFiltersInstance = void 0;
    this.genericSearchResultsFiltersInstance = document.createElement(
      "briffa-generic-search-results-filters"
    );
  }
  setupStickyElement() {
    if (this.stickyElement) {
      const pageHeader = document.getElementsByTagName(
        "page-header"
      )[0];
      if (pageHeader) {
        this.stickyElement.targetElement = pageHeader;
      }
    }
  }
  firstUpdated() {
    this.assignSearchResultsFiltersFactoryInstance();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (this.stickyElement && !this.stickyElement.targetElement) {
      this.setupStickyElement();
    }
  }
  setNarrowFiltersNodeTop(top, extraMargin = 0) {
    if (this.narrowFiltersNode) {
      this.narrowFiltersNode.style.top = `${top + extraMargin}px`;
    }
  }
  assignSearchResultsFiltersFactoryInstance() {
    this.genericSearchResultsFiltersInstance.assignSearchResultsFiltersFactoryInstance();
    this.initializeRestOfHtml();
  }
  initializeRestOfHtml() {
    const sortFilterElement = document.createElement("sort-filter");
    sortFilterElement.textClassNames = ["text-lg"];
    sortFilterElement.popoverTarget = "narrow-sort-by";
    if (this.narrowSortByFiltersNode) {
      this.narrowSortByFiltersNode.appendChild(sortFilterElement);
    }
  }
  openDrawer() {
    this.drawerOpen = true;
  }
  closeDrawer() {
    this.drawerOpen = false;
  }
  // Avoids closing wa-details triggering closing drawer
  handleDrawerAfterHide(e2) {
    if (e2.target === e2.currentTarget) {
      this.drawerOpen = false;
    }
  }
  handleClearAll() {
    store.dispatch(clearAllTags());
  }
  handleApply() {
    this.closeDrawer();
  }
  show() {
    this.visible = true;
    if (this.narrowFiltersNode) {
      this.narrowFiltersNode.classList.remove(
        "narrow-filters-node-hidden"
      );
      this.narrowFiltersNode.classList.add("narrow-filters-node-visible");
    }
  }
  hide() {
    this.visible = false;
    if (this.narrowFiltersNode) {
      this.narrowFiltersNode.classList.remove(
        "narrow-filters-node-visible"
      );
      this.narrowFiltersNode.classList.add("narrow-filters-node-hidden");
    }
  }
  getHtmlElement() {
    return this;
  }
  renderDrawer() {
    const selectedFiltersCount = this.selectedFiltersCountSelector.value;
    const showButtons = selectedFiltersCount > 0;
    return x` <wa-drawer
            placement="start"
            style="--size: 500px;"
            .open=${this.drawerOpen}
            @wa-after-hide=${this.handleDrawerAfterHide}
        >
            <div slot="header" class="flex justify-between items-center w-full">
                <p style="${HEADING_STYLES.XL}">Filters</p>
                <span class="cursor-pointer" @click=${this.closeDrawer}>
                    ${BriffaIcons.getXMarkIcon({
      color: tokens.color.black,
      width: "30px",
      height: "30px"
    })}
                </span>
            </div>

            <div class="overflow-scroll">
                ${this.genericSearchResultsFiltersInstance}
            </div>

            <div slot="footer" class="grow flex flex-col justify-end pt-[8px]">
                <selected-filters class="mb-4"></selected-filters>
                <div class="flex gap-6 w-full">
                    <wa-button
                        size="large"
                        variant="neutral"
                        class="!rounded-md !py-[0.7rem] ${showButtons ? "" : "!hidden"}"
                        @click=${this.handleClearAll}
                    >
                        Clear all (${selectedFiltersCount})
                    </wa-button>
                    <wa-button
                        size="large"
                        variant="neutral"
                        class="!rounded-md !py-[0.7rem] grow ${showButtons ? "" : "!hidden"}"
                        @click=${this.handleApply}
                    >
                        Apply (${this.searchResultsCountSelector.value})
                    </wa-button>
                </div>
            </div>
        </wa-drawer>`;
  }
  render() {
    const nodeVisibilityClass = this.visible ? "narrow-filters-node-visible" : "narrow-filters-node-hidden";
    return x`
            ${this.renderDrawer()}
            <sticky-element>
                <div class="narrow-filters-node z-[1] ${nodeVisibilityClass}">
                    <div class="container-row">
                        <div class="left-row">
                            <div class="filter-cta" @click=${this.openDrawer}>
                                <div class="icon-wrapper">
                                    ${BriffaIcons.getFiltersIcon(
      tokens.color.black,
      "32px",
      "32px"
    )}
                                </div>
                                <p class="filter-title">Filter Products</p>
                            </div>
                            <selected-filters></selected-filters>
                        </div>
                        <div class="right-row">
                            <div class="sort-container"></div>
                            <span class="products-count"
                                >Showing ${this.searchResultsCountSelector.value} products</span
                            >
                        </div>
                    </div>
                </div>
            </sticky-element>
        `;
  }
}
_init$7 = __decoratorStart$7(_a$7);
_visible$1 = /* @__PURE__ */ new WeakMap();
_drawerOpen = /* @__PURE__ */ new WeakMap();
_resultsCount = /* @__PURE__ */ new WeakMap();
_stickyElement$2 = /* @__PURE__ */ new WeakMap();
_narrowFiltersNode = /* @__PURE__ */ new WeakMap();
_narrowSortByFiltersNode = /* @__PURE__ */ new WeakMap();
_productsCountEl = /* @__PURE__ */ new WeakMap();
_filtersCta = /* @__PURE__ */ new WeakMap();
__decorateElement$7(_init$7, 4, "visible", _visible_dec$1, BriffaDesktopNarrowFilters, _visible$1);
__decorateElement$7(_init$7, 4, "drawerOpen", _drawerOpen_dec, BriffaDesktopNarrowFilters, _drawerOpen);
__decorateElement$7(_init$7, 4, "resultsCount", _resultsCount_dec, BriffaDesktopNarrowFilters, _resultsCount);
__decorateElement$7(_init$7, 4, "stickyElement", _stickyElement_dec$2, BriffaDesktopNarrowFilters, _stickyElement$2);
__decorateElement$7(_init$7, 4, "narrowFiltersNode", _narrowFiltersNode_dec, BriffaDesktopNarrowFilters, _narrowFiltersNode);
__decorateElement$7(_init$7, 4, "narrowSortByFiltersNode", _narrowSortByFiltersNode_dec, BriffaDesktopNarrowFilters, _narrowSortByFiltersNode);
__decorateElement$7(_init$7, 4, "productsCountEl", _productsCountEl_dec, BriffaDesktopNarrowFilters, _productsCountEl);
__decorateElement$7(_init$7, 4, "filtersCta", _filtersCta_dec, BriffaDesktopNarrowFilters, _filtersCta);
BriffaDesktopNarrowFilters = __decorateElement$7(_init$7, 0, "BriffaDesktopNarrowFilters", _BriffaDesktopNarrowFilters_decorators, BriffaDesktopNarrowFilters);
__runInitializers$7(_init$7, 1, BriffaDesktopNarrowFilters);
const desktopWideFiltersStyles = `
  :host {
    display: contents;
  }

  .filters-node {
    width: 340px;
    max-width: 340px;
    overflow-y: auto;
    transition-property: top;
    transition-duration: 200ms;
    position: sticky;
    margin-left: 24px;
  }

  .filters-node-visible {
    display: block;
  }

  .filters-node-hidden {
    display: none;
  }

  .filters-bar {
    margin-right: 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: flex-end;
  }

  .filters-bar-visible {
    display: block;
  }

  .filters-bar-hidden {
    display: none;
  }

  .results-count {
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: end;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  .selected-filters-container {
    margin-bottom: 0.5rem;
  }

  .generic-filters-container {
    padding: 0.5rem;
  }

  .generic-filters-no-padding {
    padding: 0 !important;
  }
`;
var __create$6 = Object.create;
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __knownSymbol$6 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$6 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$6 = (target, value) => __defProp$6(target, "name", { value, configurable: true });
var __decoratorStart$6 = (base) => [, , , __create$6(base?.[__knownSymbol$6("metadata")] ?? null)];
var __decoratorStrings$6 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$6 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$6("Function expected") : fn;
var __decoratorContext$6 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$6[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$6("Already initialized") : fns.push(__expectFn$6(fn || null)) });
var __decoratorMetadata$6 = (array, target) => __defNormalProp$6(target, __knownSymbol$6("metadata"), array[3]);
var __runInitializers$6 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$6 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$6[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$6(k2 < 4 ? target : { get [name]() {
    return __privateGet$6(this, extra);
  }, set [name](x2) {
    return __privateSet$6(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$6(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$6(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$6(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$6(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$6 : __privateMethod$6)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$6(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$6(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$6("Object expected");
    else __expectFn$6(fn = it.get) && (desc.get = fn), __expectFn$6(fn = it.set) && (desc.set = fn), __expectFn$6(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$6(array, target), desc && __defProp$6(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$6 = (obj, member, msg) => member.has(obj) || __typeError$6("Cannot " + msg);
var __privateIn$6 = (member, obj) => Object(obj) !== obj ? __typeError$6('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$6 = (obj, member, getter) => (__accessCheck$6(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$6 = (obj, member, value) => member.has(obj) ? __typeError$6("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$6 = (obj, member, value, setter) => (__accessCheck$6(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$6 = (obj, member, method) => (__accessCheck$6(obj, member, "access private method"), method);
var _genericFiltersContainer_dec, _stickyElement_dec$1, _selectedFilters_dec, _filtersNode_dec, _visible_dec, _a$6, _BriffaDesktopWideFilters_decorators, _init$6, _visible, _filtersNode, _selectedFilters, _stickyElement$1, _genericFiltersContainer;
const HEADING_LARGE_CLASSES = ["text-lg", `text-[${tokens.color.gray[700]}]`];
_BriffaDesktopWideFilters_decorators = [t$1("briffa-desktop-wide-filters")];
class BriffaDesktopWideFilters extends (_a$6 = BaseDesignSystemComponent(
  desktopWideFiltersStyles
), _visible_dec = [r$1()], _filtersNode_dec = [e$5(".filters-node")], _selectedFilters_dec = [e$5("selected-filters")], _stickyElement_dec$1 = [e$5("sticky-element")], _genericFiltersContainer_dec = [e$5(".generic-filters-container")], _a$6) {
  constructor() {
    super();
    this.searchResultsCountSelector = new MemoizedSelector(
      this,
      getSearchResultsCount
    );
    __privateAdd$6(this, _visible, __runInitializers$6(_init$6, 8, this, true)), __runInitializers$6(_init$6, 11, this);
    __privateAdd$6(this, _filtersNode, __runInitializers$6(_init$6, 12, this)), __runInitializers$6(_init$6, 15, this);
    this.filtersBar = void 0;
    this.resultsCountEl = void 0;
    __privateAdd$6(this, _selectedFilters, __runInitializers$6(_init$6, 16, this)), __runInitializers$6(_init$6, 19, this);
    __privateAdd$6(this, _stickyElement$1, __runInitializers$6(_init$6, 20, this)), __runInitializers$6(_init$6, 23, this);
    __privateAdd$6(this, _genericFiltersContainer, __runInitializers$6(_init$6, 24, this)), __runInitializers$6(_init$6, 27, this);
    this.genericSearchResultsFiltersInstance = void 0;
    this.genericSearchResultsFiltersInstance = document.createElement(
      "briffa-generic-search-results-filters"
    );
    this.initializeFiltersBar();
  }
  initializeFiltersBar() {
    const filtersBar = document.createElement("div");
    filtersBar.classList.add("mr-4", "mb-4", "flex", "justify-end");
    const resultsCountEl = document.createElement("p");
    resultsCountEl.innerText = "";
    resultsCountEl.classList.add("px-4", "text-end", ...HEADING_LARGE_CLASSES);
    this.resultsCountEl = resultsCountEl;
    this.filtersBar = filtersBar;
    filtersBar.appendChild(resultsCountEl);
  }
  firstUpdated() {
    this.assignSearchResultsFiltersFactoryInstance();
    this.setupStickyElement();
  }
  /**
   * Update results count display when selector value changes.
   * Called automatically by Lit when MemoizedSelector triggers update.
   */
  updated() {
    const count = this.searchResultsCountSelector.value;
    if (this.resultsCountEl) {
      this.resultsCountEl.innerText = `Showing ${count} products`;
    }
  }
  setupStickyElement() {
    if (this.stickyElement) {
      const pageHeader = document.getElementsByTagName(
        "page-header"
      )[0];
      if (pageHeader) {
        this.stickyElement.targetElement = pageHeader;
      }
    }
  }
  assignSearchResultsFiltersFactoryInstance() {
    this.genericSearchResultsFiltersInstance.assignSearchResultsFiltersFactoryInstance();
    this.initializeRestOfHtml();
  }
  initializeRestOfHtml() {
    const genericFilters = this.genericSearchResultsFiltersInstance;
    genericFilters.classList.add("generic-filters-no-padding", "p-2");
    if (this.genericFiltersContainer) {
      this.genericFiltersContainer.appendChild(genericFilters);
    }
    const sortFilterElement = document.createElement("sort-filter");
    sortFilterElement.textClassNames = ["text-lg"];
    sortFilterElement.popoverTarget = "aside-sort-by";
    if (this.filtersBar) {
      this.filtersBar.appendChild(sortFilterElement);
    }
  }
  show() {
    this.visible = true;
    if (this.filtersBar) {
      this.filtersBar.classList.remove("hidden");
      this.filtersBar.classList.add("block");
    }
  }
  hide() {
    this.visible = false;
    if (this.filtersBar) {
      this.filtersBar.classList.remove("block");
      this.filtersBar.classList.add("hidden");
    }
  }
  getHtmlElement() {
    return this.filtersNode;
  }
  getFiltersBarElement() {
    return this.filtersBar;
  }
  render() {
    const nodeVisibilityClass = this.visible ? "filters-node-visible" : "filters-node-hidden";
    return x`
            <sticky-element
                extraTopMargin="40"
                extraHeightMargin="60"
                classNames="overflow-auto"
            >
                <div class="filters-node ${nodeVisibilityClass}">
                    <selected-filters
                        class="selected-filters-container"
                    ></selected-filters>
                    <div class="generic-filters-container"></div>
                </div>
            </sticky-element>
        `;
  }
}
_init$6 = __decoratorStart$6(_a$6);
_visible = /* @__PURE__ */ new WeakMap();
_filtersNode = /* @__PURE__ */ new WeakMap();
_selectedFilters = /* @__PURE__ */ new WeakMap();
_stickyElement$1 = /* @__PURE__ */ new WeakMap();
_genericFiltersContainer = /* @__PURE__ */ new WeakMap();
__decorateElement$6(_init$6, 4, "visible", _visible_dec, BriffaDesktopWideFilters, _visible);
__decorateElement$6(_init$6, 4, "filtersNode", _filtersNode_dec, BriffaDesktopWideFilters, _filtersNode);
__decorateElement$6(_init$6, 4, "selectedFilters", _selectedFilters_dec, BriffaDesktopWideFilters, _selectedFilters);
__decorateElement$6(_init$6, 4, "stickyElement", _stickyElement_dec$1, BriffaDesktopWideFilters, _stickyElement$1);
__decorateElement$6(_init$6, 4, "genericFiltersContainer", _genericFiltersContainer_dec, BriffaDesktopWideFilters, _genericFiltersContainer);
BriffaDesktopWideFilters = __decorateElement$6(_init$6, 0, "BriffaDesktopWideFilters", _BriffaDesktopWideFilters_decorators, BriffaDesktopWideFilters);
__runInitializers$6(_init$6, 1, BriffaDesktopWideFilters);
const fetchCollectionDetails = async (collectionId) => {
  const url = `${getAPIUrl()}/collection/details/${collectionId}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Device-ID": getDeviceFingerPrint()
    }
  };
  return await fetch(url, options).then((response) => response.json()).then((collectionDetails) => {
    return collectionDetails ?? {};
  }).catch((error) => {
    console.error("Error:", error);
  });
};
const fetchCollectionProducts = async (request) => {
  const { collectionId, limit = 30, onlyInStock = false } = request;
  const url = `${getAPIUrl()}/collection/products/${collectionId}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Device-ID": getDeviceFingerPrint()
    }
  };
  const queryParams = new URLSearchParams({
    limit: limit.toString(),
    onlyInStock: onlyInStock.toString()
  });
  return await fetch(`${url}?${queryParams}`, options).then((response) => response.json()).then((collectionProducts) => {
    return collectionProducts ?? {};
  }).catch((error) => {
    console.error("Error:", error);
    throw error;
  });
};
const fetchRelatedProducts = async (productId, limit = 10) => {
  const url = `${getAPIUrl()}/products/related/${productId}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Device-ID": getDeviceFingerPrint()
    }
  };
  const queryParams = new URLSearchParams({
    limit: limit.toString()
  });
  return await fetch(`${url}?${queryParams}`, options).then((response) => response.json()).then((relatedProducts) => {
    return relatedProducts ?? { products: [] };
  }).catch((error) => {
    console.error("Error fetching related products:", error);
    throw error;
  });
};
const collectionResultsPageBannerStyles = safeCss(`
    :host {
        display: block;
    }
    h1 {
        ${typographyClasses["text-heading-1"]}
        margin-top: ${spacing["gutter-base"]};
        margin-bottom: ${spacing["gutter-sm"]};
    }
    h2 {
        ${typographyClasses["text-heading-2"]}
        margin-bottom: ${spacing["gutter-md"]};
    }
    h3 {
        ${typographyClasses["text-heading-3"]}
        margin-bottom: ${spacing["gutter-md"]};
    }
    .banner-container {
        padding: ${spacing["gutter-base"]};
        margin: 0 auto;
        max-width: ${cssVariables["page-content-max-width"]};
    }
    .banner-container.loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 60px;
    }
`);
var __create$5 = Object.create;
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __knownSymbol$5 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$5 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$5 = (target, value) => __defProp$5(target, "name", { value, configurable: true });
var __decoratorStart$5 = (base) => [, , , __create$5(base?.[__knownSymbol$5("metadata")] ?? null)];
var __decoratorStrings$5 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$5 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$5("Function expected") : fn;
var __decoratorContext$5 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$5[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$5("Already initialized") : fns.push(__expectFn$5(fn || null)) });
var __decoratorMetadata$5 = (array, target) => __defNormalProp$5(target, __knownSymbol$5("metadata"), array[3]);
var __runInitializers$5 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$5 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$5[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$5(k2 < 4 ? target : { get [name]() {
    return __privateGet$5(this, extra);
  }, set [name](x2) {
    return __privateSet$5(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$5(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$5(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$5(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$5(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$5 : __privateMethod$5)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$5(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$5(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$5("Object expected");
    else __expectFn$5(fn = it.get) && (desc.get = fn), __expectFn$5(fn = it.set) && (desc.set = fn), __expectFn$5(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$5(array, target), desc && __defProp$5(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$5 = (obj, member, msg) => member.has(obj) || __typeError$5("Cannot " + msg);
var __privateIn$5 = (member, obj) => Object(obj) !== obj ? __typeError$5('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$5 = (obj, member, getter) => (__accessCheck$5(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$5 = (obj, member, value) => member.has(obj) ? __typeError$5("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$5 = (obj, member, value, setter) => (__accessCheck$5(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$5 = (obj, member, method) => (__accessCheck$5(obj, member, "access private method"), method);
var _loading_dec, _collectionDetails_dec, _collectionId_dec$1, _a$5, _CollectionResultsPageBanner_decorators, _init$5, _collectionId$1, _collectionDetails, _loading;
_CollectionResultsPageBanner_decorators = [t$1("collection-results-page-banner")];
class CollectionResultsPageBanner extends (_a$5 = BaseDesignSystemComponent(
  collectionResultsPageBannerStyles
), _collectionId_dec$1 = [n$1({ type: String, attribute: "collection-id" })], _collectionDetails_dec = [r$1()], _loading_dec = [r$1()], _a$5) {
  constructor() {
    super(...arguments);
    __privateAdd$5(this, _collectionId$1, __runInitializers$5(_init$5, 8, this, "")), __runInitializers$5(_init$5, 11, this);
    __privateAdd$5(this, _collectionDetails, __runInitializers$5(_init$5, 12, this, null)), __runInitializers$5(_init$5, 15, this);
    __privateAdd$5(this, _loading, __runInitializers$5(_init$5, 16, this, false)), __runInitializers$5(_init$5, 19, this);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.collectionId) {
      this.loadCollectionDetails();
    }
  }
  updated(changedProperties) {
    if (changedProperties.has("collectionId") && this.collectionId) {
      this.loadCollectionDetails();
    }
  }
  async loadCollectionDetails() {
    if (!this.collectionId) return;
    this.loading = true;
    try {
      this.collectionDetails = await fetchCollectionDetails(
        Number(this.collectionId)
      );
    } catch (error) {
      console.error("Failed to load collection details:", error);
    } finally {
      this.loading = false;
    }
  }
  render() {
    if (this.loading) {
      return x`<div class="banner-container loading">
                <wa-spinner style="font-size: 1.5rem;"></wa-spinner>
            </div>`;
    }
    if (!this.collectionDetails?.descriptionHtml) {
      return x`<div class="banner-container">
                <h1>${this.collectionDetails.title}</h1>
            </div>`;
    }
    return x`
            <div class="banner-container">
                ${o$2(this.collectionDetails.descriptionHtml)}
            </div>
        `;
  }
}
_init$5 = __decoratorStart$5(_a$5);
_collectionId$1 = /* @__PURE__ */ new WeakMap();
_collectionDetails = /* @__PURE__ */ new WeakMap();
_loading = /* @__PURE__ */ new WeakMap();
__decorateElement$5(_init$5, 4, "collectionId", _collectionId_dec$1, CollectionResultsPageBanner, _collectionId$1);
__decorateElement$5(_init$5, 4, "collectionDetails", _collectionDetails_dec, CollectionResultsPageBanner, _collectionDetails);
__decorateElement$5(_init$5, 4, "loading", _loading_dec, CollectionResultsPageBanner, _loading);
CollectionResultsPageBanner = __decorateElement$5(_init$5, 0, "CollectionResultsPageBanner", _CollectionResultsPageBanner_decorators, CollectionResultsPageBanner);
__runInitializers$5(_init$5, 1, CollectionResultsPageBanner);
var __create$4 = Object.create;
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __knownSymbol$4 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$4 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$4 = (target, value) => __defProp$4(target, "name", { value, configurable: true });
var __decoratorStart$4 = (base) => [, , , __create$4(base?.[__knownSymbol$4("metadata")] ?? null)];
var __decoratorStrings$4 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$4 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$4("Function expected") : fn;
var __decoratorContext$4 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$4[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$4("Already initialized") : fns.push(__expectFn$4(fn || null)) });
var __decoratorMetadata$4 = (array, target) => __defNormalProp$4(target, __knownSymbol$4("metadata"), array[3]);
var __runInitializers$4 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$4 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$4[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$4(k2 < 4 ? target : { get [name]() {
    return __privateGet$4(this, extra);
  }, set [name](x2) {
    return __privateSet$4(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$4(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$4(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$4(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$4(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$4 : __privateMethod$4)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$4(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$4(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$4("Object expected");
    else __expectFn$4(fn = it.get) && (desc.get = fn), __expectFn$4(fn = it.set) && (desc.set = fn), __expectFn$4(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$4(array, target), desc && __defProp$4(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$4 = (obj, member, msg) => member.has(obj) || __typeError$4("Cannot " + msg);
var __privateIn$4 = (member, obj) => Object(obj) !== obj ? __typeError$4('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$4 = (obj, member, getter) => (__accessCheck$4(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$4 = (obj, member, value) => member.has(obj) ? __typeError$4("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$4 = (obj, member, value, setter) => (__accessCheck$4(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$4 = (obj, member, method) => (__accessCheck$4(obj, member, "access private method"), method);
var _searchTerm_dec, _a$4, _SearchResultsPageBanner_decorators, _init$4, _searchTerm;
_SearchResultsPageBanner_decorators = [t$1("search-results-page-banner")];
class SearchResultsPageBanner extends (_a$4 = BaseDesignSystemComponent(), _searchTerm_dec = [n$1({ type: String, attribute: "search-term" })], _a$4) {
  constructor() {
    super(...arguments);
    __privateAdd$4(this, _searchTerm, __runInitializers$4(_init$4, 8, this, "")), __runInitializers$4(_init$4, 11, this);
  }
  render() {
    return x`
            <div class="p-4">
                <h1
                    class="text-4xl font-bold text-black mt-4 mb-2 tracking-tight"
                >
                    Search results for: "${this.searchTerm}"
                </h1>
            </div>
        `;
  }
}
_init$4 = __decoratorStart$4(_a$4);
_searchTerm = /* @__PURE__ */ new WeakMap();
__decorateElement$4(_init$4, 4, "searchTerm", _searchTerm_dec, SearchResultsPageBanner, _searchTerm);
SearchResultsPageBanner = __decorateElement$4(_init$4, 0, "SearchResultsPageBanner", _SearchResultsPageBanner_decorators, SearchResultsPageBanner);
__runInitializers$4(_init$4, 1, SearchResultsPageBanner);
var __create$3 = Object.create;
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __knownSymbol$3 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$3 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$3 = (target, value) => __defProp$3(target, "name", { value, configurable: true });
var __decoratorStart$3 = (base) => [, , , __create$3(base?.[__knownSymbol$3("metadata")] ?? null)];
var __decoratorStrings$3 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$3 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$3("Function expected") : fn;
var __decoratorContext$3 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$3[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$3("Already initialized") : fns.push(__expectFn$3(fn || null)) });
var __decoratorMetadata$3 = (array, target) => __defNormalProp$3(target, __knownSymbol$3("metadata"), array[3]);
var __runInitializers$3 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$3 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$3[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$3(k2 < 4 ? target : { get [name]() {
    return __privateGet$3(this, extra);
  }, set [name](x2) {
    return __privateSet$3(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$3(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$3(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$3(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$3(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$3 : __privateMethod$3)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$3(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$3(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$3("Object expected");
    else __expectFn$3(fn = it.get) && (desc.get = fn), __expectFn$3(fn = it.set) && (desc.set = fn), __expectFn$3(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$3(array, target), desc && __defProp$3(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$3 = (obj, member, msg) => member.has(obj) || __typeError$3("Cannot " + msg);
var __privateIn$3 = (member, obj) => Object(obj) !== obj ? __typeError$3('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$3 = (obj, member, getter) => (__accessCheck$3(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$3 = (obj, member, value) => member.has(obj) ? __typeError$3("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$3 = (obj, member, value, setter) => (__accessCheck$3(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$3 = (obj, member, method) => (__accessCheck$3(obj, member, "access private method"), method);
var _stickyElement_dec, _targetElement_dec, _zIndex_dec, _extraHeightMargin_dec, _extraTopMargin_dec, _classNames_dec, _a$3, _StickyElement_decorators, _init$3, _classNames, _extraTopMargin, _extraHeightMargin, _zIndex, _targetElement, _stickyElement;
_StickyElement_decorators = [t$1("sticky-element")];
class StickyElement extends (_a$3 = BaseDesignSystemComponent(""), _classNames_dec = [n$1({ type: String })], _extraTopMargin_dec = [n$1({ type: Number })], _extraHeightMargin_dec = [n$1({ type: Number })], _zIndex_dec = [n$1({ type: Number })], _targetElement_dec = [n$1()], _stickyElement_dec = [e$5("#container")], _a$3) {
  constructor() {
    super();
    __privateAdd$3(this, _classNames, __runInitializers$3(_init$3, 8, this, "")), __runInitializers$3(_init$3, 11, this);
    __privateAdd$3(this, _extraTopMargin, __runInitializers$3(_init$3, 12, this, 0)), __runInitializers$3(_init$3, 15, this);
    __privateAdd$3(this, _extraHeightMargin, __runInitializers$3(_init$3, 16, this, 0)), __runInitializers$3(_init$3, 19, this);
    __privateAdd$3(this, _zIndex, __runInitializers$3(_init$3, 20, this, 1)), __runInitializers$3(_init$3, 23, this);
    __privateAdd$3(this, _targetElement, __runInitializers$3(_init$3, 24, this)), __runInitializers$3(_init$3, 27, this);
    __privateAdd$3(this, _stickyElement, __runInitializers$3(_init$3, 28, this)), __runInitializers$3(_init$3, 31, this);
    this.mutationObserver = void 0;
    this.resizeObserver = void 0;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated() {
    if (this.targetElement && this.stickyElement) {
      this.initialize();
    }
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("targetElement") && this.targetElement && this.stickyElement) {
      this.initialize();
    }
  }
  setStickyTop(top) {
    this.stickyElement.style.top = `${top + this.extraTopMargin}px`;
  }
  setStickyMaxHeight(targetHeight) {
    this.stickyElement.style.maxHeight = `${window.innerHeight - (targetHeight + this.extraHeightMargin)}px`;
  }
  initialize() {
    this.cleanup();
    this.mutationObserver = new MutationObserver((mutationList) => {
      mutationList.forEach(() => {
        this.setStickyTop(this.targetElement.offsetHeight);
        this.setStickyTop(this.targetElement.offsetHeight);
        this.setStickyMaxHeight(this.targetElement.offsetHeight);
      });
    });
    const config = {
      attributes: true,
      // Watch for attribute changes
      childList: true,
      // Watch for addition/removal of child elements
      subtree: true
      // Watch for changes in all descendants
    };
    this.mutationObserver.observe(this.targetElement, config);
    this.resizeObserver = new ResizeObserver(() => {
      this.setStickyTop(this.targetElement.offsetHeight);
      this.setStickyTop(this.targetElement.offsetHeight);
    });
    this.resizeObserver.observe(this.targetElement);
  }
  cleanup() {
    this.mutationObserver?.disconnect();
    this.resizeObserver?.disconnect();
  }
  render() {
    return x`<div
            id="container"
            class="sticky z-[${this.zIndex}] ${this.classNames}"
        >
            <slot></slot>
        </div>`;
  }
}
_init$3 = __decoratorStart$3(_a$3);
_classNames = /* @__PURE__ */ new WeakMap();
_extraTopMargin = /* @__PURE__ */ new WeakMap();
_extraHeightMargin = /* @__PURE__ */ new WeakMap();
_zIndex = /* @__PURE__ */ new WeakMap();
_targetElement = /* @__PURE__ */ new WeakMap();
_stickyElement = /* @__PURE__ */ new WeakMap();
__decorateElement$3(_init$3, 4, "classNames", _classNames_dec, StickyElement, _classNames);
__decorateElement$3(_init$3, 4, "extraTopMargin", _extraTopMargin_dec, StickyElement, _extraTopMargin);
__decorateElement$3(_init$3, 4, "extraHeightMargin", _extraHeightMargin_dec, StickyElement, _extraHeightMargin);
__decorateElement$3(_init$3, 4, "zIndex", _zIndex_dec, StickyElement, _zIndex);
__decorateElement$3(_init$3, 4, "targetElement", _targetElement_dec, StickyElement, _targetElement);
__decorateElement$3(_init$3, 4, "stickyElement", _stickyElement_dec, StickyElement, _stickyElement);
StickyElement = __decorateElement$3(_init$3, 0, "StickyElement", _StickyElement_decorators, StickyElement);
__runInitializers$3(_init$3, 1, StickyElement);
class ARUtils {
  constructor() {
    this.modelViewer = null;
    this.overlayBackground = null;
    this.desktopModalContainer = null;
    this.mobileHostpotContainer = null;
    this.arPromptButton = null;
    this.activeHotspotConfig = null;
    this.modelConfig = null;
    this.latestModelViewerConfig = {
      cameraTarget: "-0.7m 0 0.15m",
      cameraOrbit: "305deg 85deg 0rad",
      fieldOfView: "10deg"
    };
  }
  getFOV() {
    return this.modelViewer?.getFieldOfView() || 0;
  }
  showHotspots() {
    if (!this.modelViewer) return;
    const hotspots = this.modelViewer.querySelectorAll("button");
    hotspots.forEach((hotspot) => {
      hotspot.classList?.remove("hide");
    });
  }
  hideHotspots() {
    if (!this.modelViewer) return;
    const hotspots = this.modelViewer.querySelectorAll("button");
    hotspots.forEach((hotspot) => {
      if (hotspot.querySelector(".modal-description") == null) {
        hotspot.classList?.add("hide");
      }
    });
  }
  handleHotspotAnnotation() {
    if (!this.overlayBackground || !this.activeHotspotConfig) return;
    const viewWidth = this.overlayBackground.offsetWidth;
    if (viewWidth > parseInt(this.activeHotspotConfig.mobileViewConfig.delimiterPx)) {
      if (this.mobileHostpotContainer) {
        this.mobileHostpotContainer.style.display = "none";
        this.mobileHostpotContainer.style.opacity = "0";
      }
      if (this.desktopModalContainer) {
        this.desktopModalContainer.style.display = "block";
        setTimeout(() => {
          if (this.desktopModalContainer) {
            this.desktopModalContainer.style.opacity = "1";
          }
        }, 100);
      }
    } else {
      if (this.desktopModalContainer) {
        this.desktopModalContainer.style.display = "none";
        this.desktopModalContainer.style.opacity = "0";
      }
      if (this.mobileHostpotContainer) {
        this.mobileHostpotContainer.style.display = "flex";
        setTimeout(() => {
          if (this.mobileHostpotContainer) {
            this.mobileHostpotContainer.style.opacity = "1";
          }
        }, 100);
      }
    }
  }
  scaleIcons() {
    if (!this.modelViewer || !this.modelConfig) return;
    const baseHeightPx = 640;
    const baseFOV = this.modelConfig.baseFOV;
    const viewerHeight = this.modelViewer.clientHeight;
    const zoomOut = this.getFOV();
    let scale = baseFOV / zoomOut * (viewerHeight / baseHeightPx);
    const hotspotElements = document.querySelectorAll('[slot^="hotspot-"]');
    scale = Math.min(scale, this.modelConfig.maxScale);
    scale = Math.max(scale, this.modelConfig.minScale);
    hotspotElements.forEach((element) => {
      element.style.transform = `scale(${scale})`;
    });
  }
  initialiseUtils(modelViewer, overlayBackground, arPromptButton, productConfig) {
    this.modelViewer = modelViewer;
    this.overlayBackground = overlayBackground;
    this.arPromptButton = arPromptButton;
    this.modelConfig = productConfig;
    if (productConfig.initialConfig) {
      this.latestModelViewerConfig = productConfig.initialConfig;
    }
    modelViewer.addEventListener("camera-change", () => {
      this.scaleIcons();
    });
    window.addEventListener("resize", () => {
      if (this.activeHotspotConfig) {
        this.handleHotspotAnnotation();
        this.scaleIcons();
      }
    });
  }
  initialiseAR() {
    if (!this.modelViewer) return;
    const { cameraOrbit, cameraTarget, fieldOfView } = this.latestModelViewerConfig;
    this.modelViewer.cameraOrbit = cameraOrbit;
    this.modelViewer.cameraTarget = cameraTarget;
    this.modelViewer.fieldOfView = fieldOfView;
  }
  createMagnifierElement(magnifierConfig) {
    const element = document.createElement("div");
    element.style.setProperty("position", "absolute");
    element.style.setProperty("top", magnifierConfig.yOffset || "");
    element.style.setProperty("left", magnifierConfig.xOffset || "");
    element.style.setProperty("width", magnifierConfig.width || "");
    element.style.setProperty("height", magnifierConfig.height || "");
    element.style.setProperty(
      "background",
      magnifierConfig.background || ""
    );
    element.style.setProperty("border", magnifierConfig.border || "");
    element.style.setProperty(
      "border-radius",
      magnifierConfig.borderRadius || ""
    );
    return element;
  }
  createMobileAnnotation(hotspotConfig) {
    const container = document.createElement("div");
    container.style.justifyContent = hotspotConfig.mobileViewConfig.justifyContent;
    container.style.alignItems = hotspotConfig.mobileViewConfig.alignItems;
    container.classList.add("mobile-annotation-container");
    const wrapper = document.createElement("div");
    wrapper.style.pointerEvents = "all";
    wrapper.style.margin = hotspotConfig.mobileViewConfig.margin;
    wrapper.classList.add("mobile-annotation");
    wrapper.style.padding = "1em";
    const closeHotspotElement = document.createElement("div");
    closeHotspotElement.innerHTML = `<svg class='mobile-hotspot-close' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>`;
    const titleElement = document.createElement("p");
    titleElement.innerHTML = hotspotConfig.innerHtml;
    titleElement.classList.add("mobile-annotation-title");
    const descriptionElement = document.createElement("p");
    descriptionElement.innerHTML = hotspotConfig.innerHtmlDescription;
    descriptionElement.classList.add("mobile-annotation-description");
    wrapper.appendChild(titleElement);
    wrapper.appendChild(descriptionElement);
    wrapper.appendChild(closeHotspotElement);
    container.appendChild(wrapper);
    return container;
  }
  annotationClicked(hotspotConfig, hotspotElement) {
    if (!this.modelViewer || !this.overlayBackground || !this.arPromptButton)
      return;
    const cameraOrbit = this.modelViewer.getCameraOrbit();
    const cameraTarget = this.modelViewer.getCameraTarget();
    const fieldOfView = this.modelViewer.getFieldOfView();
    this.latestModelViewerConfig = {
      cameraOrbit: `${cameraOrbit.toString()}`,
      cameraTarget: `${cameraTarget.x}m ${cameraTarget.y}m ${cameraTarget.z}m`,
      fieldOfView: `${fieldOfView}deg`
    };
    const cloneHotspot = hotspotElement.cloneNode(true);
    hotspotElement.parentNode?.replaceChild(cloneHotspot, hotspotElement);
    const overlayContainer = document.createElement("div");
    const modalContainer = document.createElement("div");
    const titleElement = document.createElement("span");
    const backButton = document.createElement("button");
    const descriptionElement = document.createElement("p");
    const topContainer = document.createElement("div");
    overlayContainer.onclick = () => {
      this.hotspotExit(hotspotConfig, cloneHotspot, overlayContainer);
    };
    overlayContainer.classList.add("touch-overlay");
    if (hotspotConfig.overlayFocus.exists) {
      this.overlayBackground.style.background = hotspotConfig.overlayFocus.radialBackground || "";
      this.overlayBackground.style.scale = hotspotConfig.overlayFocus.scale || "";
      this.overlayBackground.style.opacity = "1";
    }
    modalContainer.classList.add("hotspot-modal");
    titleElement.innerHTML = hotspotConfig.innerHtml;
    backButton.innerHTML = "Back";
    titleElement.classList.add("modal-title");
    descriptionElement.innerHTML = hotspotConfig.innerHtmlDescription;
    descriptionElement.classList.add("modal-description");
    topContainer.appendChild(titleElement);
    topContainer.classList.add("hotspot-modal-top-container");
    modalContainer.innerHTML = `<span class="modal-close-icon" title="Close Info"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></span>`;
    modalContainer.appendChild(topContainer);
    modalContainer.appendChild(descriptionElement);
    modalContainer.style.maxWidth = hotspotConfig.desktopViewConfig.maxWidth;
    this.desktopModalContainer = modalContainer;
    const mobileHotspotContainer = this.createMobileAnnotation(hotspotConfig);
    this.mobileHostpotContainer = mobileHotspotContainer;
    const closeButton = mobileHotspotContainer.querySelector(
      ".mobile-hotspot-close"
    );
    if (closeButton) {
      closeButton.onclick = () => {
        this.hotspotExit(hotspotConfig, cloneHotspot, overlayContainer);
      };
    }
    this.modelViewer.insertBefore(
      mobileHotspotContainer,
      this.arPromptButton
    );
    this.modelViewer.insertBefore(overlayContainer, this.arPromptButton);
    cloneHotspot.classList.add("hotspot-opened");
    cloneHotspot.classList.add("hotspot-clicked");
    cloneHotspot.innerHTML = "";
    cloneHotspot.appendChild(modalContainer);
    cloneHotspot.style.transform = `translate(${hotspotConfig.cssConfig.xOffset}, ${hotspotConfig.cssConfig.yOffset})`;
    cloneHotspot.style.opacity = "1";
    modalContainer.style.opacity = "0";
    mobileHotspotContainer.style.opacity = "0";
    this.activeHotspotConfig = hotspotConfig;
    this.handleHotspotAnnotation();
    cloneHotspot.onclick = (e2) => {
      e2.stopPropagation();
    };
    const dataset = hotspotElement.dataset;
    this.modelViewer.cameraTarget = dataset.target;
    this.modelViewer.cameraOrbit = dataset.orbit;
    this.modelViewer.fieldOfView = dataset.fov;
    const backButtonElement = document.querySelector(
      ".modal-close-icon"
    );
    if (backButtonElement) {
      backButtonElement.onclick = () => {
        this.hotspotExit(hotspotConfig, cloneHotspot, overlayContainer);
      };
    }
    this.hideHotspots();
  }
  initialiseHotSpotButtonElement(hotspotConfig, hotspotElement) {
    hotspotElement.setAttribute("slot", hotspotConfig.slot);
    hotspotElement.setAttribute(
      "data-position",
      hotspotConfig.dataPosition
    );
    hotspotElement.setAttribute("data-normal", hotspotConfig.dataNormal);
    hotspotElement.setAttribute(
      "data-visibility-attribute",
      hotspotConfig.dataVisibilityAttribute
    );
    hotspotElement.setAttribute("data-orbit", hotspotConfig.dataOrbit);
    hotspotElement.setAttribute("data-target", hotspotConfig.dataTarget);
    hotspotElement.setAttribute("data-fov", hotspotConfig.dataFOV);
    hotspotElement.setAttribute("data-name", hotspotConfig.dataFOV);
    hotspotElement.innerHTML = `<span class="hotspot-text">${hotspotConfig.innerHtml}</span>` + hotspotConfig.hotspotIconSVG;
    hotspotElement.classList.add("hotspot");
    hotspotElement.addEventListener("click", () => {
      this.annotationClicked(hotspotConfig, hotspotElement);
    });
    hotspotElement.style.transform = "";
    hotspotElement.style.opacity = "0.25";
    if (this.modelConfig?.persistHotspots === false) {
      hotspotElement.classList.add("hotspot-non-persist");
    }
  }
  zoomOut() {
    if (!this.modelViewer) return;
    const { cameraOrbit, cameraTarget, fieldOfView } = this.latestModelViewerConfig;
    this.modelViewer.cameraTarget = cameraTarget;
    this.modelViewer.cameraOrbit = cameraOrbit;
    this.modelViewer.fieldOfView = fieldOfView;
  }
  hotspotExit(hotspotConfig, hotspotElement, overlayContainer) {
    if (!this.modelViewer || !this.overlayBackground) return;
    const cloneHotspot = hotspotElement.cloneNode(true);
    hotspotElement.parentNode?.replaceChild(cloneHotspot, hotspotElement);
    overlayContainer.remove();
    this.overlayBackground.style.opacity = "0";
    this.overlayBackground.style.background = "";
    this.overlayBackground.style.scale = "";
    if (this.mobileHostpotContainer) {
      this.modelViewer.removeChild(this.mobileHostpotContainer);
    }
    this.mobileHostpotContainer = null;
    this.desktopModalContainer = null;
    this.activeHotspotConfig = null;
    cloneHotspot.classList.remove("hotspot-opened");
    cloneHotspot.classList.remove("hotspot-clicked");
    cloneHotspot.style.transform = "";
    cloneHotspot.style.padding = "";
    cloneHotspot.style.borderRadius = "";
    cloneHotspot.style.background = "";
    cloneHotspot.style.pointerEvents = "";
    this.initialiseHotSpotButtonElement(hotspotConfig, cloneHotspot);
    this.showHotspots();
    this.zoomOut();
  }
}
const arUtils = new ARUtils();
const arConfigs = {
  "lismore-600xl-package": {
    modelSrc: "https://assets.v2.londondynamics.com/13a0b669-d2fe-4de8-82f3-9c512f769ba1/puzzle/63585808-ed7a-5d58-32e4-958c66600bb5.glb",
    baseFOV: 12,
    minScale: 0.2,
    maxScale: 2,
    maxFOV: "20deg",
    persistHotspots: false,
    initialConfig: {
      cameraTarget: "-2m 0 -1m",
      cameraOrbit: "240deg 85deg 0rad",
      fieldOfView: "15deg"
    },
    arHotspots: {
      "hotspot-1": {
        slot: "hotspot-1",
        dataPosition: "-2.193887101609819m 2.178831778596749m -0.00849393430707736m",
        dataNormal: "-0.7326103971829181m 0.6802613552436657m -0.022945467995624927m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "270deg 80deg 0m",
        dataTarget: "-2m 0.65m -0m",
        dataFOV: "13deg",
        innerHtml: "Front Awning",
        innerHtmlDescription: "Pre-Attached Front Awning: Provides extra enclosed space perfect for socialising, dining or storage",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H464 435.8c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V480c0 17.7-14.3 32-32 32H240 32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-2": {
        slot: "hotspot-2",
        dataPosition: "-2.62529039563603m 0.7596909923661881m -0.004190435608279822m",
        dataNormal: "-0.9156879935559757m 0.4018880598973189m -0.0012189214087764569m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "270deg 90deg 0m",
        dataTarget: "-2m 0.8m -0m",
        dataFOV: "12deg",
        innerHtml: "Drop Down Doors",
        innerHtmlDescription: "Drop Down Doors: Easily enter and exit your tent, perfect for pram and wheelchair access",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-3": {
        slot: "hotspot-3",
        dataPosition: "0.7768379475188248m 0.014205212375136462m -1.8336862655412596m",
        dataNormal: "1.1993109287272508e-7m -0.4431768089219528m -0.8964342229264458m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "119deg 94deg 0m",
        dataTarget: "-2.3m 0.3m 0.1m",
        dataFOV: "7deg",
        innerHtml: "Sewn-in Groundsheet",
        innerHtmlDescription: "Sewn-In Groundsheet: Adds to the comfort of your tent by providing a bug an draught free environment.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-4": {
        slot: "hotspot-4",
        dataPosition: "-1.698886127249755m 1.070190183477821m -1.5784291780762714m",
        dataNormal: "0.022486021393280306m 0.2892751674007408m -0.9569818474595922m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "153deg 75deg 0m",
        dataTarget: "-1.3m 0.45m -0m",
        dataFOV: "12deg",
        innerHtml: "Diamond Clear Windows",
        innerHtmlDescription: "Maximises light and provides a bright and airy environment.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-5": {
        slot: "hotspot-5",
        dataPosition: "-1.1024044714890513m 1.141039742739935m 0.0713426670037991m",
        dataNormal: "-0.9999999999999833m -1.7451814628782577e-7m -5.688477287951794e-8m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "260deg 140deg 0m",
        dataTarget: "-1.3m 0.5m -0m",
        dataFOV: "13deg",
        innerHtml: "Mesh Inner Doors",
        innerHtmlDescription: "Living room door has an integrated mesh panel that increases air flow while keeping bugs out.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-6": {
        slot: "hotspot-6",
        dataPosition: "-2.4783486263372585m 0.1980632158524217m 1.750329932534433m",
        dataNormal: "-0.506719125007106m 0.20771547667146603m 0.836713815532634m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "340deg 80deg 0m",
        dataTarget: "-1.9m -0.18m 0m",
        dataFOV: "3deg",
        innerHtml: "Sentinel Fabric",
        innerHtmlDescription: "Strong and durable fabric, incorporating ColourLok Eco™ for superior longevity, with 3,000mm HH.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-7": {
        slot: "hotspot-7",
        dataPosition: "2.1077119428400736m 1.2323304534172388m -1.5336798113201193m",
        dataNormal: "0.024105708164940752m 0.32409686199305443m -0.9457167328963373m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "210deg 80deg 0m",
        dataTarget: "2.8m 0.45m -0m",
        dataFOV: "16deg",
        innerHtml: "King Sized Bedrooms",
        innerHtmlDescription: "Offers a 70cm sleeping area per person (4 persons) to ensure you have plenty of space.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-8": {
        slot: "hotspot-8",
        dataPosition: "1.6077119428400736m 1.2323304534172388m -0.5336798113201193m",
        dataNormal: "0.024105708164940752m 0.32409686199305443m -0.9457167328963373m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "210deg 80deg 0m",
        dataTarget: "2m 0.55m -1m",
        dataFOV: "16deg",
        innerHtml: "Lights-Out Bedrooms",
        innerHtmlDescription: "Reduces sunlight affecting your sleeping pattern so you can have a comfortable night sleep.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-9": {
        slot: "hotspot-9",
        dataPosition: "-0.2029039563603m 0.9596909923661881m -0.3m",
        dataNormal: "0.9156879935559757m 0.4018880598973189m -0.0012189214087764569m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "170deg 80deg 0m",
        dataTarget: "0.1m 0.6m -0m",
        dataFOV: "13deg",
        innerHtml: "Extended Living Area",
        innerHtmlDescription: "Provides plenty of space to relax and unwind.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-10": {
        slot: "hotspot-10",
        dataPosition: "-0.6345222585324024m 0.33176042168267317m -1.8211133264551358m",
        dataNormal: "-0.09252381999930961m 0.4878784813502933m -0.8679941993861865m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "255deg 85deg 0m",
        dataTarget: "4.5m -0.19m -0.45m",
        dataFOV: "6deg",
        innerHtml: "AirZone Panel",
        innerHtmlDescription: "High and low level ventilation panels combine to create a comfortable flow of air through the tent.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      }
    },
    base64QRCode: "data:image/png;base64,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"
  },
  "mokala-450": {
    modelSrc: "no_src",
    baseFOV: 12,
    minScale: 0.2,
    maxScale: 2,
    maxFOV: "20deg",
    persistHotspots: false,
    initialConfig: {
      cameraTarget: "0.3m 0 0m",
      cameraOrbit: "330deg 85deg 0rad",
      fieldOfView: "16deg"
    },
    arHotspots: {
      "hotspot-1": {
        slot: "hotspot-1",
        dataPosition: "0.015597622150057368m 0.9826349754685773m 1.9817630138438478m",
        dataNormal: "0.005520808168257211m 0.5441833711944353m 0.8389481385596065m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "00deg 80deg 0m",
        dataTarget: "0m 0.45m -0m",
        dataFOV: "15deg",
        innerHtml: "Front Door",
        innerHtmlDescription: "Multi-Function Front Door: Can be opened from either side or poled up to form a sun shade.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-2": {
        slot: "hotspot-2",
        dataPosition: "-1.2718008760934862m 0.8360076559313945m -0.6714883331632748m",
        dataNormal: "-0.9506528305473424m 0.3102529071618116m -0.0015262273651564357m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "300deg 80deg 0m",
        dataTarget: "1m 0.25m -1.75m",
        dataFOV: "20deg",
        innerHtml: "King Sized Bedrooms",
        innerHtmlDescription: "Offers a 70cm sleeping area per person (4 persons) to ensure you have plenty of space.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-3": {
        slot: "hotspot-3",
        dataPosition: "-0.7427649755912979m 1.2346100426545292m 0.32345482847680396m",
        dataNormal: "-0.9280885137459011m 0.3718509176247273m -0.01945779315782763m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "310deg 80deg 0m",
        dataTarget: "1m 0.25m -1.75m",
        dataFOV: "20deg",
        innerHtml: "Lights-Out Bedrooms",
        innerHtmlDescription: "Reduces sunlight affecting your sleeping pattern so you can have a comfortable night sleep.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-4": {
        slot: "hotspot-4",
        dataPosition: "1.1344744456906317m 0.2817915742369775m 1.927542132604232m",
        dataNormal: "0.8271011795484722m 0.1959047415098844m 0.5268063885750355m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "55deg 75deg 0m",
        dataTarget: "-4.2m -1.61m -1.75m",
        dataFOV: "8deg",
        innerHtml: "Sentinel",
        innerHtmlDescription: "Strong and durable fabric, incorporating ColourLok Eco™ for superior longevity, with 3,000mm HH.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-5": {
        slot: "hotspot-5",
        dataPosition: "1.4211340520213425m 0.004976726555725897m 1.557553588344681m",
        dataNormal: "0.860909742244649m 0.13944884040323893m 0.4892733761594269m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "55deg 110deg 0m",
        dataTarget: "-3.5m 2.1m -1.75m",
        dataFOV: "15deg",
        innerHtml: "Groundsheet",
        innerHtmlDescription: "Waterproof PE Groundsheet: Robust and hardwearing fabric to stand up to the rigours of most active campers.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-6": {
        slot: "hotspot-6",
        dataPosition: "1.0499685090541357m 0.9032260632375257m 1.679417999365456m",
        dataNormal: "0.670733243080561m 0.36504167403456m 0.6456481184396645m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "55deg 80deg 0m",
        dataTarget: "-3.9m -0.2m -1.75m",
        dataFOV: "16deg",
        innerHtml: "Windows",
        innerHtmlDescription: "Diamond Clear Windows: Maximises light and provides a bright and airy environment.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-7": {
        slot: "hotspot-7",
        dataPosition: "0.2499685090541357m 1.4032260632375257m 0.209417999365456m",
        dataNormal: "0.670733243080561m 0.36504167403456m 0.6456481184396645m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "50deg 95deg 0m",
        dataTarget: "-2m 1.3m -1.75m",
        dataFOV: "12deg",
        innerHtml: "TBS®II System",
        innerHtmlDescription: "TBS®II Tension Band System: Removable tension bands brace the structure at 3 points to increase stability in harsh weather.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-8": {
        slot: "hotspot-8",
        dataPosition: "1.2360748235555035m 0.9815069860217842m 0.351631414914231m",
        dataNormal: "0.9457517968381449m 0.323611137501089m -0.028798792729412184m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "70deg 80deg 0m",
        dataTarget: "-5m -0.1m -1.75m",
        dataFOV: "20deg",
        innerHtml: "Powerflex® Poles",
        innerHtmlDescription: "Strong, lightweight and durable fibreglass poles.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      }
    },
    base64QRCode: "data:image/png;base64,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"
  },
  "lismore-450-package": {
    modelSrc: "https://assets.v2.londondynamics.com/13a0b669-d2fe-4de8-82f3-9c512f769ba1/puzzle/17b23842-0b06-11b7-8a1e-f926792760a1.glb",
    baseFOV: 12,
    minScale: 0.2,
    maxScale: 2,
    maxFOV: "17deg",
    persistHotspots: false,
    initialConfig: {
      cameraTarget: "-2m 0 -1m",
      cameraOrbit: "240deg 85deg 0rad",
      fieldOfView: "15deg"
    },
    arHotspots: {
      "hotspot-1": {
        slot: "hotspot-1",
        dataPosition: "-2.093887101609819m 2.078831778596749m -0.00849393430707736m",
        dataNormal: "-0.7326103971829181m 0.6802613552436657m -0.022945467995624927m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "270deg 80deg 0m",
        dataTarget: "-2m 0.65m -0m",
        dataFOV: "13deg",
        innerHtml: "Front Awning",
        innerHtmlDescription: "Pre-Attached Front Awning: Provides extra enclosed space perfect for socialising, dining or storage",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H464 435.8c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V480c0 17.7-14.3 32-32 32H240 32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-2": {
        slot: "hotspot-2",
        dataPosition: "-2.62529039563603m 0.7596909923661881m -0.004190435608279822m",
        dataNormal: "-0.9156879935559757m 0.4018880598973189m -0.0012189214087764569m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "270deg 90deg 0m",
        dataTarget: "-2m 0.8m -0m",
        dataFOV: "12deg",
        innerHtml: "Drop Down Doors",
        innerHtmlDescription: "Drop Down Doors: Easily enter and exit your tent, perfect for pram and wheelchair access",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-3": {
        slot: "hotspot-3",
        dataPosition: "-0.0035665636811968m 0.03654637601115951m -1.484924170392091m",
        dataNormal: "-1.3699956104518592e-7m 0.533823138957462m -0.8455961543867047m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "119deg 94deg 0m",
        dataTarget: "-2.7m 0.2m -0m",
        dataFOV: "7deg",
        innerHtml: "Sewn-in Groundsheet",
        innerHtmlDescription: "Sewn-In Groundsheet: Adds to the comfort of your tent by providing a bug an draught free environment.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-4": {
        slot: "hotspot-4",
        dataPosition: "-1.540523099169173m 1.1630070549183695m -1.2738135324080793m",
        dataNormal: "0.021655990240154487m 0.25019154648735314m -0.9679541353561051m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "153deg 75deg 0m",
        dataTarget: "-2.1m 0.45m -0m",
        dataFOV: "12deg",
        innerHtml: "Diamond Clear Windows",
        innerHtmlDescription: "Maximises light and provides a bright and airy environment.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-5": {
        slot: "hotspot-5",
        dataPosition: "-1.0782331135512688m 1.0751174839756157m 0.1174220270032053m",
        dataNormal: "-0.999999999999966m -2.1999997969824903e-7m -1.3999999899769856e-7m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "260deg 140deg 0m",
        dataTarget: "-1.3m 0.5m -0m",
        dataFOV: "13deg",
        innerHtml: "Mesh Inner Doors",
        innerHtmlDescription: "Living room door has an integrated mesh panel that increases air flow while keeping bugs out.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-6": {
        slot: "hotspot-6",
        dataPosition: "-2.264374826025078m 0.20237779145593915m 1.426276709838179m",
        dataNormal: "-0.3070065432510621m 0.15995388820022485m 0.9381693536087522m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "360deg 80deg 0m",
        dataTarget: "-2.5m -0.1m -0m",
        dataFOV: "3deg",
        innerHtml: "Sentinel Fabric",
        innerHtmlDescription: "Strong and durable fabric, incorporating ColourLok Eco™ for superior longevity, with 3,000mm HH.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-7": {
        slot: "hotspot-7",
        dataPosition: "1.3456818997891762m 1.0444088023985731m -1.3096145537743973m",
        dataNormal: "0.013689972872947138m 0.2433104065828331m -0.9698518601782619m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "210deg 80deg 0m",
        dataTarget: "1.9m 0.45m -0m",
        dataFOV: "19deg",
        innerHtml: "King Sized Bedrooms",
        innerHtmlDescription: "Offers a 70cm sleeping area per person (4 persons) to ensure you have plenty of space.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-8": {
        slot: "hotspot-8",
        dataPosition: "0.7378375267532096m 1.3181446466824017m -0.2056202558202825m",
        dataNormal: "-0.5676939282519936m 0.21863360370381224m -0.7936768556265862m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "210deg 80deg 0m",
        dataTarget: "1m 0.45m -0m",
        dataFOV: "17deg",
        innerHtml: "Lights-Out Bedrooms",
        innerHtmlDescription: "Reduces sunlight affecting your sleeping pattern so you can have a comfortable night sleep.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-9": {
        slot: "hotspot-9",
        dataPosition: "-0.14266658089302153m 1.1363242549697543m -1.2808806251531697m",
        dataNormal: "0.011785335224851912m 0.25023285266745454m -0.9681139526520347m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "170deg 75deg 0m",
        dataTarget: "-0.6m 0.6m -0m",
        dataFOV: "14deg",
        innerHtml: "Extended Living Area",
        innerHtmlDescription: "Provides plenty of space to relax and unwind.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-10": {
        slot: "hotspot-10",
        dataPosition: "-0.6423657005399441m 0.39069989064729094m -1.4579255284438493m",
        dataNormal: "0.02477998805287655m 0.30655843451890147m -0.9515292315096894m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "255deg 85deg 0m",
        dataTarget: "3.5m -0.05m -0.45m",
        dataFOV: "6deg",
        innerHtml: "AirZone Panel",
        innerHtmlDescription: "High and low level ventilation panels combine to create a comfortable flow of air through the tent.",
        desktopViewConfig: {
          maxWidth: "26em"
        },
        mobileViewConfig: {
          delimiterPx: "1000000",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "22rem"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      }
    },
    base64QRCode: "data:image/png;base64,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"
  },
  "soul-100": {
    modelSrc: "https://assets.v2.londondynamics.com/13a0b669-d2fe-4de8-82f3-9c512f769ba1/puzzle/3e378266-8916-b4d1-e90a-343ecfad3fc3.glb",
    baseFOV: 10,
    minScale: 0.2,
    maxScale: 2,
    maxFOV: "15deg",
    initialConfig: {
      cameraTarget: "-0.7m 0 0m",
      cameraOrbit: "305deg 85deg 0rad",
      fieldOfView: "10deg"
    },
    arHotspots: {
      "hotspot-1": {
        slot: "hotspot-1",
        dataPosition: "-0.3161463979815467m 0.7460759757535452m 0.0037166300460488577m",
        dataNormal: "0.634590543520234m -0.4175531434984682m 0.6503416136379722m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "23deg 110deg 0m",
        dataTarget: "-0.8m 1.05m -1m",
        dataFOV: "8deg",
        innerHtml: "Ventilation",
        innerHtmlDescription: "Additional Ventilation: Increases air flow throughout the tent and helps to reduce the possibility of condensation",
        desktopViewConfig: {
          maxWidth: "21em"
        },
        mobileViewConfig: {
          delimiterPx: "900",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"/></svg>`,
        cssConfig: {
          xOffset: "-15.5em",
          yOffset: "-4em"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-2": {
        slot: "hotspot-2",
        dataPosition: "0.4161463979815467m 0.05m 0.3037166300460488577m",
        dataNormal: "0.9483847964907902m 0.14633467801734276m 0.2813404339846715m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "74deg 82deg 0m",
        dataTarget: "-0.5m -0.01m -0m",
        dataFOV: "6deg",
        innerHtml: "Protex® Fabric",
        innerHtmlDescription: "<ul style='margin-bottom: 0;'><li>Fire Retardant Fabrics: Exceeds European EN5912 safety standard</li><li>Fully Wind and Rain tested: Weather tested to standard EN ISO 5912 for peace of mind.</li></ul>",
        desktopViewConfig: {
          maxWidth: "35em"
        },
        mobileViewConfig: {
          delimiterPx: "700",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg style="width: 1rem;" class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"/></svg>`,
        cssConfig: {
          xOffset: "5em",
          yOffset: "3em"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-3": {
        slot: "hotspot-3",
        dataPosition: "-0.019030140459424943m 0.39818589397110604m 0.28137476527784067m",
        dataNormal: "-0.0027431478811925634m 0.4847748875074658m 0.8746346572036955m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "0deg 70deg 0m",
        dataTarget: "0m 0.8 -0m",
        dataFOV: "6deg",
        innerHtml: "Bedroom",
        innerHtmlDescription: "<p style='text-align: center; margin-bottom: 0;'>Lights-Out Bedroom: Helps reduce early morning light so your sleeping pattern doesn't need to be dictated by the sunrise</p>",
        desktopViewConfig: {
          maxWidth: "28em"
        },
        mobileViewConfig: {
          delimiterPx: "700",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg style="width: 1rem;" class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"/></svg>`,
        cssConfig: {
          xOffset: "5em",
          yOffset: "3em"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-4": {
        slot: "hotspot-4",
        dataPosition: "-0.497124015905746m 0.09747282670169449m 0.0021467619896190504m",
        dataNormal: "-0.9673933205241385m 0.04196490656703834m 0.2497781215841397m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "-70deg 90deg 0m",
        dataTarget: "0m 0.05m -0.18m",
        dataFOV: "5deg",
        innerHtml: "Fibreglass Poles",
        innerHtmlDescription: "<p style='text-align: center; margin-bottom: 0;'>Vango PowerFlex® Fibreglass Poles. Create strong, light and reliable structures</p>",
        desktopViewConfig: {
          maxWidth: "22em"
        },
        mobileViewConfig: {
          delimiterPx: "900",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg style="width: 1rem;" class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"/></svg>`,
        cssConfig: {
          xOffset: "5em",
          yOffset: "15em"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      },
      "hotspot-5": {
        slot: "hotspot-5",
        dataPosition: "0.7144103686878998m 0.10790918610372537m 0.5241386455764765m",
        dataNormal: "0.5830386531323208m 0.43617339436856456m 0.6854332199409757m",
        dataVisibilityAttribute: "visible",
        dataOrbit: "10deg 70deg 0m",
        dataTarget: "0.55m -0.05m -0m",
        dataFOV: "7deg",
        innerHtml: "Guylines",
        innerHtmlDescription: "<p style='text-align: center; margin-bottom: 0;'>High Visibility Guylines: Easy to see in low light conditions</p>",
        desktopViewConfig: {
          maxWidth: "28em"
        },
        mobileViewConfig: {
          delimiterPx: "800",
          margin: "0 1em 1em",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "90%"
        },
        hotspotIconSVG: `<svg style="width: 1rem;" class="hotspot-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>`,
        cssConfig: {
          xOffset: "-15em",
          yOffset: "6em"
        },
        magnifierConfig: {
          exists: false,
          // relative to bottom right of the modal
          xOffset: "55%",
          yOffset: "90%",
          width: "15em",
          height: "15em",
          background: "transparent",
          borderRadius: "12px",
          border: "15px solid #ffffff50"
        },
        overlayFocus: {
          exists: true,
          scale: "1.1",
          // So background overlay would be bigger than canvas
          radialBackground: "radial-gradient(circle at 50% center, transparent, #ffffff10 70%, #ffffff50 100%"
        }
      }
    },
    base64QRCode: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAAXNSR0IArs4c6QAAIABJREFUeF7tndt2HbeSbK3//2ifwePtlklbnLMqo1JYZPQrgLhlApVa0nb/+PPPP//8o//XBJpAE2gCTaAJfKsEfnQA+Fb1rtkm0ASaQBNoAv8/gQ4AbYQm0ASaQBNoAt8wgQ4A37DotdwEmkATaAJNoANAe6AJNIEm0ASawDdMoAPANyx6LTeBJtAEmkAT6ADQHmgCTaAJNIEm8A0T6ADwDYtey02gCTSBJtAEOgC0B5pAE2gCTaAJfMMEOgB8w6LXchNoAk2gCTSBDgDtgSbQBJpAE2gC3zCBDgDfsOi13ASaQBNoAk2gA0B7oAk0gSbQBJrAN0ygA8A3LHotN4Em0ASaQBPoANAeaAJNoAk0gSbwDRPoAPANi17LTaAJNIEm0AQ6ALQHmkATaAJNoAl8wwQiA8CPHz++TXR//vnn2GsiL9KR4CCjpIHOm/UNH286yMuGDtJg8krsmXpN+DAaiIcw6Hwiyy2MhNcpBp03WSRqktBhtJ6wZ5pXB4CLVZwG/kaXaFDSkeCgaEgDnTfrGz46ALyvxDTzRF8YDcRDGHTe9OcpexJepxh03mSVqElCh9F6wp5pXh0ALlZxGngHgGuBb11mquuGDtJwLbn7u6deEz6MBuIhDDp/P8H9kwmvUww6b1JJ1CShw2g9Yc80rw4AF6s4DbwDwLXAty4z1XVDB2m4ltz93VOvCR9GA/EQBp2/n+D+yYTXKQadN6kkapLQYbSesGeaVweAi1WcBt4B4FrgW5eZ6rqhgzRcS+7+7qnXhA+jgXgIg87fT3D/ZMLrFIPOm1QSNUnoMFpP2DPNqwPAxSpOA+8AcC3wrctMdd3QQRquJXd/99RrwofRQDyEQefvJ7h/MuF1ikHnTSqJmiR0GK0n7Jnm1QHgYhWngXcAuBb41mWmum7oIA3Xkru/e+o14cNoIB7CoPP3E9w/mfA6xaDzJpVETRI6jNYT9kzz6gBwsYrTwDsAXAt86zJTXTd0kIZryd3fPfWa8GE0EA9h0Pn7Ce6fTHidYtB5k0qiJgkdRusJe6Z5dQC4WMVp4B0ArgW+dZmprhs6SMO15O7vnnpN+DAaiIcw6Pz9BPdPJrxOMei8SSVRk4QOo/WEPdO81gaAqdCtsKl5Ej4SHFMMOm/yTmRheDb2UB7klc5veHjjIJ1GB3khDjpvdBoM8pLQOeUwA39C5wkYpCGRBdVji8PomO4xd8Bk/pmODgAf0qHQp4GnGnSqk86b5k1kYXg29lAe5JXOb3gwH1ajg7wkskhgkJcTOBL3neph6r6BQXknsqCab3EYHdM9iZqRhg4AHQCoR365bi78bfDlg3TZyCud37JDOo0O8kIcdD71wSIvCZ1TjsQHaSvPaV50PpEF1WOLw+iY7knUnTR0AOgAQD3SAUD8tG4u6+2gLxw0jzDBkRfioPMdAN5X4JQ8pzro/NbHmfrP6KQ7srFOPsw9Ip0dADoAUI90AOgA8K4H6AFNPFwGgxo3oXPKkfjomSwSXqcYdD6RBdVji8PomO5J1J00dADoAEA90gGgA0AHgF/cgo2PXuJDsIGxkYV5rMir0Wl4nt5DPvoLwAMVoNATzZPgmGLQeRNtIgvDs7GH8iCvdH7DQ+JBSPwJymSxkecJHK+U5zQvOp/Iwtwj6j+j0/A8vYd8JO57fwHoLwC3+/hVLpIxSJeNvNJ5oyGxh3QaDvJCHHTePFwGg7wkdE45Eh89k0XC6xSDzieyoHpscRgd0z2JupOGYwYAY5bM0PpGgxofpGMDgzRsXSTyeopO6i3yQefNR9FgbOggDlMz42W65zvpJK/TLLfOJ3qHsjAchJHIg3QYDYRBOjsAhH8BSBRtA8M0DukwGNiAP358usVwbOic+qDzHQBMQtf2nNAXRnFCJ2EYHSfsMfeddFIWhoMwSINZJx1GA2GQjg4AHQB+2SPUgNPmS/3KsKETLxIMMnS+A4BJ6NqeE/rCKE7oJAyj44Q9r/KmJLIir6amhEE6OwB0AOgAQLdErJvLSjDTy2wGKtJgBhHymvBhdNKe76STvFJWp6wneoeyMByEkciLdBgNhEE6OwB0AOgAQLdErJvLSjDTy9wB4H3CVJNE3lRTs57QSRhGxwl7EjWhLAwHYSSyIh1GA2GQzg4AHQA6ANAtEevmshLM9DJ3AOgAQD12+vrGHTAciftMWZMOo4EwSEMHgA4AHQDoloh1c1kJZnqZOwB0AKAeO3194w4YjsR9pqxJh9FAGKShA0AHgA4AdEvEurmsBDO9zB0AOgBQj52+vnEHDEfiPlPWpMNoIAzS0AHgNwwAVJRpUQn/pHVqcpNFAmOaCWl4wycvBoN0EgedN0MEcSR8GJ2kgzCMTuIwGKRjg4M0JPqTfCR6y/igmiR0Gh20h3SQD1Mz0tABoAMA9cij69TkdEm2HhUKgXyYy2owSIfJizBIB3HQeeK366SDcIxO4jAYpGODgzQk+pN8bN1VqklCp8mT9pAO8mFqRho6AHQAoB55dJ2anC7J1qNCIZAPc1kNBukweREG6SAOOk/8dp10EI7RSRwGg3RscJCGRH+Sj627SjVJ6DR50h7SQT5MzUhDB4AOANQjj65Tk9Ml2XpUKATyYS6rwSAdJi/CIB3EQeeJ366TDsIxOonDYJCODQ7SkOhP8rF1V6kmCZ0mT9pDOsiHqRlp6ADQAYB65NF1anK6JFuPCoVAPsxlNRikw+RFGKSDOOg88dt10kE4RidxGAzSscFBGhL9ST627irVJKHT5El7SAf5MDUjDR0AOgBQjzy6Tk1Ol2TrUaEQyIe5rAaDdJi8CIN0EAedJ367TjoIx+gkDoNBOjY4SEOiP8nH1l2lmiR0mjxpD+kgH6ZmpKEDQAcA6pFH16nJ6ZJsPSoUAvkwl9VgkA6TF2GQDuKg88Rv10kH4RidxGEwSMcGB2lI9Cf52LqrVJOETpMn7SEd5MPUjDR0AOgAQD3y6Do1OV2SrUeFQiAf5rIaDNJh8iIM0kEcdJ747TrpIByjkzgMBunY4CANif4kH1t3lWqS0GnypD2kg3yYmpGGDgAdAKhHHl2nJqdLsvWoUAjkw1xWg0E6TF6EQTqIg84Tv10nHYRjdBKHwSAdGxykIdGf5GPrrlJNEjpNnrSHdJAPUzPS0AHgwAGAimbWqbkMBu1JNChhbPgwDxNlYXQmvBIG6dxY38qCvCSyMl5Ix8Z6wivpTGRBOk/hIJ2UlVknr0YDYZCODgAdAKhHfrmeaFDCmDa4NUc6CMfoJI4EBuncWE/4MBjkhfKm84k/YRmOxJ6EV9KxUZNTOE7I02iY5tUBoAMA3fsOACIhcxHpQicwhNTHtyR8GAwyQnnT+Q4A7xPaqMkpHIneof4ir0YDYZCGDgAdAKhHOgCIhMxFpAudwBBSH9+S8GEwyAjlTec7AHQAMD1ydw/1uOlfwiBtHQA6AFCPdAAQCZmLSBc6gSGkPr4l4cNgkBHKm853AOgAYHrk7h7qcdO/hEHaOgB0AKAe6QAgEjIXkS50AkNIfXxLwofBICOUN53vANABwPTI3T3U46Z/CYO0dQDoAEA90gFAJGQuIl3oBIaQ+viWhA+DQUYobzrfAaADgOmRu3uox03/EgZp6wDQAYB6pAOASMhcRLrQCQwh9fEtCR8Gg4xQ3nS+A0AHANMjd/dQj5v+JQzSdswAQEK31il0CpzOGx/E8YYx5TEcRut0z9THlP/v85QH6aTzKZ0n6CANKa8n4FBdTRYJDMoiwUEYpCGRBXGYddIx9Wk0JPaQj8SA2gHgwF8ATIOa5visCQ1HookJY+qD8O065UE66bzVQftO0EEayMMrrVNdTRYJDMoswUEYpCGRBXGYddIx9Wk0JPaQjw4AiZQ7ADyQooc0Te7R7u+kR4F00vn7yt6fPEEHaUh5PQGH6mqySGBQFgkOwiANiSyIw6yTjqlPoyGxh3x0AEik3AHggRQ9pGlyj3Z/Jz0KpJPO31fWASCV3R0cqiv1hXmkDQZp39BJGowP0kkcZp10bGgwOmkP+TC9hRx/BtLYEEpGUuvkheKi80YncbxhTHkMh9E63TP1MeX/+zzlQTrpfErnCTpIQ8rrCThUV5NFAoOySHAQBmlIZEEcZp10TH0aDYk95KMDQCLlDxgUOjUPnTeSiaMDgEnx2h7KnOpK56+p+fXuE3SQhpTXE3CoriaLBAZlkeAgDNKQyII4zDrpmPo0GhJ7yEcHgETKHQAeSNFDmib3aPd30qNAOun8fWXvT56ggzSkvJ6AQ3U1WSQwKIsEB2GQhkQWxGHWScfUp9GQ2EM+OgAkUu4A8ECKHtI0uUe7v5MeBdJJ5+8r6wCQyu4ODtWV+sI80gaDtG/oJA3GB+kkDrNOOjY0GJ20h3yY3kKO/huA7ANrikZFMQ065TEcpDOxPvWR0GAuEuncyvMEHaQhVZMTcKiuJosEBmWR4CAM0pDIgjjMOumY+jQaEnvIh3m3SMfafweAhLzKOjVPomgbGOTjrR6kYwODNJhLsIGxkUWiJs3i50uzkUWiP9tb778OlIep66t8b0gnZUHnOwBQQh/WKXDTfCdgkIbExyaB0Tz3f6Gi3qCa0PlEXyQwyEfi453AaJ4dAH71mTK98dknrgNAB4BfJkAPpGm+KQadTzywCYyNLF7lo9cssh+s5pnN8+KTf/R20xsdAIIlpMD7wXq9P7F2AMg+sHRHEoNMAqN39Xve1eDn4LdDmbvWASBYJgq8j8r3fFSoLxIfrATGRn82iw5Ud3+y3ujP4Ofgt0OZu9YBIFgmCnyrgac66HziY5PAaJ6vN1C1tzoAdAAIfnQ+gTJ3rQNAsBYUeD9Yr/fB6l8B9IN18geL3pzEoJ3AeJW3L/g5+O1Qpjc6AATLRIG/yiUgH4kHIYHRPF9voGpvdaA6eaAKfg5+O5S5a48PAL89hYMEmA/WhlxqDKNzA2MjC8Nh8jA4v3sP1Syh75SsTvCa0JDIM6GDeoN0Gg0JDNLZdZ9A5H8G6Om+/k5q8K0E6DIanRsYW3kQj8mDME5Yp5olNJ6S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4T6ADgs1I7qcEVSGATXUajcwMjYDUCYfKIED0MQjVL0J+S1QleExoSeSZ0UG+QTqMhgUE6u+4TiAwAVNQ3OdQcBsPbem4n+UgwJ7LY0Gm8khfSSeeNBuIwGKRjg8PofJU9ibzIK9WMzm+9W5TFhg+TBe0xOskrcZh1o8PgPL1nIwvy0AGAEvqwvlG0RANv6DTRkRfSSeeNBuIwGKRjg8PofJU9ibzIK9WMzncAMAn93GPyfpW6X3N+b/dGFqSsAwAl1AHgYkLvt9OjQJeAzhtxxGEwSMcGh9H5KnsSeZFXqhmd7wBgEuoAcC2ln7s37gBp6wBACXUAuJhQB4C7gSU+WHe5t89tPH6JPEnnV+FI1N9kQXlu6UjwTDE2siCNHQAooQ4AFxPqAHA3MPOA3sU+7dzG45fIk3R+FY5Ef5gsKM8tHQmeKcZGFqSxAwAl1AHgYkIdAO4GZh7Qu9inndt4/BJ5ks6vwpHoD5MF5bmlI8EzxdjIgjR2AKCEOgBcTKgDwN3AzAN6F/u0cxuPXyJP0vlVOBL9YbKgPLd0JHimGBtZkMYOAJRQB4CLCXUAuBuYeUDvYp92buPxS+RJOr8KR6I/TBaU55aOBM8UYyML0tgBgBLqAHAxoQ4AdwMzD+hd7NPObTx+iTxJ51fhSPSHyYLy3NKR4JlibGRBGjsAXPzAmyan0KnwX4WDcnhb/ypeN3yYPDf2bHg1HHSPKAvDQRhGA/EQBp0njW/rxGEwNvac4pV0mDynGHQ+UdcOAB0Abt9rcwkI3DQ5YZCOr8JBOWytn5In1Z3y2PBhhlzysaWT8tpYP8Ur6aCabdXd6Pisbh0AOgDcvtfT5jOXxIgjHXSZX4XD6NzYc0qeVHfKYsOH6XHysaWT8tpYP8Ur6aCabdXd6OgAcKFzKVBqDEP1XThMFs3zZ0rUFybPjT2n1Gya14aPrQ8B1X2aFeGn1rdqQnpJh8lzikHn3zwYHR0AqNr/WKdATVGI7rtwUA7mcTQYzdOklNtzyh2gupPjDR+mx8nHlk7Ka2P9FK+kg2q2VXejowPAhc6lQKkxDNV34TBZNM/+AvBffWL6gu4R9Z/hIAyjgXgIg86TxsSfFA1HYs8pXkkH1awDwIduoMAo8ERzGYwNnd+Fw+SdqHvzNEnn9pxSM6o7Od7wsfUhIK/TrAg/tb5VE9JLOkyeUww6nxjs+o8Af8OgQs1jCk8NfAIHaTSPo8E4wetGzUwWG3s2vBoOqjtlYTgIw2ggHsKg86Qx8aEwHIk9p3glHVQz87YRBmlI1HVtAEg0xwkYG0UzhZ9mQT4SDWwwyMcpOkmHqVkCY5pXQidp2OAgDab3qB4JjsQjbXTQHlMTwthYT9SEdJosSIfBIB20ThrovFnvAGBS+sceKoppjATGRdn/2k4aUg+oyeMzL6foJB3GZwKD6p7gIAzSkMiCOMw66Zj6NHekA4Cp1M89iZoQI/WFqZnBIB20vpLFnwGWjTAorK11istkkcCY+iUN5nFLYJCPBMcGxil1J68JnVSzDQ7SkOpf4jnFa0InYWysU/8mNCRqZjCmWley6ABwrUxUFNMYCYxrqv+9mzSkHlCTR38B+CuBaVapP7mY3visZsbHlMP0P+lIaCAOUxPjZbrH6JxyJM4nakI6TBakw2CQDlonDXTerPevAExK/9hDRTGNkcC4KPtf20mD+SAlMMhHgmMD45S6k9eETqrZBgdpSPUv8ZziNaGTMDbWqX8TGhI1MxhTrStZ9BeAa2WiopjGSGBcU/3v3aQh9YCaPD7zcopO0mF8JjCo7gkOwiANiSyIw6yTjqlPc0fe9iR4jN/P9lAWU/zU+Y2sTBakw2BMMyENU/z/378dAK7FSEUxjZHAuKa6AwDlRXVL1CyBQT4SHIRBGijLrY8i6Zj67ABAnXB9PVETYqW+MP1pMEgHra9k0QGAyvB+nYpiGiOBcU11BwDKi+qWqFkCg3wkOAiDNFCW5oElDrNOOqY+OwCYKlzbk6gJMVJfmP40GKSD1ley6ABAZegA8KuETINOL0qCYwPD+CQdBoO6NcFBGKTB+JhykAbzcU5oOMUr5WF0EsbGeqImpNNkQToMBumgddJA58165K8AFNGPH59uS5hNFGWq4wQN5vEzNaM906wIP+VjQ+cpXqj/ElkkOE7AIA3mT4JbdSeejbq+goatmpm8TX9RprRudHyG0QHgQzrjQGHQoYJuNbDRQXumWRF+B4B/J0SZ06ND5xM1MRwJnVMMOv/d7qLJ47P+MHWn/ppq2KqZ8ZrwQnkZHR0AKMV/rI8D7QBwIW3emrhE05qySrdjwwtxJLJIcJyAQRq2Piauez7ftVFX0nmChq2aGa+mvyhTWjc6OgBQih0ALiT0c+u0+Qxp4hJt6DzFC+WVyCLBcQIGadj6mJjeoT0bdX0FDVs1M3mb/qJMad3o6ABAKXYAuJBQB4BbYR3yX/qbPhhv3ulhMxwnYJCGrY/J3X765zmTOfGYPD7DOEHDVs2M12meVK+E1/4bgA8pm8J+OlH1rwBM3+o9iUs0rakWCxs3vBBHIosExwkYpCHxwJqBKdFfG3UlnSdo2KqZ8Wr6izKldaOjvwBQiv0F4EJC/QXgVljiT84Gly48PTp03mhIcJyAQRq2PiYmc9qzUddX0LBVM5O36S/KlNaNjg4AlGIHgAsJdQC4FVYHgHex0eNoHrYpBp3f+pjc7ad/njN5EY/J4zOMEzRs1cx4neZJ9Up4jfwVgDFKgRkMCuQEDtK4tU55UlZGJ3EkGtToSOwhL5QXnTcaieMNg3gIg84ndBoO0ml0GJ7pB4s4Ej6M1+ke8rF1V0nHRp6kwWSxhUF1n+bVAYAS/rA+Dfwi3e3t1KAJH8RhLtJtg+GD5IXyovNGLnF0AHif4jTzjbxN3Tf2mKxMHlOtpOMEDebdIh8pDMp7mlcHAEq4A8AvE0pcgovxP7advNBFo/NGOHF0AOgAYProv/aY/jT9d5f/73Ok4wQNqY83eaEsTNbEQRgdACihDgAdAMT/S9ety0w89CDQeXMdEhyEYXRMvRgNxGEwjJen95AP89FLaCQdG3mSBpPFFgZlPs2rAwAl3AGgA0AHgHc9QI9O4nE019LwfIZDPhK/uBgfG3tMViaPqVbScYKGDgAXq0xFTQVKsqh5jM4pB53fWievlJXRSRym7oZnYw95obzovPFAHIkP0oZOw2G8UmaGpwPAXwmYrBI1mdbsBA3m3UrkaTAoz2le/QWAEu4vAP0FoL8A9BeAX9yC6QN88fm5vd18bDa8kI4TNHQAuNhmVNRUoCSLmsfonHLQ+a118kpZGZ3EYepueDb2kBfKi84bD8Rh/iRHGBs6DQfpNHkZnv4C0F8APvaA6Rvqzy0Mugekk85/qV8AyOw0LMK369Q8RucUg85bL7SPvGzpmOqk82advFJWCQ6DsbEn4XVDZ4KD6p7goDxP0GB8JnRSFkYH7TE6pzpWOP6cqgz9/ZIxS0Wh9YBVolDr5NXonGLQeWVEbCIvWzpIKumk82advCY0EIfRubEn4XVDZ4JjoyaU5wkaTJYJnZSF0UF7jM6pjhWODgBU6vw6FdY0zhSDzqdck5ctHeSHdNJ5s05eExqIw+jc2JPwuqEzwbFRE8rzBA0my4ROysLooD1G51THCkcHACp1fp0KaxpnikHnU67Jy5YO8kM66bxZJ68JDcRhdG7sSXjd0Jng2KgJ5XmCBpNlQidlYXTQHqNzqmOFowMAlTq/ToU1jTPFoPMp1+RlSwf5IZ103qyT14QG4jA6N/YkvG7oTHBs1ITyPEGDyTKhk7IwOmiP0TnVscLRAYBKnV+nwprGmWLQ+ZRr8rKlg/yQTjpv1slrQgNxGJ0bexJeN3QmODZqQnmeoMFkmdBJWRgdtMfonOpY4egAQKXOr1NhTeNMMeh8yjV52dJBfkgnnTfr5DWhgTiMzo09Ca8bOhMcGzWhPE/QYLJM6KQsjA7aY3ROdaxwdACgUufXqbCmcaYYdD7lmrxs6SA/pJPOm3XymtBAHEbnxp6E1w2dCY6NmlCeJ2gwWSZ0UhZGB+0xOqc6Vjg6AFCp8+tUWNM4Uww6n3JNXrZ0kB/SSefNOnlNaCAOo3NjT8Lrhs4Ex0ZNKM8TNJgsEzopC6OD9hidUx0rHIkBgMIy68Ys4VDgCQ7SYNY3dBKH0Ul7TsmTdJosvpKXz/IwPk1elDmtGx2EMV1P+Ez4OEUH5Uk6TRaEQRrMOulIaCCON53EQxh03mRBeyL/JUAiMesUhsGgwBIcRgft2dBJHKTRrJ+SJ2k1WXwlLx0AqCP+Wjd9QUiJvjlFB3klnSYLwiANZp10JDQQh+kvwkjopLw6AFBCD6xTYakxjCTiMBi0J6GTOBLrJouv5KUDgOsa0xeElOibU3SQV9JpsiAM0mDWSUdCA3F0ADCV+sceEyhBUmETHKTBrG/oJA6jk/ackifpNFl8JS8dAKgj/lo3fUFIib45RQd5JZ0mC8IgDWaddCQ0EIfpL8JI6KS8+gsAJfTAOhWWGsNIIg6DQXsSOokjsW6y+EpeOgC4rjF9QUiJvjlFB3klnSYLwiANZp10JDQQRwcAU6l/7DGBEiQVNsFBGsz6hk7iMDppzyl5kk6TxVfy0gGAOuKvddMXhJTom1N0kFfSabIgDNJg1klHQgNxmP4ijIROyqu/AFBCD6xTYakxjCTiMBi0J6GTOBLrJouv5KUDgOsa0xeElOibU3SQV9JpsiAM0mDWSUdCA3F0ADCV+sceEyhBUmETHKTBrG/oJA6jk/ackifpNFl8JS8dAKgj/lo3fUFIib45RQd5JZ0mC8IgDWaddCQ0EIfpL8JI6KS8Ir8AkBESYdZNGAkdxHMKB+mkTDd8kAazfopO0mHqkcAwmT09AJCPqcat84maGa3E8yp5kg+TBe0xWUx1GA7SubE+9Wk0dgD4kBKFnmieBAdhUPE3fJAGs36KTtJh6pHAMJl1AHApJWpmmIiH+sJwbOwhHwkNJoupDsOR8DLFmPo0/B0AOgCYPvnPPSsN+uPHbX1/H0zopEfDcCQwpmGQhjd88mIwpjo3zpPPNw0Jr8ST4Dglr6kOkwXlSRoMB2FsrE99Go0dADoAmD7pAACDiLms9PAYjNvF+t9B0tAB4H3CJi+qCdU1wUEaEuvkI8FhspjqMBwJL1OMqU/D3wGgA4Dpkw4AHQD+rwde5QGlxjYPbMIr8SQ4yGtinXwkOEwWUx2GI+FlijH1afg7AHQAMH3SAaADQAeAmzeFHvJ+kH4Ga7KgPKlMhoMwNtanPo3GDgAdAEyfdADoANAB4OZNoYe8H6QOAP/VWtQ3N9vx3bEOAB0AbvfRSoP2HwHers9/HTQfG6qrwYiKfgiMfL7RJrwST4LjoYjewZKPhAaTxVSH4Uh4mWJMfRr+DgAdAEyf9BeA/gLQXwBu3hR6yPtB6i8AX/4XgI1LsMFx8w24NEmbB4G8JnSSjoQG4kj42MDYyiLBs5HHlMP0BWVhMKY6ScM/1xmgAAAgAElEQVQUf+tXCKPzlDynOjZqZvKkPcbn1MvaLwAk1JilwDY4SINZT+gkDKOD9lBNEhqIgzSesr6VRYLnlMw+02H6grIwGNMsSMMUvwPAvxOc1nWjZlt1n3rpAJCo1EUMKpppcMK4KOk/t5OOhAbiSPjYwNjKIsGzkceUw/QFZWEwpjpJwxS/A0AHgM96aNp/HQASN/QiBhXNPFyEcVFSB4BhYIl6nFL3YRSR44ksDMZUbKLupCHhI6EzoYO8Gp1THYaDdG6sG59TLx0ANir5gYOKtlF4Y5t0kI8Eh8E4Yc9WFgmeE/IiDdR7b+cpC4NBOmidNNB5s57wkdCZ0EF+jc6pDsNBOjfWjc+plw4AG5XsAPDLlE2T/4YSXaacXsQ3QpNFgueyud9wIJGFwZha26hHwkdCZ0IH5W10TnUYDtK5sW58Tr10ANioZAeADgCizzYuvJBxxJZEFgZjanb6ABv+hI+EzoQO8mt0TnUYDtK5sW58Tr10ANioZAeADgCizzYuvJBxxJZEFgZjanb6ABv+hI+EzoQO8mt0TnUYDtK5sW58Tr1EBoBEGGR2ajSh0fxMm9BJWRgvCR2GZ7on4ZU0JLI4RSfpOMGr0UA+qKZv68ST4CAdpIHOmzfFYCT2kBfKk84bjcRh6k48CY4tDPIyzbwDACX8YZ0KPy1I6kFI6LgYza3tlOct0A+HElmcopN0nODVaCAfpu7Ek+AgHaSBzqfuu+GhPeSF8qTzxG+zmPKQDzNkbGFQZuMs/pwikEK5ToEeIhP/oVZCJ2VhIk3oMDzTPQmvpCGRxSk6SccJXo0G8kE1TT3ShuezPcYrcSSyIA6zTl5IJ503GojD1J14EhxbGORlmnl/AaCEP6xT4acFsVMwyU7oII7EOuWZ4EhkcYpO0nGCV6OBfJi6E0+Cg3SQBjqfuu+Gh/aQF8qTzhO/zWLKQz7MkLGFQZmNs+gvABTx+3Uq/LQg9hKQ6oQO4kisU54JjkQWp+gkHSd4NRrIh6k78SQ4SAdpoPOp+254aA95oTzpPPHbLKY85KMDgKlUeA8VZVr0lNwNncRhvJySF2lNeCWORBan6CQdJ3g1GsgH1TT1SBuez/YYr8SRyII4zDp5IZ103mggDlN34klwbGGQl2nm/SsASvjDOhV+WhA7BZPshA7iSKxTngmORBan6CQdJ3g1GsiHqTvxJDhIB2mg86n7bnhoD3mhPOk88dsspjzkwwwZWxiU2TiL/hUARfx+nQo/LYi9BKQ6oYM4EuuUZ4IjkcUpOknHCV6NBvJh6k48CQ7SQRrofOq+Gx7aQ14oTzpP/DaLKQ/56ABgKnVxjwn9M8hp0a3cqU7DQ16MBsIgHRscpMFeeMKhLIxX4qB10rDllXSaLIyXz3gSHAaDvJ6yTnkmvBKHyYJ0EAedNxqII3WPjJan9xivT2tY+yuAaXNshTXVaQpGXowGwiAdGxykIXWZKQvj1WidDqgJHeSVfBgNJ3AYneT1lHXKM+GVOEwWpIM46LzRQBypN8NoeXqP8fq0hg4AHxJONDEVjQpvNBAGadjgIA2py0xZGK9GawcAl5LJ+4SaOTfzXRteicO4oLoRB503Gogj9WYYLU/vMV6f1tABoAPAL3tso0E3Ho0EB11Ek1VCh+H5TKvRcAKH0Uk1OWWd8kx4JQ6TBekgDjpvNBBHBwCTot/TAaADQAcAf19GWW09kB0AAgUNQtBH7YS+MB/WU3wk8gqW9zYU5Xkb+MLBDgAdAEYftQu99p9bE5eZLlKCg3ySBvPAEsfbuuHpAGCS3NtDNUv0J3EYt6SDOOi80UAcqXtktDy9x3h9WkMHgA4AHQACt8xc5q0HsgNAoKBBCOqNE/rCfFhP8ZHIK1je21CU523gCwc7AHQA6ABw4cL8aqu5zImHy/B0AAgUNAhBNTuhLzoABAsuoagvJMxoWweADgAdAEZX6K/D5jKf8NAbDcbL00OG0Rko2woE5ZnwShzGKOkgDjpvNBCHGVQMzwl7jNenda4NAE8b2cKnJjdFJYwNL1s6iYeyoPOpB4F4SKepWYIjgUFapxx03tRsC4OySNSdOMjrhgbSaIdcwiEvlAXhp9ZJZ4pnijPNqwPAxQpQY5iCEMZFSbe2b+kkHsqCzpuPiQmIeEjnFscr6CSNpmZbGFS3RN2Jg7xuaCCNHQBMQvt7qHdIUQcASujDOl1GUxDCuCjp1vYtncRDWdB58zExAREP6dzieAWdpNHUbAuD6paoO3GQ1w0NpLEDgElofw/1DinqAEAJdQC4mND77dSg9LjRefMxMQaIh3RucbyCTtJoaraFQXVL1J04yOuGBtLYAcAktL+HeocUdQCghDoAXEyoA8CvAqPLah76BAYVdMpB5zsAZO8I1TO1bupKXNTjCQ7SYNZJp8HY2DPNqwPAxSpRY5iCEMZFSbe2b+kkHsqCzpuPiQmIeEjnFscr6CSNpmZbGFS3RN2Jg7xuaCCN/QXAJLS/h3qHFHUAoIT6C8DFhLJ/ujENnnggiecUjlfQSRo7AGTvyOiCXjhs6kpwdI8SHKTBrJNOg7GxZ5pXB4CLVaLGMAUhjIuSbm3f0kk8lAWdNx8TExDxkM4tjlfQSRpNzbYwqG6JuhMHed3QQBr7C4BJaH8P9Q4pWhsATmliCmS6bgpCWWxgkIZpDvY8eU3oJA6r9bN9RmdCB/FscCTySugkHZQVnTcfPcNBXgmDzhsfiT2k03AkvJCOBIfxMt1zgo8OANMqfjhvmi9R+CkGnQ/H8ks4yiuhkzgSXo3OhA7i2eBI5JXQSTooKzrfAeB9Qht5mpqQjo3eMjppzwk+OgBQlS6um+ZLFH6KQecv2r69nfJK6CSO2+L/cdDoTOggng2ORF4JnaSDsqLzHQA6AJgeubuH+nPljvy5wfLHH3+Q2bshnnbOxElZbGCQhq1cyWtCJ3EkvBqdCR3Es8GRyCuhk3RQVnS+A0AHANMjd/dQf67ckQ4Ad8v33+dM0RKFn2LQ+Wwqv0ajvBI6iSPh1ehM6CCeDY5EXgmdpIOyovMdADoAmB65u4f6c+WOdAC4W74OAInkqMnpkhgNxGEwaI/RmdBBPBsclIVZT+gkHsqKzncA6ABgeuTuHurPlTvSAeBu+ToAJJKjJqdLYjQQh8GgPUZnQgfxbHBQFmY9oZN4KCs63wGgA4Dpkbt7qD9X7kgHgLvl6wCQSI6anC6J0UAcBoP2GJ0JHcSzwUFZmPWETuKhrOh8B4AOAKZH7u6h/ly5Ix0A7pavA0AiOWpyuiRGA3EYDNpjdCZ0EM8GB2Vh1hM6iYeyovMdADoAmB65u4f6c+WOfKUBgAKjwM2Fv1vsK+eMTsI7JYupF/LxlgNxGAzKkzjovFlP6DQ80z2UhfFBGEaj4TE4n+1J6JxqMD5J5xYGeSWddN6sk1ejgTCMDtpDOlY0dAB4X6aN0KeNQefNIEPNZzCMDsPzGY6pB3EYDPJCHHTerCd0Gp7pHsrC+CAMo9HwGJwOAH8lQDVJ5E0c03qZd8toSHglL6RjRUMHgA4Av2rURANSk9MlMRqIw2CQDuKg82Y9odPwTPdQFsYHYRiNhsfgdADoAPCxB07orRUNHQA6AHQA4M9E4oNFLBsXnjSYdcrC+CAMo8PwGJwOAB0AOgBMbwqcT1x4kkgPgtFAGKQhsW50Eg/5MByEQRre1g3PZzhGA3EYDPJCHHTerCd0Gp7pHsrC+CAMo9HwGJwOAB0AOgBMb0oHgFiCG4+j4Ug8sIanA8BfCSTyjjXhJ0BUU+ODMIwPw2NwOgB0AOgAML0pHQBiCW48joYj8cAang4AHQDuXJ5EfxLvtH8J36wbn6RzC4P8kE46b9bJq9FAGEYH7SEdKxr6bwDel2kj9Glj0Hnzp0lqPoNhdBieDgAdAEwvnfintDu6r54xbxLdsy0M8kY66bxZJ69GA2EYHbSHdKxoSAwAZISCOOVj8510btWMeKjJ6bzpHYNBtT9FJ+kgH2Y9kZfh+d2Dn/H5Knlv6KSamjwJw/hI8CR0EMZUp8mCNND6jw4AFNH79URRpo1hFJPOhAbieNNJPIRB5zsAmG64tsdkfg3x+m7qi1N667qzf59I5G3ySmj9DGPLR4KHskjkOdWZ0EA+OwBQQh/WE0WZNoaRTDoTGojjlEd6w6vhoLwSGKY3aI/RQRjTdcrqlN6a+jQ+DIfJy+BM9iT6xvhI8JBPo4MwpjoTGlBjfwGgiN6vJ4oybQyjmHQmNBCHedwIw+hMYFCmCY4NDPJh1k3mBmeyh7I6pbcmHv8+m8jb5JXQ+hnGlo8ED2WRyHOqM6GBfPYXAErow3qiKNPGMJJJZ0IDcZzySG94NRyUVwLD9AbtMToIY7pOWZ3SW1OfxofhMHkZnMmeRN8YHwke8ml0EMZUZ0IDauwvABTR+/VEUaaNYRSTzoQG4jCPG2EYnQkMyjTBsYFBPsy6ydzgTPZQVqf01sTj32cTeZu8Elo/w9jykeChLBJ5TnUmNJDP/gJACX1YTxRl2hhGMulMaCCOUx7pDa+Gg/JKYJjeoD1GB2FM1ymrU3pr6tP4MBwmL4Mz2ZPoG+MjwUM+jQ7CmOpMaECN/QWAInq/nijKtDGMYtKZ0EAc5nEjDKMzgUGZJjg2MMiHWTeZG5zJHsrqlN6aePz7bCJvk1dC62cYWz4SPJRFIs+pzoQG8hn5BYBIEpfVcGzsmRZ1Q+MWx0aDGi+vUpMT8jJZTXVucGy9KcaL6dHfvcfUlLwSBp03GRCHwUjsSXiZ6tjIogPAxSqd0BgXJT+2faNBjfhXqckJeZmspjo3ODoAmJvxc4+pKdWNMOi8UUwcBiOxJ+FlqmMjiw4AF6t0QmNclPzY9o0GNeJfpSYn5GWymurc4OgAYG5GB4BrKf3cbXr4LrY9N72HhqcDgEnpH3tOaIyLkh/bvtGgRvyr1OSEvExWU50bHB0AzM3oAHAtpQ4Ad/PCc/QoTB8dFBDaQD5CNC8Bc0rNXqUmJ+Rlsprq3ODoAHDtiTA1pboRBp03ionDYCT2JLxMdWxk0V8ALlbphMa4KPmx7RsNasS/Sk1OyMtkNdW5wdEBwNyM/gJwLaX+AnA3LzxHj8L00UEBoQ3kI0TzEjCn1OxVanJCXiarqc4Njg4A154IU1OqG2HQeaOYOAxGYk/Cy1THRhb9BeBilU5ojIuSH9u+0aBG/KvU5IS8TFZTnRscHQDMzegvANdS6i8Ad/PCc/QoTB8dFBDaQD5CNC8Bc0rNXqUmJ+Rlsprq3ODoAHDtiTA1pboRBp03ionDYCT2JLxMdWxksfYLAIVBgZswNjDIh9FJGGadvBKG0UkcBoN0fJV1yurNJ+VlMKZ5kQbzYSUNhoMwEuuJPMmL4SCMhFfCeBWd5OOU/kzkaTAoj2lvdQD4kPC0KNOCUMH/Xt/QSRxbXm0mv3MfZdUBYL86piakinrccBAGaUisv4pO49V4+QwnUQ+jgXgMBuVBHHS+A0AHgF/2CDXotPmoOV9pnbLqALBfTVMTUkU9bjgIgzQk1l9Fp/FqvHQAMEn+8UcHgA4AHQDcXfl0l3mU6ENgMKZSScMb/lSH4Zj6MOenPlJD2wl5mCxO0LlR14TPRJ4Gg/KYeukA0AGgAwDdMrFuLjNdVoMhpHy6hTR0AHgfH+VlakYY05qa86+iM+WlvwCYJPsLwL9SMhfl6eYypdvQSRwnPGwmq409lFXqT5NTL6ZmxssJd4CymPpI1cxkTl6m6yaLE3Qan8bL0/1pNFCeBoPyIA46318A+gtAfwGgWyLWzWWmy2owhJT+AvC/BBJ5JmpGGNOamvMmixN0prx0ADBJ9heA/gLwSZ/Qo/EqD4a7CrNdlFXqT5Mzlfw/RXzDN16efmCnPhM+UjU74Z6Ymp6g09TdeHm6P40GytNgUB7EQeeP+QUAhf74QVvwf2eNAIdsSDRGwgo1V0LnCRzmY0E6Td6UV4KDdJAGOp9a3/BKWhNZnODD9C9lYYYdg0F7Tsh8SwPxUO/Q+UTNOgBQx/6GdVP4DVmJBiWdJ3CYB5R0ks8tDtLxKr1FPhLriSwSffGdvJyQ+ZYG4qHeofMdAD7cHAo0cdE2MEzhN3RQngmdJ3BsfZwpL8oiUXPSkOAwGBteSUciixN8mP6lLBIfE8NxQuZbGoiHeofOJ2rWXwBM1y7vMYXfkJRoUNJ5Aod5QEkn+dziIB2v0lvkI7GeyCLRF9/JywmZb2kgHuodOt8BoL8AJN6OX2IkGpQEnsCx9XGmC01ZUJZmnTQYjMSeDa+kM5HFCT5M/1IWiY+J4Tgh8y0NxEO9Q+cTNesvAKZrl/eYwm9ISjQo6TyBwzygpJN8bnGQjlfpLfKRWE9kkeiL7+TlhMy3NBAP9Q6d7wDQXwASb0d/ARD/0ze6rKYQdKETHKSDNND51PqGV9KayOIEH2a4pCwSHxPDcULmWxqIh3qHzidq1l8ATNcu7zGF35CUaFDSeQKHeUBJJ/nc4iAdr9Jb5COxnsgi0RffycsJmW9pIB7qHTrfAaC/ACTejv4C0F8AHu2j/wKnx29DkHlgSccJPsxwST4SHxPDcULmWxqIh3qHzidqtvYLgDFjGugr7Dmi8F/oP6z0Kr2VqPsr9D/53PJwSl+ckgflfkpepPOE9URNKe8EB2XVAYASemCdCkuNEZn8OgA8UNnPIRN1Xxd9g5B83oC8dcTco1vAFw+dkgfJPiUv0nnCeqKmlHeCg7LqAEAJPbBOhaXG6ADwvigmrwfKeBkyUffLpL/hAPncknRKX5ySB+V+Sl6k84T1RE0p7wQHZdUBgBJ6YJ0KS43RAaADwANtGYOk/o4RAZC5RxtaTsmDvJ6SF+k8YT1RU8o7wUFZdQCghB5Yp8JSY3QA6ADwQFvGIKm/Y0QdAKJRmncnSvjCYIkep7wTHBRxBwBK6IF1Kiw1RgeADgAPtGUMkvo7RtQBIBqleXeihC8MluhxyjvBQRF3AKCEHlinwlJjdADoAPBAW8Ygqb9jRB0AolGadydK+MJgiR6nvBMcFHEHAErogXUqLDVGB4AOAA+0ZQyS+jtG1AEgGqV5d6KELwyW6HHKO8FBEUcGADJCIhIftDcM0rES6Bf6n9dR3ShvOm/WN2pmdNCejSxIQ+oeEc+GV1N30mEwpl4NB+kkDYn1hE7CMD43MBJ5GS9TnhOy6AAwreKH86ZxqPBhSY/BGa9T8lfJaiMLk+VGXhtejQ/SYTAo0wQHYZCGxLrJgnQSBp03A2oCI5GX0THl2ciTNHYAoIQurpvGocJfpPxt243XqbhXyWojC5PlRl4bXo0P0mEwKNMEB2GQhsS6yYJ0Egad7wDwvpIbeVLvdACghC6uJy7BRcrftt14nYqjSzLFT53fyMJo3chrw6vxQToMBmWa4CAM0pBYN1mQTsKg8x0AOgD8spepucwloAZMcJAO0mAuAXGcsm68TrVu1Gyq8e38RhZG50ZeG16ND9JhMCjTBAdhkIbEusmCdBIGnTdvXwIjkZfRMeXZyJM09hcASujiumkcKvxFyt+23XidinuVrDayMFlu5LXh1fggHQaDMk1wEAZpSKybLEgnYdD5DgD9BaC/APzxxx90kRIXfgPDXPipjlfJaiMLk+VGXhtejQ/SYTAo0wQHYZCGxLrJgnQSBp3vANABoANAB4BL7xk9OpfAHtxsHr8H6f8PeiOvDa/GB+kwGFSTBAdhkIbEusmCdBIGne8A8EUHgESDJjCoAamB3zRMMei88Wl0GpzP9iR0Gg2v4mVDp8mL9lDdyAedTz3S5COhkzg21slHQoOpWYJn6uUUnaTD+CQMk7fhMThP7on8G4AnBV7BpqKZgkwx6LzxY3QanA4APqWNzL2aX++k/iIfdL4DwLUqUd7X0P57t6lZgmfq5RSdpMP4JAyTt+ExOE/u6QDwIV0qPBWVzptiEofBoD0JncRhPiYGg/YkvGxkTj7MOnklH3Te1MxgkJeETuLYWCcfCQ2JvI2OqZdTdJIO45MwNvI0HNM9HQA6AEx76NPz5rJNBXyXy/qWE3mlvOl8B4Br3Uh5X0PrLwAmL8qcepzOm3uW0Gkwnt7TAaADwKM9Zi7bVABdeIO/odPooD3klXzQ+Q4AVIH365T3NbQOACYvypx6nM53ADBVOHDPRuGpeUiDiY04DAbtSegkDvMxMRi0J+FlI3PyYdbJK/mg86ZmBoO8JHQSx8Y6+UhoSORtdEy9nKKTdBifhLGRp+GY7ukvAB8SpMJT89B5UzDiMBi0J6GTOMzHxGDQnoSXjczJh1knr+SDzpuaGQzyktBJHBvr5COhIZG30TH1copO0mF8EsZGnoZjuqcDQAeAaQ99et5ctqmA73JZ33Iir5Q3ne8AcK0bKe9raP+929QswTP1copO0mF8EobJ2/AYnCf3dADoAPBkf638Vw+/y2XtAPBoq94C33jkE/1tzE29nKKTdBifhLGRp+GY7okMACYsCt1gTM2Shim+eaDNn7CMDsqLvNL5lE7jZbrHeCEOyovOb2kgnqkP8ml73OB8tsf4OCEL43Oqk84bDSZPg/P0HuN1wwvpMBqmGHQ+8UZ3AAh39EbRzCNMDbqlMxzvf8IZL6SD8qLzWxqIZ+qDfJreMxi0x/g4IQvyYfIir+TTaCAOg7Gxx3jd8EI6jIYpBp3vAHCxI03RLkL+a/tG0bYelY28pnmbLAzH1KupO+kwGojHYJAOWicNdN6sGx+kw2AYLdM9U5103ug7JQvSarxueCEdRsMUg853AKBu+rBuinYRsgPANLDAeXNRiGbaG1saiGfqg3JKDVzEY3yckAX5MHmRV/JpNBCHwdjYY7xueCEdRsMUg853ALjYkaZoFyE7AEwDC5w3F4Vopr2xpYF4pj4oJ/NBMxi0x/g4IQvyYfIir+TTaCAOg7Gxx3jd8EI6jIYpBp3vAHCxI03RLkJ2AJgGFjhvLgrRTHtjSwPxTH1QTuaDZjBoj/FxQhbkw+RFXsmn0UAcBmNjj/G64YV0GA1TDDrfAeBiR5qiXYTsADANLHDeXBSimfbGlgbimfqgnMwHzWDQHuPjhCzIh8mLvJJPo4E4DMbGHuN1wwvpMBqmGHS+A8DFjjRFuwjZAWAaWOC8uShEM+2NLQ3EM/VBOZkPmsGgPcbHCVmQD5MXeSWfRgNxGIyNPcbrhhfSYTRMMej8Sw0A1DwUqAmDOE5ZJ68JnRt5JXyQTsOxgUE1MToJg3zQ+e+2TplTnnTe5EkciUfa6KA9RidhdD2bQKL/porW/jsAJJTC+EoNTF4pK7O+kVfCB+k0HBsYlLnRSRjkg85/t3XKnPKk8yZP4ugAYFL8nnsS/TdNrgPANMEb5zcKbx6mG9LfHUn4IJ2GYwODsjI6CYN80Pnvtk6ZU5503uRJHB0ATIrfc0+i/6bJdQCYJnjj/EbhzcN0Q3oHgF+ElqjpRs2mNT/pPGVOedJ545U4OgCYFL/nnkT/TZPrADBN8Mb5jcKbh+mG9A4AHQCmbRM7T/eI7gCdN0KJowOASfF77kn03zS5DgDTBG+c3yi8eZhuSO8A0AFg2jax83SP6A7QeSOUODoAmBS/555E/02T6wAwTfDG+Y3Cm4fphvQOAB0Apm0TO0/3iO4AnTdCiaMDgEnxe+5J9N80uQ4A0wRvnN8ovHmYbkjvANABYNo2sfN0j+gO0HkjlDg6AJgUv+eeRP9Nk3uZAWBq9KTz9GiYxiCMU/waL59p3fK5oXPK8ZbTNI+EBuqtqUb70UzwkJfEOmVOPuh8oi9M5qfonNbE5DnlSNRkQ2cHgESlL2J8lYtkbE+bmLIyGsyeDZ1Tjpd5VH78MJF/usdktdUbUzPkhXzQ+URfdACYVvnf56muxGjqThi03gGAEnpgnRrDFJ4wHpB9C9J46S8APtpp3af1MEqnGs3HKPXRM36meyhzyovOp7IgnlN0Pl2PKf7f5ykv4qF60Hmz3gHApBTeQ41hCk8YYcm34YyXDgA+3mndp/UwSqcaOwC8T9nUbCNz4tjSaXrwsz1G55QjMZRt6OwAkKj0RYyvcpGM7WkTU1ZGg9mzoXPK8TKPSv8K4F3LUd2px+l8oi/M0HWKTnOfOwC4lDoAuJyiu77KRTKhmMervwCYJP/aQ71DSNN6EH5Co/kYpXiMn+keypxqSudTWRDPKTqfrscU/+/zlBfxUD3ovFnvAGBSCu+hxjCFJ4yw5NtwxksHAB/vtO7TehilU40dAN6nbGq2kTlxbOk0PfjZHqNzypEYyjZ0dgBIVPoixle5SMb2tIkpK6PB7NnQOeV4mUelfwXwruWo7tTjdD7RF2boOkWnuc8dAFxKHQBcTtFdX+UimVDM49VfAEySf+2h3iGkaT0IP6HRfIxSPMbPdA9lTjWl86ksiOcUnU/XY4r/93nKi3ioHnTerL/MAGDCTARmeKbTJXEkfJjiT/eQD/OQGwzSmciLdJzCQTopq8R6IgvSkfBJOjc4zMd5Qyflbe4qYZg8yStxJPJ8FQ6jc5pnB4APKZsm7gDwVwImK2pQg0EXgTjovPFyCkciL5PHtMenHAmfVLMNjkRvJXSaelBehGF0TjkSeZKPUziMzmmeHQA6AJg++889iQtvMEjg9BKccuGNj0RelCetG52EQesJn6RzgyPRWwmdlPfbOuVFGEbnlCORJ/k4hcPonObZAaADgOmzDgB//nk7p78P0gNpLjNhjEUKAKNTwHy6JeGTdG5wJD4mCZ2mHpQXYRidU45EnuTjFA6jc5pnB4AOAKbPOgB0APi/Hpg+OqbhzMeEcEjnBkfiY5LQSVn1F4D3CVHm1Fsmb+IwGFMdHQA6AJg+6wDQAaADwH/cAvMA00NPGHT+9gX+cJB0EI/ROeVIDFTk4xQOo3OaZweADgCmzzoAdADoANAB4NO3ogPAtafU5EWIHQD+kdA0DDP5JQpChU/4IJ2JdalvpjoAACAASURBVPJhflY0GKQ1kRfpOIWDdFJWifVEFqQj4ZN0bnCYN2VDJ+Vt7iphmDzJK3Ek8nwVDqNzmmfkFwAjlJqDjNB5o4E4DAbtMTpJxwYGaTjlolHeqXXKw9SEtBAHnd9aT3idak1klfCxoWODw9QjocPwfLbH1Gyqc4PD5GB0EM44iz+nCKTwf+tklmTQeSODOAwG7TE6SccGBmnoAPC+0qYm1Bsmc8LYWE94nepMZJXwsaFjg8PUI6HD8HQA+CuBE/qzvwBMO/bDeVNUumgbGKTBNKjBoHiNV8JIrJOXhE7iSPhIYCS8TnUkskr42NCxwWHqkdBheDoAdAD4Vw9Q851ymanBjc6E1ykGne8A0F8AqNefXDf9SfzmLhLGho4NDvL5tp7QYXg6AHQA6ADwyS0wDxddVsKg8x0AOgBMH/PJedOfhE93gM6nPoqk4yt5NZl2AOgA0AGgA8D/T4Aex+mDYs/TI5zQSRxW69P7El6nGhNZJXxs6NjgMPVI6DA8HQA6AHQA6ADQAWD6Wj50PvHhnEpLfIwSPjZ0bHCYeiR0GJ4OAB0AOgB0AOgAMH0tHzqf+HBOpSU+RgkfGzo2OEw9EjoMTweADgAdADoAdACYvpYPnU98OKfSEh+jhI8NHRscph4JHYanA0AHgMsDwLSx3s4nHgTSccIlIo2pLIzXaeaGg/xONbzhJ3RU588EKM+NmiU4qKaJ3tnSabw8vYf6wrxdBmPqI1ET0mk4CIN8vsx/B4CMmHUTqMH5bM+0IFN+ez6RhfE65TEc5HmqIfGIk0bzsBmMRF7Es5Hnq3BQVoneSWRhdJ6wx/Qv5WEwpl5Jg8EnnYaDMEhHBwBK6OL6tCAX6W5vN81F4MbrlMdwkM6phsQjTho7ALxPaKNmCQ5T12kPb+k0Xp7eY7KiPAzG1AdpMPik03AQBunoAEAJXVyfFuQi3e3tprkI3Hid8hgO0jnV0AHgNT/O1DuJvqDeS/TOlk7j5ek9VDMzKBuMqY9ETUin4SAM8tkBgBK6uD4tyEW629tNcxG48TrlMRykc6oh8YiTRvOwGYxEXsSzkeercFBWid5JZGF0nrDH9C/lYTCmXkmDwSedhoMwSEcHAEro4vq0IBfpbm83zUXgxuuUx3CQzqmGxCNOGjsAvE9oo2YJDlPXaQ9v6TRent5jsqI8DMbUB2kw+KTTcBAG6egAQAldXJ8W5CLd7e2muQjceJ3yGA7SOdXQAeA1P87UO4m+oN5L9M6WTuPl6T1UMzMoG4ypj0RNSKfhIAzy2QGAErq4Pi3IRbrb201zEbjxOuUxHKRzqiHxiJNG87AZjERexLOR56twUFaJ3klkYXSesMf0L+VhMKZeSYPBJ52GgzBIR2QA2BBKRr7SAzotqsnCcJi6Ul0MD2HQOulMaCAO0mg+BIaDvBAGnU/1DuWxoZM0mCwIw6yTV8IwOqccpMH0r8Gozp8pmbqaTCd7OgB8SG+jKHQJEhoSHIRhGi/hhXhIZ0IDcZBG84AaDvJCGHS+A4Cp5LU9VBNCS9SMOMy60UE40ywI39wzg/EqOo2Xz/Z0AOgA8Mv+SFyCxKNBTU46ExqIgzSah8lwkBfCoPMdAEwlr+2hmhBaombEYdaNDsKZZkH45p4ZjFfRabx0ALiQUqLJiY6aK6EhwUEY5DN1GYmHdG7kSRpNFuQjgWGyIB0Gg/JIcBAGaUj4IA4zUBGG0TnNgjSY3jMY1fkzJVNXk+lkT38B+JDeRlHoEiQ0JDgIwzRewgvxkM6EBuIgjeYBNRzkhTDovPlgGQzKY0MnaUj4IA6TJ2EYnZQncZh1o4NwqrMDAPXI7fVEcyWanAyQzoSGBAdhkE/z0TMYtId0buRJGk0W5COBYbIgHQaD8khwEAZpSPggjg4A7xOa1szknajrq+g0eXy2p78AfEgn0TxUFGquhIYEB2GQT/PBMhi0h3Ru5EkaTRbkI4FhsiAdBoPySHAQBmlI+CCODgAdAH7VI1v91wHA3NL/7dkoCj1cCQ0JDsIwsSa8EA/pTGggDtKY+HgnMEwW5NVgUB4JDsIgDQkfxNEBoAPAlx8AzCWY7jGXPXGhiecUDtJJeRsfUw7SkPigJTjMI23yMlo+ncZ//JhC/FGdPyM8oX/HBT0IIJEn9WeCYyMy8rGhIcER+SuAhBDCMI2RKArxnMJBOilP42PKQRo6AOT/dGTqaurSQcWltJG3U/L8rsR7QHklOJ5P4o+VQXvDRweADylTA1IDm6IlOAiDdBgfUw7S0AGgA4Dpkbt7Tujfu9pPPJfIk96dBMdGduRjQ0OCowNAB4Bf9tHGZaSLlNBAHG8BEI/BmF5I0mDwq/NnSok8KfONvEnD1noiT8orwbGRB/nY0JDg6ADQAaADQAeAS29J4pHeeEATOimYDR+kYWs9kSflleDYyIN8bGhIcHQA6ADQAaADwKW3JPFIbzygCZ0UzIYP0rC1nsiT8kpwbORBPjY0JDg6AHQA6ADQAeDSW5J4pDce0IROCmbDB2nYWk/kSXklODbyIB8bGhIcHQA6AHQA6ABw6S1JPNIbD2hCJwWz4YM0bK0n8qS8EhwbeZCPDQ0Jjg4AHQA6AHQAuPSWJB7pjQc0oZOC2fBBGrbWE3lSXgmOjTzIx4aGBMcxAwAVPhE4cbwFOuXZ4HjTaXgSDfI0BuVtfBKG8WB4DM7Te8gr+aDzprcMBuVAOul84q4aDtJpsphi0Hnjw+gkHNKxwUEazfopOkkH5Z24Ax0APnQMFYUabKNo5pEmnaesU97N832lpnnRedNbBoP6y9SVMBI6iIN0Gg1TDDpPHhIfilfqC8rD1IwwNmpiOKZeOgB0AKBef3SdGnjjEpjH7dEQLoBP86LzJguDQZZMXQkjoYM4SKfRMMWg8+ShA8C1IdrkuVETw2H67zM/HQA6AJh+f2wPNfDGJTAfvccCuAg8zYvOmywMBtkydSWMhA7iIJ1GwxSDzpOHDgAdAH7VIx0AOgCY9+OxPfSAmsePMIx4w2Nwnt5DXskHne8A8L6CJ+RJGkzPmboTDunY4CCNZv0UnaSD8k4Mdh0AOgCYO/PYnhMugfnoPRbAReBpXnTeZGEwyJZ53AgjoYM4SKfRMMWg8+Qh8aF4pb6gPEzNCGOjJoZj6qUDQAcA6vVH16mBNy6BedweDeEC+DQvOm+yMBhkydSVMBI6iIN0Gg1TDDpPHjoAvE/I1Iwy3aiJ4Zh66QDQAYB6/dF1auCNS2A+eo+GcAF8mhedN1kYDLJk6koYCR3EQTqNhikGnScPHQA6APyqRyIDgGlQc1FMIz+9h7yQDzpv9BOHeaQND+0xOggjkQdxkE6jgTBIw9Y6eUn4IA7ymtBAHFt3wOigPVt5kA5an9ad8LfWE3mfkEXCB2XeAeBDQlR4Kgqdp4LYaT3BQ1rIK53feqRJp8mKMIzXjT3kJeGDOMhnQgNxbPWW0UF7tvIgHbQ+rTvhb60n8j4hi4QPyrwDQAeAX/ZIogE3LhLpNBoIgy7S1jp5SfggDvKa0EAcHQBMQtf2TOt+je253Yn+OyGLhA9KuQNAB4AOAIH/BDRdtNQ6PUyJR4M4yEtCA3F0ADAJXdszrfs1tud2J/rvhCwSPijlDgAdADoAdAB41wPTx2/j4eoAQE/79fVp3a8zPnMi0X8nZJHwQQl3AOgA0AGgA0AHAHopB+sbD/lA3v8dPeGjl/CRyPuELBI+KM8OAB0AOgB0AOgAQC/lYH3jIR/I6wDwH+F1ALjQUSasr3IJyIfJgqIljq2fP40O8pLIgzhIp9FAGKRha528JHwQB3lNaCCOrTtgdNCerTxIB61P6074W+uJvE/IIuGDMu8vAP0FoL8A9BeA/gJAL+VgfeMhH8jrLwD9BSDRPr8fIzG19bLu1pHy3qppgmeaHGVh8MlHgsPooD2kk86/rZ/ixWh9hT1Uk0TexGFyIh3fiYOyoDwjvwAQydb6RuG3vBBPwitxbKxTAyd8EsebzwTPNC+jkzjIR4KDNJh10mkwTvFitL7CHqpJIm/iMDmRju/EQVlQnh0APiQ0DZQCT60nmjylZYJDeSd8EkcHgEkF753dqus9dd/zFNXE3CNKjjjo/Ns66fhOHJQF5dkBoAMA9cij69TAG5e5A8CjJf5P8K267jt7XUaqCd1V45w4DAbp+E4clAXl2QGgAwD1yKPr1MAbl7kDwKMl7gCwH+8tRrprdFcNKXEYDNLxnTgoC8qzA0AHAOqRR9epgTcucweAR0vcAWA/3luMdNforhpS4jAYpOM7cVAWlGcHgA4A1COPrlMDb1zmDgCPlrgDwH68txjprtFdNaTEYTBIx3fioCwozw4AHQCoRx5dpwbeuMwdAB4tcQeA/XhvMdJdo7tqSInDYJCO78RBWVCekQEgETgJTaybsKZeEhwJDMprg4M0pNbJy7SmJ+kkr6TVZEEcBoN0EAedN+sJncRjfJAOwqDzpNGukw6LM9lnvJJOgzHR+HaWNBj8hM6pjg4AHyo1LYopCHEkMKgBNzhIQ2qdvFDeKR2Ek9BJGKTBZEEcBoN0EAedN+sJncRjfJAOwqDzpNGukw6LM9lnvJJOgzHR2AEg/NGcFsOep8Z5w5k2T4IjgUGZbHCQhtQ6eZnW9CSd5JW0miyIw2CQDuKg82Y9oZN4jA/SQRh0njTaddJhcSb7jFfSaTAmGjsAdAD4Zf9Qc5ohI4FBDb7BQRpS6+Rl40EwXhI6CYN0mCyIw2CQDuKg82Y9oZN4jA/SQRh0njTaddJhcSb7jFfSaTAmGjsAdADoADC9QcHzJzwIxk5CJ2GQDvM4EofBIB3EQefNekIn8RgfpIMw6DxptOukw+JM9hmvpNNgTDR2AOgA0AFgeoOC5094EIydhE7CIB3mcSQOg0E6iIPOm/WETuIxPkgHYdB50mjXSYfFmewzXkmnwZho7ADQAaADwPQGBc+f8CAYOwmdhEE6zONIHAaDdBAHnTfrCZ3EY3yQDsKg86TRrpMOizPZZ7ySToMx0dgBoANAB4DpDQqeP+FBMHYSOgmDdJjHkTgMBukgDjpv1hM6icf4IB2EQedJo10nHRZnss94JZ0GY6KxA8CN9KgoVFRD+V04TANSFibPRE2I51V0kg+zTl5N3oRBOhIchDHVSB7+XicdhGN0TjlIQ2qdvHwVH4m3L5EF5W3qSjoMB2GQjsh/B4BI3tbJzNTId+JIXAJTs0RNiIf6gs6bLAzGxh7yavImDPKR4CCMqUby0AHg3wlR5lQzm/nT+8iHue+EkciCOExOpMNwEAbp6ABACX1Yp6JMC2IGmcQlMLYTXoiH8qTzJguDsbGHvJq8CYN8JDgIY6qRPHQA6ADwWY9Q/1H/mv4jDoNBOgwHYZCODgCUUAeAiwld226anBCnl4DwU+vk1fggDNKa4CCMqUby0AGgA0AHgL8SoLtId6kDACXUAeBiQte2Jz4W00twTfH93eTV+CAMUpfgIIypRvLQAaADQAeADgD/6gF6eOjhMg/PCRxm8iOdxmsiL+J5FZ3kw6yTV5M3YZCOBAdhTDWShw4AHQA6AHQA6ADwyS1IPML00NuHenJZDceGTqOD9lBNjA/CIA0JDsKYaiQPHQA6AEzeFOpf03+JHicdhoMwyEv/CoAS+rBORZkW5I2OOPoLwPuiJDK/2Aa3tlNdjQ/CIGEJDsKYaiQPHQA6AHQA6C8A/QWgvwD8/wTog2Q/KE/vow+j8UEY5CHBQRhTjeShA0AHgA4ABw0A5sJPHw06bx4No5NwEjqII6GTOIwP0pHASOgkDPJB51NDRkIHaTU1IYwNnaTB+PgqOo1XyuuE9a16bORFXowGwqCaGQ7CoPXIXwEYo2SGMOg8GX1bJw6DkdBBPAmdxGF8kI4ERkInYZAPOt8BwCSU3bPRWwnFCZ0GI6H1aYzEPTMaN/IiL0YDYZBXw0EYtN4BgBL6sL5SlB8/Lqq6vt34oAZOYJByw0EY5IPOdwAwCWX3mLon6jpVndBpMKY6N85v1WMjL/JiNBAG1cRwEAatdwCghDoA/DIh06AnXIKphg4AFy9JYPtGbwVkqn9/Qv1nvCa0Po1BPlP8G3mRF6OBMCgPw0EYtN4BgBLqANABIPQPDacPgmnVxKOxoZO8GB9fRafxSnmdsL5Vj428yIvRQBhUM8NBGLTeAYAS6gDQAaADwMVbMt9uHr/pAztX6f4XKKTTeE1ofRqDfKb4N/IiL0YDYVAehoMwaL0DACXUAaADQAeAi7dkvt08ftMHdq6yA8A/M9yqh+mNaW3Ji9FAGKTRcBAGrXcAoIQ6AHQA6ABw8ZbMt5vHb/rAzlV2AOgA8OsumvanuQPTHo4MAFMR5rwJkwLbwCANxqvZQ142dJAG42NDp9HxKnso8++U50YWJ3CY3kzUfeqVzhsfZg95JR10/k0DYRidtMfoIIzpegeAi3/Cp8bYKuoJOkiDac6tvIyWV9hDmX+nPDeyOIHD9GWi7lOvdN74MHvIK+mg8x0ATBWW91BR3+RQYTcwSEMqNvKyoYM0GK8bOo2OV9lDmX+nPDeyOIHD9Gai7lOvdN74MHvIK+mg8x0ATBWW91BROwC8L4hp8mkJTU2IY0MnaXildcr8O+W5kcUJHKY/E3WfeqXzxofZQ15JB53vAGCqsLyHitoBoAPAckv+Fjq6B+Zx+y3CHyDdyOIEDhNdou5Tr3Te+DB7yCvpoPMdAEwVlvdQUTsAdABYbsnfQkf3wDxuv0X4A6QbWZzAYaJL1H3qlc4bH2YPeSUddL4DgKnC8h4qageADgDLLflb6OgemMfttwh/gHQjixM4THSJuk+90nnjw+whr6SDzncAMFVY3kNF7QDQAWC5JX8LHd0D87j9FuEPkG5kcQKHiS5R96lXOm98mD3klXTQ+Q4ApgrLe6ioHQA6ACy35G+ho3tgHrffIvwB0o0sTuAw0SXqPvVK540Ps4e8kg463wHAVGF5DxU1NQBMbSWay2BMdSbyNBoMz2c4Josph/FBOoyGUzCM30lNTBakgbI65ZE2Xo2Xz/IwHJSnWSedCR3EYXRu7NnwShwbWfU/BBTuJlO0Iwr/4wc6N14IhLzSeaNhykEaUsMleTE+EhjGbweAvxJI5E0YVA/TF4Rh1klnQgdxGJ0beza8EsdGVh0Awt1kinZE4TsAXKo81ZVquvUxMTouGf+PzYksSANx9BcASvD6OmWe6C3iuK76mRMbXoljI6sOAOH+MUU7ovAdAC5VnupKNe0AcClu/JN3B4BreZrdiR4nHuKg81vr5j6TFvJKHHSe+M16BwCT0oU9pmhHFL4DwIWq7vwUTH2RGiIuGe8vAJ/GlagZ1cNwEIZZp7croYM4jM6NPRteiWMjqw4A4W4yRTui8B0ALlWe6ko1TX28EzouGe8A0AHgfwmYHqfeov6l81vrG16JYyOrDgDhjjJFO6LwHQAuVZ7qSjXtAHAp7v4VwD/iMr11Ld3/3p3ocdJBHHR+az2ROXklDjqfyKIDQCLFf2CYoh1R+A4AlypPdaWadgC4FHcHgA4A1xomvNvcZ6Kcvhl0nvjN+jEDwAmBpx5pE/xX2LPRoImcTG+RF8Kg828+EhiJPE7AOCEL0mDeg40sjU7ScUp/kpeEzkQWhLGxTlkl+rMDwIdKUgOaomw0xwkclNUJGs2H11wkqrvJIoFxSqZTHSdkQRpMX0xzMOeNTsI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL92QGgA8DtXjaX9TZ48GDiIhGGySKBEYzlt0KdkAVpSDywiZCNTuI5pT/JS0JnIgvC2FinrBL9GRkAEkIJwzQGFYU46LxZNzoTOgzPZ3oTGkwetId8GJ2EQRrMOulIaCAOo3NjD3lN+CCON58Jno28phwmC+IwWU15DAfpTKyTD6MzgTH1Qhqm+P//Dv0ZYNkINCBz5cEwOk1eVFzD0wGAUvTrVLNpPV7pg0ZeKSuTOnG8Ul7G72d7TBbEYWoy5TEcpDOxTj6MzgTG1AtpmOJ3AEgk+AHDFM00IEkzPB0AKEW/TjWb1uOVPmjklbIyqRPHK+Vl/HYAmKb08zz1junPBMbUEWmY4ncASCTYAWCUIjV54rKOBP7vMOkgH0YDcRiMjT3kNeGDODoAXKu0qYnJvH+o+CsBk+e1Cv1797Qehr9/BWBSurDHFC3RPIanl/VC4WAr1Wxaj61HJZEIeaWsjAbieKW8jN/P9pgsiMPUZMpjOEhnYp18GJ0JjKkX0jDF//93qP8GIBHjTwxTNNOApMrwdACgFP061Wxaj1f6oJFXysqkThyvlJfx2wFgmpJ/g01/Uv8ZjKkj0jDF7wCQSPADhilaonkMTweAXIGpZtN6vNIHjbxSVqYqxPFKeRm/HQCmKXUAuJNgfwG4k9onZ7YeLsPTASBXXPqoTevxSh808kpZmaoQxyvlZfx2AJim1AHgToIdAO6k1gEglho99OZjQhgJsaQjoYE4Ej4SGOQ14YM4OgBcq6Spicm8f6j4KwGT57UK/Xv3tB6Gf20AMGKe3pMINFH4hA7KKqGTOIwP0mEwSAdx0Pm39amOEzQYn4k95NVkSRhGp+ExOE9/1EhnIgvySRrMR40wEj6Ig3wmfCQ4DAbtSWRBHB0AKKEP66c0OclO6CQO06Ckw2CQDuKg8x0ATEI/91DepqaEYRQZHoPTAeCvBKgmlDedN7UgDoNBOjY4jE7ak9BJHB0AKKEOAL9MyDToq1xG4+V3fygutupj2xM1JQwjflozw7GhM8FBXkxWpIMw6DxpTAziiUHG6Ex4JR7Km86b9Q4AJqV/7EkUfqWwP35cdHZ9u/FBeRkMUkYcdD7x8JygwfhM7CGvpqaEYXQaHoPzuwe7RBbk02RFOgiDzpPGxD3sAGBS/rmnA8C1vPBnMgNHF8lg0J7EZSQO44N0GAzSQRx0PvHwnKDB+EzsIa+mpoRhdBoeg9MB4K8EqCaUN503tSAOg0E6NjiMTtqT0EkcHQAooQ/r1FwGbqWw/QXAlOL/9kxr8ip9cSmUX2wmryZLwjA6DY/B6QDQAeBqnyT6lzhX+nvrvwRIZjfWE4EmCp/QQXkldBKH8UE6DAbpIA46/7Y+1XGCBuMzsYe8miwJw+g0PAanA0AHgKt9kuhf4lzp7w4AVIb364nCrxS2vwBcKuy0Jq/SF5dC6S8A+LO4yZN6K9E7pIM0vJ0nHYRB50ljYhBP+DA6E16Jh/Km82Y98lcAhuhV9kwLu1G0RJMbn+QlgZHoC9JBPkyepNNwEIZZJ68G44Q9W3n97j/dm95KZJHoC9LxKhwn9LfRkMibMEhHB4APCU2bfFoQKtjf66STdNB5M40nMKzfyUNOWZhHmnQaDsIw6yZzg/O792zlNekbk5HxQTUzGKSFOOh86r4TD3lN+CANp6wnsiAM8toBoAPAL3uEmstcVsKgBjXrpMNoIAzSYTgIw6xPdRqOjT1beXUA8NWkmiR6b4PDO/69OxNZEAY57ADQAaADgPj7T7pI04tI+H+vJx5hy/Xkvq28OgD4KlJNEr23weEd/96diSwIgxx2AOgA0AGgAwC9E/H16cOVELTxQXvTSTyJLIjD5EU6XoXDeD1hTyJvwiCfHQA6AHQAEI80XaTpRST8/gJgE/L7Nj5oHQDe14PuSaImvgN+785EFoRBDjsAdADoANABgN6J+Pr04UoISnxsjA/iMRjklzjo/Ns66XgVDuP1hD2JvAmDfHYA6ADQAaADAL0T8fXpw5UQtPFB6y8A/QXgV71Kd8D0J2HQPekA0AGgA0AHAHon4uvThyshyDywxGN8EI/BIB3EQef7C4BJKLuH6m5qShikuAMAJXRx3RSNIE1RpzwbHOTTrBudhDPNyjyOpCH1J0HyksiLvJAGOp9a3/Ca0HpKXuRlI89EFt9Fp8lqmkUHALoVF9dN0QjSFHXKs8FBPs260Uk406w6ALxPOJEn1cysJ3rD8Ez3nJIX+djIM5HFd9Fpsppm0QGAbsXFdVM0gjRFnfJscJBPs250Es40qw4AHQCoxz5bT/TfhN+eTdw14kpk8V10mqymWXQAoI69uG6KRpCmqFOeDQ7yadaNTsKZZtUBoAMA9VgHAJfQKXeR1J6g02iYvo8dAKgTLq6bohGkKeqUZ4ODfJp1o5Nwpll1AOgAQD3WAcAldMpdJLUn6DQapu9jBwDqhIvrpmgEaYo65dngIJ9m3egknGlWHQA6AFCPdQBwCZ1yF0ntCTqNhun72AGAOuHiuikaQZqiTnk2OMinWTc6CWeaVQeADgDUYx0AXEKn3EVSe4JOo2H6PnYAoE64uG6KRpCmqFOeDQ7yadaNTsKZZtUBoAMA9VgHAJfQKXeR1J6g02iYvo+RAcAIpcBfZX0auPFp8jxBh9FgvHyWieEwmdKeqU7CP2WIMD4pc8Kg8yarjT3kY0NDqi9Iq/FKdTMYpCOxPtVJ5980JrwSD3HQ+USWHQAuprhSlB8/UNUJOowGanIyajgIw6xPdRqOhBfSSRx03nyQCIM0mKw29pCPDQ0m74QO45XqZjASWgljqpPOdwCgCnxYP6UxLsq+td00zy3gfxwyeZ6gw2gwXj7LcYYmLAAADXhJREFUy3BM805deNKR8EJ5EgedNx8kwiANlNPWOvnY0rGRl/FKOgzGRmZTnXQ+9R4QD+VJ5xNZ9xeAiymuFKW/APxfVTbyTl14aqWEl+mjQec7AFAV8+uJviBVG3UnDal1you80vnUe0A8CZ3TTDsAXEyQinoR7j+3U2OYR3pDh8nCeOkvAL5alCfVhM6b3iIM0uDdPruTfDzL/hN9Iy/jlXQYjI3MpjrpfAeAi1U8pTEuyr613TTPLeB/HDJ5nqDDaDBeOgD4jqE8qSZ0vgOAr0VqJ9UswbNR94ROg0F5kVc63wHAVOHiB+si5LHbTfNMxVMDm0d6qsFcApOF8dIBwFeL8qSa0HnTW4RBGrzbZ3eSj2fZ+wvA3Xypv6iudN68fUY78SR0Gh2f7elfAVxMkIp6Ee4/t1NjmEd6Q4fJwnjpAOCrRXlSTei86S3CIA3e7bM7ycez7B0A7uZL/UV1pfMdAC5WhgI3j8pFyse2kxdqHjpvskhgUECGgzBOWd+oScIrZU4+zMNkMKZeyMcU39yRBIfxkcjT8Ez9nKBzS0OCh/KmmhkNhEEazLrR8RnO2i8AU6EmjMQeKhr5oPPmcUtgUBaGgzBOWd+oScIrZU4+OgAkqvATg+ph7qpRZHgMzmd7TO8Qx1TnloYEzzQLo2GaJ2lM9GcHgA8pU9Go8HTeFC2BQc1jOAjjlPWNmiS8UubkowNAogodAH6VIvUnpW/6lzCMhgTPVIfRYLyQDlo3Oj7D6ADQAYB67Ph1ugTmIhJGIgTSYTQkMKZeSMMU3wzJCQ7jw9SEtBgewqD1E3RuaUjwUJ5UM6OBMEiDWTc6OgCYJP+3h4pGgdN587glMMiy4SCMU9Y3apLwSpmTj/4CkKhCfwHoLwDcRxt3lVXwDvNmdADgHP9vx7TwdL4DwIViyK10CRI1kVI+3UY6yEcHgEQVOgB0AOA+2rirrIJ3mDejAwDn2AHgQkanbaVLQJfZDGUJz6SDfHQASFShA0AHAO6jjbvKKniHeTM6AHCOHQAuZHTaVroEdJk7AFyrqMnzGuK/d1NNp/hmmEr1xavkNdWZqJnRkOCh/iEdRgNhkAazbnR0ADBJ/m8PFY0Cp/PmUUlgkGXDQRinrG/UJOGVMicf5qNlMKZeyMcU39yRBIfxkcjT8Ez9nKBzS0OCh/KmmhkNhEEazLrR8RIDwClhkQ4KnM6boib2kE7DQV4MB2EYHbSHdGxoII1mnXyYAcDwPL3H+CANpmbEQxh0PpW34aE8puuUxUlD19TrKeep7qYm5IU46Pwx/zPARBhk1oRFOgiDzpPG1DrpNDzkxXAQhtFBe0jHhgbSaNbJR+qDZLRM9hgfhG9qRjyEQedTeRseymO6Tll0AJgm/O/zVHdTE1JFHHS+A8CHhKgoFDidp4Kk1kmn4SEvhoMwjA7aQzo2NJBGs04+Uh8ko2Wyx/ggfFMz4iEMOp/K2/BQHtN1yqIDwDThDgCfJkiXwDTotESkwVx4wtjwYXIgnQaDvBgOwjA6aA/p2NBAGs06+TD9aXie3mN8kAZTM+IhDDqfytvwUB7TdcqiA8A04Q4AHQD++OMPc9HyrXa9+YwG8mIeNsIwOmgP6djQQBrNOvlIfZCMlske44PwTc2IhzDofCpvw0N5TNcpiw4A04Svv8GmJqRq2lv9K4APCVNRKHA6TwVNrZNOw0NeDAdhGB20h3RsaCCNZp18pD5IRstkj/FB+KZmxEMYdD6Vt+GhPKbrlEUHgGnCHQA+TZAugWnQaYlIg7nwhLHhw+RAOg0GeTEchGF00B7SsaGBNJp18mH60/A8vcf4IA2mZsRDGHQ+lbfhoTym65RFB4Bpwh0AOgD0rwD+1QPm4ZlePXpgNzRMPdgH+BW8UD1MVsYn8RAGne8AYCp1bQ/V5Bra2bupvxJZEAcl1L8C+JAQFYUCp/P2oafCTdeNTuKgLFIPKOmg9Q2dGxzkc2vdeN3S8jQP3ZONLEjD1ptCOhJZEIepN+lIcBgdtId00vnEegeADgC3+8g08AmXbUPnBsftQoUPGq9hyt8GR/27kQVp6ADwvj2oJibPjYYjnRsaOgB0ALjdZ6aBT7hsGzo3OG4XKnzQeA1T/jY46t+NLEhDB4AOAHcvSAeADgB3e+cP8/iZx+u2AHlwQ+cGh7T7+Dbj9XERSwTUvxtZkIYOAB0A7l6HDgAdAO72TgeAfyRnPgTmIb9djMWDxuuinEepqGYbWZCGDgAdAO5egg4AHQDu9k4HgA4At3vnVQ7Sx7cDwM9KJrKgvE3fkI4Eh9FBe0gnnU+sdwDoAHC7j0wDn3DZNnRucNwuVPig8Rqm/G1w1L8bWZCG/gLQXwDuXpAOAB0A7vZOfwHoLwC3e+dVDtLHtwNAfwG428sbvUPaOgB0AKAe+eW6aWB6QG+TXzi4oXOD44LlR7car48KWASn/t3IgjT0F4D+AnD3SnQAOHAASFx4g3G3af4+t/H4GY3kdUMnaTA+jE7iMRhGy2QPaTQfLIMx0Wg0GHyjk2pCGHT+TSdhGC+G5zOchAajc2PPNAtTkwTHNIsOAB0AbvfQCQ18ykVLPH4mT+IxGLcLLg+SRvPxNRhSzi+3JbIyOomHMOi8uQMmK8PTAcAk+deeRF09272dHQA6ANzrnD/+UP8G4Db4hYMnXDTSYOyYB5h4DIbRMtlDGjsAvE+X8jI1JQxTT8PTAcAk2QHgXylRcyUamEpDGhJTm/FBOrYwKC9aJx90PrVOeW3oJA3Gq9FJPAbDaJnsIY0dADoATPpr42ziHtE9SHBMs+gvAP0F4HYPndDAiaHtdgD/OEiX3XCYPInHYBgtkz2ksQNAB4BJf22cTdwjugcJjmkWHQA6ANzuoRMauAPA+/KdUBN6+DoAdAC4/egsHUzcI7oHCY5pHB0AOgDc7qETGrgDQAeAuw2c6F965BPDjtFpdFBOhuczjIQG0ri1Ps3ilHeJ8uoA0AGAeuSX64lLcpv8Hwfp4dnQSRqMT6OTeAyG0TLZQxoTH8WJvr/PJrLa8Gp0Gh2UmeHpAEAp/lynmkzz9kp+vfOYASBhJoGxUTTiMD6oeYiDzhsNxGEeeuJJcBgM0rGVF+mg9VfRST4S64ksEjoIg/rT+CAM0mDWSYfRsIFBXoxOwiAfb+eJx2CQjul6B4APCW4UjThMUal5iIPOGw3E0QHgfYomL5P7Z3u26jrVuXE+kcWGTuoL44MwEj5Ih9GwgUFejU7CIB8dAD4kaAKj0DfWqTkSPojD+CQdxEHnjQbi6ADQAcD00VN7Ej3+lLZ/4tI9Mj4II+GDdBgNGxjk1egkDPLRAaADwC97aKMBicM0MF0C4ugA0AGAeujJ9USPP6nvb2y6R8YHYSR8kA6jYQODvBqdhEE+OgB0AOgAEPivBZrLSpfRYCQuPGEkdBAHZUHnzcNlME7Yk8hiwwf1hfFBGAkfpMNo2MAgr0YnYZAPc48MBumYrvffAHxIkJojUTTiMEUlHcRB540G4ugvAP0FwPTRU3sSPf6Utn/i0j0yPggj4YN0GA0bGOTV6CQM8tEBoL8A9BeA/gLwrgcSD0/iYSKMDZ2kIbFuHukEzxSD8jY+CGOq0QzzRgN5SWCQV8NBGOSjA0AHgA4AHQA6ANBL+uC6eaQfpNfQ9EEyPghDi/lkI+kwGjYwyKvRSRjkowMAJfii61T4U5orES95TXAQRiJP4jB/ujEYJ+xJ5PUqdZ/qNFkRRwKD+sZwEAb5oPMnrU/zMFlMOcybQhxG57Qua/8GYCr0lPNUFCqq8UEcZro0PLTH6CCM6XoiT6PhBK9GJ+1J5HVCFsbHVGeCI4HxXWpKPu26yfwzLNM3U44OALaaL7aPmmejcToA5JuG6ppnfAZxq/+eUf8T1fiY1izBkcCgLA0HYUyzIvzN9WkeJospRweAzY5Y5KLm2WicDgD5glNd84zPIG713zPqOwD8V65fpaapnpnmYe76lKMDQKrah+FQ82w0TgeAfFNQXfOMzyBu9d8z6jsAdADgzpr2uLnrU44OAFzHl9xBzbPROB0A8q1Ddc0zPoO41X/PqO8A0AGAO2va4+auTzk6AHAdX3IHNc9G43QAyLcO1TXP+AziVv89o74DQAcA7qxpj5u7PuXoAMB1fMkd1DwbjdMBIN86VNc84zOIW/33jPoOAB0AuLOmPW7u+pSjAwDX8SV3UPNsNE4HgHzrUF3zjM8gbvXfM+o7AHQA4M6a9ri561OObzUAcMm6owk0gSbQBJpAEzgpgch/COgkQ9XSBJpAE2gCTaAJcAIdADij7mgCTaAJNIEm8OUS6ADw5UpaQ02gCTSBJtAEOIEOAJxRdzSBJtAEmkAT+HIJdAD4ciWtoSbQBJpAE2gCnEAHAM6oO5pAE2gCTaAJfLkEOgB8uZLWUBNoAk2gCTQBTqADAGfUHU2gCTSBJtAEvlwCHQC+XElrqAk0gSbQBJoAJ9ABgDPqjibQBJpAE2gCXy6BDgBfrqQ11ASaQBNoAk2AE+gAwBl1RxNoAk2gCTSBL5dAB4AvV9IaagJNoAk0gSbACXQA4Iy6owk0gSbQBJrAl0ugA8CXK2kNNYEm0ASaQBPgBP4fFjlhGntgbgsAAAAASUVORK5CYII="
  }
};
class ARCore {
  constructor() {
    this.desktopInfoContainer = null;
    this.mobileInfoContainer = null;
    this.desktopInfoContainer = document.querySelector(
      ".information-container-desktop"
    );
    this.mobileInfoContainer = document.querySelector(
      ".information-container-mobile"
    );
  }
  supportsWebGL() {
    if (!window.WebGLRenderingContext) {
      console.error("WebGL is not supported in this browser.");
      return false;
    } else {
      try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) {
          console.error("Could not create WebGL context.");
          return false;
        } else {
          return true;
        }
      } catch (e2) {
        console.error(
          "An error occurred while creating WebGL context:",
          e2
        );
        return false;
      }
    }
  }
  getProductConfig(productHandle) {
    return arConfigs[productHandle] || null;
  }
  hideSection() {
    const parentContainer = document.querySelector(
      ".parent-container"
    );
    if (parentContainer) {
      parentContainer.style.display = "none";
    }
  }
  initializeAR(productHandle, arOnRightSide = false) {
    const arProductConfig = this.getProductConfig(productHandle);
    if (!arProductConfig || !this.supportsWebGL()) {
      this.hideSection();
      return false;
    }
    const arPromptButton = document.querySelector(
      ".ar-mobile-prompt"
    );
    const modelViewer = document.querySelector(
      "#model-viewer-frame"
    );
    const overlayBackground = document.querySelector(
      ".overlay-background"
    );
    if (!modelViewer || !overlayBackground || !arPromptButton) {
      console.error("Required AR elements not found");
      return false;
    }
    modelViewer.src = arProductConfig.modelSrc;
    modelViewer.setAttribute("max-field-of-view", arProductConfig.maxFOV);
    arUtils.initialiseUtils(
      modelViewer,
      overlayBackground,
      arPromptButton,
      arProductConfig
    );
    for (const hotspotKey in arProductConfig.arHotspots) {
      const hotspotElement = document.createElement("button");
      arUtils.initialiseHotSpotButtonElement(
        arProductConfig.arHotspots[hotspotKey],
        hotspotElement
      );
      modelViewer.appendChild(hotspotElement);
    }
    const arSupportedHandler = () => {
      const isArSupported = modelViewer.canActivateAR;
      const arQRImage = document.getElementById(
        "ar-qr"
      );
      if (!isArSupported) {
        if (arProductConfig.base64QRCode && arQRImage) {
          arQRImage.src = arProductConfig.base64QRCode;
          arQRImage.style.opacity = "1";
        }
        arPromptButton.style.display = "none";
        if (this.mobileInfoContainer) {
          this.mobileInfoContainer.style.display = "none";
        }
        if (this.desktopInfoContainer) {
          this.desktopInfoContainer.style.opacity = "1";
        }
      } else {
        if (arQRImage) {
          arQRImage.style.display = "none";
        }
        arPromptButton.style.opacity = "1";
        if (this.mobileInfoContainer) {
          this.mobileInfoContainer.style.opacity = "1";
        }
        if (this.desktopInfoContainer) {
          this.desktopInfoContainer.style.display = "none";
        }
      }
      setTimeout(() => {
        arUtils.initialiseAR();
      }, 0);
    };
    modelViewer.addEventListener("load", arSupportedHandler);
    if (arOnRightSide) {
      const arContainer = document.querySelector(
        ".ar-container"
      );
      if (arContainer) {
        arContainer.classList.add("ar-container-right-side");
      }
    }
    return true;
  }
}
const arCore = new ARCore();
const arStyles = safeCss(`
  :host {
    display: block;
  }

  #ar-qr {
    margin: 1em 0;
    opacity: 0;
  }

  #ar-prompt {
    opacity: 0;
  }

  .ar-mobile-prompt {
    display: flex;
    align-items: center;
    gap: 0.4em;
    border-radius: 3em;
    padding: 0.4em 0.8em;
    box-shadow: 0 0 5px 5px #33333340;
    background: white;
    cursor: pointer;
    position: absolute;
    bottom: 1em;
    left: 50%;
    transform: translateX(-50%);
    width: max-content;
  }

  .ar-mobile-prompt-text {
    color: #5484EC;
    font-size: 1.1rem;
  }

  .ar-mobile-prompt-icon {
    /* Empty for now */
  }

  .parent-container {
    max-width: var(--page-container-width);
    margin-right: auto;
    margin-left: auto;
    padding-right: var(--container-pad-x);
    padding-left: var(--container-pad-x);
  }

  .section-container {
    display: flex;
  }

  @media only screen and (max-width: 1099px) {
    .section-container {
      flex-direction: column;
      gap: 2rem;
    }

    .ar-container {
      width: 100%;
      height: min(90vw, 40em);
    }

    #ar-qr {
      width: min(80%, 30rem);
    }
  }

  @media only screen and (min-width: 1100px) {
    .section-container {
      flex-direction: row;
      gap: 3rem;
      align-items: center;
    }

    .information-container-desktop {
      flex-basis: 35%;
    }

    .ar-container {
      flex-basis: 65%;
      height: min(60vh, 49em);
    }

    #ar-qr {
      opacity: 0;
      width: min(100%, 20rem);
    }

    .ar-container-right-side {
      order: 3 !important;
    }
  }

  .information-container-desktop {
    order: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
    max-width: 31rem;
    margin: 0 auto;
    opacity: 0;
  }

  .information-container-mobile {
    order: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
    max-width: 80vw;
    margin: 0 auto;
    opacity: 0;
  }

  .description li {
    list-style-type: disc;
    list-style-position: inside;
  }

  .ar-container {
    order: 1;
    background: #eee;
  }

  .flip-img {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .ar-row-container {
    display: flex;
    gap: 0.8rem;
  }

  .ar-row {
    display: flex;
    gap: 0.4rem;
  }

  .ar-img-container {
    width: 30px;
  }

  .ar-img {
    width: 30px;
    object-fit: contain;
  }

  .ar-img-smaller {
    width: 24px;
  }

  #model-viewer-frame {
    width: 100%;
    height: 100%;
    container-type: inline-size;
  }

  /* Container queries for mobile */
  @container (max-width: 500px) {
    button.hotspot:not(.hotspot-opened) {
      font-size: 0.85rem !important;
    }
    
    button.hotspot[data-visible] {
      padding: 1rem !important;
    }
    
    .mobile-annotation {
      padding-top: 0.6rem;
      margin: 0px 0.5em 0.5em !important;
    }
    
    .mobile-annotation-title {
      font-size: 1.2rem !important;
    }
    
    .mobile-annotation-description {
      font-size: 1rem !important;
      line-height: 1.5rem;
    }
    
    button.hotspot[data-visible]:not(.hotspot-opened):hover {
      opacity: 1 !important;
      padding: 0.7rem 0.75rem !important;
    }
  }

  .touch-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .overlay-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.5s ease-out;
  }

  .mobile-annotation-container {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    z-index: 5;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  .mobile-annotation {
    border-radius: 8px;
    background: white;
    position: relative;
    transition: margin 0.2s ease-in-out;
  }

  .mobile-annotation-title {
    font-weight: 600;
    font-size: 1.3rem;
    margin: 0 0 0.5em;
  }

  .mobile-annotation-description {
    font-size: 1.1rem;
    margin: 0;
    text-align: justify;
  }

  .mobile-hotspot-close {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 25px;
    width: 25px;
    cursor: pointer;
  }

  .hotspot-opened {
    background: transparent;
    outline: none;
    border: none;
  }

  .hotspot-modal {
    cursor: auto;
    position: relative;
    z-index: 3;
    border-radius: 0.6em;
    padding: 0.75em 1em 1em;
    background: white;
    transition: opacity 0.1s ease-out;
  }

  .modal-close-icon {
    position: absolute;
    top: 4px;
    left: 12px;
    height: 20px;
    width: 20px;
    padding: 0.3em;
  }

  .modal-close-icon:hover {
    cursor: pointer;
  }

  .modal-title {
    font-size: 1.4rem;
  }

  .modal-description {
    margin: 0;
    font-weight: 400;
    text-align: left;
  }

  .modal-description ul,
  .mobile-annotation-description ul {
    list-style-position: inside;
    list-style-type: disc;
  }

  .hotspot-modal-top-container {
    display: flex;
    justify-content: center;
  }

  button.ar-prompt {
    opacity: 0;
  }

  button.hotspot {
    position: unset;
    border: none;
    outline: none;
    border-radius: 100em;
    padding: 1rem;
    background: white;
    border: 2px solid black;
    transition: opacity 0.2s ease-in-out;
    min-width: 1em;
    display: flex;
  }

  button.hotspot.hide {
    opacity: 0 !important;
    pointer-events: none;
  }

  button.hotspot-clicked {
    border-color: transparent !important;
  }

  button.hotspot:not(.hotspot-opened):hover {
    cursor: pointer;
  }

  button svg.hotspot-icon {
    height: 16px;
  }

  button.hotspot[data-visible] {
    font-weight: 600;
    padding: 1rem;
    opacity: 0.25;
  }

  button.hotspot[data-visible]:not(.hotspot-opened):hover {
    opacity: 1 !important;
    padding: 0.7rem 0.75rem;
  }

  button.hotspot[data-visible]:not(.hotspot-opened):hover svg.hotspot-icon {
    display: none;
  }

  button.hotspot[data-visible]:not(.hotspot-opened):hover .hotspot-text {
    display: block;
    text-wrap: nowrap;
  }

  button.hotspot:not([data-visible]) {
    border: 2px solid black;
    display: flex;
    justify-content: center;
  }

  button.hotspot:not([data-visible]) svg.hotspot-icon {
    display: block;
  }

  button.hotspot:not([data-visible]) .hotspot-text {
    display: none;
  }

  button.hotspot-non-persist:not([data-visible]) {
    opacity: 0 !important;
    pointer-events: none;
  }

  @media (hover: hover) {
    button.hotspot:not(.hotspot-non-persist):not([data-visible]):hover {
      font-weight: 600;
      width: auto;
      opacity: 1 !important;
      padding: 0.7rem 0.75rem;
    }
    
    button.hotspot:not(.hotspot-non-persist):not([data-visible]):hover svg.hotspot-icon {
      display: none;
    }
    
    button.hotspot:not(.hotspot-non-persist):not([data-visible]):hover .hotspot-text {
      display: block;
      text-wrap: nowrap;
    }
  }

  @media not all and (hover: hover) {
    button.hotspot:not([data-visible]):hover {
      opacity: 1 !important;
    }
  }

  button.hotspot-opened {
    padding: 0 !important;
    border-radius: 0;
    background: transparent;
    pointer-events: none;
  }

  button:not(.hotspot-opened) .hotspot-text {
    display: none;
  }

  @keyframes fadeInHotspot {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOutHotspot {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.25;
    }
  }

  /* Instruction container styles */
  .instructions-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .mobile-instructions-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  /* AR Title styles using design system */
  .ar-desktop-title {
    ${typographyClasses["text-heading-2"]}
    margin: 0 0 ${spacing["gutter-base"]};
  }

  .ar-mobile-title {
    ${typographyClasses["text-heading-3"]}
    margin: 0 0 ${spacing["gutter-base"]};
  }
`);
var __create$2 = Object.create;
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __knownSymbol$2 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$2 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$2 = (target, value) => __defProp$2(target, "name", { value, configurable: true });
var __decoratorStart$2 = (base) => [, , , __create$2(base?.[__knownSymbol$2("metadata")] ?? null)];
var __decoratorStrings$2 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$2 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$2("Function expected") : fn;
var __decoratorContext$2 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$2[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$2("Already initialized") : fns.push(__expectFn$2(fn || null)) });
var __decoratorMetadata$2 = (array, target) => __defNormalProp$2(target, __knownSymbol$2("metadata"), array[3]);
var __runInitializers$2 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$2 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$2[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$2(k2 < 4 ? target : { get [name]() {
    return __privateGet$2(this, extra);
  }, set [name](x2) {
    return __privateSet$2(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$2(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$2(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$2(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$2(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$2 : __privateMethod$2)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$2(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$2(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$2("Object expected");
    else __expectFn$2(fn = it.get) && (desc.get = fn), __expectFn$2(fn = it.set) && (desc.set = fn), __expectFn$2(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$2(array, target), desc && __defProp$2(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$2 = (obj, member, msg) => member.has(obj) || __typeError$2("Cannot " + msg);
var __privateIn$2 = (member, obj) => Object(obj) !== obj ? __typeError$2('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$2 = (obj, member, getter) => (__accessCheck$2(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$2 = (obj, member, value) => member.has(obj) ? __typeError$2("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$2 = (obj, member, value, setter) => (__accessCheck$2(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$2 = (obj, member, method) => (__accessCheck$2(obj, member, "access private method"), method);
var _productConfig_dec, _isVisible_dec, _title_dec$1, _arOnRightSide_dec, _productHandle_dec, _a$2, _ArView_decorators, _init$2, _productHandle, _arOnRightSide, _title$1, _isVisible, _productConfig;
_ArView_decorators = [t$1("ar-view")];
class ArView extends (_a$2 = BaseDesignSystemComponent(arStyles), _productHandle_dec = [n$1({ type: String, attribute: "product-handle" })], _arOnRightSide_dec = [n$1({ type: Boolean, attribute: "ar-on-right-side" })], _title_dec$1 = [n$1({ type: String, attribute: "title" })], _isVisible_dec = [r$1()], _productConfig_dec = [r$1()], _a$2) {
  constructor() {
    super(...arguments);
    __privateAdd$2(this, _productHandle, __runInitializers$2(_init$2, 8, this, "")), __runInitializers$2(_init$2, 11, this);
    __privateAdd$2(this, _arOnRightSide, __runInitializers$2(_init$2, 12, this, false)), __runInitializers$2(_init$2, 15, this);
    __privateAdd$2(this, _title$1, __runInitializers$2(_init$2, 16, this, "AR View")), __runInitializers$2(_init$2, 19, this);
    __privateAdd$2(this, _isVisible, __runInitializers$2(_init$2, 20, this, true)), __runInitializers$2(_init$2, 23, this);
    __privateAdd$2(this, _productConfig, __runInitializers$2(_init$2, 24, this, null)), __runInitializers$2(_init$2, 27, this);
  }
  async firstUpdated() {
    await this.initializeAR();
  }
  async validateModelSrc(modelSrc) {
    try {
      const response = await fetch(modelSrc, { method: "HEAD" });
      return response.ok;
    } catch (error) {
      console.error(
        `Failed to validate model source: ${modelSrc}`,
        error
      );
      return false;
    }
  }
  async initializeAR() {
    if (!this.productHandle) {
      console.error("No product handle provided for AR view");
      this.isVisible = false;
      return;
    }
    this.productConfig = arCore.getProductConfig(this.productHandle);
    if (!this.productConfig) {
      console.error(
        `No AR configuration found for product: ${this.productHandle}`
      );
      this.isVisible = false;
      return;
    }
    if (!arCore.supportsWebGL()) {
      console.error("WebGL not supported");
      this.isVisible = false;
      return;
    }
    if (!await this.validateModelSrc(this.productConfig.modelSrc)) {
      console.error(
        `Model source not found or invalid: ${this.productConfig.modelSrc}`
      );
      this.isVisible = false;
      return;
    }
    this.updateComplete.then(() => {
      this.initializeARComponents();
    });
  }
  initializeARComponents() {
    const modelViewer = this.shadowRoot?.querySelector(
      "#model-viewer-frame"
    );
    const overlayBackground = this.shadowRoot?.querySelector(
      ".overlay-background"
    );
    const arPromptButton = this.shadowRoot?.querySelector(
      ".ar-mobile-prompt"
    );
    if (!modelViewer || !overlayBackground || !arPromptButton || !this.productConfig) {
      console.error("Required AR elements not found in component");
      this.isVisible = false;
      return;
    }
    modelViewer.src = this.productConfig.modelSrc;
    modelViewer.setAttribute(
      "max-field-of-view",
      this.productConfig.maxFOV
    );
    arUtils.initialiseUtils(
      modelViewer,
      overlayBackground,
      arPromptButton,
      this.productConfig
    );
    for (const hotspotKey in this.productConfig.arHotspots) {
      const hotspotElement = document.createElement("button");
      arUtils.initialiseHotSpotButtonElement(
        this.productConfig.arHotspots[hotspotKey],
        hotspotElement
      );
      modelViewer.appendChild(hotspotElement);
    }
    const arSupportedHandler = () => {
      const isArSupported = modelViewer.canActivateAR;
      const arQRImage = this.shadowRoot?.querySelector(
        "#ar-qr"
      );
      const desktopInfoContainer = this.shadowRoot?.querySelector(
        ".information-container-desktop"
      );
      const mobileInfoContainer = this.shadowRoot?.querySelector(
        ".information-container-mobile"
      );
      if (!isArSupported) {
        if (this.productConfig?.base64QRCode && arQRImage) {
          arQRImage.src = this.productConfig.base64QRCode;
          arQRImage.style.opacity = "1";
        }
        arPromptButton.style.display = "none";
        if (mobileInfoContainer) {
          mobileInfoContainer.style.display = "none";
        }
        if (desktopInfoContainer) {
          desktopInfoContainer.style.opacity = "1";
        }
      } else {
        if (arQRImage) {
          arQRImage.style.display = "none";
        }
        arPromptButton.style.opacity = "1";
        if (mobileInfoContainer) {
          mobileInfoContainer.style.opacity = "1";
        }
        if (desktopInfoContainer) {
          desktopInfoContainer.style.display = "none";
        }
      }
      setTimeout(() => {
        arUtils.initialiseAR();
      }, 0);
    };
    modelViewer.addEventListener("load", arSupportedHandler);
  }
  render() {
    if (!this.isVisible) {
      return E;
    }
    return x`
            <div class="parent-container">
                <div
                    class="section-container ${this.arOnRightSide ? "ar-container-right-side" : ""}"
                >
                    <div class="information-container-desktop">
                        <h2 class="ar-desktop-title">${this.title}</h2>

                        <div class="instructions-container">
                            <div class="ar-row-container">
                                <div class="ar-img-container">
                                    <img
                                        class="flip-img ar-img ar-img-smaller"
                                        src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/cursor_icon_8e7449be-e0cf-49af-a153-d2dc2b9015c5.webp?v=1754830992"
                                        alt="Cursor icon"
                                    />
                                </div>
                                <div class="ar-row">
                                    <span>1.</span>
                                    <span
                                        >Click and drag with mouse to rotate the
                                        tent or awning</span
                                    >
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/hand_pinch.avif?v=1754830615"
                                    alt="Hand pinch icon"
                                />
                                <div class="ar-row">
                                    <span>2.</span>
                                    <span
                                        >Click and hold down with two fingers
                                        and drag to re-position</span
                                    >
                                </div>
                            </div>
                        </div>

                        <img id="ar-qr" width="150" height="150" />

                        <div class="instructions-container">
                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/phone_camera.webp?v=1754830662"
                                    alt="Phone camera icon"
                                />
                                <div class="ar-row">
                                    <span>1.</span>
                                    <span
                                        >Scan the QR code with your smartphone
                                        or tablet camera</span
                                    >
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/ar_box.webp?v=1754830760"
                                    alt="AR box icon"
                                />
                                <div class="ar-row">
                                    <span>2.</span>
                                    <span>View your tent or awning in 3D</span>
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/magnify_icon_e9eef422-e9ef-4ee4-8296-24a56b2137b1.webp?v=1754830807"
                                    alt="Zoom icon"
                                />
                                <div class="ar-row">
                                    <span>3.</span>
                                    <span
                                        >Place the tent or awning in your
                                        surroundings to explore in detail</span
                                    >
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/hand_pinch.avif?v=1754830615"
                                    alt="Hand pinch icon"
                                />
                                <div class="ar-row">
                                    <span>4.</span>
                                    <span
                                        >Drag with 1 finger to position the tent
                                        or awning. Use 2 fingers to rotate &
                                        pinch to resize the tent or awning</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="information-container-mobile">
                        <h2 class="ar-mobile-title">${this.title}</h2>

                        <div class="mobile-instructions-container">
                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/single_finger.webp?v=1754830865"
                                    alt="Single finger icon"
                                />
                                <div class="ar-row">
                                    <span>1.</span>
                                    <span
                                        >Hold and drag with one finger to rotate
                                        the tent or awning</span
                                    >
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/hand_pinch.avif?v=1754830615"
                                    alt="Hand pinch icon"
                                />
                                <div class="ar-row">
                                    <span>2.</span>
                                    <span
                                        >Hold down with two fingers and drag to
                                        zoom or re-position</span
                                    >
                                </div>
                            </div>

                            <div class="ar-row-container">
                                <img
                                    class="ar-img"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/feature_icon_d98f67f2-eaab-42b0-9ac2-dd759d1768ab.avif?v=1754830899"
                                    alt="Feature icon"
                                />
                                <div class="ar-row">
                                    <span>3.</span>
                                    <span
                                        >Click on feature icons to view
                                        details</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ar-container">
                        <model-viewer
                            id="model-viewer-frame"
                            src=""
                            alt="A 3D model of a Vango camp"
                            loading="eager"
                            powerPreference="high-performance"
                            renderMode="quality"
                            ar
                            camera-orbit="305deg 85deg 0m"
                            shadow-softness="0"
                            tone-mapping="commerce"
                            exposure="0.8"
                            shadow-intensity="1.25"
                            environment-image="legacy"
                            zoom-sensitivity="1"
                            pan-sensitivity="1"
                            camera-target="-0.7m 0 0.15m"
                            interpolation-decay="100"
                            camera-controls
                            interaction-prompt="none"
                            min-field-of-view="0deg"
                            max-field-of-view="40deg"
                            max-camera-orbit="auto 160deg auto"
                        >
                            <button
                                id="ar-prompt"
                                class="ar-mobile-prompt"
                                slot="ar-button"
                            >
                                <img
                                    class="ar-mobile-prompt-icon"
                                    src="https://cdn.shopify.com/s/files/1/0589/6427/9470/files/ar-mobile-icon.png?v=1754830955"
                                    width="20"
                                    height="20"
                                    alt="Open AR Model"
                                />
                                <span class="ar-mobile-prompt-text"
                                    >View in your space</span
                                >
                            </button>

                            <div class="overlay-background"></div>
                        </model-viewer>
                    </div>
                </div>
            </div>
        `;
  }
}
_init$2 = __decoratorStart$2(_a$2);
_productHandle = /* @__PURE__ */ new WeakMap();
_arOnRightSide = /* @__PURE__ */ new WeakMap();
_title$1 = /* @__PURE__ */ new WeakMap();
_isVisible = /* @__PURE__ */ new WeakMap();
_productConfig = /* @__PURE__ */ new WeakMap();
__decorateElement$2(_init$2, 4, "productHandle", _productHandle_dec, ArView, _productHandle);
__decorateElement$2(_init$2, 4, "arOnRightSide", _arOnRightSide_dec, ArView, _arOnRightSide);
__decorateElement$2(_init$2, 4, "title", _title_dec$1, ArView, _title$1);
__decorateElement$2(_init$2, 4, "isVisible", _isVisible_dec, ArView, _isVisible);
__decorateElement$2(_init$2, 4, "productConfig", _productConfig_dec, ArView, _productConfig);
ArView = __decorateElement$2(_init$2, 0, "ArView", _ArView_decorators, ArView);
__runInitializers$2(_init$2, 1, ArView);
const features = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARCore,
  get ArView() {
    return ArView;
  },
  get BriffaDesktopNarrowFilters() {
    return BriffaDesktopNarrowFilters;
  },
  BriffaDesktopSearchResultsFilters,
  get BriffaDesktopWideFilters() {
    return BriffaDesktopWideFilters;
  },
  get BriffaGenericSearchResultsFilters() {
    return BriffaGenericSearchResultsFilters;
  },
  get BriffaMobileSearchResultsFilters() {
    return BriffaMobileSearchResultsFilters;
  },
  get BriffaPaginatedResultsGrid() {
    return BriffaPaginatedResultsGrid;
  },
  get BriffaSearchDesktopFactory() {
    return BriffaSearchDesktopFactory;
  },
  get BriffaSearchMobileFactory() {
    return BriffaSearchMobileFactory;
  },
  get CollectionResultsPageBanner() {
    return CollectionResultsPageBanner;
  },
  get SearchResultsPageBanner() {
    return SearchResultsPageBanner;
  },
  get SelectedFilters() {
    return SelectedFilters;
  },
  get StickyElement() {
    return StickyElement;
  },
  arConfigs,
  arCore,
  arUtils,
  briffaCloudSearchApiSingleton,
  briffaCloudSearchFactory,
  briffaGenericSearchFactory,
  briffaSearchSingleton,
  getEncodedSlug,
  getRecentSearchesSection,
  getTrendingSection,
  isElementInView,
  localStorageProductCardBeaconKey,
  localStorageSavedProductsScrollBeaconKey,
  searchMobileFactoryStyles,
  sectionTitleClassList,
  sessionStorageSavedScrollBeaconKey,
  useResultsGridScrollMiddleware
}, Symbol.toStringTag, { value: "Module" }));
const featuredCollectionStyles = safeCss(`
    :host {
        display: contents;
    }
    
    .featured-collection-container {
        display: flex;
        flex-direction: column;
    }

    .collection-title {
        font-size: ${typography.fontSize["2xl"]};
        font-weight: ${typography.fontWeight.medium};
        line-height: ${typography.lineHeight.tight};
        color: ${colors.text.primary};
        margin-bottom: ${spacing["gutter-sm"]};
        text-align: center;
        padding: ${spacing["gutter-sm"]} 0;
    }
    
    .view-all {
        align-self: center;
        text-align: center;
        font-size: ${typography.fontSize.base};
        font-weight: ${typography.fontWeight.normal};
        margin-bottom: ${spacing["gutter-base"]};
        text-decoration: underline;
        cursor: pointer;
    }

    .products-container {
        display: flex;
        gap: ${spacing["gutter-base"]};
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        overflow-x: auto;
        overflow-y: hidden;
        
        /* Hide scrollbars */
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar {
          display: none;
        }   
        
        & > * {
            box-sizing: content-box;
        }
    }
    
    .navigation-icon {
        padding: ${spacing["gutter-sm"]};
            box-sizing: content-box;
    }

    .products-container::-webkit-scrollbar {
        height: 8px;
    }

    .products-container::-webkit-scrollbar-track {
        background: ${colors.gray[100]};
        border-radius: ${spacing["gutter-xs"]};
    }

    .products-container::-webkit-scrollbar-thumb {
        background: ${colors.gray[400]};
        border-radius: ${spacing["gutter-xs"]};
    }

    .products-container::-webkit-scrollbar-thumb:hover {
        background: ${colors.gray[600]};
    }

    .loading-state,
    .error-state {
        text-align: center;
        padding: ${spacing["gutter-2xl"]};
        font-size: ${typography.fontSize.base};
        color: ${colors.text.secondary};
    }

    .error-state {
        color: ${colors.error[500]};
    }
`);
var __create$1 = Object.create;
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __knownSymbol$1 = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError$1 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name$1 = (target, value) => __defProp$1(target, "name", { value, configurable: true });
var __decoratorStart$1 = (base) => [, , , __create$1(base?.[__knownSymbol$1("metadata")] ?? null)];
var __decoratorStrings$1 = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn$1 = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError$1("Function expected") : fn;
var __decoratorContext$1 = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings$1[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError$1("Already initialized") : fns.push(__expectFn$1(fn || null)) });
var __decoratorMetadata$1 = (array, target) => __defNormalProp$1(target, __knownSymbol$1("metadata"), array[3]);
var __runInitializers$1 = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement$1 = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings$1[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc$1(k2 < 4 ? target : { get [name]() {
    return __privateGet$1(this, extra);
  }, set [name](x2) {
    return __privateSet$1(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name$1(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name$1(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext$1(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn$1(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet$1 : __privateMethod$1)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet$1(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn$1(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError$1("Object expected");
    else __expectFn$1(fn = it.get) && (desc.get = fn), __expectFn$1(fn = it.set) && (desc.set = fn), __expectFn$1(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata$1(array, target), desc && __defProp$1(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck$1 = (obj, member, msg) => member.has(obj) || __typeError$1("Cannot " + msg);
var __privateIn$1 = (member, obj) => Object(obj) !== obj ? __typeError$1('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet$1 = (obj, member, getter) => (__accessCheck$1(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$1 = (obj, member, value) => member.has(obj) ? __typeError$1("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$1 = (obj, member, value, setter) => (__accessCheck$1(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod$1 = (obj, member, method) => (__accessCheck$1(obj, member, "access private method"), method);
var _scrollContainer_dec, _cardSize_dec, _scrollXLeftover_dec, _showRightArrow_dec, _showLeftArrow_dec, _error_dec$1, _isLoading_dec$1, _collectionData_dec, _showArrowNavigation_dec, _onlyInStock_dec, _collectionId_dec, _a$1, _BriffaFeaturedCollection_decorators, _init$1, _collectionId, _onlyInStock, _showArrowNavigation, _collectionData, _isLoading$1, _error$1, _showLeftArrow, _showRightArrow, _scrollXLeftover, _cardSize, _scrollContainer;
_BriffaFeaturedCollection_decorators = [t$1("briffa-featured-collection")];
class BriffaFeaturedCollection extends (_a$1 = BaseDesignSystemComponent(
  featuredCollectionStyles
), _collectionId_dec = [n$1({ type: String, attribute: "collection-id" })], _onlyInStock_dec = [n$1({ type: String, attribute: "only-in-stock" })], _showArrowNavigation_dec = [n$1({ type: String, attribute: "show-arrow-navigation" })], _collectionData_dec = [r$1()], _isLoading_dec$1 = [r$1()], _error_dec$1 = [r$1()], _showLeftArrow_dec = [r$1()], _showRightArrow_dec = [r$1()], _scrollXLeftover_dec = [r$1()], _cardSize_dec = [r$1()], _scrollContainer_dec = [e$5(".products-container")], _a$1) {
  constructor() {
    super();
    __privateAdd$1(this, _collectionId, __runInitializers$1(_init$1, 8, this)), __runInitializers$1(_init$1, 11, this);
    __privateAdd$1(this, _onlyInStock, __runInitializers$1(_init$1, 12, this)), __runInitializers$1(_init$1, 15, this);
    __privateAdd$1(this, _showArrowNavigation, __runInitializers$1(_init$1, 16, this)), __runInitializers$1(_init$1, 19, this);
    __privateAdd$1(this, _collectionData, __runInitializers$1(_init$1, 20, this)), __runInitializers$1(_init$1, 23, this);
    __privateAdd$1(this, _isLoading$1, __runInitializers$1(_init$1, 24, this)), __runInitializers$1(_init$1, 27, this);
    __privateAdd$1(this, _error$1, __runInitializers$1(_init$1, 28, this)), __runInitializers$1(_init$1, 31, this);
    __privateAdd$1(this, _showLeftArrow, __runInitializers$1(_init$1, 32, this)), __runInitializers$1(_init$1, 35, this);
    __privateAdd$1(this, _showRightArrow, __runInitializers$1(_init$1, 36, this)), __runInitializers$1(_init$1, 39, this);
    __privateAdd$1(this, _scrollXLeftover, __runInitializers$1(_init$1, 40, this)), __runInitializers$1(_init$1, 43, this);
    __privateAdd$1(this, _cardSize, __runInitializers$1(_init$1, 44, this)), __runInitializers$1(_init$1, 47, this);
    __privateAdd$1(this, _scrollContainer, __runInitializers$1(_init$1, 48, this)), __runInitializers$1(_init$1, 51, this);
    this.listenerCleanupAbortController = void 0;
    this.effectsHandler = () => {
      this.listenerCleanupAbortController?.abort("Dependencies updated");
      this.listenerCleanupAbortController = new AbortController();
      if (this.scrollContainer) {
        this.scrollContainer.addEventListener(
          "scroll",
          this.scrollHandler,
          { signal: this.listenerCleanupAbortController.signal }
        );
      }
    };
    this.scrollHandler = lodashExports.debounce(() => {
      const { children, scrollLeft, offsetWidth, scrollWidth } = this.scrollContainer;
      const cardSize = children[0]?.scrollWidth ?? 0;
      if (cardSize <= 0) {
        this.showLeftArrow = false;
        this.showRightArrow = false;
        return;
      }
      this.scrollXLeftover = scrollWidth - (scrollLeft + offsetWidth);
      this.showLeftArrow = scrollLeft > cardSize / 2;
      this.showRightArrow = this.scrollXLeftover > cardSize / 2;
      this.cardSize = cardSize;
    }, 200);
    this.clickHandler = (rightArrow) => {
      const moveCardCount = this.scrollContainer.offsetWidth / this.cardSize;
      const movePx = this.cardSize * moveCardCount;
      const moveDirectionPx = rightArrow ? movePx : -movePx;
      this.scrollContainer.scrollBy({
        left: moveDirectionPx,
        behavior: "smooth"
      });
    };
    this.collectionData = null;
    this.isLoading = true;
    this.error = null;
    this.showLeftArrow = false;
    this.showRightArrow = false;
    this.listenerCleanupAbortController = new AbortController();
  }
  isOnlyInStock() {
    return this.onlyInStock === "true";
  }
  isArrowNavigationEnabled() {
    return this.showArrowNavigation === "true";
  }
  connectedCallback() {
    super.connectedCallback();
    this.loadCollectionProducts();
  }
  async loadCollectionProducts() {
    if (!this.collectionId) {
      this.error = "Collection ID is required";
      this.isLoading = false;
      return;
    }
    try {
      this.isLoading = true;
      this.error = null;
      this.collectionData = await fetchCollectionProducts({
        collectionId: this.collectionId,
        onlyInStock: this.isOnlyInStock(),
        limit: 30
      });
    } catch (err) {
      console.error("Failed to fetch collection products:", err);
      this.error = "Failed to load collection products";
    } finally {
      this.isLoading = false;
    }
  }
  renderProductCards() {
    if (!this.collectionData?.products) {
      return x``;
    }
    return this.collectionData.products.map(
      (product, index2) => {
        const productCard = createProductCard(product, index2);
        productCard.idPrefix = "featured-collection-";
        const cardMinWidth = getProductCardWidth();
        productCard.classList.add(cardMinWidth);
        if (index2 === 0) {
          productCard.classList.add("pl-8");
        }
        if (index2 === this.collectionData.products.length - 1) {
          productCard.classList.add("pr-8");
        }
        return productCard;
      }
    );
  }
  goToCollection() {
    if (!this.collectionData?.handle) {
      console.error("Collection handle not available");
      return;
    }
    const { availableFilterTags } = this.collectionData;
    const availabilities = availableFilterTags[PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY];
    const inStock = availabilities[`${[PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY]}:true`]?.resultsCount;
    const outOfStock = availabilities[`${[PRODUCT_GENERAL_FILTER_TYPE.AVAILABILITY]}:false`]?.resultsCount;
    let containsOutOfStock = false;
    if (!this.isOnlyInStock() && inStock < outOfStock) {
      containsOutOfStock = true;
    }
    goToCollection(this.collectionData.handle, containsOutOfStock);
  }
  renderHeader() {
    return x`
            <div>
                <h2 class="collection-title">${this.collectionData.title}</h2>
                <p class="view-all" @click=${this.goToCollection}>View All</p>
            </div>
        `;
  }
  updated() {
    this.scrollHandler();
    this.effectsHandler();
  }
  disconnectedCallback() {
    this.listenerCleanupAbortController.abort(
      "disconnected lifecycle hook"
    );
  }
  render() {
    if (this.isLoading) {
      return x`
                <div class="featured-collection-container">
                    <div class="loading-state">
                        <wa-spinner style="font-size: 2rem;"></wa-spinner>
                    </div>
                </div>
            `;
    }
    if (this.error) {
      return x`
                <div class="featured-collection-container">
                    <div class="error-state">${this.error}</div>
                </div>
            `;
    }
    if (!this.collectionData) {
      return x``;
    }
    return x`
            <div class="featured-collection-container py-4">
                ${this.isArrowNavigationEnabled() ? x` <div class="flex gap-2 justify-center">
                          ${BriffaIcons.getLeftChevron({
      color: tokens.color.black,
      className: `navigation-icon cursor-pointer self-center mr-4 ${!this.showLeftArrow && "opacity-0 pointer-events-none"}`,
      onClick: () => this.clickHandler(false)
    })}
                          ${this.renderHeader()}
                          ${BriffaIcons.getLeftChevron({
      color: tokens.color.black,
      className: `navigation-icon cursor-pointer rotate-180 self-center ml-4 ${!this.showRightArrow && "opacity-0 pointer-events-none"}`,
      onClick: () => this.clickHandler(true)
    })}
                      </div>` : this.renderHeader()}
                <div class="products-container">
                    ${this.renderProductCards()}
                </div>
            </div>
        `;
  }
}
_init$1 = __decoratorStart$1(_a$1);
_collectionId = /* @__PURE__ */ new WeakMap();
_onlyInStock = /* @__PURE__ */ new WeakMap();
_showArrowNavigation = /* @__PURE__ */ new WeakMap();
_collectionData = /* @__PURE__ */ new WeakMap();
_isLoading$1 = /* @__PURE__ */ new WeakMap();
_error$1 = /* @__PURE__ */ new WeakMap();
_showLeftArrow = /* @__PURE__ */ new WeakMap();
_showRightArrow = /* @__PURE__ */ new WeakMap();
_scrollXLeftover = /* @__PURE__ */ new WeakMap();
_cardSize = /* @__PURE__ */ new WeakMap();
_scrollContainer = /* @__PURE__ */ new WeakMap();
__decorateElement$1(_init$1, 4, "collectionId", _collectionId_dec, BriffaFeaturedCollection, _collectionId);
__decorateElement$1(_init$1, 4, "onlyInStock", _onlyInStock_dec, BriffaFeaturedCollection, _onlyInStock);
__decorateElement$1(_init$1, 4, "showArrowNavigation", _showArrowNavigation_dec, BriffaFeaturedCollection, _showArrowNavigation);
__decorateElement$1(_init$1, 4, "collectionData", _collectionData_dec, BriffaFeaturedCollection, _collectionData);
__decorateElement$1(_init$1, 4, "isLoading", _isLoading_dec$1, BriffaFeaturedCollection, _isLoading$1);
__decorateElement$1(_init$1, 4, "error", _error_dec$1, BriffaFeaturedCollection, _error$1);
__decorateElement$1(_init$1, 4, "showLeftArrow", _showLeftArrow_dec, BriffaFeaturedCollection, _showLeftArrow);
__decorateElement$1(_init$1, 4, "showRightArrow", _showRightArrow_dec, BriffaFeaturedCollection, _showRightArrow);
__decorateElement$1(_init$1, 4, "scrollXLeftover", _scrollXLeftover_dec, BriffaFeaturedCollection, _scrollXLeftover);
__decorateElement$1(_init$1, 4, "cardSize", _cardSize_dec, BriffaFeaturedCollection, _cardSize);
__decorateElement$1(_init$1, 4, "scrollContainer", _scrollContainer_dec, BriffaFeaturedCollection, _scrollContainer);
BriffaFeaturedCollection = __decorateElement$1(_init$1, 0, "BriffaFeaturedCollection", _BriffaFeaturedCollection_decorators, BriffaFeaturedCollection);
__runInitializers$1(_init$1, 1, BriffaFeaturedCollection);
const relatedProductsStyles = safeCss(`
    :host {
        display: contents;
    }

    .related-products-container {
        display: flex;
        flex-direction: column;
        padding: ${spacing["gutter-base"]};
        margin-top: ${spacing["gutter-lg"]};
    }

    .related-products-title {
        font-size: ${typography.fontSize["2xl"]};
        font-weight: ${typography.fontWeight.medium};
        line-height: ${typography.lineHeight.tight};
        color: ${colors.text.primary};
        margin-bottom: ${spacing["gutter-base"]};
        text-align: center;
    }

    .products-container {
        display: flex;
        gap: ${spacing["gutter-base"]};
        overflow-x: auto;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        padding: ${spacing["gutter-sm"]} 0;
        
        /* Hide scrollbars */
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar {
          display: none;
        }   
    }

    .loading-state,
    .error-state {
        text-align: center;
        padding: ${spacing["gutter-2xl"]};
        font-size: ${typography.fontSize.base};
        color: ${colors.text.secondary};
    }

    .error-state {
        color: ${colors.error[500]};
    }
`);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __decoratorStart = (base) => [, , , __create(base?.[__knownSymbol("metadata")] ?? null)];
var __decoratorStrings = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"];
var __expectFn = (fn) => fn !== void 0 && typeof fn !== "function" ? __typeError("Function expected") : fn;
var __decoratorContext = (kind, name, done, metadata, fns) => ({ kind: __decoratorStrings[kind], name, metadata, addInitializer: (fn) => done._ ? __typeError("Already initialized") : fns.push(__expectFn(fn || null)) });
var __decoratorMetadata = (array, target) => __defNormalProp(target, __knownSymbol("metadata"), array[3]);
var __runInitializers = (array, flags, self2, value) => {
  for (var i4 = 0, fns = array[flags >> 1], n3 = fns && fns.length; i4 < n3; i4++) flags & 1 ? fns[i4].call(self2) : value = fns[i4].call(self2, value);
  return value;
};
var __decorateElement = (array, flags, name, decorators, target, extra) => {
  var fn, it, done, ctx, access, k2 = flags & 7, s2 = !!(flags & 8), p2 = !!(flags & 16);
  var j2 = k2 > 3 ? array.length + 1 : k2 ? s2 ? 1 : 2 : 0, key = __decoratorStrings[k2 + 5];
  var initializers = k2 > 3 && (array[j2 - 1] = []), extraInitializers = array[j2] || (array[j2] = []);
  var desc = k2 && (!p2 && !s2 && (target = target.prototype), k2 < 5 && (k2 > 3 || !p2) && __getOwnPropDesc(k2 < 4 ? target : { get [name]() {
    return __privateGet(this, extra);
  }, set [name](x2) {
    return __privateSet(this, extra, x2);
  } }, name));
  k2 ? p2 && k2 < 4 && __name(extra, (k2 > 2 ? "set " : k2 > 1 ? "get " : "") + name) : __name(target, name);
  for (var i4 = decorators.length - 1; i4 >= 0; i4--) {
    ctx = __decoratorContext(k2, name, done = {}, array[3], extraInitializers);
    if (k2) {
      ctx.static = s2, ctx.private = p2, access = ctx.access = { has: p2 ? (x2) => __privateIn(target, x2) : (x2) => name in x2 };
      if (k2 ^ 3) access.get = p2 ? (x2) => (k2 ^ 1 ? __privateGet : __privateMethod)(x2, target, k2 ^ 4 ? extra : desc.get) : (x2) => x2[name];
      if (k2 > 2) access.set = p2 ? (x2, y3) => __privateSet(x2, target, y3, k2 ^ 4 ? extra : desc.set) : (x2, y3) => x2[name] = y3;
    }
    it = (0, decorators[i4])(k2 ? k2 < 4 ? p2 ? extra : desc[key] : k2 > 4 ? void 0 : { get: desc.get, set: desc.set } : target, ctx), done._ = 1;
    if (k2 ^ 4 || it === void 0) __expectFn(it) && (k2 > 4 ? initializers.unshift(it) : k2 ? p2 ? extra = it : desc[key] = it : target = it);
    else if (typeof it !== "object" || it === null) __typeError("Object expected");
    else __expectFn(fn = it.get) && (desc.get = fn), __expectFn(fn = it.set) && (desc.set = fn), __expectFn(fn = it.init) && initializers.unshift(fn);
  }
  return k2 || __decoratorMetadata(array, target), desc && __defProp(target, name, desc), p2 ? k2 ^ 4 ? extra : desc : target;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateIn = (member, obj) => Object(obj) !== obj ? __typeError('Cannot use the "in" operator on this value') : member.has(obj);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _error_dec, _isLoading_dec, _relatedProducts_dec, _limit_dec, _productId_dec, _title_dec, _a, _BriffaRelatedProductsOverride_decorators, _init, _title, _productId, _limit, _relatedProducts, _isLoading, _error;
_BriffaRelatedProductsOverride_decorators = [t$1("briffa-related-products-override")];
class BriffaRelatedProductsOverride extends (_a = BaseDesignSystemComponent(
  relatedProductsStyles
), _title_dec = [n$1({ type: String, attribute: "title" })], _productId_dec = [n$1({ type: String, attribute: "product-id" })], _limit_dec = [n$1({ type: Number, attribute: "limit" })], _relatedProducts_dec = [r$1()], _isLoading_dec = [r$1()], _error_dec = [r$1()], _a) {
  constructor() {
    super(...arguments);
    __privateAdd(this, _title, __runInitializers(_init, 8, this)), __runInitializers(_init, 11, this);
    __privateAdd(this, _productId, __runInitializers(_init, 12, this)), __runInitializers(_init, 15, this);
    __privateAdd(this, _limit, __runInitializers(_init, 16, this, 10)), __runInitializers(_init, 19, this);
    __privateAdd(this, _relatedProducts, __runInitializers(_init, 20, this, null)), __runInitializers(_init, 23, this);
    __privateAdd(this, _isLoading, __runInitializers(_init, 24, this, true)), __runInitializers(_init, 27, this);
    __privateAdd(this, _error, __runInitializers(_init, 28, this, null)), __runInitializers(_init, 31, this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.loadRelatedProducts();
  }
  async loadRelatedProducts() {
    if (!this.productId) {
      this.error = "Product ID is required";
      this.isLoading = false;
      return;
    }
    try {
      this.isLoading = true;
      this.error = null;
      const response = await fetchRelatedProducts(
        this.productId,
        this.limit
      );
      this.relatedProducts = response.products;
    } catch (err) {
      console.error("Failed to fetch related products:", err);
      this.error = "Failed to load related products";
    } finally {
      this.isLoading = false;
    }
  }
  renderProductCards() {
    if (!this.relatedProducts || this.relatedProducts.length === 0) {
      return x``;
    }
    const cardMinWidth = getProductCardWidth();
    return this.relatedProducts.map((product, index2) => {
      const productCard = createProductCard(product, index2);
      productCard.idPrefix = "related-products-";
      productCard.classList.add(cardMinWidth);
      if (index2 === 0) {
        productCard.classList.add("ml-4");
      }
      if (index2 === this.relatedProducts.length - 1) {
        productCard.classList.add("mr-4");
      }
      return productCard;
    });
  }
  render() {
    if (this.isLoading) {
      return x`
                <div class="related-products-container">
                    <div class="loading-state">
                        <wa-spinner style="font-size: 2rem;"></wa-spinner>
                    </div>
                </div>
            `;
    }
    if (this.error) {
      return x`
                <div class="related-products-container">
                    <div class="error-state">${this.error}</div>
                </div>
            `;
    }
    if (!this.relatedProducts || this.relatedProducts.length === 0) {
      return x``;
    }
    return x`
            <div class="related-products-container py-4">
                <h2 class="related-products-title">${this.title}</h2>
                <div class="products-container">
                    ${this.renderProductCards()}
                </div>
            </div>
        `;
  }
}
_init = __decoratorStart(_a);
_title = /* @__PURE__ */ new WeakMap();
_productId = /* @__PURE__ */ new WeakMap();
_limit = /* @__PURE__ */ new WeakMap();
_relatedProducts = /* @__PURE__ */ new WeakMap();
_isLoading = /* @__PURE__ */ new WeakMap();
_error = /* @__PURE__ */ new WeakMap();
__decorateElement(_init, 4, "title", _title_dec, BriffaRelatedProductsOverride, _title);
__decorateElement(_init, 4, "productId", _productId_dec, BriffaRelatedProductsOverride, _productId);
__decorateElement(_init, 4, "limit", _limit_dec, BriffaRelatedProductsOverride, _limit);
__decorateElement(_init, 4, "relatedProducts", _relatedProducts_dec, BriffaRelatedProductsOverride, _relatedProducts);
__decorateElement(_init, 4, "isLoading", _isLoading_dec, BriffaRelatedProductsOverride, _isLoading);
__decorateElement(_init, 4, "error", _error_dec, BriffaRelatedProductsOverride, _error);
BriffaRelatedProductsOverride = __decorateElement(_init, 0, "BriffaRelatedProductsOverride", _BriffaRelatedProductsOverride_decorators, BriffaRelatedProductsOverride);
__runInitializers(_init, 1, BriffaRelatedProductsOverride);
const shopifySections = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BriffaFeaturedCollection() {
    return BriffaFeaturedCollection;
  },
  get BriffaRelatedProductsOverride() {
    return BriffaRelatedProductsOverride;
  }
}, Symbol.toStringTag, { value: "Module" }));
const themeOverrideCSS = '/* Home page overflow fix - label was causing it */\n.container--reading-width {\n    max-width: 100%!important;\n    box-sizing: border-box!important;\n}\n\n/* Multi-column Employees */\n.shopify-section.section-gallery {\n    .text-overlay {\n        background: linear-gradient(transparent, transparent, black)\n    }\n\n    .text-overlay__inner {\n        padding: 10px 12px!important;\n    }\n}\n\n/* Product Page - START */\n\n.product-info .product-title {\n    font-size: 27px;\n}\n\n/* Product Page - END */\n\n.mobile-nav-toggle {\n    margin-left: 12px;\n}\n\n.announcement-bar > div, .container.logo-area, .section-footer__row-container, .collection-slider-row > div {\n    max-width: unset!important;\n}\n\n.testimonial__star-rating {\n    display: flex;\n}\n\n.section-footer__payment-icons {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n/* Your wishlist plugin styles */\n.swym-header-launcher {\n    margin-right: 20px !important;\n    order: 5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n@media (min-width: 768px) {\n    #symmetry-desktop.swym-header-launcher {\n        margin-left: 20px !important;\n    }\n}\n.swym-header-launcher-icon {\n    display: flex;\n}\n[aria-label="Open Wishlist"] {\n    width: 24px !important;\n    height: 24px !important;\n}\n.swym-header-launcher-badge {\n    top: -6px !important;\n    right: -11px !important;\n    left: unset !important;\n}\n';
const developmentThemeOverrideCSS = "/* README; These styles are specific only for local development, and will not be included in production build */\n\n/* Hide repetitive annoying cookies consent popup */\n#shopify-pc__banner {\n    display: none !important;\n}\n";
function injectThemeOverrideCSS() {
  const styleElement = document.createElement("style");
  styleElement.textContent = themeOverrideCSS;
  document.head.appendChild(styleElement);
  if (isDevelopmentMode()) {
    const devStyleElement = document.createElement("style");
    devStyleElement.textContent = developmentThemeOverrideCSS;
    document.head.appendChild(devStyleElement);
  }
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var badge_styles_default = i$6`
  :host {
    --pulse-color: var(--wa-color-fill-loud, var(--wa-color-brand-fill-loud));

    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.375em 0.625em;
    color: var(--wa-color-on-loud, var(--wa-color-brand-on-loud));
    font-size: max(var(--wa-font-size-2xs), 0.75em);
    font-weight: var(--wa-font-weight-semibold);
    line-height: 1;
    white-space: nowrap;
    background-color: var(--wa-color-fill-loud, var(--wa-color-brand-fill-loud));
    border-color: transparent;
    border-radius: var(--wa-border-radius-s);
    border-style: var(--wa-border-style);
    border-width: var(--wa-border-width-s);
    user-select: none;
    -webkit-user-select: none;
    cursor: inherit;
  }

  /* Appearance modifiers */
  :host([appearance='outlined']) {
    --pulse-color: var(--wa-color-border-loud, var(--wa-color-brand-border-loud));

    color: var(--wa-color-on-quiet, var(--wa-color-brand-on-quiet));
    background-color: transparent;
    border-color: var(--wa-color-border-loud, var(--wa-color-brand-border-loud));
  }

  :host([appearance='filled']) {
    --pulse-color: var(--wa-color-fill-normal, var(--wa-color-brand-fill-normal));

    color: var(--wa-color-on-normal, var(--wa-color-brand-on-normal));
    background-color: var(--wa-color-fill-normal, var(--wa-color-brand-fill-normal));
    border-color: transparent;
  }

  :host([appearance='filled-outlined']) {
    --pulse-color: var(--wa-color-border-normal, var(--wa-color-brand-border-normal));

    color: var(--wa-color-on-normal, var(--wa-color-brand-on-normal));
    background-color: var(--wa-color-fill-normal, var(--wa-color-brand-fill-normal));
    border-color: var(--wa-color-border-normal, var(--wa-color-brand-border-normal));
  }

  :host([appearance='accent']) {
    --pulse-color: var(--wa-color-fill-loud, var(--wa-color-brand-fill-loud));

    color: var(--wa-color-on-loud, var(--wa-color-brand-on-loud));
    background-color: var(--wa-color-fill-loud, var(--wa-color-brand-fill-loud));
    border-color: transparent;
  }

  /* Pill modifier */
  :host([pill]) {
    border-radius: var(--wa-border-radius-pill);
  }

  /* Pulse attention */
  :host([attention='pulse']) {
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--pulse-color);
    }
    70% {
      box-shadow: 0 0 0 0.5rem transparent;
    }
    100% {
      box-shadow: 0 0 0 0 transparent;
    }
  }

  /* Bounce attention */
  :host([attention='bounce']) {
    animation: bounce 1s cubic-bezier(0.28, 0.84, 0.42, 1) infinite;
  }

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-5px);
    }
    60% {
      transform: translateY(-2px);
    }
  }

  ::slotted(wa-icon) {
    margin-inline-end: var(--wa-space-2xs, 0.25em);
    opacity: 90%;
    line-height: 1;
    height: 0.85em;
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaBadge = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.variant = "brand";
    this.appearance = "accent";
    this.pill = false;
    this.attention = "none";
  }
  render() {
    return x` <slot part="base" role="status"></slot>`;
  }
};
WaBadge.css = [variants_styles_default, badge_styles_default];
__decorateClass([
  n$1({ reflect: true })
], WaBadge.prototype, "variant", 2);
__decorateClass([
  n$1({ reflect: true })
], WaBadge.prototype, "appearance", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaBadge.prototype, "pill", 2);
__decorateClass([
  n$1({ reflect: true })
], WaBadge.prototype, "attention", 2);
WaBadge = __decorateClass([
  t$1("wa-badge")
], WaBadge);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var switch_styles_default = i$6`
  :host {
    --height: var(--wa-form-control-toggle-size);
    --width: calc(var(--height) * 1.75);
    --thumb-size: 0.75em;

    display: inline-flex;
    line-height: var(--wa-form-control-value-line-height);
  }

  label {
    position: relative;
    display: flex;
    align-items: center;
    font: inherit;
    color: var(--wa-form-control-value-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch {
    flex: 0 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--wa-form-control-background-color);
    border-color: var(--wa-form-control-border-color);
    border-radius: var(--height);
    border-style: var(--wa-form-control-border-style);
    border-width: var(--wa-form-control-border-width);
    transition-property: translate, background, border-color, box-shadow;
    transition-duration: var(--wa-transition-normal);
    transition-timing-function: var(--wa-transition-easing);
  }

  .switch .thumb {
    aspect-ratio: 1 / 1;
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--wa-form-control-border-color);
    border-radius: 50%;
    translate: calc((var(--width) - var(--height)) / -2);
    transition: inherit;
  }

  .input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Focus */
  label:not(.disabled) .input:focus-visible ~ .switch .thumb {
    outline: var(--wa-focus-ring);
    outline-offset: var(--wa-focus-ring-offset);
  }

  /* Checked */
  .checked .switch {
    background-color: var(--wa-form-control-activated-color);
    border-color: var(--wa-form-control-activated-color);
  }

  .checked .switch .thumb {
    background-color: var(--wa-color-surface-default);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Disabled */
  label:has(> :disabled) {
    opacity: 0.5;
    cursor: not-allowed;
  }

  [part~='label'] {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) [part~='label']::after {
    content: var(--wa-form-control-required-content);
    color: var(--wa-form-control-required-content-color);
    margin-inline-start: var(--wa-form-control-required-content-offset);
  }

  @media (forced-colors: active) {
    :checked:enabled + .switch:hover .thumb,
    :checked + .switch .thumb {
      background-color: ButtonText;
    }
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var form_control_styles_default = i$6`
  :host {
    display: flex;
    flex-direction: column;
  }

  /* Label */
  :is([part~='form-control-label'], [part~='label']):has(*:not(:empty)) {
    display: inline-flex;
    color: var(--wa-form-control-label-color);
    font-weight: var(--wa-form-control-label-font-weight);
    line-height: var(--wa-form-control-label-line-height);
    margin-block-end: 0.5em;
  }

  :host([required]) :is([part~='form-control-label'], [part~='label'])::after {
    content: var(--wa-form-control-required-content);
    margin-inline-start: var(--wa-form-control-required-content-offset);
    color: var(--wa-form-control-required-content-color);
  }

  /* Help text */
  [part~='hint'] {
    display: block;
    color: var(--wa-form-control-hint-color);
    font-weight: var(--wa-form-control-hint-font-weight);
    line-height: var(--wa-form-control-hint-line-height);
    margin-block-start: 0.5em;
    font-size: var(--wa-font-size-smaller);
    line-height: var(--wa-form-control-label-line-height);

    &:not(.has-slotted) {
      display: none;
    }
  }
`;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l = e$4(class extends i$2 {
  constructor(r2) {
    if (super(r2), r2.type !== t.PROPERTY && r2.type !== t.ATTRIBUTE && r2.type !== t.BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
    if (!f(r2)) throw Error("`live` bindings can only contain a single expression");
  }
  render(r2) {
    return r2;
  }
  update(i4, [t$12]) {
    if (t$12 === T || t$12 === E) return t$12;
    const o2 = i4.element, l2 = i4.name;
    if (i4.type === t.PROPERTY) {
      if (t$12 === o2[l2]) return T;
    } else if (i4.type === t.BOOLEAN_ATTRIBUTE) {
      if (!!t$12 === o2.hasAttribute(l2)) return T;
    } else if (i4.type === t.ATTRIBUTE && o2.getAttribute(l2) === t$12 + "") return T;
    return m(i4), t$12;
  }
});
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaSwitch = class extends WebAwesomeFormAssociatedElement {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "hint");
    this.title = "";
    this.name = null;
    this._value = this.getAttribute("value") ?? null;
    this.size = "medium";
    this.disabled = false;
    this.checked = this.hasAttribute("checked");
    this.defaultChecked = this.hasAttribute("checked");
    this.required = false;
    this.hint = "";
    this.withHint = false;
  }
  static get validators() {
    return [...super.validators, MirrorValidator()];
  }
  /** The value of the switch, submitted as a name/value pair with form data. */
  get value() {
    return this._value ?? "on";
  }
  set value(val) {
    this._value = val;
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this.handleValueOrCheckedChange();
  }
  handleClick() {
    this.hasInteracted = true;
    this.checked = !this.checked;
    this.updateComplete.then(() => {
      this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
    });
  }
  handleKeyDown(event) {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.checked = false;
      this.updateComplete.then(() => {
        this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
        this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
      });
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.checked = true;
      this.updateComplete.then(() => {
        this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
        this.dispatchEvent(new InputEvent("input", { bubbles: true, composed: true }));
      });
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (changedProperties.has("defaultChecked")) {
      if (!this.hasInteracted) {
        this.checked = this.defaultChecked;
      }
    }
    if (changedProperties.has("value") || changedProperties.has("checked")) {
      this.handleValueOrCheckedChange();
    }
  }
  handleValueOrCheckedChange() {
    this.setValue(this.checked ? this.value : null, this._value);
    this.updateValidity();
  }
  handleDefaultCheckedChange() {
    if (!this.hasInteracted && this.checked !== this.defaultChecked) {
      this.checked = this.defaultChecked;
      this.handleValueOrCheckedChange();
    }
  }
  handleStateChange() {
    if (this.hasUpdated) {
      this.input.checked = this.checked;
    }
    this.customStates.set("checked", this.checked);
    this.updateValidity();
  }
  handleDisabledChange() {
    this.updateValidity();
  }
  /** Simulates a click on the switch. */
  click() {
    this.input.click();
  }
  /** Sets focus on the switch. */
  focus(options) {
    this.input.focus(options);
  }
  /** Removes focus from the switch. */
  blur() {
    this.input.blur();
  }
  setValue(value, stateValue) {
    if (!this.checked) {
      this.internals.setFormValue(null, null);
      return;
    }
    this.internals.setFormValue(value ?? "on", stateValue);
  }
  formResetCallback() {
    this.checked = this.defaultChecked;
    super.formResetCallback();
    this.handleValueOrCheckedChange();
  }
  render() {
    const hasHintSlot = this.hasUpdated ? this.hasSlotController.test("hint") : this.withHint;
    const hasHint = this.hint ? true : !!hasHintSlot;
    return x`
      <label
        part="base"
        class=${e$3({
      checked: this.checked,
      disabled: this.disabled
    })}
      >
        <input
          class="input"
          type="checkbox"
          title=${this.title}
          name=${this.name}
          value=${o$1(this.value)}
          .checked=${l(this.checked)}
          .disabled=${this.disabled}
          .required=${this.required}
          role="switch"
          aria-checked=${this.checked ? "true" : "false"}
          aria-describedby="hint"
          @click=${this.handleClick}
          @keydown=${this.handleKeyDown}
        />

        <span part="control" class="switch">
          <span part="thumb" class="thumb"></span>
        </span>

        <slot part="label" class="label"></slot>
      </label>

      <slot
        id="hint"
        name="hint"
        part="hint"
        class=${e$3({
      "has-slotted": hasHint
    })}
        aria-hidden=${hasHint ? "false" : "true"}
        >${this.hint}</slot
      >
    `;
  }
};
WaSwitch.shadowRootOptions = { ...WebAwesomeFormAssociatedElement.shadowRootOptions, delegatesFocus: true };
WaSwitch.css = [form_control_styles_default, size_styles_default, switch_styles_default];
__decorateClass([
  e$5('input[type="checkbox"]')
], WaSwitch.prototype, "input", 2);
__decorateClass([
  n$1()
], WaSwitch.prototype, "title", 2);
__decorateClass([
  n$1({ reflect: true })
], WaSwitch.prototype, "name", 2);
__decorateClass([
  n$1({ reflect: true })
], WaSwitch.prototype, "value", 1);
__decorateClass([
  n$1({ reflect: true })
], WaSwitch.prototype, "size", 2);
__decorateClass([
  n$1({ type: Boolean })
], WaSwitch.prototype, "disabled", 2);
__decorateClass([
  n$1({ type: Boolean, attribute: false })
], WaSwitch.prototype, "checked", 2);
__decorateClass([
  n$1({ type: Boolean, attribute: "checked", reflect: true })
], WaSwitch.prototype, "defaultChecked", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaSwitch.prototype, "required", 2);
__decorateClass([
  n$1({ attribute: "hint" })
], WaSwitch.prototype, "hint", 2);
__decorateClass([
  n$1({ attribute: "with-hint", type: Boolean })
], WaSwitch.prototype, "withHint", 2);
__decorateClass([
  watch("defaultChecked")
], WaSwitch.prototype, "handleDefaultCheckedChange", 1);
__decorateClass([
  watch(["checked"])
], WaSwitch.prototype, "handleStateChange", 1);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], WaSwitch.prototype, "handleDisabledChange", 1);
WaSwitch = __decorateClass([
  t$1("wa-switch")
], WaSwitch);
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var locks = /* @__PURE__ */ new Set();
function getScrollbarWidth() {
  const documentWidth = document.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}
function getExistingBodyPadding() {
  const padding = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
  if (isNaN(padding) || !padding) {
    return 0;
  }
  return padding;
}
function lockBodyScrolling(lockingEl) {
  locks.add(lockingEl);
  if (!document.documentElement.classList.contains("wa-scroll-lock")) {
    const scrollbarWidth = getScrollbarWidth() + getExistingBodyPadding();
    let scrollbarGutterProperty = getComputedStyle(document.documentElement).scrollbarGutter;
    if (!scrollbarGutterProperty || scrollbarGutterProperty === "auto") {
      scrollbarGutterProperty = "stable";
    }
    if (scrollbarWidth < 2) {
      scrollbarGutterProperty = "";
    }
    document.documentElement.style.setProperty("--wa-scroll-lock-gutter", scrollbarGutterProperty);
    document.documentElement.classList.add("wa-scroll-lock");
    document.documentElement.style.setProperty("--wa-scroll-lock-size", `${scrollbarWidth}px`);
  }
}
function unlockBodyScrolling(lockingEl) {
  locks.delete(lockingEl);
  if (locks.size === 0) {
    document.documentElement.classList.remove("wa-scroll-lock");
    document.documentElement.style.removeProperty("--wa-scroll-lock-size");
  }
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
function parseSpaceDelimitedTokens(input) {
  return input.split(" ").map((token) => token.trim()).filter((token) => token !== "");
}
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var drawer_styles_default = i$6`
  :host {
    --size: 25rem;
    --spacing: var(--wa-space-l);
    --show-duration: 200ms;
    --hide-duration: 200ms;

    display: none;
  }

  :host([open]) {
    display: block;
  }

  .drawer {
    display: flex;
    flex-direction: column;
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
    background-color: var(--wa-color-surface-raised);
    border: none;
    box-shadow: var(--wa-shadow-l);
    overflow: auto;
    padding: 0;
    margin: 0;
    animation-duration: var(--show-duration);
    animation-timing-function: ease;

    &.show::backdrop {
      animation: show-backdrop var(--show-duration, 200ms) ease;
    }

    &.hide::backdrop {
      animation: show-backdrop var(--hide-duration, 200ms) ease reverse;
    }

    &.show.top {
      animation: show-drawer-from-top var(--show-duration) ease;
    }

    &.hide.top {
      animation: show-drawer-from-top var(--hide-duration) ease reverse;
    }

    &.show.end {
      animation: show-drawer-from-end var(--show-duration) ease;

      &:dir(rtl) {
        animation-name: show-drawer-from-start;
      }
    }

    &.hide.end {
      animation: show-drawer-from-end var(--hide-duration) ease reverse;

      &:dir(rtl) {
        animation-name: show-drawer-from-start;
      }
    }

    &.show.bottom {
      animation: show-drawer-from-bottom var(--show-duration) ease;
    }

    &.hide.bottom {
      animation: show-drawer-from-bottom var(--hide-duration) ease reverse;
    }

    &.show.start {
      animation: show-drawer-from-start var(--show-duration) ease;

      &:dir(rtl) {
        animation-name: show-drawer-from-end;
      }
    }

    &.hide.start {
      animation: show-drawer-from-start var(--hide-duration) ease reverse;

      &:dir(rtl) {
        animation-name: show-drawer-from-end;
      }
    }

    &.pulse {
      animation: pulse 250ms ease;
    }
  }

  .drawer:focus {
    outline: none;
  }

  .top {
    top: 0;
    inset-inline-end: auto;
    bottom: auto;
    inset-inline-start: 0;
    width: 100%;
    height: var(--size);
  }

  .end {
    top: 0;
    inset-inline-end: 0;
    bottom: auto;
    inset-inline-start: auto;
    width: var(--size);
    height: 100%;
  }

  .bottom {
    top: auto;
    inset-inline-end: auto;
    bottom: 0;
    inset-inline-start: 0;
    width: 100%;
    height: var(--size);
  }

  .start {
    top: 0;
    inset-inline-end: auto;
    bottom: auto;
    inset-inline-start: 0;
    width: var(--size);
    height: 100%;
  }

  .header {
    display: flex;
    flex-wrap: nowrap;
    padding-inline-start: var(--spacing);
    padding-block-end: 0;

    /* Subtract the close button's padding so that the X is visually aligned with the edges of the dialog content */
    padding-inline-end: calc(var(--spacing) - var(--wa-form-control-padding-block));
    padding-block-start: calc(var(--spacing) - var(--wa-form-control-padding-block));
  }

  .title {
    align-self: center;
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--wa-font-size-l);
    font-weight: var(--wa-font-weight-heading);
    line-height: var(--wa-line-height-condensed);
    margin: 0;
  }

  .header-actions {
    align-self: start;
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--wa-space-2xs);
    padding-inline-start: var(--spacing);
  }

  .header-actions wa-button,
  .header-actions ::slotted(wa-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .body {
    flex: 1 1 auto;
    display: block;
    padding: var(--spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: var(--wa-focus-ring);
      outline-offset: var(--wa-focus-ring-offset);
    }
  }

  .footer {
    display: flex;
    flex-wrap: wrap;
    gap: var(--wa-space-xs);
    justify-content: end;
    padding: var(--spacing);
    padding-block-start: 0;
  }

  .footer ::slotted(wa-button:not(:last-of-type)) {
    margin-inline-end: var(--wa-spacing-xs);
  }

  .drawer::backdrop {
    /*
        NOTE: the ::backdrop element doesn't inherit properly in Safari yet, but it will in 17.4! At that time, we can
        remove the fallback values here.
      */
    background-color: var(--wa-color-overlay-modal, rgb(0 0 0 / 0.25));
  }

  @keyframes pulse {
    0% {
      scale: 1;
    }
    50% {
      scale: 1.01;
    }
    100% {
      scale: 1;
    }
  }

  @keyframes show-drawer {
    from {
      opacity: 0;
      scale: 0.8;
    }
    to {
      opacity: 1;
      scale: 1;
    }
  }

  @keyframes show-drawer-from-top {
    from {
      opacity: 0;
      translate: 0 -100%;
    }
    to {
      opacity: 1;
      translate: 0 0;
    }
  }

  @keyframes show-drawer-from-end {
    from {
      opacity: 0;
      translate: 100%;
    }
    to {
      opacity: 1;
      translate: 0 0;
    }
  }

  @keyframes show-drawer-from-bottom {
    from {
      opacity: 0;
      translate: 0 100%;
    }
    to {
      opacity: 1;
      translate: 0 0;
    }
  }

  @keyframes show-drawer-from-start {
    from {
      opacity: 0;
      translate: -100% 0;
    }
    to {
      opacity: 1;
      translate: 0 0;
    }
  }

  @keyframes show-backdrop {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (forced-colors: active) {
    .drawer {
      border: solid 1px white;
    }
  }
`;
/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */
var WaDrawer = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController2(this);
    this.hasSlotController = new HasSlotController(this, "footer", "header-actions", "label");
    this.open = false;
    this.label = "";
    this.placement = "end";
    this.withoutHeader = false;
    this.lightDismiss = true;
    this.handleDocumentKeyDown = (event) => {
      if (event.key === "Escape" && this.open) {
        event.preventDefault();
        event.stopPropagation();
        this.requestClose(this.drawer);
      }
    };
  }
  firstUpdated() {
    if (this.open) {
      this.addOpenListeners();
      this.drawer.showModal();
      lockBodyScrolling(this);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    unlockBodyScrolling(this);
    this.removeOpenListeners();
  }
  async requestClose(source) {
    const waHideEvent = new WaHideEvent({ source });
    this.dispatchEvent(waHideEvent);
    if (waHideEvent.defaultPrevented) {
      this.open = true;
      animateWithClass(this.drawer, "pulse");
      return;
    }
    this.removeOpenListeners();
    await animateWithClass(this.drawer, "hide");
    this.open = false;
    this.drawer.close();
    unlockBodyScrolling(this);
    const trigger = this.originalTrigger;
    if (typeof trigger?.focus === "function") {
      setTimeout(() => trigger.focus());
    }
    this.dispatchEvent(new WaAfterHideEvent());
  }
  addOpenListeners() {
    document.addEventListener("keydown", this.handleDocumentKeyDown);
  }
  removeOpenListeners() {
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  handleDialogCancel(event) {
    event.preventDefault();
    if (!this.drawer.classList.contains("hide") && event.target === this.drawer) {
      this.requestClose(this.drawer);
    }
  }
  handleDialogClick(event) {
    const target = event.target;
    const button = target.closest('[data-drawer="close"]');
    if (button) {
      event.stopPropagation();
      this.requestClose(button);
    }
  }
  async handleDialogPointerDown(event) {
    if (event.target === this.drawer) {
      if (this.lightDismiss) {
        this.requestClose(this.drawer);
      } else {
        await animateWithClass(this.drawer, "pulse");
      }
    }
  }
  handleOpenChange() {
    if (this.open && !this.drawer.open) {
      this.show();
    } else if (this.drawer.open) {
      this.open = true;
      this.requestClose(this.drawer);
    }
  }
  /** Shows the drawer. */
  async show() {
    const waShowEvent = new WaShowEvent();
    this.dispatchEvent(waShowEvent);
    if (waShowEvent.defaultPrevented) {
      this.open = false;
      return;
    }
    this.addOpenListeners();
    this.originalTrigger = document.activeElement;
    this.open = true;
    this.drawer.showModal();
    lockBodyScrolling(this);
    requestAnimationFrame(() => {
      const elementToFocus = this.querySelector("[autofocus]");
      if (elementToFocus && typeof elementToFocus.focus === "function") {
        elementToFocus.focus();
      } else {
        this.drawer.focus();
      }
    });
    await animateWithClass(this.drawer, "show");
    this.dispatchEvent(new WaAfterShowEvent());
  }
  render() {
    const hasHeader = !this.withoutHeader;
    const hasFooter = this.hasSlotController.test("footer");
    return x`
      <dialog
        part="dialog"
        class=${e$3({
      drawer: true,
      open: this.open,
      top: this.placement === "top",
      end: this.placement === "end",
      bottom: this.placement === "bottom",
      start: this.placement === "start"
    })}
        @cancel=${this.handleDialogCancel}
        @click=${this.handleDialogClick}
        @pointerdown=${this.handleDialogPointerDown}
      >
        ${hasHeader ? x`
              <header part="header" class="header">
                <h2 part="title" class="title" id="title">
                  <!-- If there's no label, use an invisible character to prevent the header from collapsing -->
                  <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(8203)} </slot>
                </h2>
                <div part="header-actions" class="header-actions">
                  <slot name="header-actions"></slot>
                  <wa-button
                    part="close-button"
                    exportparts="base:close-button__base"
                    class="close"
                    appearance="plain"
                    @click="${(event) => this.requestClose(event.target)}"
                  >
                    <wa-icon
                      name="xmark"
                      label=${this.localize.term("close")}
                      library="system"
                      variant="solid"
                    ></wa-icon>
                  </wa-button>
                </div>
              </header>
            ` : ""}

        <div part="body" class="body"><slot></slot></div>

        ${hasFooter ? x`
              <footer part="footer" class="footer">
                <slot name="footer"></slot>
              </footer>
            ` : ""}
      </dialog>
    `;
  }
};
WaDrawer.css = drawer_styles_default;
__decorateClass([
  e$5(".drawer")
], WaDrawer.prototype, "drawer", 2);
__decorateClass([
  n$1({ type: Boolean, reflect: true })
], WaDrawer.prototype, "open", 2);
__decorateClass([
  n$1({ reflect: true })
], WaDrawer.prototype, "label", 2);
__decorateClass([
  n$1({ reflect: true })
], WaDrawer.prototype, "placement", 2);
__decorateClass([
  n$1({ attribute: "without-header", type: Boolean, reflect: true })
], WaDrawer.prototype, "withoutHeader", 2);
__decorateClass([
  n$1({ attribute: "light-dismiss", type: Boolean })
], WaDrawer.prototype, "lightDismiss", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], WaDrawer.prototype, "handleOpenChange", 1);
WaDrawer = __decorateClass([
  t$1("wa-drawer")
], WaDrawer);
document.addEventListener("click", (event) => {
  const drawerAttrEl = event.target.closest("[data-drawer]");
  if (drawerAttrEl instanceof Element) {
    const [command, id] = parseSpaceDelimitedTokens(drawerAttrEl.getAttribute("data-drawer") || "");
    if (command === "open" && id?.length) {
      const doc = drawerAttrEl.getRootNode();
      const drawer = doc.getElementById(id);
      if (drawer?.localName === "wa-drawer") {
        drawer.open = true;
      } else {
        console.warn(`A drawer with an ID of "${id}" could not be found in this document.`);
      }
    }
  }
});
{
  document.body.addEventListener("pointerdown", () => {
  });
}
const exportMap = {
  features,
  containers,
  components,
  services,
  types,
  utils,
  constants,
  resources,
  arCore,
  shopifySections
};
injectThemeOverrideCSS();
window.__briffaExportMap__ = exportMap;
